export const commonTranslations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.services': 'Services',
    'nav.projects': 'Projects',
    'nav.sectors': 'Sectors',
    'nav.blog': 'Blog',
    'nav.careers': 'Careers',
    'nav.contact': 'Contact',
    'nav.documents': 'Documents',
    
    // Common buttons and actions
    'get.quote': 'Get Quote',
    'learn.more': 'Learn More',
    'view.all': 'View All',
    'read.more': 'Read More',
    
    // Service titles (used in footer and other components)
    'services.commercial.title': 'Commercial Construction',
    'services.residential.title': 'Residential Development',
    'services.infrastructure.title': 'Infrastructure Projects',
    'services.detailed.renovation.title': 'Renovation & Remodeling',
    'services.detailed.projectManagement.title': 'Project Management',
    
    // Footer
    'footer.company.tagline': 'Construction Excellence',
    'footer.company.description': 'Building the future with excellence, innovation, and unwavering commitment to quality.',
    'footer.quickLinks.title': 'Quick Links',
    'footer.services.title': 'Our Services',
    'footer.contact.title': 'Contact Info',
    'footer.links.careers': 'Careers',
    'footer.links.blog': 'Blog',
    'footer.address.line1': '123 Construction Ave',
    'footer.address.line2': 'Building District',
    'footer.address.line3': 'City, State 12345',
    'footer.legal.privacy': 'Privacy Policy',
    'footer.legal.terms': 'Terms of Service',
    'footer.legal.cookie': 'Cookie Policy',
    'footer.copyright': '© 2025 FMC Construction. All rights reserved.',

    // Admin Panel
    'admin.panel': 'Admin Panel',
    'admin.dashboard': 'Dashboard',
    'admin.projects': 'Projects',
    'admin.jobApplications': 'Job Applications',
    'admin.contactSubmissions': 'Contact Form Submissions',
    'admin.subscriptions': 'Subscriptions',
    'admin.blogPosts': 'Blog Posts',
    'admin.socialMedia': 'Social Media Management',
    
    // Social Media Management
    'socialMedia.title': 'LinkedIn Social Media Management',
    'socialMedia.subtitle': 'Manage your LinkedIn posts with calendar, list, kanban, and card views',
    'socialMedia.addPost': 'Add Post',
    'socialMedia.createPost': 'Create New Post',
    'socialMedia.editPost': 'Edit Post',
    'socialMedia.save': 'Save',
    'socialMedia.cancel': 'Cancel',
    'socialMedia.search': 'Search posts...',
    'socialMedia.more': 'more',
    'socialMedia.scheduled': 'Scheduled',
    
    // Views
    'socialMedia.views.calendar': 'Calendar',
    'socialMedia.views.list': 'List',
    'socialMedia.views.kanban': 'Kanban',
    'socialMedia.views.cards': 'Cards',
    
    // Calendar
    'socialMedia.calendar.title': 'Post Calendar',
    
    // List
    'socialMedia.list.title': 'Post List',
    
    // Kanban
    'socialMedia.kanban.title': 'Post Pipeline',
    
    // Cards
    'socialMedia.cards.title': 'Post Cards',
    
    // Status
    'socialMedia.status.label': 'Status',
    'socialMedia.status.draft': 'Draft',
    'socialMedia.status.scheduled': 'Scheduled',
    'socialMedia.status.published': 'Published',
    'socialMedia.status.failed': 'Failed',
    
    // Filters
    'socialMedia.filters.all': 'All Posts',
    
    // Form Fields
    'socialMedia.imageUrl': 'Image URL',
    'socialMedia.imageUrlPlaceholder': 'Enter image URL...',
    'socialMedia.description': 'Description',
    'socialMedia.descriptionPlaceholder': 'Write your post description...',
    'socialMedia.hashtags': 'Hashtags',
    'socialMedia.hashtagsPlaceholder': 'Enter hashtags separated by commas...',
    'socialMedia.scheduledDate': 'Scheduled Date & Time',
    'socialMedia.viewPost': 'View Post',
    'socialMedia.deletePost': 'Delete Post',
    'socialMedia.dropHere': 'Drop here to change status',
    'socialMedia.imagePreview': 'Image Preview',
    'socialMedia.imageLoadError': 'Failed to load image',
    'socialMedia.close': 'Close',
    'socialMedia.loading': 'Loading...',
    
    'admin.pageViews': 'Page Views',
    'admin.documents': 'Documents',
    'admin.vendors': 'Vendors',
    'admin.clients': 'Clients',
    'admin.users': 'Users',
    'admin.settings': 'Settings',
    'admin.profile': 'Profile',
    'admin.goToWebsite': 'Go to Website',
    'admin.welcomeBack': 'Welcome back',
    'admin.welcomeMessage': 'Welcome back to the FMC Admin Panel',
    'admin.logout': 'Logout',
    
    // Admin Profile
    'adminProfile.personalInformation': 'Personal Information',
    'adminProfile.firstName': 'First Name',
    'adminProfile.lastName': 'Last Name',
    'adminProfile.email': 'Email',
    'adminProfile.phone': 'Phone',
    'adminProfile.position': 'Position',
    'adminProfile.department': 'Department',
    'adminProfile.preferences': 'Preferences',
    'adminProfile.language': 'Language',
    'adminProfile.theme': 'Theme',
    'adminProfile.security': 'Security',
    'adminProfile.twoFactorAuth': 'Two-Factor Authentication',
    'adminProfile.twoFactorDesc': 'Add an extra layer of security to your account',
    'adminProfile.changePassword': 'Change Password',
    'adminProfile.currentPassword': 'Current Password',
    'adminProfile.newPassword': 'New Password',
    'adminProfile.confirmPassword': 'Confirm Password',
    'adminProfile.updatePassword': 'Update Password',
    'adminProfile.updateAvatar': 'Update Avatar',
    'adminProfile.avatarDescription': 'Upload a new profile picture',
    'adminProfile.chooseFile': 'Choose File',
    'adminProfile.updateAvatarButton': 'Update Avatar',
    'adminProfile.saveChanges': 'Save Changes',
    'adminProfile.personalInfo': 'Personal Info',
    
    // Dashboard Projects
    'dashboard.activeProjects': 'Active Projects',
    'dashboard.completedProjects': 'Completed Projects',
    
    // Projects
    'projects.filters.planning': 'Planning',
    'projects.filters.completed': 'Completed',
    'projects.filters.onHold': 'On Hold',
    'projects.filters.allSectors': 'All Sectors',
    'projects.filters.allCities': 'All Cities',
    'projects.filters.allYears': 'All Years',
    'projects.filters.healthcare': 'Healthcare',
    'projects.filters.education': 'Education',
    'projects.filters.industrial': 'Industrial',
    'projects.table.projectName': 'Project Name',
    'projects.table.builtUpArea': 'Built Up Area',
    'projects.table.gpsLocation': 'GPS Location',
    'projects.table.googleMapLink': 'Google Map Link',
    'projects.table.client': 'Client',
    'projects.table.consultant': 'Consultant',
    'projects.table.city': 'City',
    'projects.table.value': 'Value',
    'projects.table.status': 'Status',
    'projects.table.sector': 'Sector',
    'projects.table.yearAwarded': 'Year Awarded',
    'projects.table.startDate': 'Start Date',
    'projects.table.finishDate': 'Finish Date',
    'projects.table.scopeOfWork': 'Scope of Work',
    'projects.table.photos': 'Photos',
    'projects.table.featuredPhoto': 'Featured Photo',
    'projects.table.videos': 'Videos',
    'projects.table.references': 'References',
    'projects.table.progress': 'Progress',
    'projects.table.actions': 'Actions',
    'projects.status.active': 'Active',
    'projects.status.planning': 'Planning',
    'projects.status.completed': 'Completed',
    'projects.status.on-hold': 'On Hold',
    'projects.deleteConfirm.title': 'Delete Project',
    'projects.deleteConfirm.message': 'Are you sure you want to delete the project',
    'projects.deleteConfirm.delete': 'Delete',
    'projects.addNew': 'Add New Project',
    'projects.edit': 'Edit Project',
    'projects.view': 'View Project',
    'projects.modal.addTitle': 'Add New Project',
    'projects.modal.editTitle': 'Edit Project',
    'projects.modal.viewTitle': 'Project Details',
    'projects.modal.basicInfo': 'Basic Information',
    'projects.modal.projectDetails': 'Project Details',
    'projects.modal.scopeOfWork': 'Scope of Work',
    'projects.modal.location': 'Location',
    'projects.modal.references': 'References',
    'projects.modal.photos': 'Project Photos',
    'projects.modal.videos': 'Project Videos',
    'projects.modal.addReference': 'Add Reference',
    'projects.modal.addPhoto': 'Upload Photos',
    'projects.modal.addVideo': 'Add Video',
    'projects.modal.save': 'Save Project',
    'projects.modal.update': 'Update Project',
    'projects.modal.close': 'Close',
    'projects.modal.cancel': 'Cancel',
    'projects.modal.next': 'Next',
    'projects.modal.previous': 'Previous',
    'projects.modal.review': 'Review Project Details',
    'projects.modal.step1': 'Basic Information',
    'projects.modal.step2': 'Project Details',
    'projects.modal.step3': 'Media & Progress',
    'projects.modal.step4': 'Review & Save',
    'projects.form.projectName': 'Project Name',
    'projects.form.client': 'Client',
    'projects.form.consultant': 'Consultant',
    'projects.form.city': 'City',
    'projects.form.builtUpArea': 'Built Up Area',
    'projects.form.value': 'Project Value',
    'projects.form.yearAwarded': 'Year Awarded',
    'projects.form.progress': 'Progress (%)',
    'projects.form.scopeOfWork': 'Scope of Work',
    'projects.form.gpsLocation': 'GPS Location',
    'projects.form.googleMapLink': 'Google Map Link',
    'projects.form.placeholder.projectName': 'Enter project name',
    'projects.form.placeholder.client': 'Enter client name',
    'projects.form.placeholder.consultant': 'Enter consultant name',
    'projects.form.placeholder.city': 'Enter city',
    'projects.form.placeholder.builtUpArea': 'e.g., 25,000 sqm',
    'projects.form.placeholder.value': 'e.g., 15,000,000 SAR',
    'projects.form.placeholder.yearAwarded': 'e.g., 2024',
    'projects.form.placeholder.progress': '0',
    'projects.form.placeholder.scopeOfWork': 'Describe the scope of work...',
    'projects.form.placeholder.gpsLocation': 'e.g., 24.7136° N, 46.6753° E',
    'projects.form.placeholder.googleMapLink': 'https://maps.google.com/...',
    'projects.form.placeholder.videoUrl': 'Enter YouTube URL',
    'projects.form.placeholder.referenceUrl': 'Enter reference URL',
    'projects.form.sector': 'Sector',
    'projects.form.status': 'Status',
    'projects.form.startDate': 'Start Date',
    'projects.form.finishDate': 'Finish Date',
    'projects.form.selectClient': 'Select Client',
    'projects.form.selectConsultant': 'Select Consultant',
    'projects.form.selectStatus': 'Select Status',
    'projects.form.uploadPhotos': 'Upload Photos',
    'projects.form.featuredPhoto': 'Featured Photo',
    'projects.form.uploadFeaturedPhoto': 'Upload Featured Photo',
    'projects.form.featuredPhotoPreview': 'Featured Photo Preview',
    'projects.form.addVideo': 'Add Video',
    'projects.form.dragDropPhotos': 'Drag and drop photos here, or click to browse',
    'projects.form.noPhotos': 'No photos uploaded yet',
    'projects.form.noVideos': 'No videos added yet',
    'projects.form.fileSupport': 'Supports JPG, PNG, GIF up to 10MB each',
    'projects.mapModal.title': 'Project Location',
    'projects.mapModal.close': 'Close Map',
    'projects.fieldVisibility.title': 'Show/Hide Columns',
    'projects.fieldVisibility.selectAll': 'Select All',
    'projects.fieldVisibility.deselectAll': 'Deselect All',
    'projects.fieldVisibility.apply': 'Apply',
    'projects.fieldVisibility.cancel': 'Cancel',
    'projects.form.selectYear': 'Select Year',
    'projects.form.selectCity': 'Select City',
    'projects.cities.riyadh': 'Riyadh',
    'projects.cities.jeddah': 'Jeddah',
    'projects.cities.dammam': 'Dammam',
    'projects.cities.mecca': 'Mecca',
    'projects.cities.medina': 'Medina',
    'projects.cities.taif': 'Taif',
    'projects.cities.khobar': 'Khobar',
    'projects.cities.dhahran': 'Dhahran',
    'projects.cities.other': 'Other',
    
    // Submissions
    'submissions.archive': 'Archive',
    'submissions.filters.all': 'All',
    'submissions.filters.contact': 'Contact',
    'submissions.filters.job': 'Job',
    'submissions.filters.partnership': 'Partnership',
    'submissions.filters.allStatus': 'All Status',
    'submissions.filters.new': 'New',
    'submissions.filters.reviewed': 'Reviewed',
    'submissions.filters.inProgress': 'In Progress',
    'submissions.filters.completed': 'Completed',
    'submissions.table.type': 'Type',
    'submissions.table.name': 'Name',
    'submissions.table.company': 'Company',
    'submissions.table.subject': 'Subject',
    'submissions.table.status': 'Status',
    'submissions.table.priority': 'Priority',
    'submissions.table.actions': 'Actions',
    'submissions.types.contact': 'Contact',
    'submissions.types.job': 'Job',
    'submissions.types.partnership': 'Partnership',
    'submissions.status.new': 'New',
    'submissions.status.reviewed': 'Reviewed',
    'submissions.status.inProgress': 'In Progress',
    'submissions.status.completed': 'Completed',
    'submissions.priority.high': 'High',
    'submissions.priority.medium': 'Medium',
    'submissions.priority.low': 'Low',
    'submissions.viewSubmission': 'View Submission',
    'submissions.message': 'Message',
    'common.close': 'Close',
    
    // Job Applications
    'jobApplications.filters.all': 'All',
    'jobApplications.filters.projectManager': 'Project Manager',
    'jobApplications.filters.civilEngineer': 'Civil Engineer',
    'jobApplications.filters.siteSupervisor': 'Site Supervisor',
    'jobApplications.filters.architect': 'Architect',
    'jobApplications.filters.quantitySurveyor': 'Quantity Surveyor',
    'jobApplications.filters.allStatus': 'All Status',
    'jobApplications.filters.pending': 'Pending',
    'jobApplications.filters.reviewed': 'Reviewed',
    'jobApplications.filters.interviewed': 'Interviewed',
    'jobApplications.filters.accepted': 'Accepted',
    'jobApplications.filters.rejected': 'Rejected',
    'jobApplications.table.name': 'Name',
    'jobApplications.table.position': 'Position',
    'jobApplications.table.experience': 'Experience',
    'jobApplications.table.location': 'Location',
    'jobApplications.table.status': 'Status',
    'jobApplications.table.appliedAt': 'Applied At',
    'jobApplications.table.actions': 'Actions',
    'jobApplications.status.pending': 'Pending',
    'jobApplications.status.reviewed': 'Reviewed',
    'jobApplications.status.interviewed': 'Interviewed',
    'jobApplications.status.accepted': 'Accepted',
    'jobApplications.status.rejected': 'Rejected',
    'jobApplications.viewApplication': 'View Application',
    'jobApplications.coverLetter': 'Cover Letter',
    
    // Subscriptions
    'subscriptions.totalSubscribers': 'Total Subscribers',
    'subscriptions.activeSubscribers': 'Active Subscribers',
    'subscriptions.openRate': 'Open Rate',
    'subscriptions.clickRate': 'Click Rate',
    'subscriptions.filters.allStatus': 'All Status',
    'subscriptions.filters.active': 'Active',
    'subscriptions.filters.unsubscribed': 'Unsubscribed',
    'subscriptions.filters.pending': 'Pending',
    'subscriptions.filters.allSources': 'All Sources',
    'subscriptions.filters.website': 'Website',
    'subscriptions.filters.social': 'Social',
    'subscriptions.filters.referral': 'Referral',
    'subscriptions.table.email': 'Email',
    'subscriptions.table.name': 'Name',
    'subscriptions.table.company': 'Company',
    'subscriptions.table.status': 'Status',
    'subscriptions.table.source': 'Source',
    'subscriptions.table.subscribedAt': 'Subscribed At',
    'subscriptions.table.actions': 'Actions',
    'subscriptions.status.active': 'Active',
    'subscriptions.status.unsubscribed': 'Unsubscribed',
    'subscriptions.status.pending': 'Pending',
    'subscriptions.source.website': 'Website',
    'subscriptions.source.social': 'Social',
    'subscriptions.source.referral': 'Referral',
    'subscriptions.unsubscribedSubscribers': 'Unsubscribed',
    'subscriptions.pendingSubscribers': 'Pending',
    'subscriptions.title': 'Subscribers',
    'subscriptions.searchPlaceholder': 'Search subscribers...',
    'subscriptions.export': 'Export',
    'subscriptions.sendNewsletter': 'Send Newsletter',
    'subscriptions.viewSubscriber': 'View Subscriber',
    'subscriptions.deleteSubscriber': 'Delete Subscriber',
    'subscriptions.deleteConfirmation': 'Are you sure you want to delete {name}?',
    'subscriptions.sendToAll': 'Send Email to All',
    'subscriptions.sendToSubscriber': 'Send Email to Subscriber',
    'subscriptions.emailSubject': 'Email Subject',
    'subscriptions.emailMessage': 'Email Message',
    'subscriptions.sendEmail': 'Send Email',
    
    // Blog
    'blog.totalPosts': 'Total Posts',
    'blog.publishedPosts': 'Published Posts',
    'blog.totalViews': 'Total Views',
    'blog.totalComments': 'Total Comments',
    'blog.export': 'Export',
    'blog.newPost': 'New Post',
    'blog.filters.published': 'Published',
    'blog.filters.draft': 'Draft',
    'blog.filters.archived': 'Archived',
    'blog.filters.allCategories': 'All Categories',
    'blog.filters.company': 'Company',
    'blog.table.title': 'Title',
    'blog.table.featuredImage': 'Featured Image',
    'blog.tags.label': 'Tags',
    'blog.filters.allTags': 'All Tags',
    'blog.filters.clearAll': 'Clear All',
    'blog.filters.active': 'Active filters:',
    'blog.filters.category': 'Category:',
    'blog.filters.tag': 'Tag:',
    'blog.filters.date': 'Date:',
    'blog.filters.search': 'Search:',
    'blog.table.author': 'Author',
    'blog.table.category': 'Category',
    'blog.table.status': 'Status',
    'blog.table.views': 'Views',
    'blog.table.publishedAt': 'Published At',
    'blog.table.actions': 'Actions',
    'blog.viewPost': 'View Blog Post',
    'blog.deletePost': 'Delete Blog Post',
    'blog.deleteConfirmation': 'Are you sure you want to delete "{title}"?',
    'blog.deleteWarning': 'This action cannot be undone.',
    'blog.excerpt': 'Excerpt',
    'blog.content': 'Content',
    'blog.tags': 'Tags',
    
    // PageViews
    'pageViews.totalViews': 'Total Views',
    'pageViews.uniqueVisitors': 'Unique Visitors',
    'pageViews.avgSessionDuration': 'Avg Session Duration',
    'pageViews.bounceRate': 'Bounce Rate',
    'pageViews.title': 'Page Views Analytics',
    'pageViews.export': 'Export',
    'pageViews.refresh': 'Refresh',
    'pageViews.searchPlaceholder': 'Search pages...',
    'pageViews.last7Days': 'Last 7 Days',
    'pageViews.last30Days': 'Last 30 Days',
    'pageViews.last90Days': 'Last 90 Days',
    'pageViews.lastYear': 'Last Year',
    'pageViews.table.page': 'Page',
    'pageViews.table.views': 'Views',
    'pageViews.table.uniqueViews': 'Unique Views',
    'pageViews.table.avgTime': 'Avg Time',
    'pageViews.table.bounceRate': 'Bounce Rate',
    'pageViews.table.lastViewed': 'Last Viewed',
    'admin.searchPages': 'Search pages...',
    'admin.noResultsFound': 'No results found',

    // Dashboard specific translations
    'dashboard.totalProjects': 'Total Projects',
    'dashboard.formSubmissions': 'Form Submissions',
    'dashboard.jobApplications': 'Job Applications',
    'dashboard.newsletterSubscribers': 'Newsletter Subscribers',
    'dashboard.blogPosts': 'Blog Posts',
    'dashboard.pageViews': 'Page Views',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.recentActivities': 'Recent Activities',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.fromLastMonth': 'from last month',
    'dashboard.noRecentActivities': 'No recent activities',
    'dashboard.timePeriods.day': 'Last Day',
    'dashboard.timePeriods.week': 'Last Week',
    'dashboard.timePeriods.month': 'Last Month',
    'dashboard.timePeriods.6months': 'Last 6 Months',
    'dashboard.timePeriods.year': 'Last Year',
    'dashboard.selectTimePeriod': 'Select Time Period',
    'dashboard.newProject': 'New Project',
    'dashboard.createProject': 'Create a new project',
    'dashboard.viewReports': 'View Reports',
    'dashboard.analyticsReports': 'View analytics and reports',
    'dashboard.manageUsers': 'Manage Users',
    'dashboard.userManagement': 'User management tools',
    'dashboard.systemSettings': 'System Settings',
    'dashboard.configureSystem': 'Configure system settings',

    // Recent Activity translations
    'activity.newProjectCreated': 'New project created',
    'activity.formSubmitted': 'New form submission received',
    'activity.jobApplication': 'New job application received',
    'activity.newsletterSubscription': 'New newsletter subscription',
    'activity.timeAgo': 'ago',
    'activity.hoursAgo': 'hours ago',
    'activity.smartOfficeProject': 'New project "Smart Office Complex" added',
    'activity.contactFormSubmission': 'Contact form submission from John Doe',
    'activity.civilEngineerApplication': 'Job application for Civil Engineer position',

    // Projects page translations
    'projects.title': 'Projects Management',
    'projects.subtitle': 'Create, edit, and manage your construction projects',
    'projects.newProject': 'New Project',
    'projects.searchPlaceholder': 'Search projects...',
    'projects.filterAll': 'All Projects',
    'projects.filterActive': 'Active',
    'projects.filterCompleted': 'Completed',
    'projects.filterPlanning': 'Planning',
    'projects.sectorAll': 'All Sectors',
    'projects.sectorCommercial': 'Commercial',
    'projects.sectorResidential': 'Residential',
    'projects.sectorInfrastructure': 'Infrastructure',
    'projects.projectName': 'Project Name',
    'projects.location': 'Location',
    'projects.status': 'Status',
    'projects.sector': 'Sector',
    'projects.budget': 'Budget',
    'projects.startDate': 'Start Date',
    'projects.endDate': 'End Date',
    'projects.actions': 'Actions',
    'projects.delete': 'Delete',
    'projects.customer': 'Customer',
    'projects.deleteProject': 'Delete Project',
    'projects.deleteConfirm': 'Are you sure you want to delete "{projectName}"? This action cannot be undone.',
    'projects.noProjects': 'No projects found',
    'projects.loading': 'Loading projects...',
    'projects.pagination.showing': 'Showing',
    'projects.pagination.of': 'of',
    'projects.pagination.projects': 'projects',
    'projects.pagination.page': 'Page',


    // Job Applications page translations
    'jobApplications.title': 'Job Applications',
    'jobApplications.subtitle': 'Manage and review job applications',
    'jobApplications.totalApplications': 'Total Applications',
    'jobApplications.interview': 'Interview',
    'jobApplications.rejected': 'Rejected',
    'jobApplications.pending': 'Pending',
    'jobApplications.export': 'Export',
    'jobApplications.new': 'New',
    'jobApplications.interviews': 'Interviews',
    'jobApplications.reviewed': 'Reviewed',
    'jobApplications.searchPlaceholder': 'Search applications...',
    'jobApplications.allPositions': 'All Positions',
    'jobApplications.positionCivil': 'Civil Engineer',
    'jobApplications.positionMEP': 'MEP Engineer',
    'jobApplications.positionProject': 'Project Manager',
    'jobApplications.positionArchitect': 'Architect',
    'jobApplications.allStatus': 'All Status',
    'jobApplications.statusNew': 'New',
    'jobApplications.statusReviewed': 'Reviewed',
    'jobApplications.statusInterviewScheduled': 'Interview Scheduled',
    'jobApplications.statusInterviewed': 'Interviewed',
    'jobApplications.statusAccepted': 'Accepted',
    'jobApplications.statusRejected': 'Rejected',
    'jobApplications.clearFilters': 'Clear Filters',
    'jobApplications.candidate': 'Candidate',
    'jobApplications.position': 'Position',
    'jobApplications.experience': 'Experience',
    'jobApplications.location': 'Location',
    'jobApplications.status': 'Status',
    'jobApplications.applied': 'Applied',
    'jobApplications.actions': 'Actions',
    'jobApplications.expected': 'Expected',
    'jobApplications.noResults': 'No applications found',
    'jobApplications.noResultsMessage': 'Try adjusting your search or filters',
    'jobApplications.applicationDetails': 'Application Details',
    'jobApplications.fullName': 'Full Name',
    'jobApplications.positionApplied': 'Position Applied',
    'jobApplications.email': 'Email',
    'jobApplications.phone': 'Phone',
    'jobApplications.availability': 'Availability',
    'jobApplications.education': 'Education',

    // Admin Blog page translations
    'adminBlog.title': 'Blog Posts Management',
    'adminBlog.subtitle': 'Create, edit, and manage your blog content',
    'adminBlog.export': 'Export',
    'adminBlog.newPost': 'New Post',
    'adminBlog.totalPosts': 'Total Posts',
    'adminBlog.published': 'Published',
    'adminBlog.drafts': 'Drafts',
    'adminBlog.totalViews': 'Total Views',
    'adminBlog.searchPlaceholder': 'Search blog posts...',
    'adminBlog.allStatus': 'All Status',
    'adminBlog.statusPublished': 'Published',
    'adminBlog.statusDraft': 'Draft',
    'adminBlog.statusScheduled': 'Scheduled',
    'adminBlog.statusArchived': 'Archived',
    'adminBlog.allCategories': 'All Categories',
    'adminBlog.categoryTechnology': 'Technology',
    'adminBlog.categoryEngineering': 'Engineering',
    'adminBlog.categorySustainability': 'Sustainability',
    'adminBlog.categorySafety': 'Safety',
    'adminBlog.clearFilters': 'Clear Filters',
    'adminBlog.post': 'Post',
    'adminBlog.author': 'Author',
    'adminBlog.category': 'Category',
    'adminBlog.status': 'Status',
    'adminBlog.engagement': 'Engagement',
    'adminBlog.actions': 'Actions',
    'adminBlog.more': 'more',
    'adminBlog.notPublished': 'Not published',
    'adminBlog.draft': 'Draft',
    'adminBlog.noResults': 'No blog posts found',
    'adminBlog.noResultsMessage': 'Try adjusting your search or filters',
    'adminBlog.createFirstPost': 'Create Your First Post',
    'adminBlog.deletePost': 'Delete Blog Post',
    'adminBlog.deleteConfirm': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
    'adminBlog.delete': 'Delete',
    'pageViews.noResults': 'No page views found',
    'pageViews.noResultsMessage': 'Try adjusting your search or date range',

    // Admin Documents page translations
    'adminDocuments.title': 'Documents Management',
    'adminDocuments.subtitle': 'Upload, organize, and manage your documents',
    'adminDocuments.exportList': 'Export List',
    'adminDocuments.uploadDocument': 'Upload Document',
    'adminDocuments.totalDocuments': 'Total Documents',
    'adminDocuments.pdfFiles': 'PDF Files',
    'adminDocuments.totalDownloads': 'Total Downloads',
    'adminDocuments.publicFiles': 'Public Files',
    'adminDocuments.searchDocuments': 'Search documents...',
    'adminDocuments.allTypes': 'All Types',
    'adminDocuments.typePdf': 'PDF',
    'adminDocuments.typeWord': 'Word',
    'adminDocuments.typeExcel': 'Excel',
    'adminDocuments.typeImage': 'Image',
    'adminDocuments.typeArchive': 'Archive',
    'adminDocuments.allCategories': 'All Categories',
    'adminDocuments.categoryCompany': 'Company Documents',
    'adminDocuments.categoryProject': 'Project Documents',
    'adminDocuments.categorySafety': 'Safety Documents',
    'adminDocuments.categoryTechnical': 'Technical Documents',
    'adminDocuments.categoryFinancial': 'Financial Documents',
    'adminDocuments.table.name': 'Name',
    'adminDocuments.table.type': 'Type',
    'adminDocuments.table.category': 'Category',
    'adminDocuments.table.size': 'Size',
    'adminDocuments.table.downloads': 'Downloads',
    'adminDocuments.table.status': 'Status',
    'adminDocuments.table.actions': 'Actions',
    'adminDocuments.statusPublic': 'Public',
    'adminDocuments.statusPrivate': 'Private',
    
    // Vendors
    'vendors.title': 'Vendors Management',
    'vendors.subtitle': 'Manage vendor relationships and partnerships',
    'vendors.totalVendors': 'Total Vendors',
    'vendors.activeVendors': 'Active Vendors',
    'vendors.pendingVendors': 'Pending Vendors',
    'vendors.avgRating': 'Average Rating',
    'vendors.export': 'Export',
    'vendors.addVendor': 'Add Vendor',
    'vendors.searchPlaceholder': 'Search vendors...',
    'vendors.filters.all': 'All',
    'vendors.filters.allCategories': 'All Categories',
    'vendors.status.active': 'Active',
    'vendors.status.pending': 'Pending',
    'vendors.status.inactive': 'Inactive',
    'vendors.category.construction': 'Construction',
    'vendors.category.technology': 'Technology',
    'vendors.category.sustainability': 'Sustainability',
    'vendors.category.safety': 'Safety',
    'vendors.category.office': 'Office',
    'vendors.table.name': 'Name',
    'vendors.table.category': 'Category',
    'vendors.table.contact': 'Contact',
    'vendors.table.rating': 'Rating',
    'vendors.table.projects': 'Projects',
    'vendors.table.status': 'Status',
    'vendors.table.actions': 'Actions',
    
    // Clients
    'clients.title': 'Clients Management',
    'clients.subtitle': 'Manage client relationships and project portfolios',
    'clients.totalClients': 'Total Clients',
    'clients.activeClients': 'Active Clients',
    'clients.totalValue': 'Total Value',
    'clients.avgProjectValue': 'Avg Project Value',
    'clients.export': 'Export',
    'clients.addClient': 'Add Client',
    'clients.searchPlaceholder': 'Search clients...',
    'clients.filters.all': 'All',
    'clients.filters.allTypes': 'All Types',
    'clients.status.active': 'Active',
    'clients.status.pending': 'Pending',
    'clients.status.inactive': 'Inactive',
    'clients.type.corporate': 'Corporate',
    'clients.type.construction': 'Construction',
    'clients.type.energy': 'Energy',
    'clients.type.technology': 'Technology',
    'clients.type.smallBusiness': 'Small Business',
    'clients.table.name': 'Name',
    'clients.table.type': 'Type',
    'clients.table.contact': 'Contact',
    'clients.table.projects': 'Projects',
    'clients.table.value': 'Value',
    'clients.table.status': 'Status',
    'clients.table.actions': 'Actions',
    
    // Users
    'users.title': 'Users Management',
    'users.subtitle': 'Manage user accounts and permissions',
    'users.totalUsers': 'Total Users',
    'users.activeUsers': 'Active Users',
    'users.adminUsers': 'Admin Users',
    'users.pendingUsers': 'Pending Users',
    'users.export': 'Export',
    'users.addUser': 'Add User',
    'users.searchPlaceholder': 'Search users...',
    'users.filters.allRoles': 'All Roles',
    'users.filters.allStatuses': 'All Statuses',
    'users.status.active': 'Active',
    'users.status.pending': 'Pending',
    'users.status.inactive': 'Inactive',
    'users.role.admin': 'Admin',
    'users.role.manager': 'Manager',
    'users.role.employee': 'Employee',
    'users.table.name': 'Name',
    'users.table.role': 'Role',
    'users.table.department': 'Department',
    'users.table.lastLogin': 'Last Login',
    'users.table.status': 'Status',
    'users.table.actions': 'Actions',
    'users.never': 'Never',
    
    // Settings
    'settings.title': 'System Settings',
    'settings.subtitle': 'Configure system preferences and options',
    'settings.save': 'Save Changes',
    'settings.reset': 'Reset to Default',
    'settings.tabs.general': 'General',
    'settings.tabs.notifications': 'Notifications',
    'settings.tabs.security': 'Security',
    'settings.tabs.system': 'System',
    'settings.general.title': 'General Settings',
    'settings.general.siteName': 'Site Name',
    'settings.general.siteDescription': 'Site Description',
    'settings.general.siteUrl': 'Site URL',
    'settings.general.adminEmail': 'Admin Email',
    'settings.general.timezone': 'Timezone',
    'settings.notifications.title': 'Notification Settings',
    'settings.notifications.emailNotifications': 'Email Notifications',
    'settings.notifications.smsNotifications': 'SMS Notifications',
    'settings.notifications.pushNotifications': 'Push Notifications',
    'settings.notifications.newSubmissions': 'New Submissions',
    'settings.notifications.newJobApplications': 'New Job Applications',
    'settings.notifications.newBlogComments': 'New Blog Comments',
    'settings.notifications.systemAlerts': 'System Alerts',
    'settings.notifications.weeklyReports': 'Weekly Reports',
    'settings.security.title': 'Security Settings',
    'settings.security.twoFactorAuth': 'Two-Factor Authentication',
    'settings.security.sessionTimeout': 'Session Timeout (minutes)',
    'settings.security.passwordExpiry': 'Password Expiry (days)',
    'settings.security.loginAttempts': 'Max Login Attempts',
    'settings.security.ipWhitelist': 'IP Whitelist',
    'settings.security.sslEnabled': 'SSL Enabled',
    'settings.security.backupEnabled': 'Backup Enabled',
    'settings.security.backupFrequency': 'Backup Frequency',
    'settings.system.title': 'System Settings',
    'settings.system.maintenanceMode': 'Maintenance Mode',
    'settings.system.debugMode': 'Debug Mode',
    'settings.system.cacheEnabled': 'Cache Enabled',
    'settings.system.compressionEnabled': 'Compression Enabled',
    'settings.system.maxUploadSize': 'Max Upload Size (MB)',
    'settings.system.allowedFileTypes': 'Allowed File Types',
    'settings.system.apiRateLimit': 'API Rate Limit',
    'settings.system.logRetention': 'Log Retention (days)',
    'settings.successMessage': 'Settings saved successfully!',
    'settings.confirmReset': 'Confirm Reset',
    'settings.resetConfirmMessage': 'Are you sure you want to reset all settings to their default values? This action cannot be undone.',
    'settings.resetSettings': 'Reset Settings',
    'settings.cancel': 'Cancel',
    'settings.siteInformation': 'Site Information',
    'settings.seoSettings': 'SEO Settings',
    'settings.metaKeywords': 'Meta Keywords',
    'settings.metaDescription': 'Meta Description',
    'settings.notificationChannels': 'Notification Channels',
    'settings.notificationTypes': 'Notification Types',
    'settings.receiveNotificationsViaEmail': 'Receive notifications via email',
    'settings.browserPushNotifications': 'Browser push notifications',
    'settings.smsNotificationsPremium': 'SMS notifications (Premium)',
    'settings.monthlyReports': 'Monthly Reports',
    'settings.maintenanceAlerts': 'Maintenance Alerts',
    'settings.securityAlerts': 'Security Alerts',
    'settings.authenticationAccess': 'Authentication & Access',
    'settings.extraSecurityLayer': 'Extra security layer',
    'settings.autoLogoutAfterInactivity': 'Auto logout after inactivity',
    'settings.maxFailedAttemptsBeforeLockout': 'Max failed attempts before lockout',
    'settings.passwordExpiresAfterDays': 'Password expires after days',
    'settings.systemSecurity': 'System Security',
    'settings.passwordComplexity': 'Password Complexity',
    'settings.autoLogout': 'Auto Logout',
    'settings.auditLogging': 'Audit Logging',
    'settings.systemStatus': 'System Status',
    'settings.systemConfiguration': 'System Configuration',
    'settings.autoBackup': 'Auto Backup',
    'settings.performanceMonitoring': 'Performance Monitoring',
    'settings.errorReporting': 'Error Reporting',
    'adminDocuments.categoryMedia': 'Media Files',
    'adminDocuments.clearFilters': 'Clear Filters',
    'adminDocuments.document': 'Document',
    'adminDocuments.type': 'Type',
    'adminDocuments.size': 'Size',
    'adminDocuments.category': 'Category',
    'adminDocuments.uploadedBy': 'Uploaded By',
    'adminDocuments.downloads': 'Downloads',
    'adminDocuments.visibility': 'Visibility',
    'adminDocuments.actions': 'Actions',
    'adminDocuments.more': 'more',
    'adminDocuments.public': 'Public',
    'adminDocuments.private': 'Private',
    'adminDocuments.download': 'Download',
    'adminDocuments.share': 'Share',
    'adminDocuments.edit': 'Edit',
    'adminDocuments.delete': 'Delete',
    'adminDocuments.noResults': 'No documents found',
    'adminDocuments.noResultsMessage': 'Try adjusting your search or filters',
    'adminDocuments.uploadFirstDocument': 'Upload Your First Document',
    'adminDocuments.selectFile': 'Select File',
    'adminDocuments.dragAndDrop': 'Drag and drop files here, or click to browse',
    'adminDocuments.chooseFiles': 'Choose Files',
    'adminDocuments.selectCategory': 'Select Category',
    'adminDocuments.description': 'Description',
    'adminDocuments.descriptionPlaceholder': 'Brief description of the document',
    'adminDocuments.makePublic': 'Make this document public',
    'adminDocuments.upload': 'Upload',
    'adminDocuments.deleteDocument': 'Delete Document',
    'adminDocuments.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone.',

    // Admin Vendors page translations
    'adminVendors.title': 'Vendors Management',
    'adminVendors.subtitle': 'Manage your vendor network and supplier relationships',
    'adminVendors.export': 'Export',
    'adminVendors.addVendor': 'Add Vendor',
    'adminVendors.totalVendors': 'Total Vendors',
    'adminVendors.active': 'Active',
    'adminVendors.pending': 'Pending',
    'adminVendors.avgRating': 'Avg. Rating',
    'adminVendors.searchVendors': 'Search vendors...',
    'adminVendors.allStatus': 'All Status',
    'adminVendors.statusActive': 'Active',
    'adminVendors.statusPending': 'Pending',
    'adminVendors.statusInactive': 'Inactive',
    'adminVendors.statusSuspended': 'Suspended',
    'adminVendors.allCategories': 'All Categories',
    'adminVendors.categoryConstruction': 'Construction Materials',
    'adminVendors.categoryEngineering': 'Engineering Services',
    'adminVendors.categorySteel': 'Steel & Metal Works',
    'adminVendors.categoryGreen': 'Green Technology',
    'adminVendors.categoryLogistics': 'Logistics & Transportation',
    'adminVendors.clearFilters': 'Clear Filters',
    'adminVendors.vendor': 'Vendor',
    'adminVendors.contact': 'Contact',
    'adminVendors.category': 'Category',
    'adminVendors.status': 'Status',
    'adminVendors.rating': 'Rating',
    'adminVendors.projects': 'Projects',
    'adminVendors.joined': 'Joined',
    'adminVendors.actions': 'Actions',
    'adminVendors.noResults': 'No vendors found',
    'adminVendors.noResultsMessage': 'Try adjusting your search or filters',
    'adminVendors.addFirstVendor': 'Add Your First Vendor',
    'adminVendors.deleteVendor': 'Delete Vendor',
    'adminVendors.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
    'adminVendors.delete': 'Delete',

    // Admin Clients page translations
    'adminClients.title': 'Clients Management',
    'adminClients.subtitle': 'Manage your client relationships and project portfolio',
    'adminClients.export': 'Export',
    'adminClients.addClient': 'Add Client',
    'adminClients.totalClients': 'Total Clients',
    'adminClients.active': 'Active',
    'adminClients.totalValue': 'Total Value',
    'adminClients.totalProjects': 'Total Projects',
    'adminClients.searchPlaceholder': 'Search clients...',
    'adminClients.allStatus': 'All Status',
    'adminClients.statusActive': 'Active',
    'adminClients.statusPending': 'Pending',
    'adminClients.statusInactive': 'Inactive',
    'adminClients.statusSuspended': 'Suspended',
    'adminClients.allTypes': 'All Types',
    'adminClients.typeGovernment': 'Government',
    'adminClients.typePrivate': 'Private',
    'adminClients.clearFilters': 'Clear Filters',
    'adminClients.client': 'Client',
    'adminClients.contact': 'Contact',
    'adminClients.type': 'Type',
    'adminClients.status': 'Status',
    'adminClients.projects': 'Projects',
    'adminClients.joined': 'Joined',
    'adminClients.actions': 'Actions',
    'adminClients.last': 'Last',
    'adminClients.noResults': 'No clients found',
    'adminClients.noResultsMessage': 'Try adjusting your search or filters',
    'adminClients.addFirstClient': 'Add Your First Client',
    'adminClients.deleteClient': 'Delete Client',
    'adminClients.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
    'adminClients.delete': 'Delete',

    // Admin Users page translations
    'adminUsers.title': 'Users Management',
    'adminUsers.subtitle': 'Manage admin users and their permissions',
    'adminUsers.export': 'Export',
    'adminUsers.addUser': 'Add User',
    'adminUsers.totalUsers': 'Total Users',
    'adminUsers.active': 'Active',
    'adminUsers.admins': 'Admins',
    'adminUsers.pending': 'Pending',
    'adminUsers.searchPlaceholder': 'Search users...',
    'adminUsers.allRoles': 'All Roles',
    'adminUsers.roleSuperAdmin': 'Super Admin',
    'adminUsers.roleAdmin': 'Admin',
    'adminUsers.roleEditor': 'Editor',
    'adminUsers.roleViewer': 'Viewer',
    'adminUsers.allStatus': 'All Status',
    'adminUsers.statusActive': 'Active',
    'adminUsers.statusInactive': 'Inactive',
    'adminUsers.statusPending': 'Pending',
    'adminUsers.statusSuspended': 'Suspended',
    'adminUsers.clearFilters': 'Clear Filters',
    'adminUsers.user': 'User',
    'adminUsers.role': 'Role',
    'adminUsers.status': 'Status',
    'adminUsers.department': 'Department',
    'adminUsers.lastLogin': 'Last Login',
    'adminUsers.created': 'Created',
    'adminUsers.actions': 'Actions',
    'adminUsers.never': 'Never',
    'adminUsers.noResults': 'No users found',
    'adminUsers.noResultsMessage': 'Try adjusting your search or filters',
    'adminUsers.addFirstUser': 'Add Your First User',
    'adminUsers.deleteUser': 'Delete User',
    'adminUsers.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
    'adminUsers.delete': 'Delete',
    'adminUsers.resetPassword': 'Reset Password',
    'adminUsers.newPassword': 'New Password',
    'adminUsers.enterNewPassword': 'Enter new password',
    'adminUsers.confirmPassword': 'Confirm Password',
    'adminUsers.confirmNewPassword': 'Confirm new password',

    // Admin Settings page translations
    'adminSettings.title': 'System Settings',
    'adminSettings.subtitle': 'Configure your admin panel and system preferences',
    'adminSettings.resetToDefault': 'Reset to Default',
    'adminSettings.saveChanges': 'Save Changes',
    'adminSettings.settings': 'Settings',
    'adminSettings.tabGeneral': 'General',
    'adminSettings.tabNotifications': 'Notifications',
    'adminSettings.tabSecurity': 'Security',
    'adminSettings.tabEmail': 'Email',
    'adminSettings.tabBackup': 'Backup',
    'adminSettings.generalSettings': 'General Settings',
    'adminSettings.siteName': 'Site Name',
    'adminSettings.siteUrl': 'Site URL',
    'adminSettings.siteDescription': 'Site Description',
    'adminSettings.adminEmail': 'Admin Email',
    'adminSettings.timezone': 'Timezone',
    'adminSettings.language': 'Language',
    'adminSettings.dateFormat': 'Date Format',
    'adminSettings.notificationSettings': 'Notification Settings',
    'adminSettings.emailNotifications': 'Email Notifications',
    'adminSettings.smsNotifications': 'SMS Notifications',
    'adminSettings.pushNotifications': 'Push Notifications',
    'adminSettings.newSubmissions': 'New Submissions',
    'adminSettings.newJobApplications': 'New Job Applications',
    'adminSettings.weeklyReports': 'Weekly Reports',
    'adminSettings.securitySettings': 'Security Settings',
    'adminSettings.twoFactorAuth': 'Two-Factor Authentication',
    'adminSettings.sessionTimeout': 'Session Timeout (minutes)',
    'adminSettings.passwordExpiry': 'Password Expiry (days)',
    'adminSettings.maxLoginAttempts': 'Max Login Attempts',
    'adminSettings.backupFrequency': 'Backup Frequency',
    'adminSettings.ipWhitelist': 'IP Whitelist',
    'adminSettings.emailConfiguration': 'Email Configuration',
    'adminSettings.smtpHost': 'SMTP Host',
    'adminSettings.smtpPort': 'SMTP Port',
    'adminSettings.smtpUsername': 'SMTP Username',
    'adminSettings.smtpPassword': 'SMTP Password',
    'adminSettings.fromName': 'From Name',
    'adminSettings.fromEmail': 'From Email',
    'adminSettings.backupSettings': 'Backup Settings',
    'adminSettings.automaticBackup': 'Automatic Backup',
    'adminSettings.backupLocation': 'Backup Location',
    'adminSettings.retentionDays': 'Retention Days',
    'adminSettings.includeMediaFiles': 'Include Media Files',
    'adminSettings.includeDatabase': 'Include Database',
    'adminSettings.lastBackup': 'Last Backup',
    'adminSettings.placeholderSiteName': 'Enter site name',
    'adminSettings.placeholderSiteUrl': 'Enter site URL',
    'adminSettings.placeholderSiteDescription': 'Enter site description',
    'adminSettings.placeholderAdminEmail': 'Enter admin email',
    'adminSettings.placeholderSmtpHost': 'Enter SMTP host',
    'adminSettings.placeholderSmtpPort': 'Enter SMTP port',
    'adminSettings.placeholderSmtpUsername': 'Enter SMTP username',
    'adminSettings.placeholderSmtpPassword': 'Enter SMTP password',
    'adminSettings.placeholderFromName': 'Enter sender name',
    'adminSettings.placeholderFromEmail': 'Enter sender email',
    'adminSettings.placeholderIpWhitelist': 'Enter IP addresses separated by commas',
    'adminSettings.receiveNotificationsViaEmail': 'Receive notifications via email',
    'adminSettings.receiveNotificationsViaSms': 'Receive notifications via SMS',
    'adminSettings.receiveBrowserPushNotifications': 'Receive browser push notifications',
    'adminSettings.notifyWhenNewFormSubmissions': 'Notify when new form submissions are received',
    'adminSettings.notifyWhenNewJobApplications': 'Notify when new job applications are submitted',
    'adminSettings.receiveWeeklySummaryReports': 'Receive weekly summary reports',
    'adminSettings.addExtraLayerOfSecurity': 'Add an extra layer of security to your account',
    'adminSettings.enableAutomaticSystemBackups': 'Enable automatic system backups',
    'adminSettings.includeUploadedImagesAndDocuments': 'Include uploaded images and documents in backup',
    'adminSettings.includeDatabaseInBackup': 'Include database in backup',


    // Subscribe section
    'subscribe.title': 'Stay Updated',
    'subscribe.subtitle': 'Subscribe to our newsletter for the latest projects, insights, and company news.',
    'subscribe.placeholder': 'Enter your email address',
    'subscribe.button': 'Subscribe',
    'subscribe.success': 'Thanks for subscribing! Please check your inbox.',
    'subscribe.error': 'Please enter a valid email address.',
    
    // Navigation dropdown items
    'nav.aboutUs': 'About Us',
    'nav.organizationChart': 'Organization Chart',
    'nav.csr': 'CSR',
    'nav.codeOfEthics': 'Code of Ethics',
    'nav.hse': 'HSE',
    'nav.qualityManagement': 'Quality Management',
    
    // CSR Page
    'csr.title': 'Corporate Social Responsibility',
    'csr.subtitle': 'Building a better future through responsible construction and community engagement',
    'csr.communityFirst': 'Community First',
    'csr.sustainableFuture': 'Sustainable Future',
    'csr.peopleCentered': 'People Centered',
    'csr.mission': 'Our Mission',
    'csr.missionText': 'To create lasting positive impact in the communities we serve through responsible construction practices, environmental stewardship, and meaningful social engagement that builds a sustainable future for all.',
    'csr.coreValues': 'Core Values',
    'csr.integrity': 'Integrity in all our operations',
    'csr.respect': 'Respect for communities and environment',
    'csr.innovation': 'Innovation in sustainable practices',
    'csr.collaboration': 'Collaboration with stakeholders',
    'csr.vision': 'Our Vision',
    'csr.visionText': 'To be the leading construction company that sets the standard for corporate social responsibility, creating a legacy of positive change that extends far beyond our construction projects.',
    'csr.impactGoals': 'Impact Goals',
    'csr.zeroHarm': 'Zero environmental harm by 2030',
    'csr.communityEngagement': '100% community engagement in projects',
    'csr.educationalSupport': 'Educational support for 10,000+ students',
    'csr.safetyStandards': 'Industry-leading safety standards',
    'csr.impactNumbers': 'Our Impact in Numbers',
    'csr.impactSubtitle': 'Measuring our commitment to corporate social responsibility through tangible results',
    'csr.communityProjects': 'Community Projects',
    'csr.studentsSupported': 'Students Supported',
    'csr.greenCertifications': 'Green Certifications',
    'csr.safetyRecord': 'Safety Record',
    'csr.initiatives': 'Our CSR Initiatives',
    'csr.initiativesSubtitle': 'Four pillars of our corporate social responsibility program',
    'csr.communityDevelopment': 'Community Development',
    'csr.communityDescription': 'Supporting local communities through infrastructure development and social programs.',
    'csr.environmentalSustainability': 'Environmental Sustainability',
    'csr.environmentalDescription': 'Committed to sustainable construction practices and environmental protection.',
    'csr.educationTraining': 'Education & Training',
    'csr.educationDescription': 'Investing in education and skill development for future generations.',
    'csr.safetyHealth': 'Safety & Health',
    'csr.safetyDescription': 'Ensuring the highest standards of safety and health for all stakeholders.',
    'csr.keyInitiatives': 'Key Initiatives:',
    'csr.educationalInfrastructure': 'Educational infrastructure support',
    'csr.healthcareFacility': 'Healthcare facility development',
    'csr.communityCenter': 'Community center construction',
    'csr.youthDevelopment': 'Youth development programs',
    'csr.greenBuilding': 'Green building certifications',
    'csr.wasteReduction': 'Waste reduction programs',
    'csr.renewableEnergy': 'Renewable energy integration',
    'csr.carbonFootprint': 'Carbon footprint reduction',
    'csr.scholarshipPrograms': 'Scholarship programs',
    'csr.technicalTraining': 'Technical training centers',
    'csr.internshipOpportunities': 'Internship opportunities',
    'csr.educationalMaterial': 'Educational material donations',
    'csr.workplaceSafety': 'Workplace safety programs',
    'csr.healthAwareness': 'Health awareness campaigns',
    'csr.emergencyResponse': 'Emergency response training',
    'csr.safetyEquipment': 'Safety equipment provision',
    'csr.joinUs': 'Join Us in Making a Difference',
    'csr.joinUsText': 'Together, we can build a better future for our communities and the environment. Contact us to learn more about our CSR programs and how you can get involved.',
    'csr.learnMore': 'Learn More About Us',
    'csr.partnerWithUs': 'Partner With Us',
    
    // Code of Ethics Page
    'ethics.title': 'Code of Ethics',
    'ethics.subtitle': 'Our commitment to integrity, transparency, and ethical business practices',
    'ethics.introduction': 'Introduction',
    'ethics.introductionText': 'Our Code of Ethics serves as the foundation for all our business activities and relationships. It reflects our commitment to conducting business with the highest standards of integrity, transparency, and respect for all stakeholders.',
    'ethics.corePrinciples': 'Core Principles',
    'ethics.integrity': 'Integrity',
    'ethics.integrityText': 'We conduct all business activities with honesty, fairness, and transparency.',
    'ethics.respect': 'Respect',
    'ethics.respectText': 'We treat all individuals with dignity and respect, valuing diversity and inclusion.',
    'ethics.accountability': 'Accountability',
    'ethics.accountabilityText': 'We take responsibility for our actions and decisions, ensuring transparency in all operations.',
    'ethics.excellence': 'Excellence',
    'ethics.excellenceText': 'We strive for the highest standards in everything we do, continuously improving our practices.',
    'ethics.businessConduct': 'Business Conduct',
    'ethics.businessConductText': 'Guidelines for ethical business practices and professional behavior',
    'ethics.conflictsOfInterest': 'Conflicts of Interest',
    'ethics.conflictsText': 'We avoid situations where personal interests conflict with company interests.',
    'ethics.fairCompetition': 'Fair Competition',
    'ethics.fairCompetitionText': 'We compete fairly and lawfully, respecting competitors and market regulations.',
    'ethics.confidentiality': 'Confidentiality',
    'ethics.confidentialityText': 'We protect confidential information and respect intellectual property rights.',
    'ethics.giftsEntertainment': 'Gifts & Entertainment',
    'ethics.giftsText': 'We maintain appropriate standards for gifts and entertainment in business relationships.',
    'ethics.stakeholderRelations': 'Stakeholder Relations',
    'ethics.stakeholderText': 'Our commitment to ethical relationships with all stakeholders',
    'ethics.customers': 'Customers',
    'ethics.customersText': 'We provide quality services and maintain honest communication with our clients.',
    'ethics.employees': 'Employees',
    'ethics.employeesText': 'We create a safe, inclusive, and respectful workplace for all employees.',
    'ethics.suppliers': 'Suppliers',
    'ethics.suppliersText': 'We work with suppliers who share our ethical standards and values.',
    'ethics.community': 'Community',
    'ethics.communityText': 'We contribute positively to the communities where we operate.',
    'ethics.compliance': 'Compliance & Reporting',
    'ethics.complianceText': 'Our commitment to legal compliance and ethical reporting',
    'ethics.legalCompliance': 'Legal Compliance',
    'ethics.legalText': 'We comply with all applicable laws and regulations in our operations.',
    'ethics.reportingViolations': 'Reporting Violations',
    'ethics.reportingText': 'We encourage reporting of ethical violations through confidential channels.',
    'ethics.whistleblowerProtection': 'Whistleblower Protection',
    'ethics.whistleblowerText': 'We protect individuals who report ethical violations from retaliation.',
    'ethics.continuousImprovement': 'Continuous Improvement',
    'ethics.improvementText': 'We regularly review and update our ethical standards and practices.',
    
    // HSE Page
    'hse.title': 'Health, Safety & Environment',
    'hse.subtitle': 'Protecting people, communities, and the environment through comprehensive HSE management',
    'hse.commitment': 'Our HSE Commitment',
    'hse.commitmentText': 'We are committed to maintaining the highest standards of health, safety, and environmental protection in all our operations. Our HSE policies ensure the well-being of our employees, communities, and the environment.',
    'hse.zeroHarm': 'Zero Harm Policy',
    'hse.zeroHarmText': 'Our goal is to achieve zero harm to people and the environment through proactive risk management and continuous improvement.',
    'hse.healthManagement': 'Health Management',
    'hse.healthText': 'Comprehensive health programs and medical support for all employees and stakeholders.',
    'hse.safetyManagement': 'Safety Management',
    'hse.safetyText': 'Robust safety systems and procedures to prevent accidents and injuries.',
    'hse.environmentalManagement': 'Environmental Management',
    'hse.environmentalText': 'Sustainable practices and environmental protection measures in all operations.',
    'hse.hsePrograms': 'HSE Programs',
    'hse.programsText': 'Comprehensive programs covering all aspects of health, safety, and environment',
    'hse.occupationalHealth': 'Occupational Health',
    'hse.occupationalText': 'Regular health screenings, medical support, and wellness programs.',
    'hse.emergencyResponse': 'Emergency Response',
    'hse.emergencyText': 'Comprehensive emergency response plans and crisis management procedures.',
    'hse.environmentalProtection': 'Environmental Protection',
    'hse.protectionText': 'Waste management, pollution control, and sustainable resource utilization.',
    'hse.trainingEducation': 'Training & Education',
    'hse.trainingText': 'Continuous HSE training and awareness programs for all employees.',
    'hse.performanceMetrics': 'Performance Metrics',
    'hse.metricsText': 'Key performance indicators for HSE management',
    'hse.lostTimeInjuries': 'Lost Time Injuries',
    'hse.environmentalIncidents': 'Environmental Incidents',
    'hse.trainingHours': 'Training Hours',
    'hse.certifications': 'Certifications',
    'hse.certificationsText': 'Our HSE certifications and accreditations',
    'hse.iso45001': 'ISO 45001 - Occupational Health & Safety',
    'hse.iso14001': 'ISO 14001 - Environmental Management',
    'hse.ohsas18001': 'OHSAS 18001 - Safety Management',
    'hse.continuousImprovement': 'Continuous Improvement',
    'hse.improvementText': 'Regular audits, assessments, and improvement initiatives for HSE performance.',
    
    // Quality Management Page
    'quality.title': 'Quality Management',
    'quality.subtitle': 'Delivering excellence through systematic quality management and continuous improvement',
    'quality.commitment': 'Our Quality Commitment',
    'quality.commitmentText': 'We are committed to delivering the highest quality in all our projects and services. Our quality management system ensures consistent excellence and customer satisfaction.',
    'quality.qualityPolicy': 'Quality Policy',
    'quality.policyText': 'Our quality policy emphasizes customer satisfaction, continuous improvement, and adherence to international standards.',
    'quality.qualityObjectives': 'Quality Objectives',
    'quality.objectivesText': 'Clear objectives for quality performance and continuous improvement',
    'quality.customerSatisfaction': 'Customer Satisfaction',
    'quality.satisfactionText': 'Achieving 100% customer satisfaction through quality deliverables.',
    'quality.defectReduction': 'Defect Reduction',
    'quality.defectText': 'Reducing defects and rework through systematic quality control.',
    'quality.onTimeDelivery': 'On-Time Delivery',
    'quality.deliveryText': 'Completing all projects on schedule without compromising quality.',
    'quality.continuousImprovement': 'Continuous Improvement',
    'quality.improvementText': 'Regular review and enhancement of quality processes and procedures.',
    'quality.qualitySystem': 'Quality Management System',
    'quality.systemText': 'Comprehensive system covering all aspects of quality management',
    'quality.planning': 'Quality Planning',
    'quality.planningText': 'Detailed quality plans for each project and service delivery.',
    'quality.control': 'Quality Control',
    'quality.controlText': 'Systematic monitoring and control of quality throughout project execution.',
    'quality.assurance': 'Quality Assurance',
    'quality.assuranceText': 'Proactive measures to ensure quality standards are met.',
    'quality.improvement': 'Quality Improvement',
    'quality.standards': 'Quality Standards',
    'quality.standardsText': 'Adherence to international quality standards and best practices',
    'quality.iso9001': 'ISO 9001 - Quality Management System',
    'quality.iso14001': 'ISO 14001 - Environmental Management',
    'quality.ohsas18001': 'OHSAS 18001 - Occupational Health & Safety',
    'quality.processes': 'Quality Processes',
    'quality.processesText': 'Systematic processes for quality management',
    'quality.designReview': 'Design Review',
    'quality.designText': 'Comprehensive review of designs before implementation.',
    'quality.materialInspection': 'Material Inspection',
    'quality.materialText': 'Thorough inspection of all materials and components.',
    'quality.testing': 'Testing & Validation',
    'quality.testingText': 'Rigorous testing and validation of all deliverables.',
    'quality.documentation': 'Documentation',
    'quality.documentationText': 'Comprehensive documentation of all quality activities.',
    'quality.certifications': 'Quality Certifications',
    'quality.certificationsText': 'Our quality certifications and accreditations',
    'quality.audits': 'Quality Audits',
    'quality.auditsText': 'Regular internal and external audits to ensure compliance.',
    'quality.training': 'Quality Training',
    'quality.trainingText': 'Comprehensive training programs for quality management.',
    
    'nav.ourClients': 'Our Clients',
    'nav.ourVendors': 'Our Vendors',
    'nav.ourServices': 'Our Services',
    'nav.ourProjects': 'Our Projects',
    'nav.ongoingProjects': 'Ongoing Projects',
    'nav.completedProjects': 'Completed Projects',
    'nav.industriesSectors': 'Industries & Sectors',
    'nav.news': 'News',
    'nav.whatWeDo': 'What we do',
    'nav.sectorsIndustries': 'Sectors & Industries',
    
    // Services
    'services.buildingInfrastructure': 'Building & Infrastructure',
    'services.designEngineering': 'Design & Engineering',
    'services.architecturalFitout': 'Architectural Fitout',
    'services.civilWorks': 'Civil Works',
    'services.mepWorks': 'MEP Works',
    'services.dataCenters': 'Data Centers Works',
    'services.pricingBidding': 'Pricing & Bidding',
    'services.maintenanceWorks': 'Maintenance Works',
    
    // Sectors
    'sectors.commercial': 'Commercial',
    'sectors.entertainment': 'Entertainment',
    'sectors.hotel': 'Hotel',
    'sectors.industrial': 'Industrial',
    'sectors.residential': 'Residential',
    'sectors.school': 'Education',
    'sectors.utilities': 'Utilities',
    'sectors.warehouse': 'Warehouse',
    'sectors.title': 'Sectors',
    
    // Buttons and actions
    'contact.us': 'Contact Us',
    'follow.us': 'Follow Us',
    'site.map': 'Site Map',
    
    // LinkedIn banner
    'linkedin.banner': 'Engage with our professional community on LinkedIn for insights and updates!',
    
    // Subscribe modal translations
    'subscribe.modal.title': 'Subscribe to our Newsletter',
    'subscribe.modal.success.title': 'Successfully Subscribed!',
    'subscribe.modal.success.message': 'Thank you for subscribing to our newsletter. You\'ll receive updates about our latest projects and company news.',
    'subscribe.modal.name.label': 'Name',
    'subscribe.modal.name.placeholder': 'Enter your name',
    'subscribe.modal.email.label': 'Email *',
    'subscribe.modal.email.placeholder': 'Enter your email address',
    'subscribe.modal.consent.text': 'I\'ve read and agree with',
    'subscribe.modal.consent.terms': 'Terms of Service',
    'subscribe.modal.consent.and': 'and',
    'subscribe.modal.consent.privacy': 'Privacy Policy.',
    'subscribe.modal.submit.subscribing': 'Subscribing...',
    'subscribe.modal.submit.text': 'Subscribe',
    'subscribe.modal.errors.emailRequired': 'Email is required',
    'subscribe.modal.errors.consentRequired': 'Please accept the terms and privacy policy',
    'subscribe.modal.errors.invalidEmail': 'Please enter a valid email address',
    
    // Button texts
    'buttons.downloadNow': 'Download now',
    'buttons.viewDetails': 'View Details',
    'buttons.readMore': 'Read More',
    'buttons.getQuote': 'Get Quote',
    'buttons.learnMore': 'Learn More',
    'buttons.viewAll': 'View All',
    'buttons.showMore': 'Show More',
    'buttons.showLess': 'Show Less',
    'buttons.explore': 'Explore',
    'buttons.discover': 'Discover',
    'buttons.seeAll': 'See All',
    'buttons.viewAllNews': 'View All News',
    'buttons.seeAllVendors': 'See All Vendors',
    
    // Common actions
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.loading': 'Loading...',
    
    // Chairman and leadership
    'leadership.chairman': 'Chairman',
    'leadership.chairmanFMC': 'Chairman, FMC',
    'leadership.engrMohammadFarhat': 'Mohammad Farhat',
    'leadership.mohamedAbdulRahmanFarhat': 'Mohamed Abdul Rahman Farhat',
    'leadership.position.chairman': 'Chairman',
    
    // Cities
    'cities.jeddah': 'Jeddah',
    'cities.riyadh': 'Riyadh',
    'cities.dammam': 'Dammam',
    
    // Contact Widget
    'contact.widget.button': 'Contact Us',
    'contact.widget.support': 'FMC Support',
    'contact.widget.online': 'Online',
    'contact.widget.message': 'Hi there 👋 How can I help you?',
    'contact.widget.whatsapp': 'WhatsApp',
    'contact.widget.call': 'Call',
    'contact.widget.email': 'Email',
    
    // Privacy Policy
    'privacy.title': 'Privacy Policy',
    'privacy.subtitle': 'Your privacy is important to us. Learn how we collect, use, and protect your information.',
    'privacy.lastUpdated': 'Last updated: January 15, 2024',
    'privacy.sections.introduction.title': 'Introduction',
    'privacy.sections.introduction.content1': 'FMC Construction ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or interact with us.',
    'privacy.sections.introduction.content2': 'By using our services, you agree to the collection and use of information in accordance with this policy.',
    'privacy.informationWeCollect.title': 'Information We Collect',
    'privacy.personalInformation.title': 'Personal Information',
    'privacy.automaticallyCollected.title': 'Automatically Collected Information',
    'privacy.howWeUse.title': 'How We Use Your Information',
    'privacy.informationSharing.title': 'Information Sharing and Disclosure',
    'privacy.dataSecurity.title': 'Data Security',
    'privacy.cookiesTracking.title': 'Cookies and Tracking Technologies',
    'privacy.yourRights.title': 'Your Privacy Rights',
    'privacy.dataRetention.title': 'Data Retention',
    'privacy.internationalTransfers.title': 'International Data Transfers',
    'privacy.childrensPrivacy.title': 'Children\'s Privacy',
    'privacy.changesPolicy.title': 'Changes to This Privacy Policy',
    'privacy.contact.title': 'Contact Us',
    'privacy.effective': 'This Privacy Policy is effective as of January 15, 2024, and will remain in effect except with respect to any changes in its provisions in the future.',
    'privacy.personalInformation.desc': 'We may collect personal information that you voluntarily provide to us, including:',
    'privacy.personalInformation.list1': 'Name and contact information (email, phone number, address)',
    'privacy.personalInformation.list2': 'Company name and job title',
    'privacy.personalInformation.list3': 'Project requirements and specifications',
    'privacy.personalInformation.list4': 'Communication preferences',
    'privacy.personalInformation.list5': 'Resume and employment information (for job applications)',
    'privacy.automaticallyCollected.desc': 'When you visit our website, we automatically collect certain information:',
    'privacy.automaticallyCollected.list1': 'IP address and device information',
    'privacy.automaticallyCollected.list2': 'Browser type and version',
    'privacy.automaticallyCollected.list3': 'Pages visited and time spent',
    'privacy.automaticallyCollected.list4': 'Referring website',
    'privacy.automaticallyCollected.list5': 'Cookies and similar technologies',
    'privacy.howWeUse.desc': 'We use the collected information for various purposes:',
    'privacy.howWeUse.list1': 'Provide and maintain our services',
    'privacy.howWeUse.list2': 'Process and respond to your inquiries',
    'privacy.howWeUse.list3': 'Send you project updates and newsletters',
    'privacy.howWeUse.list4': 'Improve our website and services',
    'privacy.howWeUse.list5': 'Comply with legal obligations',
    'privacy.howWeUse.list6': 'Protect against fraud and security threats',
    'privacy.howWeUse.list7': 'Recruit and evaluate job candidates',
    'privacy.informationSharing.desc': 'We do not sell, trade, or rent your personal information to third parties. We may share your information in the following circumstances:',
    'privacy.informationSharing.list1': 'Service Providers: With trusted third-party service providers who assist us in operating our business',
    'privacy.informationSharing.list2': 'Legal Requirements: When required by law or to protect our rights and safety',
    'privacy.informationSharing.list3': 'Business Transfers: In connection with a merger, acquisition, or sale of assets',
    'privacy.informationSharing.list4': 'Consent: With your explicit consent',
    'privacy.dataSecurity.desc1': 'We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.',
    'privacy.dataSecurity.desc2': 'However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.',
    'privacy.cookiesTracking.desc1': 'We use cookies and similar tracking technologies to enhance your browsing experience and analyze website traffic.',
    'privacy.cookiesTracking.desc2': 'You can control cookie settings through your browser preferences. However, disabling cookies may affect website functionality.',
    'privacy.yourRights.desc': 'Depending on your location, you may have the following rights regarding your personal information:',
    'privacy.yourRights.list1': 'Access: Request a copy of your personal information',
    'privacy.yourRights.list2': 'Correction: Request correction of inaccurate information',
    'privacy.yourRights.list3': 'Deletion: Request deletion of your personal information',
    'privacy.yourRights.list4': 'Portability: Request transfer of your data',
    'privacy.yourRights.list5': 'Objection: Object to processing of your information',
    'privacy.yourRights.list6': 'Withdrawal: Withdraw consent for data processing',
    'privacy.dataRetention.desc': 'We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.',
    'privacy.internationalTransfers.desc': 'Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy.',
    'privacy.childrensPrivacy.desc': 'Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.',
    'privacy.changesPolicy.desc': 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.',
    'privacy.contact.desc': 'If you have any questions about this Privacy Policy or our data practices, please contact us:',
    'privacy.contact.email': 'Email:',
    'privacy.contact.phone': 'Phone:',
    'privacy.contact.address': 'Address:',
    
    // Terms of Service
    'terms.title': 'Terms of Service',
    'terms.subtitle': 'Please read these terms carefully before using our services.',
    'terms.lastUpdated': 'Last updated: January 15, 2024',
    'terms.sections.introduction.title': 'Introduction',
    'terms.sections.introduction.content1': 'These Terms of Service ("Terms") govern your use of our website and services provided by FMC Construction ("Company," "we," "our," or "us").',
    'terms.sections.introduction.content2': 'By accessing or using our services, you agree to be bound by these Terms.',
    'terms.services.title': 'Description of Services',
    'terms.userResponsibilities.title': 'User Responsibilities',
    'terms.prohibited.title': 'Prohibited Activities',
    'terms.intellectualProperty.title': 'Intellectual Property Rights',
    'terms.privacy.title': 'Privacy and Data Protection',
    'terms.disclaimers.title': 'Disclaimers and Limitations',
    'terms.serviceAvailability.title': 'Service Availability',
    'terms.informationAccuracy.title': 'Information Accuracy',
    'terms.thirdPartyContent.title': 'Third-Party Content',
    'terms.limitationLiability.title': 'Limitation of Liability',
    'terms.indemnification.title': 'Indemnification',
    'terms.termination.title': 'Termination',
    'terms.governingLaw.title': 'Governing Law',
    'terms.changes.title': 'Changes to Terms',
    'terms.severability.title': 'Severability',
    'terms.contact.title': 'Contact Information',
    'terms.effective': 'These Terms of Service are effective as of January 15, 2024, and will remain in effect until modified or terminated.',
    'terms.services.desc': 'FMC Construction provides construction, engineering, and project management services including:',
    'terms.services.list1': 'Commercial and residential construction',
    'terms.services.list2': 'Infrastructure development',
    'terms.services.list3': 'Project management and consulting',
    'terms.services.list4': 'Engineering and architectural services',
    'terms.services.list5': 'Renovation and remodeling',
    'terms.services.list6': 'Construction documentation and reports',
    'terms.userResponsibilities.desc': 'When using our services, you agree to:',
    'terms.userResponsibilities.list1': 'Provide accurate and complete information',
    'terms.userResponsibilities.list2': 'Use our services only for lawful purposes',
    'terms.userResponsibilities.list3': 'Respect intellectual property rights',
    'terms.userResponsibilities.list4': 'Maintain the security of your account',
    'terms.userResponsibilities.list5': 'Not interfere with the proper functioning of our services',
    'terms.userResponsibilities.list6': 'Comply with all applicable laws and regulations',
    'terms.prohibited.desc': 'You may not use our services to:',
    'terms.prohibited.list1': 'Violate any applicable laws or regulations',
    'terms.prohibited.list2': 'Infringe on intellectual property rights',
    'terms.prohibited.list3': 'Transmit harmful, offensive, or inappropriate content',
    'terms.prohibited.list4': 'Attempt to gain unauthorized access to our systems',
    'terms.prohibited.list5': 'Interfere with other users\' access to our services',
    'terms.prohibited.list6': 'Use our services for commercial purposes without permission',
    'terms.prohibited.list7': 'Attempt to reverse engineer or modify our services',
    'terms.intellectualProperty.desc1': 'All content, features, and functionality of our services are owned by FMC Construction and are protected by international copyright, trademark, and other intellectual property laws.',
    'terms.intellectualProperty.desc2': 'You may not reproduce, distribute, modify, or create derivative works without our express written consent.',
    'terms.privacy.desc1': 'Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference.',
    'terms.privacy.desc2': 'By using our services, you consent to the collection and use of information as described in our Privacy Policy.',
    'terms.serviceAvailability.desc': 'We strive to provide reliable and uninterrupted services, but we do not guarantee that our services will be available at all times or error-free.',
    'terms.informationAccuracy.desc': 'While we strive to provide accurate and up-to-date information, we make no warranties about the accuracy, completeness, or reliability of any content on our services.',
    'terms.thirdPartyContent.desc': 'Our services may contain links to third-party websites or content. We are not responsible for the content or practices of these third-party sites.',
    'terms.limitationLiability.desc': 'To the maximum extent permitted by law, FMC Construction shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:',
    'terms.limitationLiability.list1': 'Loss of profits, data, or use',
    'terms.limitationLiability.list2': 'Business interruption',
    'terms.limitationLiability.list3': 'Personal injury or property damage',
    'terms.limitationLiability.list4': 'Any damages resulting from the use of our services',
    'terms.indemnification.desc': 'You agree to indemnify and hold harmless FMC Construction from any claims, damages, losses, or expenses arising from your use of our services or violation of these Terms.',
    'terms.termination.desc1': 'We may terminate or suspend your access to our services immediately, without prior notice, for any reason, including breach of these Terms.',
    'terms.termination.desc2': 'Upon termination, your right to use our services will cease immediately.',
    'terms.governingLaw.desc': 'These Terms shall be governed by and construed in accordance with the laws of Saudi Arabia. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Jeddah, Saudi Arabia.',
    'terms.changes.desc': 'We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last updated" date.',
    'terms.severability.desc': 'If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that these Terms will otherwise remain in full force and effect.',
    'terms.contact.desc': 'If you have any questions about these Terms of Service, please contact us:',
    'terms.contact.email': 'Email:',
    'terms.contact.phone': 'Phone:',
    'terms.contact.address': 'Address:',
    
    // Cookie Policy
    'cookie.title': 'Cookie Policy',
    'cookie.subtitle': 'Learn how we use cookies and similar technologies to enhance your browsing experience.',
    'cookie.lastUpdated': 'Last updated: January 15, 2024',
    'cookie.sections.introduction.title': 'Introduction',
    'cookie.sections.introduction.content1': 'This Cookie Policy explains how FMC Construction ("we," "our," or "us") uses cookies and similar technologies when you visit our website.',
    'cookie.sections.introduction.content2': 'By using our website, you consent to the use of cookies as described in this policy.',
    'cookie.types.title': 'Types of Cookies We Use',
    'cookie.essential.title': 'Essential Cookies',
    'cookie.essential.desc': 'These cookies are necessary for the website to function properly. They enable basic functions like page navigation, access to secure areas, and form submissions.',
    'cookie.functional.title': 'Functional Cookies',
    'cookie.functional.desc': 'These cookies enhance the functionality and personalization of our website by remembering your preferences and choices.',
    'cookie.analytics.title': 'Analytics Cookies',
    'cookie.analytics.desc': 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
    'cookie.marketing.title': 'Marketing Cookies',
    'cookie.marketing.desc': 'These cookies are used to track visitors across websites to display relevant and engaging advertisements.',
    'cookie.specific.title': 'Specific Cookies We Use',
    'cookie.thirdParty.title': 'Third-Party Cookies',
    'cookie.management.title': 'Managing Your Cookie Preferences',
    'cookie.browserSettings.title': 'Browser Settings',
    'cookie.consent.title': 'Cookie Consent',
    'cookie.impact.title': 'Impact of Disabling Cookies',
    'cookie.updates.title': 'Updates to This Cookie Policy',
    'cookie.contact.title': 'Contact Us',
    'cookie.effective': 'This Cookie Policy is effective as of January 15, 2024, and will remain in effect until modified or updated.',
    'cookie.essential.list1': 'Authentication and security cookies',
    'cookie.essential.list2': 'Session management cookies',
    'cookie.essential.list3': 'Load balancing cookies',
    'cookie.essential.list4': 'User interface customization cookies',
    'cookie.functional.list1': 'Language preference cookies',
    'cookie.functional.list2': 'Theme and display preference cookies',
    'cookie.functional.list3': 'Form data retention cookies',
    'cookie.functional.list4': 'User experience enhancement cookies',
    'cookie.analytics.list1': 'Google Analytics cookies',
    'cookie.analytics.list2': 'Page view and session duration tracking',
    'cookie.analytics.list3': 'Traffic source analysis',
    'cookie.analytics.list4': 'User behavior insights',
    'cookie.marketing.list1': 'Social media integration cookies',
    'cookie.marketing.list2': 'Advertising platform cookies',
    'cookie.marketing.list3': 'Retargeting cookies',
    'cookie.marketing.list4': 'Campaign effectiveness tracking',
    'cookie.googleAnalytics.title': 'Google Analytics',
    'cookie.googleAnalytics.purpose': 'Purpose:',
    'cookie.googleAnalytics.duration': 'Duration:',
    'cookie.googleAnalytics.provider': 'Provider:',
    'cookie.session.title': 'Session Cookies',
    'cookie.language.title': 'Language Preference',
    'cookie.thirdParty.desc': 'Some cookies on our website are set by third-party services that we use to enhance your experience:',
    'cookie.thirdParty.list1': 'Google Analytics: For website analytics and performance monitoring',
    'cookie.thirdParty.list2': 'Social Media Platforms: For social sharing and integration features',
    'cookie.thirdParty.list3': 'Payment Processors: For secure payment processing (if applicable)',
    'cookie.thirdParty.list4': 'Content Delivery Networks: For faster content loading',
    'cookie.thirdParty.note': 'These third parties have their own privacy policies and cookie practices. We recommend reviewing their policies for more information.',
    'cookie.browserSettings.desc': 'You can control and manage cookies through your browser settings:',
    'cookie.browserSettings.chrome': 'Chrome: Settings → Privacy and Security → Cookies and other site data',
    'cookie.browserSettings.firefox': 'Firefox: Options → Privacy & Security → Cookies and Site Data',
    'cookie.browserSettings.safari': 'Safari: Preferences → Privacy → Manage Website Data',
    'cookie.browserSettings.edge': 'Edge: Settings → Cookies and site permissions → Cookies and site data',
    'cookie.consent.desc': 'When you first visit our website, you\'ll see a cookie consent banner that allows you to:',
    'cookie.consent.list1': 'Accept all cookies',
    'cookie.consent.list2': 'Reject non-essential cookies',
    'cookie.consent.list3': 'Customize your cookie preferences',
    'cookie.consent.list4': 'Learn more about our cookie usage',
    'cookie.impact.desc': 'While you can disable cookies, please note that doing so may affect your experience on our website:',
    'cookie.impact.list1': 'Some website features may not function properly',
    'cookie.impact.list2': 'Your preferences and settings may not be saved',
    'cookie.impact.list3': 'You may need to re-enter information on each visit',
    'cookie.impact.list4': 'Personalized content may not be available',
    'cookie.impact.list5': 'Website performance may be affected',
    'cookie.updates.desc': 'We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the updated policy on our website.',
    'cookie.contact.desc': 'If you have any questions about our use of cookies or this Cookie Policy, please contact us:',
    'cookie.contact.email': 'Email:',
    'cookie.contact.phone': 'Phone:',
    'cookie.contact.address': 'Address:',
    
    // Site Map
    'sitemap.title': 'Site Map',
    'sitemap.subtitle': 'Navigate through our website easily with this comprehensive site map.',
    'sitemap.description': 'Find what you\'re looking for quickly and efficiently',
    'sitemap.quickAccess': 'Quick Access',
    'sitemap.quickAccessDesc': 'Most popular pages and actions',
    'sitemap.completeStructure': 'Complete Website Structure',
    'sitemap.completeStructureDesc': 'Explore all sections and pages of our website organized by category',
    'sitemap.mainPages': 'Main Pages',
    'sitemap.about': 'About',
    'sitemap.whatWeDo': 'What We Do',
    'sitemap.ourServices': 'Our Services',
    'sitemap.sectorsIndustries': 'Sectors & Industries',
    'sitemap.resourcesNews': 'Resources & News',
    'sitemap.legalPrivacy': 'Legal & Privacy',
    'sitemap.cantFind': 'Can\'t Find What You\'re Looking For?',
    'sitemap.cantFindDesc': 'Use our search functionality or contact us directly for assistance',
    'sitemap.learnMore': 'Learn More About Us',
    'sitemap.lastUpdated': 'This site map is regularly updated to reflect our current website structure. Last updated: January 2025',
    'sitemap.sections.mainPages': 'Main Pages',
    'sitemap.sections.about': 'About',
    'sitemap.sections.whatWeDo': 'What We Do',
    'sitemap.sections.ourServices': 'Our Services',
    'sitemap.sections.sectorsIndustries': 'Sectors & Industries',
    'sitemap.sections.resourcesNews': 'Resources & News',
    'sitemap.sections.legalPrivacy': 'Legal & Privacy',
    'sitemap.links.home': 'Home',
    'sitemap.links.homeDesc': 'Welcome to FMC Construction',
    'sitemap.links.contact': 'Contact',
    'sitemap.links.contactDesc': 'Get in touch with our team',
    'sitemap.links.aboutUs': 'About Us',
    'sitemap.links.aboutUsDesc': 'Learn about our company and mission',
    'sitemap.links.organizationChart': 'Organization Chart',
    'sitemap.links.organizationChartDesc': 'Our company structure and leadership',
    'sitemap.links.csr': 'Corporate Social Responsibility',
    'sitemap.links.csrDesc': 'Our commitment to sustainability and community',
    'sitemap.links.codeOfEthics': 'Code of Ethics',
    'sitemap.links.codeOfEthicsDesc': 'Our ethical standards and business principles',
    'sitemap.links.hse': 'Health, Safety & Environment',
    'sitemap.links.hseDesc': 'Our commitment to safety and environmental protection',
    'sitemap.links.qualityManagement': 'Quality Management',
    'sitemap.links.qualityManagementDesc': 'Our quality assurance and management systems',
    'sitemap.links.ourClients': 'Our Clients',
    'sitemap.links.ourClientsDesc': 'Trusted partners and client portfolio',
    'sitemap.links.ourVendors': 'Our Vendors',
    'sitemap.links.ourVendorsDesc': 'Strategic vendor partnerships',
    'sitemap.links.careers': 'Careers',
    'sitemap.links.careersDesc': 'Job opportunities and career information',
    'sitemap.links.documents': 'Documents',
    'sitemap.links.documentsDesc': 'Company documents and resources',
    'sitemap.links.ourServices': 'Our Services',
    'sitemap.links.ourServicesDesc': 'Complete overview of our services',
    'sitemap.links.projects': 'Projects',
    'sitemap.links.projectsDesc': 'Browse our complete project portfolio',
    'sitemap.links.servicesOverview': 'Services Overview',
    'sitemap.links.servicesOverviewDesc': 'Comprehensive construction services',
    'sitemap.links.buildingInfrastructure': 'Building & Infrastructure',
    'sitemap.links.buildingInfrastructureDesc': 'Core construction and infrastructure services',
    'sitemap.links.designEngineering': 'Design & Engineering',
    'sitemap.links.designEngineeringDesc': 'Professional design and engineering solutions',
    'sitemap.links.architecturalFitout': 'Architectural Fitout',
    'sitemap.links.architecturalFitoutDesc': 'Interior and architectural finishing services',
    'sitemap.links.civilWorks': 'Civil Works',
    'sitemap.links.civilWorksDesc': 'Civil engineering and construction',
    'sitemap.links.mepWorks': 'MEP Works',
    'sitemap.links.mepWorksDesc': 'Mechanical, Electrical & Plumbing services',
    'sitemap.links.dataCenters': 'Data Centers Works',
    'sitemap.links.dataCentersDesc': 'Professional data center construction and infrastructure services',
    'sitemap.links.pricing': 'Pricing',
    'sitemap.links.pricingDesc': 'Transparent pricing and cost estimation',
    'sitemap.links.maintenance': 'Maintenance',
    'sitemap.links.maintenanceDesc': 'Ongoing maintenance and support services',
    'sitemap.links.sectorsOverview': 'Sectors Overview',
    'sitemap.links.sectorsOverviewDesc': 'Explore all our construction sectors',
    'sitemap.links.industriesSectors': 'Industries & Sectors',
    'sitemap.links.industriesSectorsDesc': 'Comprehensive industry coverage',
    'sitemap.links.commercial': 'Commercial',
    'sitemap.links.commercialDesc': 'Commercial construction expertise',
    'sitemap.links.entertainment': 'Entertainment',
    'sitemap.links.entertainmentDesc': 'Entertainment and leisure facilities',
    'sitemap.links.hotel': 'Hotel',
    'sitemap.links.hotelDesc': 'Hospitality construction services',
    'sitemap.links.industrial': 'Industrial',
    'sitemap.links.industrialDesc': 'Industrial construction solutions',
    'sitemap.links.residential': 'Residential',
    'sitemap.links.residentialDesc': 'Residential construction projects',
    'sitemap.links.school': 'Education',
    'sitemap.links.schoolDesc': 'Educational facility construction',
    'sitemap.links.utilities': 'Utilities',
    'sitemap.links.utilitiesDesc': 'Infrastructure and utilities',
    'sitemap.links.warehouse': 'Warehouse',
    'sitemap.links.warehouseDesc': 'Storage facility construction',
    'sitemap.links.blogNews': 'Blog & News',
    'sitemap.links.blogNewsDesc': 'Industry insights and company news',
    'sitemap.links.ourSuccessPartners': 'Our Success Partners',
    'sitemap.links.ourSuccessPartnersDesc': 'Strategic partnerships and collaborations',
    'sitemap.links.privacyPolicy': 'Privacy Policy',
    'sitemap.links.privacyPolicyDesc': 'How we protect your information',
    'sitemap.links.termsOfService': 'Terms of Service',
    'sitemap.links.termsOfServiceDesc': 'Terms and conditions of use',
    'sitemap.links.cookiePolicy': 'Cookie Policy',
    'sitemap.links.cookiePolicyDesc': 'Our cookie usage and management',
    'sitemap.links.siteMap': 'Site Map',
    'sitemap.links.siteMapDesc': 'Complete website navigation guide',
    'sitemap.quickLinks.getQuote': 'Get a Quote',
    'sitemap.quickLinks.getQuoteDesc': 'Request a project quote',
    'sitemap.quickLinks.viewProjects': 'View Projects',
    'sitemap.quickLinks.viewProjectsDesc': 'Explore our work',
    'sitemap.quickLinks.ourServices': 'Our Services',
    'sitemap.quickLinks.ourServicesDesc': 'Complete service overview',
    'sitemap.quickLinks.joinOurTeam': 'Join Our Team',
    'sitemap.quickLinks.joinOurTeamDesc': 'Career opportunities',
    'sitemap.quickLinks.ourClients': 'Our Clients',
    'sitemap.quickLinks.ourClientsDesc': 'See our client portfolio',
    'sitemap.quickLinks.companyDocuments': 'Company Documents',
    'sitemap.quickLinks.companyDocumentsDesc': 'Download company resources',
    'sitemap.contactUs': 'Contact Us',
    'cookie.sessionCookies.title': 'Session Cookies',
    'cookie.sessionCookies.purpose': 'Purpose:',
    'cookie.sessionCookies.purposeDesc': 'Maintain user session and preferences',
    'cookie.sessionCookies.duration': 'Duration:',
    'cookie.sessionCookies.durationDesc': 'Session duration',
    'cookie.sessionCookies.provider': 'Provider:',
    'cookie.sessionCookies.providerDesc': 'FMC Construction',
    'cookie.languageCookies.title': 'Language Preference Cookies',
    'cookie.languageCookies.purpose': 'Purpose:',
    'cookie.languageCookies.purposeDesc': 'Remember user\'s language choice',
    'cookie.languageCookies.duration': 'Duration:',
    'cookie.languageCookies.durationDesc': '1 year',
    'cookie.languageCookies.provider': 'Provider:',
    'cookie.languageCookies.providerDesc': 'FMC Construction',
    'contact.companyAddress': 'FMC Construction, Jeddah, Saudi Arabia',
    'cookie.googleAnalytics.purposeDesc': 'Website analytics and performance monitoring',
    'cookie.googleAnalytics.durationDesc': 'Up to 2 years',
    'cookie.googleAnalytics.providerDesc': 'Google LLC',
    'contact.phone': '+966 12 345 6789',
    'contact.email': 'info@fmcksa.com',
    'contact.email.privacy': 'info@fmcksa.com',
    
    // About Page Translations
    'about.hero.title': 'About',
    'about.hero.subtitle': 'Building the future through innovation, excellence, and unwavering commitment to quality construction solutions.',
    'about.story.introduction': 'Introduction',
    'about.story.title': 'Our',
    'about.story.highlight': 'Founded with a vision to transform the construction industry through innovation, quality, and unwavering commitment to excellence.',
    'about.story.desc1': 'What started as a small family business has grown into one of the region\'s most trusted construction companies, known for delivering projects that exceed expectations and stand as testaments to our craftsmanship.',
    'about.story.desc2': 'Today, FMC continues to push boundaries, embracing new technologies and sustainable practices while maintaining the personal touch that has defined us for over two decades.',
    'about.story.yearsExcellence': 'Years of Excellence',
    'about.story.projectsCompleted': 'Projects Completed',
    'about.story.buildingExcellence': 'Building Excellence',
    'about.story.craftingTomorrow': 'Crafting Tomorrow\'s Infrastructure',
    'about.story.visionReality': 'From vision to reality, we transform construction projects into landmarks of excellence and innovation.',
    'about.missionVision.title': 'Our Mission, Vision &',
    'about.missionVision.subtitle': 'Driving the future of construction through innovation, excellence, and sustainable development',
    'about.mission.title': 'Our Mission',
    'about.mission.desc': 'To deliver exceptional construction solutions that exceed client expectations while maintaining the highest standards of quality, safety, and sustainability.',
    'about.mission.point1': 'Transform through innovative technology',
    'about.mission.point2': 'Build lasting client relationships',
    'about.mission.point3': 'Create sustainable infrastructure',
    'about.vision.title': 'Our Vision',
    'about.vision.desc': 'To be the leading construction company in Saudi Arabia and beyond, recognized for innovation, excellence, and commitment to building a sustainable future.',
    'about.vision.point1': 'Pioneer next-generation technologies',
    'about.vision.point2': 'Expand across the region',
    'about.vision.point3': 'Inspire future professionals',
    'about.values.title': 'Our Values',
    'about.values.desc': 'The core principles that guide every decision we make and every project we undertake with unwavering commitment.',
    'about.values.integrity': 'Integrity - Honest & transparent',
    'about.values.excellence': 'Excellence - Uncompromising quality',
    'about.values.collaboration': 'Collaboration - Unified teamwork',
    'about.values.passion': 'Passion - Dedicated enthusiasm',
    'about.history.title': 'Our History',
    'about.leadership.title': 'FMC Leadership',
    'about.stats.industriesServed': 'Industries Served',
    'about.stats.completedProjects': 'Completed Projects',
    'about.stats.yearsExperience': 'Years Experience',
    'about.stats.clientSatisfaction': 'Client Satisfaction',
    'about.cta.title': 'Ready to Build Together?',
    'about.cta.subtitle': 'Let\'s discuss your next construction project and explore how FMC can bring your vision to life.',
    'about.cta.button1': 'Get Started',
    'about.cta.button2': 'View Our Work',
    'about.modal.title': 'Team Member Profile',
    'about.modal.biography': 'Biography',
    'about.modal.expertise': 'Areas of Expertise',
    'about.modal.experience': 'of Experience',
    'about.modal.close': 'Close',
    'about.timeline.categories.foundation': 'Foundation',
    'about.timeline.categories.milestone': 'Milestone',
    'about.timeline.categories.certification': 'Certification',
    'about.timeline.categories.growth': 'Growth',
    'about.timeline.categories.innovation': 'Innovation',
    'about.timeline.categories.sustainability': 'Sustainability',
    'about.timeline.categories.achievement': 'Achievement',
    'about.timeline.categories.strategy': 'Strategy',
    'about.timeline.categories.partnership': 'Partnership',
    'about.timeline.categories.transformation': 'Transformation',
    'about.timeline.categories.future': 'Future',
    'about.timeline.milestone': 'Milestone',
    'about.timeline.progress': 'of',
    'about.timeline.2006.title': 'FMC Construction Established',
    'about.timeline.2006.desc': 'FMC Construction was founded in Saudi Arabia with a vision to transform the construction industry through innovation, quality, and unwavering commitment to excellence.',
    'about.timeline.2008.title': 'First Major Commercial Project',
    'about.timeline.2008.desc': 'Successfully completed our first large-scale commercial building project, establishing FMC as a reliable partner in the construction sector.',
    'about.timeline.2010.title': 'ISO Certification Achievement',
    'about.timeline.2010.desc': 'Obtained ISO 9001 quality management certification, demonstrating our commitment to international standards and quality excellence.',
    'about.timeline.2012.title': 'Workforce Expansion',
    'about.timeline.2012.desc': 'Expanded our team to over 200 skilled professionals, including engineers, project managers, and specialized construction workers.',
    'about.timeline.2014.title': 'Technology Integration Initiative',
    'about.timeline.2014.desc': 'Implemented advanced project management software and BIM technology to enhance project efficiency and client communication.',
    'about.timeline.2016.title': 'Sustainable Construction Focus',
    'about.timeline.2016.desc': 'Launched our sustainability initiative, incorporating green building practices and eco-friendly materials in all new projects.',
    'about.timeline.2018.title': 'Regional Market Leadership',
    'about.timeline.2018.desc': 'Achieved recognition as one of the top construction companies in the Western Region of Saudi Arabia with over 100 completed projects.',
    'about.timeline.2019.title': 'Vision 2030 Alignment',
    'about.timeline.2019.desc': 'Aligned company strategy with Saudi Vision 2030, focusing on mega-projects and national development initiatives.',
    'about.timeline.2020.title': 'Digital Transformation',
    'about.timeline.2020.desc': 'Successfully navigated the global pandemic by implementing comprehensive digital project management and remote collaboration tools.',
    'about.timeline.2021.title': 'Strategic Partnership Development',
    'about.timeline.2021.desc': 'Established key partnerships with international construction firms and technology providers to enhance service capabilities.',
    'about.timeline.2022.title': 'Company Rebranding & Modernization',
    'about.timeline.2022.desc': 'Completed comprehensive rebranding initiative reflecting our evolution into a modern, technology-driven construction leader.',
    'about.timeline.2023.title': 'Smart Building Solutions Launch',
    'about.timeline.2023.desc': 'Introduced smart building technologies and IoT integration services, positioning FMC at the forefront of intelligent construction.',
    'about.timeline.2024.title': 'Mega Project Portfolio Expansion',
    'about.timeline.2024.desc': 'Successfully secured and commenced multiple mega-projects worth over SAR 1 billion, marking our largest project portfolio to date.',
    'about.timeline.2025.title': 'Next Generation Construction Hub',
    'about.timeline.2025.desc': 'Establishing our new headquarters and training center, featuring cutting-edge construction technologies and industry 4.0 capabilities.',
    'about.timeline.pause': 'Pause auto-play',
    'about.timeline.start': 'Start auto-play',
    
    // Team Members Translations
    'about.team.ahmed.name': 'Engr. Mohammad Farhat',
    'about.team.ahmed.position': 'General Manager',
    'about.team.ahmed.expertise1': 'Strategic Leadership',
    'about.team.ahmed.expertise2': 'Business Development',
    'about.team.ahmed.expertise3': 'Vision 2030 Alignment',
    'about.team.ahmed.expertise4': 'Industry Innovation',
    'about.team.ahmed.experience': '20+ years',
    'about.team.abdulrahman.name': 'Abdulrahman Farhat',
    'about.team.abdulrahman.position': 'Civil Division Manager',
    'about.team.abdulrahman.expertise1': 'Civil Engineering',
    'about.team.abdulrahman.expertise2': 'Project Management',
    'about.team.abdulrahman.expertise3': 'Infrastructure Development',
    'about.team.abdulrahman.expertise4': 'Quality Control',
    'about.team.abdulrahman.experience': '15+ years',
    'about.team.kasem.name': 'Kasem Farhat',
    'about.team.kasem.position': 'MEP Division Manager',
    'about.team.kasem.expertise1': 'MEP Systems',
    'about.team.kasem.expertise2': 'Energy Efficiency',
    'about.team.kasem.expertise3': 'Smart Building Technology',
    'about.team.kasem.expertise4': 'Sustainable Engineering',
    'about.team.kasem.experience': '12+ years',
    'about.team.abdulrahman2.name': 'Abdulrahman Sallam',
    'about.team.abdulrahman2.position': 'Executive Manager',
    'about.team.abdulrahman2.expertise1': 'Executive Leadership',
    'about.team.abdulrahman2.expertise2': 'Operations Management',
    'about.team.abdulrahman2.expertise3': 'Strategic Implementation',
    'about.team.abdulrahman2.expertise4': 'Project Development',
    'about.team.abdulrahman2.experience': '18+ years',
    'about.story.story': 'Story',
    'about.team.ahmed.bio': 'Mohammad Farhat is the visionary Chairman of FMC Construction. With over 40 years of experience in the construction industry, he has led FMC\'s transformation from a small family business to one of Saudi Arabia\'s most trusted construction companies. His leadership has been instrumental in aligning FMC with Saudi Vision 2030 and establishing the company as a leader in innovative construction technology.',
    'about.team.abdulrahman.bio': 'Abdulrahman Farhat serves as Civil Division Manager, bringing expertise in civil engineering and construction management to FMC Construction. He oversees major civil infrastructure projects and ensures the highest standards of engineering excellence in all civil construction activities.',
    'about.team.kasem.bio': 'Kasem Farhat serves as MEP Division Manager, specializing in mechanical, electrical, and plumbing systems. He leads FMC\'s MEP division with expertise in modern building systems, energy efficiency, and smart building technologies that align with Saudi Arabia\'s sustainability goals.',
    'about.team.abdulrahman2.bio': 'Abdulrahman Sallam serves as Executive Manager, leading FMC\'s day-to-day operations and strategic implementation. With extensive experience in project management and business development, he ensures operational excellence and drives the company\'s growth in alignment with Saudi Vision 2030 objectives.',
    
    // Organization Chart Translations
    'org.hero.title': 'Organization',
    'org.hero.subtitle': 'Our organizational structure reflects our commitment to excellence, efficiency, and professional expertise across all departments',
    'org.generalManager': 'General Manager',
    'org.deputyGeneralManager': 'Deputy General Manager',
    'org.electricalMechanical': '(Electrical & Mechanical)',
    'org.executiveManager': 'Executive Manager',
    'org.estimationDepartment': 'Estimation Department',
    'org.estimatorManager': 'Estimator Manager',
    'org.electricalEngineers': 'Electrical Engineers',
    'org.mechanicalEngineers': 'Mechanical Engineers',
    'org.projectManager': 'Project Manager',
    'org.projectSecretary': 'Project Secretary',
    'org.qaQcEngineers': 'QA/QC Engineers',
    'org.technicalDepartment': 'Technical Department',
    'org.seniorMechanicalEngineers': 'Senior Mechanical Engineers',
    'org.mechanicalDraftsman': 'Mechanical Draftsman',
    'org.mechanicalForeman': 'Mechanical Foreman',
    'org.mechanicalTechnicians': 'Mechanical Technicians',
    'org.seniorElectricalEngineers': 'Senior Electrical Engineers',
    'org.electricalDraftsman': 'Electrical Draftsman',
    'org.electricalForeman': 'Electrical Foreman',
    'org.electricalTechnicians': 'Electrical Technicians',
    'org.procurementDepartment': 'Procurement Department',
    'org.procurementOfficers': 'Procurement Officers',
    'org.purchaseAdministrator': 'Purchase Administrator',
    'org.materialCoordinator': 'Material Coordinator',
    'org.financeDepartment': 'Finance Department',
    'org.financeManager': 'Finance Manager',
    'org.chiefAccountant': 'Chief Accountant',
    'org.accountants': 'Accountants',
    'org.adminGeneralServices': 'Administration & General Services',
    'org.hrManager': 'HR Manager',
    'org.hrOfficeAdmin': 'HR & Office Admin',
    'org.itDepartment': 'IT Department',
    'org.transportLegalDepartment': 'Transport / Legal Department',
    'org.contractingCivil': '(Contracting & Civil)',
    'org.contractDepartment': 'Contract Department',
    'org.contractManager': 'Contract Manager',
    'org.contractEngineers': 'Contract Engineers',
    'org.contractAdministrators': 'Contract Administrators',
    'org.civilDepartment': 'Civil Department',
    'org.civilEngineers': 'Civil Engineers',
    'org.civilDraftsman': 'Civil Draftsman',
    'org.civilForeman': 'Civil Foreman',
    'org.civilTechnicians': 'Civil Technicians',
    'org.srQuantitySurveyor': 'Sr. Quantity Surveyor',
    'org.documentsSection': 'Documents Section',
    'org.seniorCivilEngineers': 'Senior Civil Engineers',
    'org.structuralDraftsman': 'Structural Draftsman',
    'org.structuralForeman': 'Structural Foreman',
    'org.structuralTechnicians': 'Structural Technicians',
    'org.seniorArchitectEngineers': 'Senior Architect Engineers',
    'org.architectEngineers': 'Architect Engineers',
    'org.architecturalDraftsman': 'Architectural Draftsman',
    'org.architecturalForeman': 'Architectural Foreman',
    'org.architecturalTechnicians': 'Architectural Technicians',
    'org.hero.chart': 'Chart',
    'org.backToAbout': 'Back to About',
    'org.cta.title': 'Join Our Professional Team',
    'org.cta.description': 'Be part of our organized, professional team structure and contribute to exceptional construction and infrastructure projects',
    'org.cta.viewCareers': 'View Careers',
    'org.cta.contactUs': 'Contact Us',
    
    // Clients Page Translations
    'clients.hero.title': 'Our Clients',
    'clients.hero.subtitle': 'Trusted by leading organizations across various industries',
    'clients.hero.description': 'We are proud to work with some of the most prestigious companies and organizations in Saudi Arabia and the region. Our diverse client portfolio reflects our commitment to excellence and our ability to deliver exceptional results across multiple sectors.',
    'clients.categories.all': 'All Categories',
    'clients.categories.entertainment': 'Entertainment & Media',
    'clients.categories.healthcare': 'Healthcare',
    'clients.categories.education': 'Education',
    'clients.categories.government': 'Government',
    'clients.categories.retail': 'Retail & Commercial',
    'clients.categories.hospitality': 'Hospitality',
    'clients.categories.technology': 'Technology',
    'clients.categories.finance': 'Finance',
    'clients.categories.manufacturing': 'Manufacturing',
    'clients.categories.infrastructure': 'Infrastructure',
    'clients.projects': 'Projects',
    'clients.since': 'Since',
    'clients.contact.title': 'Become Our Client',
    'clients.contact.subtitle': 'Ready to start your next project with us?',
    'clients.contact.description': 'Fill out the form below and our team will get back to you within 24 hours.',
    'clients.form.firstName': 'First Name',
    'clients.form.lastName': 'Last Name',
    'clients.form.email': 'Email Address',
    'clients.form.phone': 'Phone Number',
    'clients.form.mobile': 'Mobile Number',
    'clients.form.company': 'Company Name',
    'clients.form.position': 'Position',
    'clients.form.projectType': 'Project Type',
    'clients.form.projectDetails': 'Project Details',
    'clients.form.message': 'Message',
    'clients.form.consent': 'I agree to the terms and conditions',
    'clients.form.submit': 'Send Message',
    'clients.form.submitting': 'Sending...',
    'clients.form.success': 'Thank you! Your message has been sent successfully.',
    'clients.form.close': 'Close',
    'clients.projectTypes.residential': 'Residential Construction',
    'clients.projectTypes.commercial': 'Commercial Construction',
    'clients.projectTypes.industrial': 'Industrial Construction',
    'clients.projectTypes.infrastructure': 'Infrastructure Development',
    'clients.projectTypes.renovation': 'Renovation & Remodeling',
    'clients.projectTypes.designBuild': 'Design & Build',
    'clients.projectTypes.projectManagement': 'Project Management',
    'clients.projectTypes.consulting': 'Consulting Services',
    'clients.projectTypes.other': 'Other',
    
    // Careers Page Translations
    'careers.hero.title': 'Join Our Team',
    'careers.hero.subtitle': 'Build your career with FMC Construction',
    'careers.hero.description': 'Discover exciting career opportunities in construction, engineering, and project management. Join a team that values innovation, growth, and excellence.',
    'careers.search.placeholder': 'Search for jobs...',
    'careers.filters.department': 'Department',
    'careers.filters.location': 'Location',
    'careers.filters.type': 'Job Type',
    'careers.filters.all': 'All',
    'careers.view.grid': 'Grid View',
    'careers.view.list': 'List View',
    'careers.job.apply': 'Apply Now',
    'careers.job.view': 'View Details',
    'careers.job.share': 'Share',
    'careers.job.posted': 'Posted',
    'careers.job.experience': 'Experience',
    'careers.job.salary': 'Salary',
    'careers.job.location': 'Location',
    'careers.job.type': 'Type',
    'careers.job.remote': 'Remote',
    'careers.job.urgent': 'Urgent',
    'careers.job.fullTime': 'Full-time',
    'careers.job.partTime': 'Part-time',
    'careers.job.contract': 'Contract',
    'careers.job.internship': 'Internship',
    'careers.modal.title': 'Apply for Position',
    'careers.modal.subtitle': 'Submit your application',
    'careers.form.name': 'Full Name',
    'careers.form.email': 'Email Address',
    'careers.form.mobile': 'Mobile Number',
    'careers.form.currentSalary': 'Current Salary',
    'careers.form.expectedSalary': 'Expected Salary',
    'careers.form.currentLocation': 'Current Location',
    'careers.form.experience': 'Years of Experience',
    'careers.form.position': 'Position Applied For',
    'careers.form.cv': 'Upload CV',
    'careers.form.consent': 'I agree to the terms and conditions',
    'careers.form.submit': 'Submit Application',
    'careers.form.submitting': 'Submitting...',
    'careers.form.success': 'Application submitted successfully!',
    'careers.form.close': 'Close',
    'careers.departments.engineering': 'Engineering',
    'careers.departments.projectManagement': 'Project Management',
    'careers.departments.construction': 'Construction',
    'careers.departments.hr': 'Human Resources',
    'careers.departments.finance': 'Finance',
    'careers.departments.it': 'Information Technology',
    'careers.departments.operations': 'Operations',
    'careers.locations.jeddah': 'Jeddah',
    'careers.locations.riyadh': 'Riyadh',
    'careers.locations.dammam': 'Dammam',
    'careers.locations.remote': 'Remote',
    
    // Contact Information
    'contact.companyName': 'FMC Company',
    'contact.address.poBox': 'P.O. Box 6599, Jeddah',
    'contact.address.postalCode': '21452',
    'contact.address.country': 'Saudi Arabia',
    
    // Contact Page Translations
    'contact.title': 'Contact Us',
    'contact.hero.subtitle': 'Get in touch with our team for project inquiries, partnerships, or career opportunities. We\'re here to help bring your vision to life.',
    'contact.form.title': 'Contact Us Form',
    'contact.form.subtitle': 'Fill out the form below and our team will get back to you at the earliest possible time to discuss your inquiry, whether it\'s for project quotes, partnerships, or career opportunities.',
    'contact.form.success.title': 'Message Sent Successfully!',
    'contact.form.success.message': 'Thank you for your inquiry. We will get back to you within 24 hours.',
    'contact.form.type.label': 'What are you looking for?',
    'contact.form.type.quote': 'Request a Quote for a new project',
    'contact.form.type.vendor': 'Request a partnership as a vendor',
    'contact.form.type.subcontractor': 'Request a partnership as a subcontractor',
    'contact.form.type.job': 'Looking for a job inquiry',
    'contact.form.company.label': 'Company Name',
    'contact.form.company.placeholder': 'Enter your company name',
    'contact.form.name.label': 'Contact Full Name',
    'contact.form.name.placeholder': 'Enter your full name',
    'contact.form.position.label': 'Position',
    'contact.form.position.placeholder': 'Enter your position',
    'contact.form.phone.label': 'Phone Number',
    'contact.form.phone.placeholder': 'Enter your phone number',
    'contact.form.mobile.label': 'Mobile Number',
    'contact.form.mobile.placeholder': 'Enter your mobile number',
    'contact.form.email.label': 'Email',
    'contact.form.email.placeholder': 'Enter your email address',
    'contact.form.projectType.label': 'Project Type',
    'contact.form.projectType.placeholder': 'Select project type',
    'contact.form.projectDetails.label': 'Project Details',
    'contact.form.projectDetails.placeholder': 'Tell us about your project requirements, timeline, and any specific needs...',
    'contact.form.vendorName.label': 'Vendor Name',
    'contact.form.vendorName.placeholder': 'Enter vendor name',
    'contact.form.subcontractorName.label': 'Subcontractor Name',
    'contact.form.subcontractorName.placeholder': 'Enter subcontractor name',
    'contact.form.services.label': 'Services Provided',
    'contact.form.services.placeholder': 'Describe the services your company provides',
    'contact.form.vat.label': 'VAT#',
    'contact.form.vat.placeholder': 'Enter your VAT number',
    'contact.form.profile.label': 'Company Profile Upload',
    'contact.form.profile.placeholder': 'Click to upload company profile',
    'contact.form.certificate.label': 'Company Registration Certificate Upload',
    'contact.form.certificate.placeholder': 'Click to upload registration certificate',
    'contact.form.message.label': 'Message',
    'contact.form.message.placeholder': 'Tell us more about your company and partnership interest...',
    'contact.form.location.label': 'Current Location',
    'contact.form.location.placeholder': 'Enter your current location',
    'contact.form.experience.label': 'Years of Experience',
    'contact.form.experience.placeholder': 'Select experience level',
    'contact.form.experience.0-1': '0-1 years',
    'contact.form.experience.2-3': '2-3 years',
    'contact.form.experience.4-5': '4-5 years',
    'contact.form.experience.6-10': '6-10 years',
    'contact.form.experience.10+': '10+ years',
    'contact.form.jobPosition.label': 'Position Applied For',
    'contact.form.jobPosition.placeholder': 'Enter the position you\'re applying for',
    'contact.form.cv.label': 'Upload Your CV/Resume',
    'contact.form.cv.placeholder': 'Click to upload your CV/Resume',
    'contact.form.consent.label': 'I consent to the processing of my personal data for recruitment purposes',
    'contact.form.submit.sending': 'Sending...',
    'contact.form.submit.send': 'Send Message',
    'contact.form.fileTypes': 'PDF, DOC, DOCX (Max 5MB)',
    'contact.info.title': 'Contact Information',
    'contact.info.subtitle': 'Reach out to us through any of the following channels. We\'re always ready to assist you with your construction and engineering needs.',
    'contact.info.office.title': 'Office Address',
    'contact.info.phone.title': 'Phone Numbers',
    'contact.info.email.title': 'Email Address',
    'contact.info.hours.title': 'Business Hours',
    'contact.info.hours.weekdays': 'Saturday- Wednesday: 8:00 AM - 5:00 PM',
    'contact.info.hours.thursday': 'Thursday: 8:00 AM - 2:30 PM',
    'contact.info.hours.weekend': 'Friday: Closed',
    
    // Home Page Blog Section Translations
    'home.blog.title': 'Latest from our Blog',
    'home.blog.subtitle': 'Stay informed with construction insights, industry trends, and project updates',
    'home.blog.views': 'views',
    'home.blog.readTime': 'min read',
    'home.blog.viewArticle': 'View Article',
    'home.blog.articles.1.title': 'Smart Cities: The Future of Urban Infrastructure',
    'home.blog.articles.1.description': 'Discover how smart city technologies are revolutionizing urban planning and construction, from IoT sensors to intelligent traffic management systems.',
    'home.blog.articles.1.category': 'Technology',
    'home.blog.articles.2.title': 'Sustainable Construction: Building for Tomorrow',
    'home.blog.articles.2.description': 'Explore innovative sustainable construction practices that are reducing environmental impact while maintaining cost-effectiveness and quality.',
    'home.blog.articles.2.category': 'Sustainability',
    'home.blog.articles.3.title': 'Modern Bridge Engineering: From Concept to Completion',
    'home.blog.articles.3.description': 'An in-depth look at the latest bridge construction techniques, materials, and design principles that are shaping the future of infrastructure.',
    'home.blog.articles.3.category': 'Construction',
    'home.blog.articles.4.title': 'The Rise of Prefabricated Construction',
    'home.blog.articles.4.description': 'How prefabrication is transforming the construction industry, reducing costs, improving quality, and accelerating project timelines.',
    'home.blog.articles.4.category': 'Industry',
    'home.blog.articles.5.title': 'Safety First: Advanced Construction Safety Protocols',
    'home.blog.articles.5.description': 'Essential safety measures and protocols that every construction professional should know to ensure workplace safety and compliance.',
    'home.blog.articles.5.category': 'Safety',
    'home.blog.articles.6.title': 'Green Building Materials: Eco-Friendly Alternatives',
    'home.blog.articles.6.description': 'Explore sustainable building materials that are revolutionizing construction while reducing environmental impact and carbon footprint.',
    'home.blog.articles.6.category': 'Sustainability',
    
    // Home Page Vendors Section Translations
    'home.vendors.title': 'Our',
    'home.vendors.highlight': 'Vendors',
    'home.vendors.subtitle': 'Comprehensive construction solutions tailored to meet your specific needs and vision',
    'home.vendors.viewAll': 'See All Vendors',
    
    // Home Page Success Partners Section Translations
    'home.partners.title': 'Our Success',
    'home.partners.highlight': 'Partners',
    
    
    // Blog posts
    'blog.posts.smartCities.title': 'Smart Cities: The Future of Urban Infrastructure',
    'blog.posts.smartCities.excerpt': 'Exploring how smart city technologies are revolutionizing urban development and infrastructure management.',
    'blog.posts.smartCities.category': 'Smart Cities',
    
    'blog.posts.sustainableConstruction.title': 'Sustainable Construction: Building for Tomorrow',
    'blog.posts.sustainableConstruction.excerpt': 'Discover innovative approaches to eco-friendly construction and green building practices.',
    'blog.posts.sustainableConstruction.category': 'Sustainability',
    
    'blog.posts.bridgeEngineering.title': 'Modern Bridge Engineering: From Concept to Completion',
    'blog.posts.bridgeEngineering.excerpt': 'An in-depth look at contemporary bridge design and construction techniques.',
    'blog.posts.bridgeEngineering.category': 'Engineering',
    
    'blog.posts.prefabricatedConstruction.title': 'The Rise of Prefabricated Construction',
    'blog.posts.prefabricatedConstruction.excerpt': 'How prefabrication is changing the construction industry with faster, more efficient building methods.',
    'blog.posts.prefabricatedConstruction.category': 'Innovation',
    
    'blog.posts.constructionSafety.title': 'Safety First: Advanced Construction Safety Protocols',
    'blog.posts.constructionSafety.excerpt': 'Essential safety measures and protocols that every construction project should implement.',
    'blog.posts.constructionSafety.category': 'Safety',
    
    'blog.posts.greenMaterials.title': 'Green Building Materials: Eco-Friendly Alternatives',
    'blog.posts.greenMaterials.excerpt': 'Exploring sustainable materials that are revolutionizing the construction industry.',
    'blog.posts.greenMaterials.category': 'Materials',
    
    'blog.posts.digitalTwins.title': 'Digital Twins in Construction: Virtual Reality Meets Reality',
    'blog.posts.digitalTwins.excerpt': 'How digital twin technology is transforming project management and construction processes.',
    'blog.posts.digitalTwins.category': 'Technology',
    
    'blog.posts.costManagement.title': 'Effective Cost Management in Construction Projects',
    'blog.posts.costManagement.excerpt': 'Strategies for maintaining budget control and maximizing value in construction projects.',
    'blog.posts.costManagement.category': 'Project Management',
    
    'blog.posts.innovativeMaterials.title': 'Innovative Materials Shaping the Future of Construction',
    'blog.posts.innovativeMaterials.excerpt': 'Cutting-edge materials that are pushing the boundaries of what\'s possible in construction.',
    'blog.posts.innovativeMaterials.category': 'Innovation',
    
    'blog.posts.aiAutomation.title': 'AI and Automation in Construction: The Next Revolution',
    'blog.posts.aiAutomation.excerpt': 'How artificial intelligence and automation are transforming construction workflows and efficiency.',
    'blog.posts.aiAutomation.category': 'Technology',
    
    'blog.posts.sustainableUrban.title': 'Sustainable Urban Development: Case Studies and Best Practices',
    'blog.posts.sustainableUrban.excerpt': 'Real-world examples of sustainable urban development projects and their impact.',
    'blog.posts.sustainableUrban.category': 'Urban Planning',
    
    'blog.posts.projectManagement.title': 'Advanced Project Management Techniques in Construction',
    'blog.posts.projectManagement.excerpt': 'Modern project management methodologies that ensure successful construction project delivery.',
    'blog.posts.projectManagement.category': 'Project Management',
    
    'blog.posts.bridgeDesign.title': 'Innovative Bridge Design: Engineering Marvels of the Modern Era',
    'blog.posts.bridgeDesign.excerpt': 'Exploring groundbreaking bridge designs that combine aesthetics with engineering excellence.',
    'blog.posts.bridgeDesign.category': 'Engineering',
    
    'blog.posts.greenCertification.title': 'Green Building Certification: LEED and Beyond',
    'blog.posts.greenCertification.excerpt': 'Understanding green building certifications and their importance in sustainable construction.',
    'blog.posts.greenCertification.category': 'Certification',
    
    // Services Page Translations
    'services.title': 'Our Services',
    'services.hero.subtitle': 'Comprehensive construction and engineering solutions tailored to meet your project requirements',
    'services.building.title': 'Building & Infrastructure',
    'services.building.description': 'Comprehensive construction services for commercial, residential, and industrial buildings with modern infrastructure development.',
    'services.building.feature1': 'Commercial & Residential Construction',
    'services.building.feature2': 'Industrial Facilities & Warehouses',
    'services.building.feature3': 'Infrastructure Development',
    'services.building.feature4': 'Foundation & Structural Work',
    'services.building.feature5': 'Quality Assurance & Testing',
    'services.building.feature6': 'Project Management & Coordination',
    'services.building.benefit1': 'End-to-end project delivery',
    'services.building.benefit2': 'Advanced construction techniques',
    'services.building.benefit3': 'Timely completion guarantee',
    'services.building.benefit4': 'Cost-effective solutions',
    'services.building.benefit5': 'Sustainable building practices',
    'services.design.title': 'Design & Engineering',
    'services.design.description': 'Professional architectural design and engineering services with innovative solutions and technical expertise.',
    'services.design.feature1': 'Architectural Design & Planning',
    'services.design.feature2': 'Structural Engineering',
    'services.design.feature3': 'MEP Engineering Design',
    'services.design.feature4': '3D Modeling & Visualization',
    'services.design.feature5': 'Technical Documentation',
    'services.design.feature6': 'Design Optimization',
    'services.design.benefit1': 'Innovative design solutions',
    'services.design.benefit2': 'Technical excellence',
    'services.design.benefit3': 'Cost optimization',
    'services.design.benefit4': 'Sustainable design principles',
    'services.design.benefit5': 'Comprehensive documentation',
    'services.cta.title': 'Ready to Start Your Project?',
    'services.cta.subtitle': 'Get in touch with our experts to discuss your construction needs and receive a customized solution.',
    'services.cta.button': 'Get Started',
    'services.cta.contact': 'Contact Us',
    'services.whatWeOffer': 'What We Offer',
    'services.keyBenefits': 'Key Benefits',
    'services.getQuoteFor': 'Get Quote for',
    'services.fallback.imageText': 'Service Image',
    'services.process.title': 'Our Process',
    'services.process.subtitle': 'How we deliver exceptional construction and engineering solutions',
    'services.process.step1.title': 'Consultation',
    'services.process.step1.description': 'We discuss your requirements and provide expert advice',
    'services.process.step2.title': 'Design & Planning',
    'services.process.step2.description': 'Create detailed plans and designs for your project',
    'services.process.step3.title': 'Implementation',
    'services.process.step3.description': 'Execute the project with precision and quality',
    'services.process.step4.title': 'Delivery',
    'services.process.step4.description': 'Complete project delivery with ongoing support',
    'services.why.title': 'Why Choose FMC',
    'services.why.subtitle1': 'We combine decades of experience with cutting-edge technology',
    'services.why.subtitle2': 'to deliver construction solutions that exceed expectations',
    'services.why.feature1.title': 'Expert Team',
    'services.why.feature1.description': 'Experienced professionals with proven track records',
    'services.why.feature2.title': 'Quality Assurance',
    'services.why.feature2.description': 'Rigorous quality control at every stage',
    'services.why.feature3.title': 'Innovation',
    'services.why.feature3.description': 'Latest technology and construction methods',
    'services.excellence.title': 'Excellence in Every Project',
    'services.excellence.subtitle': 'Delivering outstanding results since 2006',
    'services.cta.button1': 'Get Started',
    'services.cta.button2': 'Contact Us',
    'services.fitout.title': 'Architectural Fitout',
    'services.fitout.description': 'Complete interior design and fitout services for commercial and residential spaces with modern aesthetics.',
    'services.fitout.feature1': 'Interior Design & Planning',
    'services.fitout.feature2': 'Custom Furniture & Fixtures',
    'services.fitout.feature3': 'Premium Material Selection',
    'services.fitout.feature4': 'Space Optimization',
    'services.fitout.feature5': 'Aesthetic Enhancement',
    'services.fitout.feature6': 'Project Coordination',
    'services.fitout.benefit1': 'Customized solutions',
    'services.fitout.benefit2': 'Premium finishes',
    'services.fitout.benefit3': 'Space efficiency',
    'services.fitout.benefit4': 'Modern aesthetics',
    'services.fitout.benefit5': 'Quality craftsmanship',
    'services.civil.title': 'Civil Works',
    'services.civil.description': 'Comprehensive civil engineering services including roads, bridges, and infrastructure development.',
    'services.civil.feature1': 'Road & Highway Construction',
    'services.civil.feature2': 'Bridge & Tunnel Engineering',
    'services.civil.feature3': 'Utility Infrastructure',
    'services.civil.feature4': 'Drainage Systems',
    'services.civil.feature5': 'Site Preparation',
    'services.civil.feature6': 'Quality Control',
    'services.civil.benefit1': 'Durable infrastructure',
    'services.civil.benefit2': 'Safety compliance',
    'services.civil.benefit3': 'Cost efficiency',
    'services.civil.benefit4': 'Timely delivery',
    'services.civil.benefit5': 'Long-term reliability',
    'services.mep.title': 'MEP Works',
    'services.mep.description': 'Mechanical, electrical, and plumbing services with energy-efficient solutions and smart building integration.',
    'services.pricing.title': 'Pricing',
    'services.pricing.description': 'Transparent and competitive pricing with detailed cost breakdowns and value engineering solutions.',
    'services.pricing.feature1': 'Cost Analysis & Estimation',
    'services.pricing.feature2': 'Value Engineering',
    'services.pricing.feature3': 'Budget Planning',
    'services.pricing.feature4': 'Tender Documentation',
    'services.pricing.feature5': 'Price Optimization',
    'services.pricing.feature6': 'Financial Planning',
    'services.pricing.benefit1': 'Transparent pricing',
    'services.pricing.benefit2': 'Cost optimization',
    'services.pricing.benefit3': 'Value for money',
    'services.pricing.benefit4': 'Budget control',
    'services.pricing.benefit5': 'Financial planning',
    'services.maintenance.title': 'Maintenance',
    'services.maintenance.description': 'Comprehensive maintenance and facility management services to ensure long-term building performance.',
    'services.maintenance.feature1': 'Preventive Maintenance',
    'services.maintenance.feature2': 'Corrective Repairs',
    'services.maintenance.feature3': 'Facility Management',
    'services.maintenance.feature4': 'Equipment Maintenance',
    'services.maintenance.feature5': 'Emergency Services',
    'services.maintenance.feature6': 'Performance Monitoring',
    'services.maintenance.benefit1': 'Extended lifespan',
    'services.maintenance.benefit2': 'Cost efficiency',
    'services.maintenance.benefit3': 'Safety compliance',
    'services.maintenance.benefit4': 'Maintenance optimization',
    'services.maintenance.benefit5': 'Cost savings',
    
    // Sectors Page Translations
    'sectors.hero.title': 'Our Sectors',
    'sectors.hero.subtitle': 'Explore our diverse portfolio across multiple construction and engineering sectors',
    'sectors.hero.description1': 'From commercial buildings and residential complexes to industrial facilities and infrastructure projects, we deliver specialized solutions tailored to each sector\'s unique requirements and standards.',
    'sectors.hero.description2': 'Our extensive experience spans across eight key sectors, enabling us to provide comprehensive construction services that meet the specific needs of diverse industries and project types.',
    'sectors.hero.description3': 'With over 25 years of expertise and hundreds of completed projects, we have established ourselves as a trusted partner capable of handling complex construction challenges across all sectors.',
    'sectors.commercial.name': 'Commercial',
    'sectors.commercial.description': 'Office buildings, retail centers, shopping malls, and commercial complexes',
    'sectors.entertainment.name': 'Entertainment',
    'sectors.entertainment.description': 'Entertainment venues, cinemas, theme parks, and recreational facilities',
    'sectors.hotel.name': 'Hotel',
    'sectors.hotel.description': 'Luxury hotels, resorts, hospitality facilities, and accommodation complexes',
    'sectors.education.name': 'Education',
    'sectors.education.description': 'Education, universities, training centers, and educational institutions',
    'sectors.residential.name': 'Residential',
    'sectors.residential.description': 'Housing complexes, apartments, villas, and residential developments',
    'sectors.industrial.name': 'Industrial',
    'sectors.industrial.description': 'Manufacturing facilities, warehouses, industrial plants, and production centers',
    'sectors.energy.name': 'Energy',
    'sectors.energy.description': 'Power plants, renewable energy facilities, and energy infrastructure projects',
    'sectors.healthcare.name': 'Healthcare',
    'sectors.healthcare.description': 'Hospitals, medical centers, clinics, and healthcare facilities',
    'sectors.warehouse.name': 'Warehouse',
    'sectors.warehouse.description': 'Storage facilities, logistics centers, and distribution hubs',
    'sectors.cta.title': 'Ready to Build Your Vision?',
    'sectors.cta.subtitle': 'Let us help you bring your project to life with our sector-specific expertise and proven track record.',
    'sectors.cta.button': 'Start Your Project',
    'sectors.cta.contact': 'Contact Us',
    
    // Projects Page Translations
    'projects.hero.title': 'Our',
    'projects.hero.projects': 'Projects',
    'projects.hero.subtitle': 'Discover our portfolio of successful construction and engineering projects across various sectors',
    'projects.categories.all': 'All Sectors',
    'projects.categories.commercial': 'Commercial',
    'projects.categories.residential': 'Residential',
    'projects.categories.infrastructure': 'Infrastructure',
    'projects.categories.industrial': 'Industrial',
    'projects.categories.maintenance': 'Maintenance',
    'projects.locations.all': 'All Locations',
    'projects.locations.jeddah': 'Jeddah',
    'projects.locations.riyadh': 'Riyadh',
    'projects.locations.al-dammam': 'Al Dammam',
    'projects.locations.al-ula': 'Al Ula',
    'projects.status.all': 'All Status',
    'projects.status.ongoing': 'Ongoing',
    'projects.search.label': 'Search',
    'projects.search.placeholder': 'Search projects...',
    'projects.view.photo': 'Photo View',
    'projects.view.grid': 'Grid View',
    'projects.view.list': 'List View',
    'projects.view.map': 'Map View',
    'projects.map.title': 'Project Locations Map',
    'projects.map.subtitle': 'Explore our projects across different locations',
    'projects.map.widgetTitle': 'FMC Projects Locations',
    'projects.results.found': 'found',
    'projects.results.count': 'projects',
    'projects.filter.categories': 'Categories',
    'projects.filter.locations': 'Locations',
    'projects.filter.status': 'Status',
    'projects.filters.active': 'Active filters:',
    'projects.filters.sector': 'Sector:',
    'projects.filters.location': 'Location:',
    'projects.filters.status': 'Status:',
    'projects.filters.search': 'Search:',
    'projects.filters.clearAll': 'Clear all',
    'projects.cta.title': 'Ready to Start Your Project?',
    'projects.cta.subtitle': 'Let us help you bring your vision to life with our proven expertise and track record.',
    'projects.cta.contact': 'Contact Us',
    'projects.sector.commercial': 'Commercial',
    'projects.sector.residential': 'Residential',
    'projects.sector.infrastructure': 'Infrastructure',
    'projects.sector.maintenance': 'Maintenance',
    'projects.sector.industrial': 'Industrial',
    'projects.share': 'Share Project',
    'projects.labels.location': 'Location',
    'projects.labels.size': 'Size',
    'projects.labels.value': 'Value',
    'projects.labels.keyFeatures': 'Key Features',
    'projects.labels.year': 'Year',
    'projects.labels.builtUpArea': 'Built-up Area',
    'projects.views': 'views',
    'projects.viewDetails': 'View Details',
    'projects.noResults.title': 'No Projects Found',
    'projects.noResults.message': 'Try adjusting your search criteria or filters to find what you\'re looking for.',
    'projects.noResults.clearFilters': 'Clear All Filters',
    'projects.stats.title': 'Project Statistics',
    'projects.stats.subtitle': 'Our track record speaks for itself with impressive numbers across all sectors',
    'projects.stats.completed': 'Projects Completed',
    'projects.stats.value': 'Total Value',
    'projects.stats.satisfaction': 'Client Satisfaction',
    'projects.stats.experience': 'Years Experience',
    'projects.cta.button1': 'Start Your Project',
    'projects.cta.button2': 'View Our Services',
    'projects.locations.title': 'Our Project Locations',
    'projects.locations.subtitle': 'Explore our projects across different locations and see where we\'re making a difference',
    
    // Vendors Page Translations
    'vendors.hero.title': 'Our Trusted Vendors',
    'vendors.hero.subtitle': 'Working with leading manufacturers and suppliers across the region to deliver exceptional quality and reliability',
    'vendors.hero.description': 'Partner With Us',
    'vendors.categories.all': 'All Categories',
    'vendors.categories.materials': 'Materials',
    'vendors.categories.equipment': 'Equipment',
    'vendors.categories.services': 'Services',
    'vendors.categories.technology': 'Technology',
    'vendors.search.placeholder': 'Search vendors...',
    'vendors.cta.title': 'Become Our Partner',
    'vendors.cta.subtitle': 'Join our network of trusted vendors and suppliers to help us deliver exceptional construction solutions.',
    'vendors.cta.button': 'Apply Now',
    'vendors.cta.contact': 'Contact Us',
    'vendors.hero.partners': 'Partners',
    'vendors.verified': 'Verified Partner',
    'vendors.specialties': 'Specialties:',
    'vendors.partnership': 'Partnership:',
    'vendors.noResults': 'No vendors found',
    'vendors.noResultsDesc': 'Try adjusting your search criteria or category filter.',
    'vendors.contact': 'Contact Vendor',
    
    // Our Services Page
    'ourServices.title': 'Our Services',
    'ourServices.highlight': 'Services',
    'ourServices.subtitle': 'Comprehensive construction and engineering solutions designed to bring your vision to life with excellence and innovation.',
    'ourServices.cta.title': 'Ready to Start Your Next Project?',
    'ourServices.cta.subtitle': 'Contact us today to discuss your construction and engineering needs. Our expert team is ready to turn your vision into reality.',
    'ourServices.cta.button': 'Get Started Today',
    'ourServices.learnMore': 'Learn More',
    
    // Service Types
    'ourServices.buildingInfrastructure.title': 'Building & Infrastructure',
    'ourServices.buildingInfrastructure.description': 'Comprehensive construction services for commercial, residential, and industrial buildings with modern infrastructure development.',
    'ourServices.designEngineering.title': 'Design & Engineering',
    'ourServices.designEngineering.description': 'Professional architectural design and engineering services with innovative solutions and technical expertise.',
    'ourServices.architecturalFitout.title': 'Architectural Fitout',
    'ourServices.architecturalFitout.description': 'Specialized interior fitout services for commercial and residential spaces with premium finishes and custom solutions.',
    'ourServices.civilWorks.title': 'Civil Works',
    'ourServices.civilWorks.description': 'Comprehensive civil engineering services including roads, bridges, utilities, and infrastructure development.',
    'ourServices.mepWorks.title': 'MEP Works',
    'ourServices.mepWorks.description': 'Mechanical, Electrical, and Plumbing systems installation and maintenance with modern technology integration.',
    'ourServices.dataCenters.title': 'Data Centers Works',
    'ourServices.dataCenters.description': 'Professional data center construction and infrastructure services with advanced power, cooling, and security systems.',
    'ourServices.pricing.title': 'Pricing',
    'ourServices.pricing.description': 'Transparent and competitive pricing services with detailed cost analysis and value engineering.',
    'ourServices.maintenance.title': 'Maintenance',
    'ourServices.maintenance.description': 'Comprehensive maintenance services for buildings and infrastructure with preventive and corrective solutions.',
    
    // Documents Page
    'documents.hero.title': 'Our',
    'documents.hero.highlight': 'Documents',
    'documents.subtitle': 'Access our comprehensive collection of company documents, reports, and resources.',
    'documents.search.label': 'Search',
    'documents.search.placeholder': 'Search documents by title, date, volume, or issue...',
    'documents.filter.category': 'Category',
    'documents.filter.year': 'Year',
    'documents.categories.all': 'All Categories',
    'documents.categories.business': 'Business',
    'documents.categories.technology': 'Technology',
    'documents.categories.innovation': 'Innovation',
    'documents.categories.architecture': 'Architecture',
    'documents.categories.industrial': 'Industrial',
    'documents.categories.construction': 'Construction',
    'documents.categories.design': 'Design',
    'documents.years.all': 'All Years',
    'documents.results.found': 'documents found',
    'documents.view.grid': 'Grid View',
    'documents.view.list': 'List View',
    'documents.magazine': 'Magazine',
    'documents.download': 'Download',
    'documents.view': 'View',
    'documents.views': 'views',
    'documents.share': 'Share Document',
    'documents.volume': 'Volume',
    'documents.issue': 'Issue',
    'documents.filters.active': 'Active filters:',
    'documents.filters.category': 'Category:',
    'documents.filters.year': 'Year:',
    'documents.filters.search': 'Search:',
    'documents.filters.clearAll': 'Clear All Filters',
    'documents.noDocuments.title': 'No Documents Available',
    'documents.noDocuments.message': 'We are currently updating our document collection. Please check back soon for the latest resources.',
    'documents.cta.title': 'Need Specific Documents?',
    'documents.cta.subtitle': 'Can\'t find what you\'re looking for? Contact us and we\'ll help you locate the right documents.',
    'documents.cta.button': 'Contact Us',
    
    // Document Items
    'documents.april2019.title': 'Building Safety Guidelines',
    'documents.april2019.date': 'April 2019',
    'documents.april2019.volume': 'Vol. 12',
    'documents.april2019.issue': 'Issue 4',
    'documents.march2019.title': 'Project Management Standards',
    'documents.march2019.date': 'March 2019',
    'documents.march2019.volume': 'Vol. 12',
    'documents.march2019.issue': 'Issue 3',
    'documents.february2019.title': 'Quality Control Procedures',
    'documents.february2019.date': 'February 2019',
    'documents.february2019.volume': 'Vol. 12',
    'documents.february2019.issue': 'Issue 2',
    'documents.january2019.title': 'Building Code Compliance',
    'documents.january2019.date': 'January 2019',
    'documents.january2019.volume': 'Vol. 12',
    'documents.january2019.issue': 'Issue 1',
    'documents.december2018.title': 'Industrial Construction',
    'documents.december2018.date': 'December 2018',
    'documents.december2018.volume': 'Vol. 11',
    'documents.december2018.issue': 'Issue 12',
    'documents.november2018.title': 'Construction Management',
    'documents.november2018.date': 'November 2018',
    'documents.november2018.volume': 'Vol. 11',
    'documents.november2018.issue': 'Issue 11',
    'documents.october2018.title': 'Infrastructure Development',
    'documents.october2018.date': 'October 2018',
    'documents.october2018.volume': 'Vol. 11',
    'documents.october2018.issue': 'Issue 10',
    'documents.september2018.title': 'Construction Safety',
    'documents.september2018.date': 'September 2018',
    'documents.september2018.volume': 'Vol. 11',
    'documents.september2018.issue': 'Issue 9',
    'documents.august2018.title': 'Design Excellence',
    'documents.august2018.date': 'August 2018',
    'documents.august2018.volume': 'Vol. 11',
    'documents.august2018.issue': 'Issue 8',
    
    // Industries & Sectors Page
    'industriesSectors.title': 'Industries & Sectors',
    'industriesSectors.highlight': 'Sectors',
    'industriesSectors.subtitle': 'We serve diverse industries with specialized construction solutions tailored to meet unique sector requirements and standards.',
    'industriesSectors.cta.title': 'Looking for Industry-Specific Solutions?',
    'industriesSectors.cta.subtitle': 'Our specialized teams understand the unique requirements of each industry. Let us help you build something extraordinary.',
    'industriesSectors.cta.startProject': 'Start Your Project',
    'industriesSectors.cta.viewWork': 'View Our Work',
    'industriesSectors.projects': 'Projects',
    
    // Sector Types
    'industriesSectors.commercial.title': 'Commercial',
    'industriesSectors.commercial.description': 'Office buildings, retail centers, shopping malls, and commercial complexes designed for modern business needs. We specialize in creating dynamic workspaces that enhance productivity and collaboration. Our commercial projects feature cutting-edge technology integration and sustainable design principles.',
    'industriesSectors.entertainment.title': 'Entertainment',
    'industriesSectors.entertainment.description': 'Entertainment venues, cinemas, theme parks, and recreational facilities that create memorable experiences. We design immersive spaces that captivate audiences and create lasting memories. Our entertainment projects combine cutting-edge technology with innovative design to deliver extraordinary visitor experiences.',
    'industriesSectors.hotel.title': 'Hotel',
    'industriesSectors.hotel.description': 'Luxury hotels, resorts, boutique hotels, and hospitality projects with world-class amenities. We create exceptional guest experiences through innovative design and premium finishes. Our hospitality projects combine comfort, functionality, and aesthetic appeal to exceed guest expectations.',
    'industriesSectors.industrial.title': 'Industrial',
    'industriesSectors.industrial.description': 'Manufacturing facilities, processing plants, and industrial complexes built for optimal efficiency. We specialize in creating state-of-the-art production environments that maximize operational performance. Our industrial projects integrate advanced automation systems and sustainable manufacturing practices.',
    'industriesSectors.residential.title': 'Residential',
    'industriesSectors.residential.description': 'Housing complexes, apartments, villas, and residential developments that feel like home. We create comfortable living spaces that blend modern amenities with traditional values. Our residential projects focus on community integration, sustainable living, and exceptional quality of life.',
    'industriesSectors.school.title': 'Education',
    'industriesSectors.school.description': 'Educational institutions, universities, schools, and learning centers that inspire knowledge. We design innovative learning environments that foster creativity and academic excellence. Our educational projects incorporate modern technology, flexible spaces, and sustainable design to support future generations.',
    'industriesSectors.utilities.title': 'Utilities',
    'industriesSectors.utilities.description': 'Power plants, water treatment facilities, and infrastructure projects for essential services. We build critical infrastructure that supports communities and drives economic growth. Our utilities projects prioritize reliability, efficiency, and environmental sustainability for long-term success.',
    'industriesSectors.warehouse.title': 'Warehouse',
    'industriesSectors.warehouse.description': 'Storage facilities, logistics centers, and distribution hubs for efficient supply chain operations. We design smart warehousing solutions that optimize inventory management and distribution efficiency. Our warehouse projects integrate advanced automation, climate control, and security systems for maximum operational effectiveness.',
    
    // Commercial Sector Projects
    'commercial.projects.project1.title': 'Modern Office Complex',
    'commercial.projects.project1.description': 'A cutting-edge office building featuring flexible workspaces, advanced technology integration, and sustainable design elements.',
    'commercial.projects.project1.location': 'Riyadh',
    'commercial.projects.project1.status': 'completed',
    'commercial.projects.project1.completion': '2023',
    'commercial.projects.project1.size': '450,000 sq ft',
    'commercial.projects.project1.value': '$120M',
    'commercial.projects.project1.features.smart': 'Smart Building Systems',
    'commercial.projects.project1.features.flexible': 'Flexible Workspaces',
    'commercial.projects.project1.features.green': 'Green Roof',
    'commercial.projects.project1.features.security': 'Advanced Security',
    
    'commercial.projects.project2.title': 'Shopping Mall Development',
    'commercial.projects.project2.description': 'A comprehensive retail destination with multiple anchor stores, entertainment facilities, and premium dining options.',
    'commercial.projects.project2.location': 'Jeddah',
    'commercial.projects.project2.status': 'ongoing',
    'commercial.projects.project2.completion': '2024',
    'commercial.projects.project2.size': '800,000 sq ft',
    'commercial.projects.project2.value': '$180M',
    'commercial.projects.project2.features.retail': 'Multi-Level Retail',
    'commercial.projects.project2.features.entertainment': 'Entertainment Zone',
    'commercial.projects.project2.features.food': 'Food Court',
    'commercial.projects.project2.features.parking': 'Parking Garage',
    
    'commercial.projects.project3.title': 'Corporate Headquarters',
    'commercial.projects.project3.description': 'A flagship corporate building designed to reflect brand identity while providing state-of-the-art facilities for business operations.',
    'commercial.projects.project3.location': 'Dammam',
    'commercial.projects.project3.status': 'completed',
    'commercial.projects.project3.completion': '2022',
    'commercial.projects.project3.size': '300,000 sq ft',
    'commercial.projects.project3.value': '$85M',
    'commercial.projects.project3.features.suites': 'Executive Suites',
    'commercial.projects.project3.features.conference': 'Conference Centers',
    'commercial.projects.project3.features.amenities': 'Employee Amenities',
    'commercial.projects.project3.features.brand': 'Brand Integration',
    
    // Commercial Sector Page Content
    'commercial.hero.title': 'Commercial',
    'commercial.hero.highlight': 'Sector',
    'commercial.hero.subtitle': 'Constructing modern commercial spaces, office buildings, retail centers, and business complexes that drive economic growth',
    'commercial.overview.title': 'Commercial Construction Excellence',
    'commercial.overview.subtitle': 'Building the Future of Business',
    'commercial.overview.description': 'Our commercial construction division specializes in creating innovative business environments that foster productivity, collaboration, and growth. From towering office complexes to bustling retail centers, we deliver projects that exceed expectations and stand as landmarks of architectural excellence.',
    'commercial.overview.stats.projects': 'Commercial Projects',
    'commercial.overview.stats.experience': 'Years Experience',
    'commercial.overview.description1': 'Our Commercial sector expertise encompasses the construction of cutting-edge office buildings, retail centers, shopping malls, and mixed-use developments. We understand the unique demands of commercial spaces that need to be functional, efficient, and inspiring.',
    'commercial.overview.description2': 'From corporate headquarters to retail destinations, we deliver commercial projects that enhance business operations while creating environments that attract customers and employees alike.',
    
    // Commercial Services Section
    'commercial.services.title': 'Our Commercial Construction Services',
    'commercial.services.subtitle': 'Comprehensive commercial construction solutions for modern business needs',
    'commercial.services.office.title': 'Office Buildings',
    'commercial.services.office.description': 'Modern office complexes with flexible spaces and advanced technology',
    'commercial.services.office.feature1': 'Open floor plans',
    'commercial.services.office.feature2': 'Meeting facilities',
    'commercial.services.office.feature3': 'Technology integration',
    'commercial.services.office.feature4': 'Parking solutions',
    'commercial.services.retail.title': 'Retail Centers',
    'commercial.services.retail.description': 'Shopping malls and retail spaces designed for customer experience',
    'commercial.services.retail.feature1': 'Storefront design',
    'commercial.services.retail.feature2': 'Customer flow optimization',
    'commercial.services.retail.feature3': 'Loading facilities',
    'commercial.services.retail.feature4': 'Security systems',
    'commercial.services.corporate.title': 'Corporate Headquarters',
    'commercial.services.corporate.description': 'Flagship corporate buildings that reflect brand identity',
    'commercial.services.corporate.feature1': 'Executive facilities',
    'commercial.services.corporate.feature2': 'Conference centers',
    'commercial.services.corporate.feature3': 'Reception areas',
    'commercial.services.corporate.feature4': 'Brand integration',
    'commercial.services.mixed.title': 'Mixed-Use Developments',
    'commercial.services.mixed.description': 'Integrated commercial and residential development projects',
    'commercial.services.mixed.feature1': 'Multi-purpose design',
    'commercial.services.mixed.feature2': 'Shared amenities',
    'commercial.services.mixed.feature3': 'Efficient land use',
    'commercial.services.mixed.feature4': 'Community integration',
    'commercial.services.parks.title': 'Business Parks',
    'commercial.services.parks.description': 'Comprehensive business park development and construction',
    'commercial.services.parks.feature1': 'Campus planning',
    'commercial.services.parks.feature2': 'Landscaping',
    'commercial.services.parks.feature3': 'Infrastructure',
    'commercial.services.parks.feature4': 'Expansion capability',
    'commercial.services.smart.title': 'Smart Buildings',
    'commercial.services.smart.description': 'Technology-integrated buildings with automation systems',
    'commercial.services.smart.feature1': 'Building automation',
    'commercial.services.smart.feature2': 'Energy management',
    'commercial.services.smart.feature3': 'Smart security',
    'commercial.services.smart.feature4': 'IoT integration',
    'commercial.projects.title': 'Our Commercial Projects',
    'commercial.projects.subtitle': 'Discover our portfolio of innovative commercial developments that are shaping the future of business',
    'commercial.fallback.title': 'Commercial Construction',
    'commercial.project.category': 'Commercial',
    'commercial.project.status.completed': 'Completed',
    'commercial.project.status.ongoing': 'Ongoing',
    'commercial.project.location': 'Location:',
    'commercial.project.size': 'Size:',
    'commercial.project.value': 'Value:',
    'commercial.project.status': 'Status:',
    'commercial.project.features': 'Key Features:',
    
    // Commercial Why Choose Section
    'commercial.whyChoose.title': 'Why Choose FMC for Commercial Construction?',
    'commercial.whyChoose.subtitle': 'Our expertise in commercial construction, combined with innovative technology and efficient project management, delivers exceptional business environments.',
    'commercial.whyChoose.trackRecord.title': 'Proven Track Record',
    'commercial.whyChoose.trackRecord.description': 'Decades of experience delivering successful commercial projects across various industries',
    'commercial.whyChoose.expertTeams.title': 'Expert Teams',
    'commercial.whyChoose.expertTeams.description': 'Specialized teams understanding commercial construction requirements and regulations',
    'commercial.whyChoose.quality.title': 'Quality Standards',
    'commercial.whyChoose.quality.description': 'Commitment to highest quality standards and sustainable construction practices',
    'commercial.whyChoose.delivery.title': 'On-Time Delivery',
    'commercial.whyChoose.delivery.description': 'Efficient project management ensuring timely completion within budget',
    'commercial.whyChoose.card.title': 'Building Business Success',
    'commercial.whyChoose.card.subtitle': 'Where commerce meets construction excellence',
    
    // Commercial CTA Section
    'commercial.cta.title': 'Ready to Build Your Commercial Vision?',
    'commercial.cta.subtitle': 'Let\'s collaborate to create innovative commercial spaces that drive your business forward',
    'commercial.cta.startProject': 'Start Your Project',
    'commercial.cta.callNow': 'Call Now',
    
    // Entertainment Sector Projects
    'entertainment.projects.project1.title': 'Cinema Complex',
    'entertainment.projects.project1.description': 'A state-of-the-art cinema complex featuring multiple screens, premium seating, and advanced audio-visual technology.',
    'entertainment.projects.project1.location': 'Riyadh',
    'entertainment.projects.project1.status': 'completed',
    'entertainment.projects.project1.completion': '2023',
    'entertainment.projects.project1.size': '150,000 sq ft',
    'entertainment.projects.project1.value': '$45M',
    'entertainment.projects.project1.features.imax': 'IMAX Theater',
    'entertainment.projects.project1.features.seating': 'Premium Seating',
    'entertainment.projects.project1.features.audio': 'Dolby Atmos',
    'entertainment.projects.project1.features.concession': 'Concession Areas',
    
    'entertainment.projects.project2.title': 'Theme Park Development',
    'entertainment.projects.project2.description': 'A comprehensive theme park with multiple attractions, themed areas, and entertainment facilities for all ages.',
    'entertainment.projects.project2.location': 'Jeddah',
    'entertainment.projects.project2.status': 'ongoing',
    'entertainment.projects.project2.completion': '2025',
    'entertainment.projects.project2.size': '2,000,000 sq ft',
    'entertainment.projects.project2.value': '$350M',
    'entertainment.projects.project2.features.coasters': 'Roller Coasters',
    'entertainment.projects.project2.features.water': 'Water Rides',
    'entertainment.projects.project2.features.themed': 'Themed Areas',
    'entertainment.projects.project2.features.shows': 'Entertainment Shows',
    
    'entertainment.projects.project3.title': 'Concert Venue',
    'entertainment.projects.project3.description': 'A professional music venue designed for live performances with world-class acoustics and modern amenities.',
    'entertainment.projects.project3.location': 'Dammam',
    'entertainment.projects.project3.status': 'completed',
    'entertainment.projects.project3.completion': '2022',
    'entertainment.projects.project3.size': '200,000 sq ft',
    'entertainment.projects.project3.value': '$75M',
    'entertainment.projects.project3.features.acoustic': 'Acoustic Engineering',
    'entertainment.projects.project3.features.vip': 'VIP Areas',
    'entertainment.projects.project3.features.sound': 'Sound Systems',
    'entertainment.projects.project3.features.backstage': 'Backstage Facilities',
    
    // Entertainment Sector Page Content
    'entertainment.hero.title': 'Entertainment',
    'entertainment.hero.highlight': 'Sector',
    'entertainment.hero.subtitle': 'Creating extraordinary entertainment experiences through innovative construction of venues, cinemas, and recreational facilities',
    'entertainment.overview.title': 'Building Entertainment Destinations',
    'entertainment.overview.description1': 'Our Entertainment sector expertise encompasses the construction of world-class entertainment venues, from state-of-the-art cinemas and theme parks to recreational facilities and cultural centers. We understand the unique requirements of entertainment spaces.',
    'entertainment.overview.description2': 'From acoustic engineering to specialized lighting systems, we deliver entertainment venues that provide unforgettable experiences while meeting the highest standards of safety and functionality.',
    'entertainment.overview.stats.projects': 'Entertainment Projects',
    'entertainment.overview.stats.experience': 'Years Experience',
    'entertainment.fallback.title': 'Entertainment Construction',
    
    // Entertainment Services Section
    'entertainment.services.title': 'Our Entertainment Construction Services',
    'entertainment.services.subtitle': 'Specialized construction solutions for entertainment and recreational facilities',
    'entertainment.services.cinema.title': 'Cinema Complexes',
    'entertainment.services.cinema.description': 'State-of-the-art movie theaters with advanced audio-visual systems',
    'entertainment.services.cinema.feature1': 'Digital projection systems',
    'entertainment.services.cinema.feature2': 'Surround sound engineering',
    'entertainment.services.cinema.feature3': 'Comfortable seating',
    'entertainment.services.cinema.feature4': 'Concession facilities',
    'entertainment.services.theme.title': 'Theme Parks',
    'entertainment.services.theme.description': 'Complete theme park construction from concept to completion',
    'entertainment.services.theme.feature1': 'Ride infrastructure',
    'entertainment.services.theme.feature2': 'Safety systems',
    'entertainment.services.theme.feature3': 'Themed environments',
    'entertainment.services.theme.feature4': 'Visitor facilities',
    'entertainment.services.concert.title': 'Concert Venues',
    'entertainment.services.concert.description': 'Professional music venues and performance halls',
    'entertainment.services.concert.feature1': 'Acoustic engineering',
    'entertainment.services.concert.feature2': 'Stage construction',
    'entertainment.services.concert.feature3': 'Sound systems',
    'entertainment.services.concert.feature4': 'Audience facilities',
    'entertainment.services.recreation.title': 'Recreation Centers',
    'entertainment.services.recreation.description': 'Community and recreational facility construction',
    'entertainment.services.recreation.feature1': 'Sports facilities',
    'entertainment.services.recreation.feature2': 'Swimming pools',
    'entertainment.services.recreation.feature3': 'Fitness areas',
    'entertainment.services.recreation.feature4': 'Multi-purpose halls',
    'entertainment.services.cultural.title': 'Cultural Centers',
    'entertainment.services.cultural.description': 'Museums, galleries, and cultural facility construction',
    'entertainment.services.cultural.feature1': 'Exhibition spaces',
    'entertainment.services.cultural.feature2': 'Climate control',
    'entertainment.services.cultural.feature3': 'Security systems',
    'entertainment.services.cultural.feature4': 'Accessibility features',
    'entertainment.services.complex.title': 'Entertainment Complexes',
    'entertainment.services.complex.description': 'Mixed-use entertainment and dining complexes',
    'entertainment.services.complex.feature1': 'Multi-venue design',
    'entertainment.services.complex.feature2': 'Integrated systems',
    'entertainment.services.complex.feature3': 'Parking facilities',
    'entertainment.services.complex.feature4': 'Safety compliance',
    'entertainment.projects.title': 'Our Entertainment Projects',
    'entertainment.projects.subtitle': 'Discover our portfolio of innovative entertainment venues that create unforgettable experiences',
    'entertainment.project.category': 'Entertainment',
    'entertainment.project.status.completed': 'Completed',
    'entertainment.project.status.ongoing': 'Ongoing',
    'entertainment.project.location': 'Location:',
    'entertainment.project.size': 'Size:',
    'entertainment.project.value': 'Value:',
    'entertainment.project.status': 'Status:',
    'entertainment.project.features': 'Key Features:',
    
    // Entertainment Why Choose Section
    'entertainment.whyChoose.title': 'Why Choose FMC for Entertainment Construction?',
    'entertainment.whyChoose.subtitle': 'Our expertise in entertainment construction, combined with innovative technology and creative solutions, delivers exceptional entertainment venues.',
    'entertainment.whyChoose.specialized.title': 'Specialized Expertise',
    'entertainment.whyChoose.specialized.description': 'Deep understanding of entertainment venue requirements and regulations',
    'entertainment.whyChoose.technical.title': 'Technical Excellence',
    'entertainment.whyChoose.technical.description': 'Advanced audio-visual, lighting, and safety system integration',
    'entertainment.whyChoose.creative.title': 'Creative Solutions',
    'entertainment.whyChoose.creative.description': 'Innovative design approaches for unique entertainment experiences',
    'entertainment.whyChoose.delivery.title': 'Timely Delivery',
    'entertainment.whyChoose.delivery.description': 'Efficient project management meeting opening date requirements',
    'entertainment.whyChoose.card.title': 'Creating Entertainment Experiences',
    'entertainment.whyChoose.card.subtitle': 'Where imagination meets construction excellence',
    
    // Entertainment CTA Section
    'entertainment.cta.title': 'Ready to Build Your Entertainment Vision?',
    'entertainment.cta.subtitle': 'Let\'s collaborate to create extraordinary entertainment venues that captivate and inspire',
    'entertainment.cta.startProject': 'Start Your Project',
    'entertainment.cta.callNow': 'Call Now',
    
    // Hotel Sector Projects
    'hotel.projects.project1.title': 'Luxury Resort Complex',
    'hotel.projects.project1.description': 'A five-star resort featuring luxury accommodations, world-class amenities, and breathtaking views of the coastline.',
    'hotel.projects.project1.location': 'Jeddah',
    'hotel.projects.project1.status': 'completed',
    'hotel.projects.project1.completion': '2023',
    'hotel.projects.project1.size': '500,000 sq ft',
    'hotel.projects.project1.value': '$200M',
    'hotel.projects.project1.features.beachfront': 'Beachfront Access',
    'hotel.projects.project1.features.spa': 'Spa Facilities',
    'hotel.projects.project1.features.dining': 'Fine Dining',
    'hotel.projects.project1.features.conference': 'Conference Centers',
    
    'hotel.projects.project2.title': 'Boutique Hotel',
    'hotel.projects.project2.description': 'An intimate boutique hotel with unique character, personalized service, and sophisticated design elements.',
    'hotel.projects.project2.location': 'Riyadh',
    'hotel.projects.project2.status': 'ongoing',
    'hotel.projects.project2.completion': '2024',
    'hotel.projects.project2.size': '100,000 sq ft',
    'hotel.projects.project2.value': '$65M',
    'hotel.projects.project2.features.design': 'Custom Design',
    'hotel.projects.project2.features.service': 'Personalized Service',
    'hotel.projects.project2.features.character': 'Local Character',
    'hotel.projects.project2.features.amenities': 'Unique Amenities',
    
    'hotel.projects.project3.title': 'Business Hotel',
    'hotel.projects.project3.description': 'A modern business hotel designed for corporate travelers with extensive meeting facilities and business amenities.',
    'hotel.projects.project3.location': 'Dammam',
    'hotel.projects.project3.status': 'completed',
    'hotel.projects.project3.completion': '2022',
    'hotel.projects.project3.size': '300,000 sq ft',
    'hotel.projects.project3.value': '$120M',
    'hotel.projects.project3.features.business': 'Business Center',
    'hotel.projects.project3.features.meeting': 'Meeting Rooms',
    'hotel.projects.project3.features.lounge': 'Executive Lounge',
    'hotel.projects.project3.features.internet': 'High-Speed Internet',
    
    // Hotel Sector Page Content
    'hotel.hero.title': 'Hotel',
    'hotel.hero.highlight': 'Sector',
    'hotel.hero.subtitle': 'Constructing luxury hotels, resorts, and hospitality venues that deliver exceptional guest experiences and lasting memories',
    'hotel.overview.title': 'Crafting Hospitality Excellence',
    'hotel.overview.description1': 'Our Hotel sector expertise encompasses the construction of world-class hospitality venues, from luxury five-star hotels and boutique properties to resort complexes and conference centers. We understand the intricate requirements of hospitality construction.',
    'hotel.overview.description2': 'From guest room comfort to operational efficiency, we deliver hotel projects that enhance the guest experience while maximizing operational performance and profitability for owners.',
    'hotel.overview.stats.projects': 'Hotel Projects',
    'hotel.overview.stats.experience': 'Years Experience',
    'hotel.fallback.title': 'Hotel Construction',
    
    // Hotel Services Section
    'hotel.services.title': 'Our Hotel Construction Services',
    'hotel.services.subtitle': 'Comprehensive hospitality construction solutions for exceptional guest experiences',
    'hotel.services.luxury.title': 'Luxury Hotels',
    'hotel.services.luxury.description': 'Five-star hotels with premium amenities and sophisticated design',
    'hotel.services.luxury.feature1': 'Presidential suites',
    'hotel.services.luxury.feature2': 'Concierge services',
    'hotel.services.luxury.feature3': 'Spa facilities',
    'hotel.services.luxury.feature4': 'Fine dining venues',
    'hotel.services.boutique.title': 'Boutique Hotels',
    'hotel.services.boutique.description': 'Intimate, stylish hotels with unique character and personalized service',
    'hotel.services.boutique.feature1': 'Custom design',
    'hotel.services.boutique.feature2': 'Local character',
    'hotel.services.boutique.feature3': 'Personalized service',
    'hotel.services.boutique.feature4': 'Unique amenities',
    'hotel.services.resort.title': 'Resort Complexes',
    'hotel.services.resort.description': 'Complete resort destinations with comprehensive recreational facilities',
    'hotel.services.resort.feature1': 'Multiple pools',
    'hotel.services.resort.feature2': 'Recreation centers',
    'hotel.services.resort.feature3': 'Beachfront access',
    'hotel.services.resort.feature4': 'Entertainment venues',
    'hotel.services.conference.title': 'Conference Hotels',
    'hotel.services.conference.description': 'Business hotels with extensive meeting and conference facilities',
    'hotel.services.conference.feature1': 'Meeting rooms',
    'hotel.services.conference.feature2': 'Convention centers',
    'hotel.services.conference.feature3': 'Business centers',
    'hotel.services.conference.feature4': 'Catering facilities',
    'hotel.services.smart.title': 'Smart Hotels',
    'hotel.services.smart.description': 'Technology-integrated hotels with modern automation systems',
    'hotel.services.smart.feature1': 'Room automation',
    'hotel.services.smart.feature2': 'Digital check-in',
    'hotel.services.smart.feature3': 'Smart controls',
    'hotel.services.smart.feature4': 'High-speed connectivity',
    'hotel.services.extended.title': 'Extended Stay Hotels',
    'hotel.services.extended.description': 'Long-term accommodation with apartment-style amenities',
    'hotel.services.extended.feature1': 'Kitchenettes',
    'hotel.services.extended.feature2': 'Extended space',
    'hotel.services.extended.feature3': 'Laundry facilities',
    'hotel.services.extended.feature4': 'Storage solutions',
    'hotel.projects.title': 'Our Hotel Projects',
    'hotel.projects.subtitle': 'Discover our portfolio of innovative hospitality venues that deliver exceptional guest experiences',
    'hotel.project.category': 'Hotel',
    'hotel.project.status.completed': 'Completed',
    'hotel.project.status.ongoing': 'Ongoing',
    'hotel.project.location': 'Location:',
    'hotel.project.size': 'Size:',
    'hotel.project.value': 'Value:',
    'hotel.project.status': 'Status:',
    'hotel.project.features': 'Key Features:',
    
    // Hotel Why Choose Section
    'hotel.whyChoose.title': 'Why Choose FMC for Hotel Construction?',
    'hotel.whyChoose.subtitle': 'Our expertise in hospitality construction, combined with understanding of guest expectations and operational requirements, delivers exceptional hotel properties.',
    'hotel.whyChoose.expertise.title': 'Hospitality Expertise',
    'hotel.whyChoose.expertise.description': 'Specialized knowledge of hotel operations, guest expectations, and industry standards',
    'hotel.whyChoose.guest.title': 'Guest Experience Focus',
    'hotel.whyChoose.guest.description': 'Design and construction prioritizing comfort, convenience, and memorable experiences',
    'hotel.whyChoose.luxury.title': 'Luxury Standards',
    'hotel.whyChoose.luxury.description': 'Commitment to highest quality finishes and premium construction standards',
    'hotel.whyChoose.schedule.title': 'Opening Schedule',
    'hotel.whyChoose.schedule.description': 'Efficient project delivery to meet critical opening dates and revenue targets',
    'hotel.whyChoose.card.title': 'Creating Hospitality Excellence',
    'hotel.whyChoose.card.subtitle': 'Where luxury meets construction craftsmanship',
    
    // Hotel CTA Section
    'hotel.cta.title': 'Ready to Build Your Hotel Vision?',
    'hotel.cta.subtitle': 'Let\'s collaborate to create exceptional hospitality venues that provide unforgettable guest experiences',
    'hotel.cta.startProject': 'Start Your Project',
    'hotel.cta.callNow': 'Call Now',
    
    // Industrial Sector Projects
    'industrial.projects.project1.title': 'Advanced Manufacturing Plant',
    'industrial.projects.project1.description': 'A state-of-the-art manufacturing facility designed for high-tech production with automated systems and quality control.',
    'industrial.projects.project1.location': 'Jeddah',
    'industrial.projects.project1.status': 'completed',
    'industrial.projects.project1.completion': '2023',
    'industrial.projects.project1.size': '600,000 sq ft',
    'industrial.projects.project1.value': '$95M',
    'industrial.projects.project1.features.automation': 'Automated Production Lines',
    'industrial.projects.project1.features.quality': 'Quality Control Labs',
    'industrial.projects.project1.features.robotics': 'Advanced Robotics',
    'industrial.projects.project1.features.energy': 'Sustainable Energy Systems',
    
    'industrial.projects.project2.title': 'Chemical Processing Facility',
    'industrial.projects.project2.description': 'A modern chemical processing plant with advanced safety systems and environmental compliance technology.',
    'industrial.projects.project2.location': 'Yanbu',
    'industrial.projects.project2.status': 'ongoing',
    'industrial.projects.project2.completion': '2024',
    'industrial.projects.project2.size': '450,000 sq ft',
    'industrial.projects.project2.value': '$110M',
    'industrial.projects.project2.features.safety': 'Advanced Safety Systems',
    'industrial.projects.project2.features.environmental': 'Environmental Controls',
    'industrial.projects.project2.features.automation': 'Process Automation',
    'industrial.projects.project2.features.waste': 'Waste Treatment',
    
    // Industrial Sector Page Content
    'industrial.hero.title': 'Industrial',
    'industrial.hero.highlight': 'Sector',
    'industrial.hero.subtitle': 'Building the foundation of industrial progress with cutting-edge manufacturing and processing facilities',
    'industrial.overview.title': 'Industrial Excellence & Innovation',
    'industrial.overview.description': 'Our industrial sector expertise covers manufacturing facilities, processing plants, and industrial complexes. We focus on efficiency, safety, and sustainability to create facilities that drive industrial growth.',
    'industrial.overview.feature1': 'Advanced automation systems',
    'industrial.overview.feature2': 'Safety and compliance standards',
    'industrial.overview.feature3': 'Environmental sustainability',
    'industrial.overview.feature4': 'Quality control integration',
    'industrial.overview.stats.projects': 'Industrial Projects',
    'industrial.overview.stats.experience': 'Years Experience',
    'industrial.overview.card.title': 'Industrial Projects',
    'industrial.overview.card.description': 'We\'ve successfully delivered industrial projects, creating facilities that drive manufacturing excellence and economic growth.',
    'industrial.projects.title': 'Our Industrial Projects',
    'industrial.projects.subtitle': 'Discover our portfolio of innovative industrial facilities that are powering the future of manufacturing',
    'industrial.project.category': 'Industrial',
    'industrial.project.status.completed': 'Completed',
    'industrial.project.status.ongoing': 'Ongoing',
    'industrial.project.location': 'Location:',
    'industrial.project.size': 'Size:',
    'industrial.project.value': 'Value:',
    'industrial.project.features': 'Key Features',
    'industrial.cta.title': 'Ready to Build Your Industrial Facility?',
    'industrial.cta.subtitle': 'Let\'s discuss how we can bring your industrial vision to life with our expertise in industrial construction and development.',
    'industrial.cta.startProject': 'Start Your Project',
    'industrial.cta.exploreSectors': 'Explore Other Sectors',
    
    // Industrial Services
    'industrial.services.title': 'Our Industrial Construction Services',
    'industrial.services.subtitle': 'Comprehensive industrial construction solutions for manufacturing excellence and operational efficiency',
    'industrial.services.manufacturing.title': 'Manufacturing Plants',
    'industrial.services.manufacturing.description': 'State-of-the-art manufacturing facilities with advanced automation and quality control systems',
    'industrial.services.manufacturing.feature1': 'Automated production lines',
    'industrial.services.manufacturing.feature2': 'Quality control systems',
    'industrial.services.manufacturing.feature3': 'Robotic integration',
    'industrial.services.manufacturing.feature4': 'Energy efficiency',
    'industrial.services.warehouse.title': 'Industrial Warehouses',
    'industrial.services.warehouse.description': 'Large-scale storage and distribution facilities with modern logistics infrastructure',
    'industrial.services.warehouse.feature1': 'Automated storage systems',
    'industrial.services.warehouse.feature2': 'Loading docks',
    'industrial.services.warehouse.feature3': 'Climate control',
    'industrial.services.warehouse.feature4': 'Security systems',
    'industrial.services.processing.title': 'Processing Facilities',
    'industrial.services.processing.description': 'Specialized processing plants for food, chemical, and material processing industries',
    'industrial.services.processing.feature1': 'Hygienic design',
    'industrial.services.processing.feature2': 'Waste management',
    'industrial.services.processing.feature3': 'Safety protocols',
    'industrial.services.processing.feature4': 'Regulatory compliance',
    'industrial.services.energy.title': 'Energy Infrastructure',
    'industrial.services.energy.description': 'Power generation and distribution systems for industrial operations',
    'industrial.services.energy.feature1': 'Power plants',
    'industrial.services.energy.feature2': 'Distribution networks',
    'industrial.services.energy.feature3': 'Backup systems',
    'industrial.services.energy.feature4': 'Renewable integration',
    'industrial.services.research.title': 'Research Facilities',
    'industrial.services.research.description': 'Advanced research and development centers with cutting-edge technology',
    'industrial.services.research.feature1': 'Laboratory spaces',
    'industrial.services.research.feature2': 'Testing equipment',
    'industrial.services.research.feature3': 'Data centers',
    'industrial.services.research.feature4': 'Collaboration areas',
    'industrial.services.maintenance.title': 'Maintenance Centers',
    'industrial.services.maintenance.description': 'Specialized maintenance and repair facilities for industrial equipment',
    'industrial.services.maintenance.feature1': 'Equipment bays',
    'industrial.services.maintenance.feature2': 'Tool storage',
    'industrial.services.maintenance.feature3': 'Safety equipment',
    'industrial.services.maintenance.feature4': 'Training areas',
    
    // Residential Sector Projects
    'residential.projects.project1.title': 'Luxury Villa Complex',
    'residential.projects.project1.description': 'A premium residential development featuring luxury villas with modern amenities and beautiful landscaping.',
    'residential.projects.project1.location': 'Jeddah',
    'residential.projects.project1.status': 'completed',
    'residential.projects.project1.completion': '2023',
    'residential.projects.project1.size': '250,000 sq ft',
    'residential.projects.project1.value': '$65M',
    'residential.projects.project1.features.villas': 'Luxury Villas',
    'residential.projects.project1.features.amenities': 'Modern Amenities',
    'residential.projects.project1.features.landscaping': 'Beautiful Landscaping',
    'residential.projects.project1.features.security': 'Security Systems',
    
    'residential.projects.project2.title': 'Modern Apartment Tower',
    'residential.projects.project2.description': 'A contemporary residential tower with smart home features and community facilities.',
    'residential.projects.project2.location': 'Riyadh',
    'residential.projects.project2.status': 'ongoing',
    'residential.projects.project2.completion': '2024',
    'residential.projects.project2.size': '400,000 sq ft',
    'residential.projects.project2.value': '$80M',
    'residential.projects.project2.features.smart': 'Smart Home Features',
    'residential.projects.project2.features.community': 'Community Facilities',
    'residential.projects.project2.features.design': 'Modern Design',
    'residential.projects.project2.features.finishes': 'Premium Finishes',
    
    // Residential Sector Page Content
    'residential.hero.title': 'Residential',
    'residential.hero.highlight': 'Sector',
    'residential.hero.subtitle': 'Creating dream homes and communities that provide comfort, luxury, and modern living',
    'residential.overview.title': 'Residential Excellence & Innovation',
    'residential.overview.description': 'Our residential sector expertise covers housing complexes, apartments, villas, and residential developments. We focus on creating comfortable, sustainable, and modern living spaces.',
    'residential.overview.feature1': 'Comfortable living spaces',
    'residential.overview.feature2': 'Modern amenities',
    'residential.overview.feature3': 'Sustainable design',
    'residential.overview.feature4': 'Community facilities',
    'residential.overview.stats.projects': 'Residential Projects',
    'residential.overview.stats.experience': 'Years Experience',
    'residential.overview.card.title': 'Residential Projects',
    'residential.overview.card.description': 'We\'ve successfully delivered residential projects, creating homes and communities that families love to live in.',
    'residential.projects.title': 'Our Residential Projects',
    'residential.projects.subtitle': 'Discover our portfolio of innovative residential developments that are redefining modern living',
    'residential.project.category': 'Residential',
    'residential.project.status.completed': 'Completed',
    'residential.project.status.ongoing': 'Ongoing',
    'residential.project.location': 'Location:',
    'residential.project.size': 'Size:',
    'residential.project.value': 'Value:',
    'residential.project.features': 'Key Features',
    'residential.cta.title': 'Ready to Build Your Dream Home?',
    'residential.cta.subtitle': 'Let\'s discuss how we can bring your residential vision to life with our expertise in home construction and development.',
    'residential.cta.startProject': 'Start Your Project',
    'residential.cta.exploreSectors': 'Explore Other Sectors',
    
    // Residential Services
    'residential.services.title': 'Our Residential Construction Services',
    'residential.services.subtitle': 'Comprehensive residential construction solutions for comfortable and modern living spaces',
    'residential.services.villas.title': 'Luxury Villas',
    'residential.services.villas.description': 'Premium villa construction with custom designs and high-end finishes',
    'residential.services.villas.feature1': 'Custom architecture',
    'residential.services.villas.feature2': 'Premium materials',
    'residential.services.villas.feature3': 'Smart home systems',
    'residential.services.villas.feature4': 'Landscaping design',
    'residential.services.apartments.title': 'Apartment Complexes',
    'residential.services.apartments.description': 'Modern apartment buildings with contemporary amenities and efficient layouts',
    'residential.services.apartments.feature1': 'Modern layouts',
    'residential.services.apartments.feature2': 'Community amenities',
    'residential.services.apartments.feature3': 'Parking facilities',
    'residential.services.apartments.feature4': 'Security systems',
    'residential.services.townhouses.title': 'Townhouses',
    'residential.services.townhouses.description': 'Connected residential units with individual entrances and shared amenities',
    'residential.services.townhouses.feature1': 'Individual entrances',
    'residential.services.townhouses.feature2': 'Shared amenities',
    'residential.services.townhouses.feature3': 'Private gardens',
    'residential.services.townhouses.feature4': 'Community spaces',
    'residential.services.compounds.title': 'Residential Compounds',
    'residential.services.compounds.description': 'Gated communities with comprehensive facilities and recreational areas',
    'residential.services.compounds.feature1': 'Gated security',
    'residential.services.compounds.feature2': 'Recreational facilities',
    'residential.services.compounds.feature3': 'Maintenance services',
    'residential.services.compounds.feature4': 'Community centers',
    'residential.services.renovation.title': 'Home Renovation',
    'residential.services.renovation.description': 'Complete home renovation and remodeling services for existing properties',
    'residential.services.renovation.feature1': 'Interior design',
    'residential.services.renovation.feature2': 'Structural updates',
    'residential.services.renovation.feature3': 'Modern fixtures',
    'residential.services.renovation.feature4': 'Energy efficiency',
    'residential.services.custom.title': 'Custom Homes',
    'residential.services.custom.description': 'Bespoke home construction tailored to individual preferences and requirements',
    'residential.services.custom.feature1': 'Personalized design',
    'residential.services.custom.feature2': 'Flexible layouts',
    'residential.services.custom.feature3': 'Quality craftsmanship',
    'residential.services.custom.feature4': 'Timeline management',
    
    // School Sector Projects
    'school.projects.project1.title': 'International School Campus',
    'school.projects.project1.description': 'A modern educational complex featuring state-of-the-art classrooms, science labs, and sports facilities.',
    'school.projects.project1.location': 'Jeddah',
    'school.projects.project1.status': 'completed',
    'school.projects.project1.completion': '2023',
    'school.projects.project1.size': '450,000 sq ft',
    'school.projects.project1.value': '$75M',
    'school.projects.project1.features.classrooms': 'Modern Classrooms',
    'school.projects.project1.features.labs': 'Science Labs',
    'school.projects.project1.features.sports': 'Sports Facilities',
    'school.projects.project1.features.technology': 'Technology Integration',
    
    'school.projects.project2.title': 'University Research Center',
    'school.projects.project2.description': 'A cutting-edge research facility designed for advanced studies and innovation in various fields.',
    'school.projects.project2.location': 'Riyadh',
    'school.projects.project2.status': 'ongoing',
    'school.projects.project2.completion': '2024',
    'school.projects.project2.size': '380,000 sq ft',
    'school.projects.project2.value': '$90M',
    'school.projects.project2.features.research': 'Research Labs',
    'school.projects.project2.features.conference': 'Conference Centers',
    'school.projects.project2.features.innovation': 'Innovation Hubs',
    'school.projects.project2.features.collaborative': 'Collaborative Spaces',
    
    // School Sector Page Content
    'school.hero.title': 'Education',
    'school.hero.highlight': 'Sector',
    'school.hero.subtitle': 'Building the future through innovative educational facilities that inspire learning and growth',
    'school.overview.title': 'Educational Excellence & Innovation',
    'school.overview.description': 'Our schools sector expertise covers educational institutions, universities, and learning centers. We focus on creating environments that foster academic excellence and personal development.',
    'school.overview.feature1': 'Modern learning environments',
    'school.overview.feature2': 'Technology integration',
    'school.overview.feature3': 'Collaborative spaces',
    'school.overview.feature4': 'Sustainable design',
    'school.overview.stats.projects': 'Educational Projects',
    'school.overview.stats.experience': 'Years Experience',
    'school.overview.card.title': 'Educational Projects',
    'school.overview.card.description': 'We\'ve successfully delivered educational projects, creating learning environments that inspire students and educators alike.',
    'school.projects.title': 'Our Educational Projects',
    'school.projects.subtitle': 'Discover our portfolio of innovative educational facilities that are shaping the future of learning',
    'school.project.category': 'Education',
    'school.project.status.completed': 'Completed',
    'school.project.status.ongoing': 'Ongoing',
    'school.project.location': 'Location:',
    'school.project.size': 'Size:',
    'school.project.value': 'Value:',
    'school.project.features': 'Key Features',
    'school.cta.title': 'Ready to Build Your Educational Facility?',
    'school.cta.subtitle': 'Let\'s discuss how we can bring your educational vision to life with our expertise in school construction and development.',
    'school.cta.startProject': 'Start Your Project',
    'school.cta.exploreSectors': 'Explore Other Sectors',
    
    // School Services
    'school.services.title': 'Our Educational Construction Services',
    'school.services.subtitle': 'Comprehensive educational construction solutions for inspiring learning environments',
    'school.services.universities.title': 'Universities',
    'school.services.universities.description': 'Higher education institutions with advanced research facilities and modern infrastructure',
    'school.services.universities.feature1': 'Research laboratories',
    'school.services.universities.feature2': 'Lecture halls',
    'school.services.universities.feature3': 'Student housing',
    'school.services.universities.feature4': 'Library facilities',
    'school.services.schools.title': 'Education',
    'school.services.schools.description': 'Primary and secondary educational facilities with modern classrooms and amenities',
    'school.services.schools.feature1': 'Modern classrooms',
    'school.services.schools.feature2': 'Science laboratories',
    'school.services.schools.feature3': 'Sports facilities',
    'school.services.schools.feature4': 'Cafeteria spaces',
    'school.services.kindergartens.title': 'Kindergartens',
    'school.services.kindergartens.description': 'Early childhood education centers with safe and stimulating environments',
    'school.services.kindergartens.feature1': 'Play areas',
    'school.services.kindergartens.feature2': 'Safety features',
    'school.services.kindergartens.feature3': 'Learning corners',
    'school.services.kindergartens.feature4': 'Outdoor spaces',
    'school.services.training.title': 'Training Centers',
    'school.services.training.description': 'Professional development and vocational training facilities',
    'school.services.training.feature1': 'Workshop spaces',
    'school.services.training.feature2': 'Equipment rooms',
    'school.services.training.feature3': 'Conference rooms',
    'school.services.training.feature4': 'Practical labs',
    'school.services.libraries.title': 'Libraries',
    'school.services.libraries.description': 'Modern library facilities with digital resources and study spaces',
    'school.services.libraries.feature1': 'Digital resources',
    'school.services.libraries.feature2': 'Study areas',
    'school.services.libraries.feature3': 'Group spaces',
    'school.services.libraries.feature4': 'Technology access',
    'school.services.sports.title': 'Sports Facilities',
    'school.services.sports.description': 'Comprehensive sports and recreational facilities for educational institutions',
    'school.services.sports.feature1': 'Gymnasiums',
    'school.services.sports.feature2': 'Playing fields',
    'school.services.sports.feature3': 'Swimming pools',
    'school.services.sports.feature4': 'Equipment storage',
    
    // Utilities Sector Projects
    'utilities.projects.project1.title': 'Solar Power Plant',
    'utilities.projects.project1.description': 'A large-scale solar energy facility designed to provide clean, renewable power to the region.',
    'utilities.projects.project1.location': 'Jeddah',
    'utilities.projects.project1.status': 'completed',
    'utilities.projects.project1.completion': '2023',
    'utilities.projects.project1.size': '800,000 sq ft',
    'utilities.projects.project1.value': '$150M',
    'utilities.projects.project1.features.solar': 'Solar Panels',
    'utilities.projects.project1.features.storage': 'Energy Storage',
    'utilities.projects.project1.features.grid': 'Grid Integration',
    'utilities.projects.project1.features.monitoring': 'Monitoring Systems',
    
    'utilities.projects.project2.title': 'Water Treatment Facility',
    'utilities.projects.project2.description': 'A modern water purification plant with advanced filtration and treatment technologies.',
    'utilities.projects.project2.location': 'Riyadh',
    'utilities.projects.project2.status': 'ongoing',
    'utilities.projects.project2.completion': '2024',
    'utilities.projects.project2.size': '350,000 sq ft',
    'utilities.projects.project2.value': '$95M',
    'utilities.projects.project2.features.filtration': 'Advanced Filtration',
    'utilities.projects.project2.features.purification': 'Water Purification',
    'utilities.projects.project2.features.quality': 'Quality Control',
    'utilities.projects.project2.features.distribution': 'Distribution Systems',
    
    // Utilities Sector Page Content
    'utilities.hero.title': 'Utilities',
    'utilities.hero.highlight': 'Sector',
    'utilities.hero.subtitle': 'Powering progress with sustainable energy and essential infrastructure solutions',
    'utilities.overview.title': 'Infrastructure Excellence & Innovation',
    'utilities.overview.description': 'Our utilities sector expertise covers power plants, water treatment facilities, and infrastructure projects. We focus on sustainability, efficiency, and reliability to create essential services for communities.',
    'utilities.overview.feature1': 'Sustainable energy solutions',
    'utilities.overview.feature2': 'Advanced infrastructure',
    'utilities.overview.feature3': 'Environmental compliance',
    'utilities.overview.feature4': 'Reliable operations',
    'utilities.overview.stats.projects': 'Utilities Projects',
    'utilities.overview.stats.experience': 'Years Experience',
    'utilities.overview.card.title': 'Utilities Projects',
    'utilities.overview.card.description': 'We\'ve successfully delivered utilities projects, creating essential infrastructure that powers communities and drives progress.',
    'utilities.projects.title': 'Our Utilities Projects',
    'utilities.projects.subtitle': 'Discover our portfolio of innovative infrastructure projects that are powering the future',
    'utilities.project.category': 'Utilities',
    'utilities.project.status.completed': 'Completed',
    'utilities.project.status.ongoing': 'Ongoing',
    'utilities.project.location': 'Location:',
    'utilities.project.size': 'Size:',
    'utilities.project.value': 'Value:',
    'utilities.project.features': 'Key Features',
    'utilities.cta.title': 'Ready to Build Your Infrastructure Project?',
    'utilities.cta.subtitle': 'Let\'s discuss how we can bring your utilities vision to life with our expertise in infrastructure construction and development.',
    'utilities.cta.startProject': 'Start Your Project',
    'utilities.cta.exploreSectors': 'Explore Other Sectors',
    
    // Utilities Services
    'utilities.services.title': 'Our Utilities Construction Services',
    'utilities.services.subtitle': 'Comprehensive utilities construction solutions for essential infrastructure and services',
    'utilities.services.power.title': 'Power Plants',
    'utilities.services.power.description': 'Electricity generation facilities including conventional and renewable energy sources',
    'utilities.services.power.feature1': 'Power generation',
    'utilities.services.power.feature2': 'Grid connection',
    'utilities.services.power.feature3': 'Backup systems',
    'utilities.services.power.feature4': 'Maintenance facilities',
    'utilities.services.water.title': 'Water Treatment',
    'utilities.services.water.description': 'Water treatment and distribution systems for clean water supply',
    'utilities.services.water.feature1': 'Treatment plants',
    'utilities.services.water.feature2': 'Distribution networks',
    'utilities.services.water.feature3': 'Storage tanks',
    'utilities.services.water.feature4': 'Quality control',
    'utilities.services.sewage.title': 'Sewage Systems',
    'utilities.services.sewage.description': 'Wastewater collection and treatment infrastructure',
    'utilities.services.sewage.feature1': 'Collection systems',
    'utilities.services.sewage.feature2': 'Treatment plants',
    'utilities.services.sewage.feature3': 'Pumping stations',
    'utilities.services.sewage.feature4': 'Environmental compliance',
    'utilities.services.gas.title': 'Gas Infrastructure',
    'utilities.services.gas.description': 'Natural gas distribution and storage facilities',
    'utilities.services.gas.feature1': 'Distribution networks',
    'utilities.services.gas.feature2': 'Storage facilities',
    'utilities.services.gas.feature3': 'Compression stations',
    'utilities.services.gas.feature4': 'Safety systems',
    'utilities.services.telecom.title': 'Telecommunications',
    'utilities.services.telecom.description': 'Communication infrastructure including towers and fiber networks',
    'utilities.services.telecom.feature1': 'Communication towers',
    'utilities.services.telecom.feature2': 'Fiber networks',
    'utilities.services.telecom.feature3': 'Data centers',
    'utilities.services.telecom.feature4': 'Equipment rooms',
    'utilities.services.renewable.title': 'Renewable Energy',
    'utilities.services.renewable.description': 'Solar, wind, and other renewable energy infrastructure',
    'utilities.services.renewable.feature1': 'Solar farms',
    'utilities.services.renewable.feature2': 'Wind farms',
    'utilities.services.renewable.feature3': 'Energy storage',
    'utilities.services.renewable.feature4': 'Grid integration',
    
    // Warehouse Sector Projects
    'warehouse.projects.project1.title': 'Modern Distribution Center',
    'warehouse.projects.project1.description': 'A state-of-the-art logistics facility designed for efficient storage and distribution operations.',
    'warehouse.projects.project1.location': 'Jeddah',
    'warehouse.projects.project1.status': 'completed',
    'warehouse.projects.project1.completion': '2023',
    'warehouse.projects.project1.size': '500,000 sq ft',
    'warehouse.projects.project1.value': '$75M',
    'warehouse.projects.project1.features.storage': 'Automated Storage',
    'warehouse.projects.project1.features.docks': 'Loading Docks',
    'warehouse.projects.project1.features.security': 'Security Systems',
    'warehouse.projects.project1.features.climate': 'Climate Control',
    
    'warehouse.projects.project2.title': 'Cold Storage Facility',
    'warehouse.projects.project2.description': 'A specialized warehouse with temperature-controlled environments for perishable goods.',
    'warehouse.projects.project2.location': 'Riyadh',
    'warehouse.projects.project2.status': 'ongoing',
    'warehouse.projects.project2.completion': '2024',
    'warehouse.projects.project2.size': '300,000 sq ft',
    'warehouse.projects.project2.value': '$60M',
    'warehouse.projects.project2.features.temperature': 'Temperature Control',
    'warehouse.projects.project2.features.refrigeration': 'Refrigeration Systems',
    'warehouse.projects.project2.features.quality': 'Quality Monitoring',
    'warehouse.projects.project2.features.layout': 'Efficient Layout',
    
    // Warehouse Sector Page Content
    'warehouse.hero.title': 'Warehouse',
    'warehouse.hero.highlight': 'Sector',
    'warehouse.hero.subtitle': 'Building efficient storage and logistics solutions that drive supply chain excellence',
    'warehouse.overview.title': 'Logistics Excellence & Innovation',
    'warehouse.overview.description': 'Our warehouse sector expertise covers storage facilities, logistics centers, and distribution hubs. We focus on efficiency, automation, and optimization to create spaces that maximize operational performance.',
    'warehouse.overview.feature1': 'Efficient storage solutions',
    'warehouse.overview.feature2': 'Automated systems',
    'warehouse.overview.feature3': 'Security and safety',
    'warehouse.overview.feature4': 'Optimized workflows',
    'warehouse.overview.stats.projects': 'Warehouse Projects',
    'warehouse.overview.stats.experience': 'Years Experience',
    'warehouse.overview.card.title': 'Warehouse Projects',
    'warehouse.overview.card.description': 'We\'ve successfully delivered warehouse projects, creating efficient storage and logistics solutions that optimize supply chain operations.',
    'warehouse.projects.title': 'Our Warehouse Projects',
    'warehouse.projects.subtitle': 'Discover our portfolio of innovative storage and logistics facilities that are optimizing supply chains',
    'warehouse.project.category': 'Warehouse',
    'warehouse.project.status.completed': 'Completed',
    'warehouse.project.status.ongoing': 'Ongoing',
    'warehouse.project.location': 'Location:',
    'warehouse.project.size': 'Size:',
    'warehouse.project.value': 'Value:',
    'warehouse.project.features': 'Key Features',
    'warehouse.cta.title': 'Ready to Build Your Warehouse Project?',
    'warehouse.cta.subtitle': 'Let\'s discuss how we can bring your logistics vision to life with our expertise in warehouse construction and development.',
    'warehouse.cta.startProject': 'Start Your Project',
    'warehouse.cta.exploreSectors': 'Explore Other Sectors',
    
    // Warehouse Services
    'warehouse.services.title': 'Our Warehouse Construction Services',
    'warehouse.services.subtitle': 'Comprehensive warehouse construction solutions for efficient storage and logistics operations',
    'warehouse.services.distribution.title': 'Distribution Centers',
    'warehouse.services.distribution.description': 'Large-scale distribution facilities with advanced logistics and automation systems',
    'warehouse.services.distribution.feature1': 'Automated systems',
    'warehouse.services.distribution.feature2': 'Loading docks',
    'warehouse.services.distribution.feature3': 'Sorting systems',
    'warehouse.services.distribution.feature4': 'Fleet management',
    'warehouse.services.cold.title': 'Cold Storage',
    'warehouse.services.cold.description': 'Temperature-controlled storage facilities for perishable goods and pharmaceuticals',
    'warehouse.services.cold.feature1': 'Climate control',
    'warehouse.services.cold.feature2': 'Temperature monitoring',
    'warehouse.services.cold.feature3': 'Energy efficiency',
    'warehouse.services.cold.feature4': 'Safety systems',
    'warehouse.services.retail.title': 'Retail Warehouses',
    'warehouse.services.retail.description': 'Modern retail distribution centers with efficient inventory management',
    'warehouse.services.retail.feature1': 'Inventory systems',
    'warehouse.services.retail.feature2': 'Order processing',
    'warehouse.services.retail.feature3': 'Quality control',
    'warehouse.services.retail.feature4': 'Returns handling',
    'warehouse.services.industrial.title': 'Industrial Storage',
    'warehouse.services.industrial.description': 'Heavy-duty storage facilities for industrial materials and equipment',
    'warehouse.services.industrial.feature1': 'Heavy-duty floors',
    'warehouse.services.industrial.feature2': 'Crane systems',
    'warehouse.services.industrial.feature3': 'Material handling',
    'warehouse.services.industrial.feature4': 'Safety protocols',
    'warehouse.services.ecommerce.title': 'E-commerce Fulfillment',
    'warehouse.services.ecommerce.description': 'Specialized fulfillment centers for online retail and e-commerce operations',
    'warehouse.services.ecommerce.feature1': 'Order fulfillment',
    'warehouse.services.ecommerce.feature2': 'Packaging stations',
    'warehouse.services.ecommerce.feature3': 'Shipping areas',
    'warehouse.services.ecommerce.feature4': 'Technology integration',
    'warehouse.services.custom.title': 'Custom Warehouses',
    'warehouse.services.custom.description': 'Bespoke warehouse solutions tailored to specific industry requirements',
    'warehouse.services.custom.feature1': 'Custom design',
    'warehouse.services.custom.feature2': 'Flexible layouts',
    'warehouse.services.custom.feature3': 'Specialized equipment',
    'warehouse.services.custom.feature4': 'Scalable solutions',
    
    // Building & Infrastructure Service
    'buildingInfrastructure.hero.title': 'Building &',
    'buildingInfrastructure.hero.highlight': 'Infrastructure',
    'buildingInfrastructure.hero.subtitle': 'Comprehensive construction services for commercial, residential, and industrial buildings with modern infrastructure development',
    'buildingInfrastructure.overview.title': 'Building Excellence',
    'buildingInfrastructure.overview.highlight': 'From Foundation to Finish',
    'buildingInfrastructure.overview.description1': 'Our Building & Infrastructure division delivers end-to-end construction solutions, from initial planning to final handover. We specialize in creating sustainable, innovative, and high-quality structures that stand the test of time.',
    'buildingInfrastructure.overview.description2': 'With over two decades of experience, we have successfully completed hundreds of projects across various sectors, establishing ourselves as a trusted partner for all your construction needs. Our comprehensive approach encompasses everything from site preparation and foundation work to structural engineering and finishing touches.',
    'buildingInfrastructure.overview.description3': 'We utilize cutting-edge construction technologies, sustainable building practices, and rigorous quality control measures to ensure every project meets the highest standards. Our team of certified engineers, architects, and construction professionals work collaboratively to deliver projects on time, within budget, and exceeding expectations.',
    'buildingInfrastructure.overview.description4': 'From residential complexes and commercial buildings to industrial facilities and infrastructure projects, we have the expertise and resources to handle projects of any scale and complexity. Our commitment to safety, environmental responsibility, and client satisfaction drives every aspect of our construction process.',
    'buildingInfrastructure.overview.stats.projects': 'Projects Completed',
    'buildingInfrastructure.overview.stats.experience': 'Years Experience',
    'buildingInfrastructure.fallback.title': 'Building & Infrastructure',
    'buildingInfrastructure.services.title': 'Our Building Services',
    'buildingInfrastructure.services.subtitle': 'Comprehensive construction solutions tailored to meet your specific requirements',
    'buildingInfrastructure.services.commercial.title': 'Commercial Construction',
    'buildingInfrastructure.services.commercial.description': 'Office buildings, retail spaces, shopping centers, and commercial complexes',
    'buildingInfrastructure.services.commercial.feature1': 'Modern office spaces',
    'buildingInfrastructure.services.commercial.feature2': 'Retail environments',
    'buildingInfrastructure.services.commercial.feature3': 'Shopping centers',
    'buildingInfrastructure.services.commercial.feature4': 'Commercial complexes',
    'buildingInfrastructure.services.residential.title': 'Residential Construction',
    'buildingInfrastructure.services.residential.description': 'Luxury homes, apartment buildings, and residential communities',
    'buildingInfrastructure.services.residential.feature1': 'Luxury homes',
    'buildingInfrastructure.services.residential.feature2': 'Apartment buildings',
    'buildingInfrastructure.services.residential.feature3': 'Residential communities',
    'buildingInfrastructure.services.residential.feature4': 'Custom designs',
    'buildingInfrastructure.services.industrial.title': 'Industrial Facilities',
    'buildingInfrastructure.services.industrial.description': 'Manufacturing plants, warehouses, and industrial complexes',
    'buildingInfrastructure.services.industrial.feature1': 'Manufacturing plants',
    'buildingInfrastructure.services.industrial.feature2': 'Warehouses',
    'buildingInfrastructure.services.industrial.feature3': 'Industrial complexes',
    'buildingInfrastructure.services.industrial.feature4': 'Specialized facilities',
    'buildingInfrastructure.services.infrastructure.title': 'Infrastructure Development',
    'buildingInfrastructure.services.infrastructure.description': 'Roads, bridges, utilities, and public infrastructure projects',
    'buildingInfrastructure.services.infrastructure.feature1': 'Road construction',
    'buildingInfrastructure.services.infrastructure.feature2': 'Bridge engineering',
    'buildingInfrastructure.services.infrastructure.feature3': 'Utility systems',
    'buildingInfrastructure.services.infrastructure.feature4': 'Public infrastructure',
    'buildingInfrastructure.services.foundation.title': 'Foundation & Structural Work',
    'buildingInfrastructure.services.foundation.description': 'Robust foundation systems and structural engineering solutions',
    'buildingInfrastructure.services.foundation.feature1': 'Foundation systems',
    'buildingInfrastructure.services.foundation.feature2': 'Structural engineering',
    'buildingInfrastructure.services.foundation.feature3': 'Load-bearing structures',
    'buildingInfrastructure.services.foundation.feature4': 'Seismic design',
    'buildingInfrastructure.services.management.title': 'Project Management',
    'buildingInfrastructure.services.management.description': 'End-to-end project coordination and quality assurance',
    'buildingInfrastructure.services.management.feature1': 'Project coordination',
    'buildingInfrastructure.services.management.feature2': 'Quality assurance',
    'buildingInfrastructure.services.management.feature3': 'Timeline management',
    'buildingInfrastructure.services.management.feature4': 'Cost control',
    'buildingInfrastructure.whyChoose.title': 'Why Choose FMC for Building & Infrastructure?',
    'buildingInfrastructure.whyChoose.subtitle': 'Our commitment to excellence, innovation, and customer satisfaction sets us apart in the construction industry.',
    'buildingInfrastructure.whyChoose.trackRecord.title': 'Proven Track Record',
    'buildingInfrastructure.whyChoose.trackRecord.description': 'Over 500 successful projects completed with exceptional quality and timely delivery',
    'buildingInfrastructure.whyChoose.expertTeam.title': 'Expert Team',
    'buildingInfrastructure.whyChoose.expertTeam.description': 'Highly skilled professionals with decades of combined experience in construction',
    'buildingInfrastructure.whyChoose.quality.title': 'Quality Assurance',
    'buildingInfrastructure.whyChoose.quality.description': 'Rigorous quality control processes ensuring the highest standards in every project',
    'buildingInfrastructure.whyChoose.delivery.title': 'Timely Delivery',
    'buildingInfrastructure.whyChoose.delivery.description': 'Efficient project management ensuring on-time completion within budget',
    'buildingInfrastructure.whyChoose.card.title': 'Excellence in Every Project',
    'buildingInfrastructure.whyChoose.card.subtitle': 'Building the future, one project at a time',
    'buildingInfrastructure.cta.title': 'Ready to Start Your Building Project?',
    'buildingInfrastructure.cta.subtitle': 'Let\'s discuss your construction needs and create something extraordinary together',
    'buildingInfrastructure.cta.consultation': 'Get Free Consultation',
    'buildingInfrastructure.cta.callNow': 'Call Now',
    
    // Design & Engineering Service
    'designEngineering.hero.title': 'Design &',
    'designEngineering.hero.highlight': 'Engineering',
    'designEngineering.hero.subtitle': 'Professional architectural design and engineering services with innovative solutions and technical expertise',
    'designEngineering.overview.title': 'Innovative Design',
    'designEngineering.overview.highlight': 'Meets Engineering Excellence',
    'designEngineering.overview.description1': 'Our Design & Engineering team combines creative vision with technical precision to deliver exceptional architectural and engineering solutions. We transform concepts into reality through innovative design approaches and cutting-edge engineering practices.',
    'designEngineering.overview.description2': 'From initial concept development to detailed technical documentation, we ensure every project meets the highest standards of design excellence and engineering integrity. Our multidisciplinary team includes licensed architects, structural engineers, MEP engineers, and design specialists who collaborate seamlessly to create integrated solutions.',
    'designEngineering.overview.description3': 'We leverage advanced design software, Building Information Modeling (BIM), and sustainable design principles to optimize building performance, energy efficiency, and occupant comfort. Our engineering solutions incorporate the latest technologies while maintaining cost-effectiveness and constructability.',
    'designEngineering.overview.description4': 'Our design process emphasizes client collaboration, regulatory compliance, and innovative problem-solving. We provide comprehensive design services including architectural design, structural engineering, MEP design, interior design, and project documentation to ensure seamless project delivery from concept to completion.',
    'designEngineering.overview.stats.designs': 'Designs Created',
    'designEngineering.overview.stats.experience': 'Years Experience',
    'designEngineering.fallback.title': 'Design & Engineering',
    'designEngineering.services.title': 'Our Design & Engineering Services',
    'designEngineering.services.subtitle': 'Comprehensive design and engineering solutions for all your project needs',
    'designEngineering.services.architectural.title': 'Architectural Design',
    'designEngineering.services.architectural.description': 'Creative and functional architectural solutions for all project types',
    'designEngineering.services.architectural.feature1': 'Concept development',
    'designEngineering.services.architectural.feature2': 'Space planning',
    'designEngineering.services.architectural.feature3': 'Aesthetic design',
    'designEngineering.services.architectural.feature4': 'Building codes compliance',
    'designEngineering.services.structural.title': 'Structural Engineering',
    'designEngineering.services.structural.description': 'Robust structural analysis and design for safety and durability',
    'designEngineering.services.structural.feature1': 'Structural analysis',
    'designEngineering.services.structural.feature2': 'Load calculations',
    'designEngineering.services.structural.feature3': 'Foundation design',
    'designEngineering.services.structural.feature4': 'Seismic engineering',
    'designEngineering.services.mep.title': 'MEP Engineering Design',
    'designEngineering.services.mep.description': 'Mechanical, electrical, and plumbing system design and optimization',
    'designEngineering.services.mep.feature1': 'HVAC design',
    'designEngineering.services.mep.feature2': 'Electrical systems',
    'designEngineering.services.mep.feature3': 'Plumbing design',
    'designEngineering.services.mep.feature4': 'Energy efficiency',
    'designEngineering.services.modeling.title': '3D Modeling & Visualization',
    'designEngineering.services.modeling.description': 'Advanced 3D modeling and realistic project visualization',
    'designEngineering.services.modeling.feature1': '3D modeling',
    'designEngineering.services.modeling.feature2': 'Rendering',
    'designEngineering.services.modeling.feature3': 'Virtual walkthroughs',
    'designEngineering.services.modeling.feature4': 'Animation',
    'designEngineering.services.documentation.title': 'Technical Documentation',
    'designEngineering.services.documentation.description': 'Comprehensive technical drawings and project documentation',
    'designEngineering.services.documentation.feature1': 'Construction drawings',
    'designEngineering.services.documentation.feature2': 'Specifications',
    'designEngineering.services.documentation.feature3': 'Technical reports',
    'designEngineering.services.documentation.feature4': 'As-built documentation',
    'designEngineering.services.optimization.title': 'Design Optimization',
    'designEngineering.services.optimization.description': 'Performance optimization and value engineering solutions',
    'designEngineering.services.optimization.feature1': 'Cost optimization',
    'designEngineering.services.optimization.feature2': 'Performance analysis',
    'designEngineering.services.optimization.feature3': 'Sustainability',
    'designEngineering.services.optimization.feature4': 'Value engineering',
    'designEngineering.whyChoose.title': 'Why Choose FMC for Design & Engineering?',
    'designEngineering.whyChoose.subtitle': 'Our expertise in design and engineering, combined with innovative technology and creative solutions, delivers exceptional results.',
    'designEngineering.whyChoose.experts.title': 'Expert Designers',
    'designEngineering.whyChoose.experts.description': 'Highly qualified architects and designers with extensive industry experience',
    'designEngineering.whyChoose.engineering.title': 'Engineering Excellence',
    'designEngineering.whyChoose.engineering.description': 'Professional engineers ensuring structural integrity and technical precision',
    'designEngineering.whyChoose.innovation.title': 'Innovative Solutions',
    'designEngineering.whyChoose.innovation.description': 'Cutting-edge design approaches and engineering methodologies',
    'designEngineering.whyChoose.delivery.title': 'Timely Delivery',
    'designEngineering.whyChoose.delivery.description': 'Efficient project management ensuring on-time design completion',
    'designEngineering.whyChoose.card.title': 'Designing Tomorrow\'s Spaces',
    'designEngineering.whyChoose.card.subtitle': 'Where creativity meets engineering excellence',
    'designEngineering.cta.title': 'Ready to Design Your Vision?',
    'designEngineering.cta.subtitle': 'Let\'s collaborate to create innovative design and engineering solutions for your project',
    'designEngineering.cta.consultation': 'Start Design Consultation',
    'designEngineering.cta.callNow': 'Call Now',
    
    // Architectural Fitout Service
    'architecturalFitout.hero.title': 'Architectural',
    'architecturalFitout.hero.highlight': 'Fitout',
    'architecturalFitout.hero.subtitle': 'Professional interior design and fitout services creating functional and aesthetic spaces',
    'architecturalFitout.overview.title': 'Transform Your Space',
    'architecturalFitout.overview.highlight': 'With Expert Fitout Solutions',
    'architecturalFitout.overview.description1': 'Our Architectural Fitout team specializes in transforming interior spaces into functional, beautiful, and efficient environments. We combine creative design with practical solutions to create spaces that enhance productivity and well-being.',
    'architecturalFitout.overview.description2': 'From concept to completion, we handle every aspect of interior fitout including space planning, material selection, custom furniture design, and installation. Our experienced team ensures every project meets the highest standards of quality and craftsmanship.',
    'architecturalFitout.overview.description3': 'We work closely with clients to understand their vision and requirements, delivering customized solutions that reflect their brand identity and operational needs. Our fitout services cover offices, retail spaces, hospitality venues, and residential properties.',
    'architecturalFitout.overview.description4': 'Our comprehensive approach includes detailed project planning, 3D visualization, material sourcing, and professional installation. We ensure timely delivery and exceptional quality while maintaining cost-effectiveness and sustainability.',
    'architecturalFitout.overview.stats.projects': 'Fitout Projects',
    'architecturalFitout.overview.stats.experience': 'Years Experience',
    'architecturalFitout.fallback.title': 'Architectural Fitout',
    'architecturalFitout.services.title': 'Our Fitout Services',
    'architecturalFitout.services.subtitle': 'Complete interior design and fitout solutions for all your space requirements',
    'architecturalFitout.services.office.title': 'Office Fitout',
    'architecturalFitout.services.office.description': 'Modern office spaces designed for productivity and collaboration',
    'architecturalFitout.services.office.feature1': 'Workstation design',
    'architecturalFitout.services.office.feature2': 'Meeting rooms',
    'architecturalFitout.services.office.feature3': 'Reception areas',
    'architecturalFitout.services.office.feature4': 'Breakout spaces',
    'architecturalFitout.services.retail.title': 'Retail Fitout',
    'architecturalFitout.services.retail.description': 'Attractive retail spaces that enhance customer experience',
    'architecturalFitout.services.retail.feature1': 'Store layout design',
    'architecturalFitout.services.retail.feature2': 'Display systems',
    'architecturalFitout.services.retail.feature3': 'Lighting design',
    'architecturalFitout.services.retail.feature4': 'Brand integration',
    'architecturalFitout.services.hospitality.title': 'Hospitality Fitout',
    'architecturalFitout.services.hospitality.description': 'Welcoming spaces for hotels, restaurants, and cafes',
    'architecturalFitout.services.hospitality.feature1': 'Guest room design',
    'architecturalFitout.services.hospitality.feature2': 'Dining areas',
    'architecturalFitout.services.hospitality.feature3': 'Lobby spaces',
    'architecturalFitout.services.hospitality.feature4': 'Amenity areas',
    'architecturalFitout.services.residential.title': 'Residential Fitout',
    'architecturalFitout.services.residential.description': 'Personalized home interiors that reflect your style',
    'architecturalFitout.services.residential.feature1': 'Living spaces',
    'architecturalFitout.services.residential.feature2': 'Kitchen design',
    'architecturalFitout.services.residential.feature3': 'Bedroom design',
    'architecturalFitout.services.residential.feature4': 'Storage solutions',
    'architecturalFitout.services.custom.title': 'Custom Furniture',
    'architecturalFitout.services.custom.description': 'Bespoke furniture and fixtures tailored to your needs',
    'architecturalFitout.services.custom.feature1': 'Custom design',
    'architecturalFitout.services.custom.feature2': 'Material selection',
    'architecturalFitout.services.custom.feature3': 'Manufacturing',
    'architecturalFitout.services.custom.feature4': 'Installation',
    'architecturalFitout.services.project.title': 'Project Management',
    'architecturalFitout.services.project.description': 'End-to-end project coordination and quality assurance',
    'architecturalFitout.services.project.feature1': 'Timeline management',
    'architecturalFitout.services.project.feature2': 'Quality control',
    'architecturalFitout.services.project.feature3': 'Vendor coordination',
    'architecturalFitout.services.project.feature4': 'Final inspection',
    'architecturalFitout.whyChoose.title': 'Why Choose FMC for Architectural Fitout?',
    'architecturalFitout.whyChoose.subtitle': 'Our expertise in interior design and fitout, combined with attention to detail and quality craftsmanship, delivers exceptional results.',
    'architecturalFitout.whyChoose.design.title': 'Creative Design',
    'architecturalFitout.whyChoose.design.description': 'Innovative interior design solutions that maximize space potential',
    'architecturalFitout.whyChoose.quality.title': 'Quality Craftsmanship',
    'architecturalFitout.whyChoose.quality.description': 'Skilled craftsmen ensuring superior quality and attention to detail',
    'architecturalFitout.whyChoose.custom.title': 'Custom Solutions',
    'architecturalFitout.whyChoose.custom.description': 'Tailored fitout solutions that meet your specific requirements',
    'architecturalFitout.whyChoose.delivery.title': 'Timely Delivery',
    'architecturalFitout.whyChoose.delivery.description': 'Efficient project management ensuring on-time completion',
    'architecturalFitout.whyChoose.card.title': 'Creating Beautiful Spaces',
    'architecturalFitout.whyChoose.card.subtitle': 'Where design meets functionality',
    'architecturalFitout.cta.title': 'Ready to Transform Your Space?',
    'architecturalFitout.cta.subtitle': 'Let\'s create a beautiful and functional interior that reflects your vision',
    'architecturalFitout.cta.consultation': 'Start Design Consultation',
    'architecturalFitout.cta.callNow': 'Call Now',
    
    // Civil Works Service
    'civilWorks.hero.title': 'Civil',
    'civilWorks.hero.highlight': 'Works',
    'civilWorks.hero.subtitle': 'Comprehensive civil engineering and infrastructure development services for all construction needs',
    'civilWorks.overview.title': 'Building Strong Foundations',
    'civilWorks.overview.highlight': 'With Civil Engineering Excellence',
    'civilWorks.overview.description1': 'Our Civil Works division specializes in infrastructure development, providing comprehensive civil engineering solutions for roads, bridges, utilities, and public facilities. We combine technical expertise with innovative approaches to deliver projects that enhance communities and support economic growth.',
    'civilWorks.overview.description2': 'From initial site assessment to final completion, we handle every aspect of civil construction including earthworks, concrete work, drainage systems, and utility installations. Our experienced team ensures all projects meet regulatory requirements and exceed quality standards.',
    'civilWorks.overview.description3': 'We work with government agencies, private developers, and municipalities to deliver infrastructure projects that improve connectivity, safety, and quality of life. Our services include road construction, bridge engineering, water treatment facilities, and public space development.',
    'civilWorks.overview.description4': 'Our civil engineering solutions incorporate sustainable practices, advanced materials, and modern construction techniques. We ensure proper environmental compliance, safety protocols, and long-term durability while maintaining cost-effectiveness and timely delivery.',
    'civilWorks.overview.stats.projects': 'Civil Projects',
    'civilWorks.overview.stats.experience': 'Years Experience',
    'civilWorks.fallback.title': 'Civil Works',
    'civilWorks.services.title': 'Our Civil Works Services',
    'civilWorks.services.subtitle': 'Complete civil engineering solutions for infrastructure development and construction',
    'civilWorks.services.roads.title': 'Road Construction',
    'civilWorks.services.roads.description': 'High-quality road construction and maintenance services',
    'civilWorks.services.roads.feature1': 'Highway construction',
    'civilWorks.services.roads.feature2': 'Urban roads',
    'civilWorks.services.roads.feature3': 'Rural access roads',
    'civilWorks.services.roads.feature4': 'Road maintenance',
    'civilWorks.services.bridges.title': 'Bridge Engineering',
    'civilWorks.services.bridges.description': 'Structural bridge design and construction services',
    'civilWorks.services.bridges.feature1': 'Bridge design',
    'civilWorks.services.bridges.feature2': 'Structural analysis',
    'civilWorks.services.bridges.feature3': 'Construction supervision',
    'civilWorks.services.bridges.feature4': 'Maintenance programs',
    'civilWorks.services.utilities.title': 'Utility Infrastructure',
    'civilWorks.services.utilities.description': 'Water, sewer, and utility system development',
    'civilWorks.services.utilities.feature1': 'Water systems',
    'civilWorks.services.utilities.feature2': 'Sewer networks',
    'civilWorks.services.utilities.feature3': 'Storm drainage',
    'civilWorks.services.utilities.feature4': 'Utility coordination',
    'civilWorks.services.earthworks.title': 'Earthworks & Excavation',
    'civilWorks.services.earthworks.description': 'Site preparation and earthmoving services',
    'civilWorks.services.earthworks.feature1': 'Site clearing',
    'civilWorks.services.earthworks.feature2': 'Excavation',
    'civilWorks.services.earthworks.feature3': 'Grading',
    'civilWorks.services.earthworks.feature4': 'Compaction',
    'civilWorks.services.concrete.title': 'Concrete Construction',
    'civilWorks.services.concrete.description': 'Reinforced concrete structures and foundations',
    'civilWorks.services.concrete.feature1': 'Foundation work',
    'civilWorks.services.concrete.feature2': 'Structural concrete',
    'civilWorks.services.concrete.feature3': 'Precast elements',
    'civilWorks.services.concrete.feature4': 'Quality control',
    'civilWorks.services.project.title': 'Project Management',
    'civilWorks.services.project.description': 'Comprehensive project coordination and oversight',
    'civilWorks.services.project.feature1': 'Planning & scheduling',
    'civilWorks.services.project.feature2': 'Quality assurance',
    'civilWorks.services.project.feature3': 'Safety management',
    'civilWorks.services.project.feature4': 'Progress monitoring',
    'civilWorks.whyChoose.title': 'Why Choose FMC for Civil Works?',
    'civilWorks.whyChoose.subtitle': 'Our expertise in civil engineering and infrastructure development, combined with quality craftsmanship and technical excellence, delivers exceptional results.',
    'civilWorks.whyChoose.experience.title': 'Proven Experience',
    'civilWorks.whyChoose.experience.description': 'Extensive track record in civil infrastructure projects',
    'civilWorks.whyChoose.quality.title': 'Quality Assurance',
    'civilWorks.whyChoose.quality.description': 'Rigorous quality control ensuring superior construction standards',
    'civilWorks.whyChoose.innovation.title': 'Technical Innovation',
    'civilWorks.whyChoose.innovation.description': 'Advanced engineering solutions and modern construction techniques',
    'civilWorks.whyChoose.delivery.title': 'Timely Delivery',
    'civilWorks.whyChoose.delivery.description': 'Efficient project management ensuring on-time completion',
    'civilWorks.whyChoose.card.title': 'Building Infrastructure',
    'civilWorks.whyChoose.card.subtitle': 'Connecting communities through quality construction',
    'civilWorks.cta.title': 'Ready to Start Your Civil Project?',
    'civilWorks.cta.subtitle': 'Let\'s discuss your infrastructure needs and create solutions that benefit your community',
    'civilWorks.cta.consultation': 'Get Project Consultation',
    'civilWorks.cta.callNow': 'Call Now',
    
    // OurVendors form translations
    'ourVendors.form.vendorName.placeholder': 'Enter vendor name',
    'ourVendors.form.contactFullName': 'Contact Full Name *',
    'ourVendors.form.contactFullName.placeholder': 'Enter your full name',
    'ourVendors.form.position.placeholder': 'Enter your position',
    'ourVendors.form.phone.placeholder': 'Enter your phone number',
    'ourVendors.form.mobile.placeholder': 'Enter your mobile number',
    'ourVendors.form.email.placeholder': 'Enter your email address',
    'ourVendors.form.services.placeholder': 'Describe your services or products',
    'ourVendors.form.vat.placeholder': 'Enter your VAT number',
    'ourVendors.form.subcontractorName.placeholder': 'Enter subcontractor name',
    'ourVendors.form.subcontractingServices.placeholder': 'Describe your subcontracting services',
    'ourVendors.form.additionalInfo.placeholder': 'Any additional information or questions...',
    
    // MEP Works Service
    'mepWorks.hero.title': 'MEP',
    'mepWorks.hero.highlight': 'Works',
    'mepWorks.hero.subtitle': 'Professional mechanical, electrical, and plumbing services for complete building systems',
    'mepWorks.overview.title': 'Complete Building Systems',
    'mepWorks.overview.highlight': 'With MEP Engineering Excellence',
    'mepWorks.overview.description1': 'Our MEP Works division provides comprehensive mechanical, electrical, and plumbing services for all types of construction projects. We design, install, and maintain building systems that ensure comfort, safety, and energy efficiency.',
    'mepWorks.overview.description2': 'From initial design to final commissioning, we handle every aspect of MEP systems including HVAC design, electrical distribution, plumbing networks, and fire protection systems. Our experienced engineers ensure all systems meet code requirements and performance standards.',
    'mepWorks.overview.description3': 'We work with architects, contractors, and building owners to integrate MEP systems seamlessly into construction projects. Our services include energy modeling, system optimization, and sustainable design solutions that reduce operating costs and environmental impact.',
    'mepWorks.overview.description4': 'Our MEP solutions incorporate the latest technologies, energy-efficient equipment, and smart building systems. We ensure proper coordination between all building systems, optimal performance, and long-term reliability while maintaining cost-effectiveness and compliance with regulations.',
    'mepWorks.overview.stats.projects': 'MEP Projects',
    'mepWorks.overview.stats.experience': 'Years Experience',
    'mepWorks.fallback.title': 'MEP Works',
    'mepWorks.services.title': 'Our MEP Services',
    'mepWorks.services.subtitle': 'Complete mechanical, electrical, and plumbing solutions for all building needs',
    'mepWorks.services.mechanical.title': 'Mechanical Systems',
    'mepWorks.services.mechanical.description': 'HVAC and mechanical system design and installation',
    'mepWorks.services.mechanical.feature1': 'HVAC design',
    'mepWorks.services.mechanical.feature2': 'Ventilation systems',
    'mepWorks.services.mechanical.feature3': 'Heating systems',
    'mepWorks.services.mechanical.feature4': 'Cooling systems',
    'mepWorks.services.electrical.title': 'Electrical Systems',
    'mepWorks.services.electrical.description': 'Complete electrical design and installation services',
    'mepWorks.services.electrical.feature1': 'Power distribution',
    'mepWorks.services.electrical.feature2': 'Lighting design',
    'mepWorks.services.electrical.feature3': 'Emergency systems',
    'mepWorks.services.electrical.feature4': 'Smart controls',
    'mepWorks.services.plumbing.title': 'Plumbing Systems',
    'mepWorks.services.plumbing.description': 'Water supply and drainage system solutions',
    'mepWorks.services.plumbing.feature1': 'Water supply',
    'mepWorks.services.plumbing.feature2': 'Drainage systems',
    'mepWorks.services.plumbing.feature3': 'Water treatment',
    'mepWorks.services.plumbing.feature4': 'Waste management',
    'mepWorks.services.fire.title': 'Fire Protection',
    'mepWorks.services.fire.description': 'Fire safety and protection system installation',
    'mepWorks.services.fire.feature1': 'Fire suppression',
    'mepWorks.services.fire.feature2': 'Detection systems',
    'mepWorks.services.fire.feature3': 'Emergency lighting',
    'mepWorks.services.fire.feature4': 'Safety systems',
    'mepWorks.services.energy.title': 'Energy Management',
    'mepWorks.services.energy.description': 'Energy efficiency and smart building solutions',
    'mepWorks.services.energy.feature1': 'Energy modeling',
    'mepWorks.services.energy.feature2': 'Efficiency optimization',
    'mepWorks.services.energy.feature3': 'Smart controls',
    'mepWorks.services.energy.feature4': 'Monitoring systems',
    'mepWorks.services.maintenance.title': 'Maintenance Services',
    'mepWorks.services.maintenance.description': 'Ongoing maintenance and system optimization',
    'mepWorks.services.maintenance.feature1': 'Preventive maintenance',
    'mepWorks.services.maintenance.feature2': 'System repairs',
    'mepWorks.services.maintenance.feature3': 'Performance tuning',
    'mepWorks.services.maintenance.feature4': 'Emergency service',
    
    // Data Centers Works
    'dataCenters.hero.title': 'Empowering Digital',
    'dataCenters.hero.highlight': 'Infrastructure',
    'dataCenters.hero.subtitle': 'Enabling digital transformation through reliable, scalable, and future-ready data center infrastructure solutions',
    'dataCenters.overview.title': 'Building Secure and Resilient',
    'dataCenters.overview.highlight': 'Digital Foundations',
    'dataCenters.overview.description1': 'We combine strong engineering expertise with practical execution to build secure and resilient digital foundations, supporting Saudi Vision 2030.',
    'dataCenters.overview.description2': '',
    'dataCenters.overview.description3': '',
    'dataCenters.overview.description4': '',
    'dataCenters.whyChoose.title': 'Why Choose FMC?',
    'dataCenters.whyChoose.subtitle': 'Strategic Differentiators',
    'dataCenters.whyChoose.scalable.title': 'Scalable & Future-Ready',
    'dataCenters.whyChoose.scalable.description': 'Solutions designed to grow with your business, adapting seamlessly to evolving technologies and workloads.',
    'dataCenters.whyChoose.sustainable.title': 'Sustainable Design',
    'dataCenters.whyChoose.sustainable.description': 'Integration of energy-efficient architectures and green technologies to reduce carbon footprints and operational costs.',
    'dataCenters.whyChoose.endToEnd.title': 'End-to-End Service',
    'dataCenters.whyChoose.endToEnd.description': 'Complete lifecycle services from concept and construction to connectivity, security, and maintenance, eliminating the need for multiple vendors.',
    'dataCenters.whyChoose.rapid.title': 'Rapid Deployment',
    'dataCenters.whyChoose.rapid.description': 'Powered by in-house EPC (Engineering, Procurement, and Construction) capabilities and a local supply network for faster delivery.',
    'dataCenters.whyChoose.reliability.title': 'Reliability',
    'dataCenters.whyChoose.reliability.description': 'Engineered for continuous uptime with proactive monitoring to ensure uninterrupted performance.',
    'dataCenters.overview.stats.projects': 'Data Center Projects',
    'dataCenters.overview.stats.experience': 'Years Experience',
    'dataCenters.services.title': 'Our Solutions & Offerings',
    'dataCenters.services.subtitle': 'Comprehensive data center infrastructure solutions',
    'dataCenters.services.power.title': 'Power & Backup Systems',
    'dataCenters.services.power.description': 'Reliable power distribution and backup systems for continuous operations',
    'dataCenters.services.power.ups.title': 'UPS Systems',
    'dataCenters.services.power.ups.description': 'Delivery of pure, continuous power using Standby, Line Interactive, and Online/Double Conversion topologies. We offer Modular UPS for high scalability and fault tolerance.',
    'dataCenters.services.power.generators.title': 'Backup Diesel Generators',
    'dataCenters.services.power.generators.description': 'High-performance generators with rapid response engines capable of accepting full load within seconds. Features include sound-attenuated enclosures for noise reduction and flexible fuel storage for extended autonomy.',
    'dataCenters.services.power.distribution.title': 'Power Distribution',
    'dataCenters.services.power.distribution.description': 'Modular power distribution and rack PDUs (Switched, Metered, Basic) ensuring power reaches IT loads efficiently.',
    'dataCenters.services.cooling.title': 'Cooling Technologies',
    'dataCenters.services.cooling.description': 'Precision cooling solutions designed to maintain 99.99% uptime',
    'dataCenters.services.cooling.feature1': 'Chilled Water & DX Close Control Units',
    'dataCenters.services.cooling.feature2': 'Aisle Containment Systems',
    'dataCenters.services.cooling.feature3': 'In-Row Cooling & In-Rack Heat Extraction',
    'dataCenters.services.cooling.feature4': 'Direct Liquid-to-Chip & Liquid Immersion Cooling',
    'dataCenters.services.infrastructure.title': 'Civil, MEP & Infrastructure',
    'dataCenters.services.infrastructure.description': 'Comprehensive turnkey site preparation and infrastructure',
    'dataCenters.services.infrastructure.civil.title': 'Civil & MEP Works',
    'dataCenters.services.infrastructure.civil.description': 'Comprehensive turnkey site preparation including structural integrity, thermal insulation, and fire-rated partitioning.',
    'dataCenters.services.infrastructure.flooring.title': 'Raised Access Flooring',
    'dataCenters.services.infrastructure.flooring.description': 'Heavy-duty panels (Cementitious or Calcium Sulphate cores) with anti-static High-Pressure Laminate (HPL) finishes to support heavy racks and manage airflow.',
    'dataCenters.services.infrastructure.racks.title': 'Racks & Accessories',
    'dataCenters.services.infrastructure.racks.description': 'Cabinets, airflow management, cable management systems, and KVM switches.',
    'dataCenters.services.infrastructure.cabling.title': 'Cabling',
    'dataCenters.services.infrastructure.cabling.description': 'Design and deployment of data center-grade copper and fiber systems.',
    'dataCenters.services.security.title': 'Safety, Security & Management',
    'dataCenters.services.security.description': 'Comprehensive safety, security, and management solutions',
    'dataCenters.services.security.fire.title': 'Fire Suppression',
    'dataCenters.services.security.fire.description': 'State-of-the-art protection including VESDA (Very Early Warning Aspirating Smoke Detection) and Clean Agent systems (Novec 1230 / FM-200).',
    'dataCenters.services.security.dcim.title': 'DCIM (Data Center Infrastructure Management)',
    'dataCenters.services.security.dcim.description': 'A single dashboard solution for monitoring asset management, capacity planning, and energy consumption.',
    'dataCenters.services.security.ems.title': 'Security & EMS',
    'dataCenters.services.security.ems.description': 'Physical security (CCTV, Access Control) combined with Environmental Monitoring Systems (Temperature, Humidity, and Leak detection sensors).',
    'dataCenters.services.modular.title': 'Prefabricated Modular Data Centers',
    'dataCenters.services.modular.description': 'Factory-assembled and tested units transported to the site for rapid deployment. Highly scalable, cost-efficient, portable, and ideal for disaster recovery or remote locations.',
    'dataCenters.fallback.title': 'Data Centers Works',
    'mepWorks.whyChoose.title': 'Why Choose FMC for MEP Works?',
    'mepWorks.whyChoose.subtitle': 'Our expertise in MEP systems, combined with technical innovation and quality installation, delivers reliable and efficient building systems.',
    'mepWorks.whyChoose.experts.title': 'Expert Engineers',
    'mepWorks.whyChoose.experts.description': 'Licensed engineers with extensive MEP system experience',
    'mepWorks.whyChoose.quality.title': 'Quality Installation',
    'mepWorks.whyChoose.quality.description': 'Professional installation ensuring optimal system performance',
    'mepWorks.whyChoose.innovation.title': 'Technical Innovation',
    'mepWorks.whyChoose.innovation.description': 'Latest technologies and energy-efficient solutions',
    'mepWorks.whyChoose.support.title': 'Ongoing Support',
    'mepWorks.whyChoose.support.description': 'Comprehensive maintenance and support services',
    'mepWorks.whyChoose.card.title': 'Powering Buildings',
    'mepWorks.whyChoose.card.subtitle': 'Reliable systems for modern construction',
    'mepWorks.cta.title': 'Ready to Power Your Building?',
    'mepWorks.cta.subtitle': 'Let\'s discuss your MEP requirements and create efficient building systems',
    'mepWorks.cta.consultation': 'Get MEP Consultation',
    'mepWorks.cta.callNow': 'Call Now',
    
    // Pricing & Bidding Service
    'pricingBidding.hero.title': 'Pricing &',
    'pricingBidding.hero.highlight': 'Bidding',
    'pricingBidding.hero.subtitle': 'Professional cost estimation and competitive bidding services for construction projects',
    'pricingBidding.overview.title': 'Accurate Cost Estimation',
    'pricingBidding.overview.highlight': 'With Competitive Bidding Excellence',
    'pricingBidding.overview.description1': 'Our Pricing & Bidding division provides comprehensive cost estimation and competitive bidding services for construction projects of all sizes. We combine market expertise with detailed analysis to deliver accurate pricing that ensures project success and profitability.',
    'pricingBidding.overview.description2': 'From initial project assessment to final bid submission, we handle every aspect of the pricing process including quantity takeoffs, material costing, labor analysis, and overhead calculations. Our experienced estimators ensure all costs are properly accounted for and competitive.',
    'pricingBidding.overview.description3': 'We work with contractors, developers, and project owners to develop winning strategies for competitive bidding. Our services include market analysis, risk assessment, value engineering, and strategic pricing to maximize success rates and project profitability.',
    'pricingBidding.overview.description4': 'Our pricing solutions incorporate the latest market data, material costs, and labor rates to ensure accuracy and competitiveness. We provide detailed breakdowns, alternative pricing options, and ongoing support throughout the bidding process to help clients make informed decisions.',
    'pricingBidding.overview.stats.projects': 'Bids Submitted',
    'pricingBidding.overview.stats.experience': 'Years Experience',
    'pricingBidding.fallback.title': 'Pricing & Bidding',
    'pricingBidding.services.title': 'Our Pricing Services',
    'pricingBidding.services.subtitle': 'Complete cost estimation and bidding solutions for all construction needs',
    'pricingBidding.services.estimation.title': 'Cost Estimation',
    'pricingBidding.services.estimation.description': 'Detailed cost analysis and project pricing',
    'pricingBidding.services.estimation.feature1': 'Quantity takeoffs',
    'pricingBidding.services.estimation.feature2': 'Material costing',
    'pricingBidding.services.estimation.feature3': 'Labor analysis',
    'pricingBidding.services.estimation.feature4': 'Overhead calculations',
    'pricingBidding.services.bidding.title': 'Competitive Bidding',
    'pricingBidding.services.bidding.description': 'Strategic bidding and proposal development',
    'pricingBidding.services.bidding.feature1': 'Bid preparation',
    'pricingBidding.services.bidding.feature2': 'Proposal writing',
    'pricingBidding.services.bidding.feature3': 'Strategy development',
    'pricingBidding.services.bidding.feature4': 'Submission support',
    'pricingBidding.services.analysis.title': 'Market Analysis',
    'pricingBidding.services.analysis.description': 'Comprehensive market research and pricing analysis',
    'pricingBidding.services.analysis.feature1': 'Market trends',
    'pricingBidding.services.analysis.feature2': 'Competitor analysis',
    'pricingBidding.services.analysis.feature3': 'Price benchmarking',
    'pricingBidding.services.analysis.feature4': 'Risk assessment',
    'pricingBidding.services.value.title': 'Value Engineering',
    'pricingBidding.services.value.description': 'Cost optimization and value enhancement solutions',
    'pricingBidding.services.value.feature1': 'Cost reduction',
    'pricingBidding.services.value.feature2': 'Alternative solutions',
    'pricingBidding.services.value.feature3': 'Efficiency improvements',
    'pricingBidding.services.value.feature4': 'Value analysis',
    'pricingBidding.services.support.title': 'Bid Support',
    'pricingBidding.services.support.description': 'Ongoing support throughout the bidding process',
    'pricingBidding.services.support.feature1': 'Bid clarification',
    'pricingBidding.services.support.feature2': 'Negotiation support',
    'pricingBidding.services.support.feature3': 'Contract review',
    'pricingBidding.services.support.feature4': 'Post-award support',
    'pricingBidding.services.reporting.title': 'Reporting & Analytics',
    'pricingBidding.services.reporting.description': 'Detailed reporting and performance analytics',
    'pricingBidding.services.reporting.feature1': 'Cost reports',
    'pricingBidding.services.reporting.feature2': 'Performance metrics',
    'pricingBidding.services.reporting.feature3': 'Trend analysis',
    'pricingBidding.services.reporting.feature4': 'Success tracking',
    'pricingBidding.whyChoose.title': 'Why Choose FMC for Pricing & Bidding?',
    'pricingBidding.whyChoose.subtitle': 'Our expertise in cost estimation and competitive bidding, combined with market knowledge and strategic approach, delivers winning results.',
    'pricingBidding.whyChoose.experts.title': 'Expert Estimators',
    'pricingBidding.whyChoose.experts.description': 'Experienced professionals with deep construction cost knowledge',
    'pricingBidding.whyChoose.accuracy.title': 'Accurate Pricing',
    'pricingBidding.whyChoose.accuracy.description': 'Precise cost estimation ensuring competitive and profitable bids',
    'pricingBidding.whyChoose.strategy.title': 'Strategic Approach',
    'pricingBidding.whyChoose.strategy.description': 'Winning strategies tailored to each project and market',
    'pricingBidding.whyChoose.support.title': 'Ongoing Support',
    'pricingBidding.whyChoose.support.description': 'Comprehensive support throughout the entire bidding process',
    'pricingBidding.whyChoose.card.title': 'Winning Bids',
    'pricingBidding.whyChoose.card.subtitle': 'Strategic pricing for project success',
    'pricingBidding.cta.title': 'Ready to Win Your Next Bid?',
    'pricingBidding.cta.subtitle': 'Let\'s discuss your project requirements and develop a winning bidding strategy',
    'pricingBidding.cta.consultation': 'Get Bidding Consultation',
    'pricingBidding.cta.callNow': 'Call Now',
    
    // Maintenance Works Service
    'maintenanceWorks.hero.title': 'Maintenance',
    'maintenanceWorks.hero.highlight': 'Works',
    'maintenanceWorks.hero.subtitle': 'Comprehensive maintenance and facility management services for all building types',
    'maintenanceWorks.overview.title': 'Keep Your Facilities Running',
    'maintenanceWorks.overview.highlight': 'With Expert Maintenance Services',
    'maintenanceWorks.overview.description1': 'Our Maintenance Works division provides comprehensive facility maintenance and management services to ensure optimal building performance and longevity. We offer preventive, corrective, and emergency maintenance solutions for all types of facilities.',
    'maintenanceWorks.overview.description2': 'From routine maintenance to major repairs, we handle every aspect of facility upkeep including HVAC systems, electrical systems, plumbing, structural maintenance, and building automation. Our experienced technicians ensure all systems operate efficiently and safely.',
    'maintenanceWorks.overview.description3': 'We work with property managers, building owners, and facility operators to develop customized maintenance programs that meet specific needs and budgets. Our services include scheduled maintenance, emergency response, system upgrades, and performance optimization.',
    'maintenanceWorks.overview.description4': 'Our maintenance solutions incorporate modern technologies, predictive maintenance techniques, and energy-efficient practices to reduce operating costs and extend equipment life. We ensure compliance with safety regulations and environmental standards while maintaining high service quality.',
    'maintenanceWorks.overview.stats.projects': 'Maintenance Contracts',
    'maintenanceWorks.overview.stats.experience': 'Years Experience',
    'maintenanceWorks.fallback.title': 'Maintenance Works',
    'maintenanceWorks.services.title': 'Our Maintenance Services',
    'maintenanceWorks.services.subtitle': 'Complete facility maintenance and management solutions for all building needs',
    'maintenanceWorks.services.preventive.title': 'Preventive Maintenance',
    'maintenanceWorks.services.preventive.description': 'Scheduled maintenance to prevent equipment failures',
    'maintenanceWorks.services.preventive.feature1': 'HVAC maintenance',
    'maintenanceWorks.services.preventive.feature2': 'Electrical inspections',
    'maintenanceWorks.services.preventive.feature3': 'Plumbing checks',
    'maintenanceWorks.services.preventive.feature4': 'System testing',
    'maintenanceWorks.services.corrective.title': 'Corrective Maintenance',
    'maintenanceWorks.services.corrective.description': 'Repair and restoration services for existing issues',
    'maintenanceWorks.services.corrective.feature1': 'Equipment repairs',
    'maintenanceWorks.services.corrective.feature2': 'System restoration',
    'maintenanceWorks.services.corrective.feature3': 'Component replacement',
    'maintenanceWorks.services.corrective.feature4': 'Performance tuning',
    'maintenanceWorks.services.emergency.title': 'Emergency Response',
    'maintenanceWorks.services.emergency.description': '24/7 emergency maintenance and repair services',
    'maintenanceWorks.services.emergency.feature1': 'Emergency repairs',
    'maintenanceWorks.services.emergency.feature2': 'System restoration',
    'maintenanceWorks.services.emergency.feature3': 'Safety response',
    'maintenanceWorks.services.emergency.feature4': 'Rapid deployment',
    'maintenanceWorks.services.facility.title': 'Facility Management',
    'maintenanceWorks.services.facility.description': 'Comprehensive facility management and operations',
    'maintenanceWorks.services.facility.feature1': 'Building operations',
    'maintenanceWorks.services.facility.feature2': 'Vendor management',
    'maintenanceWorks.services.facility.feature3': 'Work order management',
    'maintenanceWorks.services.facility.feature4': 'Performance monitoring',
    'maintenanceWorks.services.energy.title': 'Energy Management',
    'maintenanceWorks.services.energy.description': 'Energy efficiency and optimization services',
    'maintenanceWorks.services.energy.feature1': 'Energy audits',
    'maintenanceWorks.services.energy.feature2': 'Efficiency improvements',
    'maintenanceWorks.services.energy.feature3': 'System optimization',
    'maintenanceWorks.services.energy.feature4': 'Cost reduction',
    'maintenanceWorks.services.specialized.title': 'Specialized Services',
    'maintenanceWorks.services.specialized.description': 'Specialized maintenance for specific systems and equipment',
    'maintenanceWorks.services.specialized.feature1': 'Elevator maintenance',
    'maintenanceWorks.services.specialized.feature2': 'Fire safety systems',
    'maintenanceWorks.services.specialized.feature3': 'Security systems',
    'maintenanceWorks.services.specialized.feature4': 'Building automation',
    'maintenanceWorks.whyChoose.title': 'Why Choose FMC for Maintenance Works?',
    'maintenanceWorks.whyChoose.subtitle': 'Our expertise in facility maintenance and management, combined with proactive approach and quality service, ensures optimal building performance.',
    'maintenanceWorks.whyChoose.experts.title': 'Expert Technicians',
    'maintenanceWorks.whyChoose.experts.description': 'Skilled professionals with extensive maintenance experience',
    'maintenanceWorks.whyChoose.reliability.title': 'Reliable Service',
    'maintenanceWorks.whyChoose.reliability.description': 'Consistent, high-quality maintenance services you can depend on',
    'maintenanceWorks.whyChoose.proactive.title': 'Proactive Approach',
    'maintenanceWorks.whyChoose.proactive.description': 'Preventive maintenance strategies that minimize downtime and costs',
    'maintenanceWorks.whyChoose.response.title': 'Rapid Response',
    'maintenanceWorks.whyChoose.response.description': 'Quick response times for emergency and urgent maintenance needs',
    'maintenanceWorks.whyChoose.card.title': 'Maintaining Excellence',
    'maintenanceWorks.whyChoose.card.subtitle': 'Keeping facilities running at peak performance',
    'maintenanceWorks.cta.title': 'Ready to Maintain Your Facility?',
    'maintenanceWorks.cta.subtitle': 'Let\'s discuss your maintenance needs and develop a comprehensive facility management plan',
    'maintenanceWorks.cta.consultation': 'Get Maintenance Consultation',
    'maintenanceWorks.cta.callNow': 'Call Now',
  },
  ar: {
    // Navigation
    'nav.home': 'الرئيسية',
    'nav.about': 'من نحن',
    'nav.services': 'خدماتنا',
    'nav.projects': 'مشاريعنا',
    'nav.sectors': 'القطاعات',
    'nav.blog': 'المدونة',
    'nav.careers': 'الوظائف',
    'nav.contact': 'اتصل بنا',
    'nav.documents': 'المستندات',
    
    // Common buttons and actions
    'get.quote': 'احصل على عرض سعر',
    'learn.more': 'اعرف المزيد',
    'view.all': 'عرض الكل',
    'read.more': 'اقرأ المزيد',
    
    // Service titles (used in footer and other components)
    'services.commercial.title': 'البناء التجاري',
    'services.residential.title': 'التطوير السكني',
    'services.infrastructure.title': 'مشاريع البنية التحتية',
    'services.detailed.renovation.title': 'التجديد وإعادة التصميم',
    'services.detailed.projectManagement.title': 'إدارة المشاريع',
    
    // Footer
    'footer.company.tagline': 'التميز في البناء',
    'footer.company.description': 'نبني المستقبل بالتميز والابتكار والالتزام الثابت بالجودة.',
    'footer.quickLinks.title': 'روابط سريعة',
    'footer.services.title': 'خدماتنا',
    'footer.contact.title': 'معلومات الاتصال',
    'footer.links.careers': 'الوظائف',
    'footer.links.blog': 'المدونة',
    'footer.address.line1': '١٢٣ شارع البناء',
    'footer.address.line2': 'حي البناء',
    'footer.address.line3': 'المدينة، الولاية ١٢٣٤٥',
    'footer.legal.privacy': 'سياسة الخصوصية',
    'footer.legal.terms': 'شروط الخدمة',
    'footer.legal.cookie': 'سياسة الكوكيز',
    'footer.copyright': '© ٢٠٢٤ شركة إف إم سي للبناء. جميع الحقوق محفوظة.',

    // Admin Panel
    'admin.panel': 'لوحة الإدارة',
    'admin.dashboard': 'لوحة التحكم',
    'admin.projects': 'المشاريع',
    'admin.jobApplications': 'طلبات الوظائف',
    'admin.contactSubmissions': 'طلبات النماذج',
    'admin.subscriptions': 'الاشتراكات',
    'admin.blogPosts': 'مقالات المدونة',
    'admin.socialMedia': 'إدارة وسائل التواصل الاجتماعي',
    
    // Social Media Management
    'socialMedia.title': 'إدارة منشورات لينكد إن',
    'socialMedia.subtitle': 'إدارة منشورات لينكد إن مع عروض التقويم والقائمة والكانبان والبطاقات',
    'socialMedia.addPost': 'إضافة منشور',
    'socialMedia.createPost': 'إنشاء منشور جديد',
    'socialMedia.editPost': 'تعديل المنشور',
    'socialMedia.save': 'حفظ',
    'socialMedia.cancel': 'إلغاء',
    'socialMedia.search': 'البحث في المنشورات...',
    'socialMedia.more': 'المزيد',
    'socialMedia.scheduled': 'مجدول',
    
    // Views
    'socialMedia.views.calendar': 'التقويم',
    'socialMedia.views.list': 'القائمة',
    'socialMedia.views.kanban': 'الكانبان',
    'socialMedia.views.cards': 'البطاقات',
    
    // Calendar
    'socialMedia.calendar.title': 'تقويم المنشورات',
    
    // List
    'socialMedia.list.title': 'قائمة المنشورات',
    
    // Kanban
    'socialMedia.kanban.title': 'خط أنابيب المنشورات',
    
    // Cards
    'socialMedia.cards.title': 'بطاقات المنشورات',
    
    // Status
    'socialMedia.status.label': 'الحالة',
    'socialMedia.status.draft': 'مسودة',
    'socialMedia.status.scheduled': 'مجدول',
    'socialMedia.status.published': 'منشور',
    'socialMedia.status.failed': 'فشل',
    
    // Filters
    'socialMedia.filters.all': 'جميع المنشورات',
    
    // Form Fields
    'socialMedia.imageUrl': 'رابط الصورة',
    'socialMedia.imageUrlPlaceholder': 'أدخل رابط الصورة...',
    'socialMedia.description': 'الوصف',
    'socialMedia.descriptionPlaceholder': 'اكتب وصف المنشور...',
    'socialMedia.hashtags': 'الهاشتاغات',
    'socialMedia.hashtagsPlaceholder': 'أدخل الهاشتاغات مفصولة بفواصل...',
    'socialMedia.scheduledDate': 'التاريخ والوقت المجدول',
    'socialMedia.viewPost': 'عرض المنشور',
    'socialMedia.deletePost': 'حذف المنشور',
    'socialMedia.dropHere': 'اسحب هنا لتغيير الحالة',
    'socialMedia.imagePreview': 'معاينة الصورة',
    'socialMedia.imageLoadError': 'فشل في تحميل الصورة',
    'socialMedia.close': 'إغلاق',
    'socialMedia.loading': 'جاري التحميل...',
    
    'admin.pageViews': 'مشاهدات الصفحة',
    'admin.documents': 'المستندات',
    'admin.vendors': 'الموردين',
    'admin.clients': 'العملاء',
    'admin.users': 'المستخدمين',
    'admin.settings': 'الإعدادات',
    'admin.profile': 'الملف الشخصي',
    'admin.goToWebsite': 'الذهاب للموقع',
    'admin.welcomeBack': 'مرحباً بعودتك',
    'admin.welcomeMessage': 'مرحباً بعودتك إلى لوحة إدارة FMC',
    'admin.logout': 'تسجيل الخروج',
    
    // Admin Profile
    'adminProfile.personalInformation': 'المعلومات الشخصية',
    'adminProfile.firstName': 'الاسم الأول',
    'adminProfile.lastName': 'اسم العائلة',
    'adminProfile.email': 'البريد الإلكتروني',
    'adminProfile.phone': 'رقم الهاتف',
    'adminProfile.position': 'المنصب',
    'adminProfile.department': 'القسم',
    'adminProfile.preferences': 'التفضيلات',
    'adminProfile.language': 'اللغة',
    'adminProfile.theme': 'المظهر',
    'adminProfile.security': 'الأمان',
    'adminProfile.twoFactorAuth': 'المصادقة الثنائية',
    'adminProfile.twoFactorDesc': 'أضف طبقة إضافية من الأمان لحسابك',
    'adminProfile.changePassword': 'تغيير كلمة المرور',
    'adminProfile.currentPassword': 'كلمة المرور الحالية',
    'adminProfile.newPassword': 'كلمة المرور الجديدة',
    'adminProfile.confirmPassword': 'تأكيد كلمة المرور',
    'adminProfile.updatePassword': 'تحديث كلمة المرور',
    'adminProfile.updateAvatar': 'تحديث الصورة الشخصية',
    'adminProfile.avatarDescription': 'قم برفع صورة شخصية جديدة',
    'adminProfile.chooseFile': 'اختر ملف',
    'adminProfile.updateAvatarButton': 'تحديث الصورة الشخصية',
    'adminProfile.saveChanges': 'حفظ التغييرات',
    'adminProfile.personalInfo': 'المعلومات الشخصية',
    
    // Dashboard Projects
    'dashboard.activeProjects': 'المشاريع النشطة',
    'dashboard.completedProjects': 'المشاريع المكتملة',
    
    // Projects
    'projects.filters.planning': 'قيد التخطيط',
    'projects.filters.completed': 'مكتمل',
    'projects.filters.onHold': 'معلق',
    'projects.filters.allSectors': 'جميع القطاعات',
    'projects.filters.allCities': 'جميع المدن',
    'projects.filters.allYears': 'جميع السنوات',
    'projects.filters.healthcare': 'الرعاية الصحية',
    'projects.filters.education': 'التعليم',
    'projects.filters.industrial': 'صناعي',
    'projects.table.projectName': 'اسم المشروع',
    'projects.table.builtUpArea': 'المساحة المبنية',
    'projects.table.gpsLocation': 'موقع GPS',
    'projects.table.googleMapLink': 'رابط خرائط جوجل',
    'projects.table.client': 'العميل',
    'projects.table.consultant': 'الاستشاري',
    'projects.table.city': 'المدينة',
    'projects.table.value': 'القيمة',
    'projects.table.status': 'الحالة',
    'projects.table.sector': 'القطاع',
    'projects.table.yearAwarded': 'سنة المنح',
    'projects.table.startDate': 'تاريخ البداية',
    'projects.table.finishDate': 'تاريخ الانتهاء',
    'projects.table.scopeOfWork': 'نطاق العمل',
    'projects.table.photos': 'الصور',
    'projects.table.featuredPhoto': 'الصورة المميزة',
    'projects.table.videos': 'الفيديوهات',
    'projects.table.references': 'المراجع',
    'projects.table.progress': 'التقدم',
    'projects.table.actions': 'الإجراءات',
    'projects.status.active': 'نشط',
    'projects.status.planning': 'قيد التخطيط',
    'projects.status.completed': 'مكتمل',
    'projects.status.on-hold': 'معلق',
    'projects.deleteConfirm.title': 'حذف المشروع',
    'projects.deleteConfirm.message': 'هل أنت متأكد من أنك تريد حذف المشروع',
    'projects.deleteConfirm.delete': 'حذف',
    'projects.addNew': 'إضافة مشروع جديد',
    'projects.edit': 'تعديل المشروع',
    'projects.view': 'عرض المشروع',
    'projects.modal.addTitle': 'إضافة مشروع جديد',
    'projects.modal.editTitle': 'تعديل المشروع',
    'projects.modal.viewTitle': 'تفاصيل المشروع',
    'projects.modal.basicInfo': 'المعلومات الأساسية',
    'projects.modal.projectDetails': 'تفاصيل المشروع',
    'projects.modal.scopeOfWork': 'نطاق العمل',
    'projects.modal.location': 'الموقع',
    'projects.modal.references': 'المراجع',
    'projects.modal.photos': 'صور المشروع',
    'projects.modal.videos': 'فيديوهات المشروع',
    'projects.modal.addReference': 'إضافة مرجع',
    'projects.modal.addPhoto': 'رفع الصور',
    'projects.modal.addVideo': 'إضافة فيديو',
    'projects.modal.save': 'حفظ المشروع',
    'projects.modal.update': 'تحديث المشروع',
    'projects.modal.close': 'إغلاق',
    'projects.modal.cancel': 'إلغاء',
    'projects.modal.next': 'التالي',
    'projects.modal.previous': 'السابق',
    'projects.modal.review': 'مراجعة تفاصيل المشروع',
    'projects.modal.step1': 'المعلومات الأساسية',
    'projects.modal.step2': 'تفاصيل المشروع',
    'projects.modal.step3': 'الوسائط والتقدم',
    'projects.modal.step4': 'المراجعة والحفظ',
    'projects.form.projectName': 'اسم المشروع',
    'projects.form.client': 'العميل',
    'projects.form.consultant': 'الاستشاري',
    'projects.form.city': 'المدينة',
    'projects.form.builtUpArea': 'المساحة المبنية',
    'projects.form.value': 'قيمة المشروع',
    'projects.form.yearAwarded': 'سنة المنح',
    'projects.form.progress': 'التقدم (%)',
    'projects.form.scopeOfWork': 'نطاق العمل',
    'projects.form.gpsLocation': 'موقع GPS',
    'projects.form.googleMapLink': 'رابط خرائط جوجل',
    'projects.form.placeholder.projectName': 'أدخل اسم المشروع',
    'projects.form.placeholder.client': 'أدخل اسم العميل',
    'projects.form.placeholder.consultant': 'أدخل اسم الاستشاري',
    'projects.form.placeholder.city': 'أدخل المدينة',
    'projects.form.placeholder.builtUpArea': 'مثال: 25,000 متر مربع',
    'projects.form.placeholder.value': 'مثال: 15,000,000 ريال',
    'projects.form.placeholder.yearAwarded': 'مثال: 2024',
    'projects.form.placeholder.progress': '0',
    'projects.form.placeholder.scopeOfWork': 'اوصف نطاق العمل...',
    'projects.form.placeholder.gpsLocation': 'مثال: 24.7136° شمال، 46.6753° شرق',
    'projects.form.placeholder.googleMapLink': 'https://maps.google.com/...',
    'projects.form.placeholder.videoUrl': 'أدخل رابط يوتيوب',
    'projects.form.placeholder.referenceUrl': 'أدخل رابط المرجع',
    'projects.form.sector': 'القطاع',
    'projects.form.status': 'الحالة',
    'projects.form.startDate': 'تاريخ البداية',
    'projects.form.finishDate': 'تاريخ الانتهاء',
    'projects.form.selectClient': 'اختر العميل',
    'projects.form.selectConsultant': 'اختر الاستشاري',
    'projects.form.selectStatus': 'اختر الحالة',
    'projects.form.uploadPhotos': 'رفع الصور',
    'projects.form.featuredPhoto': 'الصورة المميزة',
    'projects.form.uploadFeaturedPhoto': 'رفع الصورة المميزة',
    'projects.form.featuredPhotoPreview': 'معاينة الصورة المميزة',
    'projects.form.addVideo': 'إضافة فيديو',
    'projects.form.dragDropPhotos': 'اسحب وأفلت الصور هنا، أو انقر للتصفح',
    'projects.form.noPhotos': 'لم يتم رفع صور بعد',
    'projects.form.noVideos': 'لم يتم إضافة فيديوهات بعد',
    'projects.form.fileSupport': 'يدعم JPG، PNG، GIF حتى 10 ميجابايت لكل صورة',
    'projects.mapModal.title': 'موقع المشروع',
    'projects.mapModal.close': 'إغلاق الخريطة',
    'projects.fieldVisibility.title': 'إظهار/إخفاء الأعمدة',
    'projects.fieldVisibility.selectAll': 'تحديد الكل',
    'projects.fieldVisibility.deselectAll': 'إلغاء تحديد الكل',
    'projects.fieldVisibility.apply': 'تطبيق',
    'projects.fieldVisibility.cancel': 'إلغاء',
    'projects.form.selectYear': 'اختر السنة',
    'projects.form.selectCity': 'اختر المدينة',
    'projects.cities.riyadh': 'الرياض',
    'projects.cities.jeddah': 'جدة',
    'projects.cities.dammam': 'الدمام',
    'projects.cities.mecca': 'مكة المكرمة',
    'projects.cities.medina': 'المدينة المنورة',
    'projects.cities.taif': 'الطائف',
    'projects.cities.khobar': 'الخبر',
    'projects.cities.dhahran': 'الظهران',
    'projects.cities.other': 'أخرى',
    
    // Submissions
    'submissions.archive': 'أرشيف',
    'submissions.filters.all': 'الكل',
    'submissions.filters.contact': 'اتصال',
    'submissions.filters.job': 'وظيفة',
    'submissions.filters.partnership': 'شراكة',
    'submissions.filters.allStatus': 'جميع الحالات',
    'submissions.filters.new': 'جديد',
    'submissions.filters.reviewed': 'تم المراجعة',
    'submissions.filters.inProgress': 'قيد التنفيذ',
    'submissions.filters.completed': 'مكتمل',
    'submissions.table.type': 'النوع',
    'submissions.table.name': 'الاسم',
    'submissions.table.company': 'الشركة',
    'submissions.table.subject': 'الموضوع',
    'submissions.table.status': 'الحالة',
    'submissions.table.priority': 'الأولوية',
    'submissions.table.actions': 'الإجراءات',
    'submissions.types.contact': 'اتصال',
    'submissions.types.job': 'وظيفة',
    'submissions.types.partnership': 'شراكة',
    'submissions.status.new': 'جديد',
    'submissions.status.reviewed': 'تم المراجعة',
    'submissions.status.inProgress': 'قيد التنفيذ',
    'submissions.status.completed': 'مكتمل',
    'submissions.priority.high': 'عالي',
    'submissions.priority.medium': 'متوسط',
    'submissions.priority.low': 'منخفض',
    'submissions.viewSubmission': 'عرض الطلب',
    'submissions.message': 'الرسالة',
    'common.close': 'إغلاق',
    
    // Job Applications
    'jobApplications.filters.all': 'الكل',
    'jobApplications.filters.projectManager': 'مدير المشروع',
    'jobApplications.filters.civilEngineer': 'مهندس مدني',
    'jobApplications.filters.siteSupervisor': 'مشرف موقع',
    'jobApplications.filters.architect': 'مهندس معماري',
    'jobApplications.filters.quantitySurveyor': 'مهندس كميات',
    'jobApplications.filters.allStatus': 'جميع الحالات',
    'jobApplications.filters.pending': 'معلق',
    'jobApplications.filters.reviewed': 'تم المراجعة',
    'jobApplications.filters.interviewed': 'تم المقابلة',
    'jobApplications.filters.accepted': 'مقبول',
    'jobApplications.filters.rejected': 'مرفوض',
    'jobApplications.table.name': 'الاسم',
    'jobApplications.table.position': 'المنصب',
    'jobApplications.table.experience': 'الخبرة',
    'jobApplications.table.location': 'الموقع',
    'jobApplications.table.status': 'الحالة',
    'jobApplications.table.appliedAt': 'تاريخ التقديم',
    'jobApplications.table.actions': 'الإجراءات',
    'jobApplications.status.pending': 'معلق',
    'jobApplications.status.reviewed': 'تم المراجعة',
    'jobApplications.status.interviewed': 'تم المقابلة',
    'jobApplications.status.accepted': 'مقبول',
    'jobApplications.status.rejected': 'مرفوض',
    'jobApplications.viewApplication': 'عرض الطلب',
    'jobApplications.coverLetter': 'خطاب التغطية',
    
    // Subscriptions
    'subscriptions.totalSubscribers': 'إجمالي المشتركين',
    'subscriptions.activeSubscribers': 'المشتركين النشطين',
    'subscriptions.openRate': 'معدل الفتح',
    'subscriptions.clickRate': 'معدل النقر',
    'subscriptions.filters.allStatus': 'جميع الحالات',
    'subscriptions.filters.active': 'نشط',
    'subscriptions.filters.unsubscribed': 'غير مشترك',
    'subscriptions.filters.pending': 'في الانتظار',
    'subscriptions.filters.allSources': 'جميع المصادر',
    'subscriptions.filters.website': 'الموقع الإلكتروني',
    'subscriptions.filters.social': 'وسائل التواصل',
    'subscriptions.filters.referral': 'إحالة',
    'subscriptions.table.email': 'البريد الإلكتروني',
    'subscriptions.table.name': 'الاسم',
    'subscriptions.table.company': 'الشركة',
    'subscriptions.table.status': 'الحالة',
    'subscriptions.table.source': 'المصدر',
    'subscriptions.table.subscribedAt': 'تاريخ الاشتراك',
    'subscriptions.table.actions': 'الإجراءات',
    'subscriptions.status.active': 'نشط',
    'subscriptions.status.unsubscribed': 'غير مشترك',
    'subscriptions.status.pending': 'في الانتظار',
    'subscriptions.source.website': 'الموقع الإلكتروني',
    'subscriptions.source.social': 'وسائل التواصل',
    'subscriptions.source.referral': 'إحالة',
    'subscriptions.unsubscribedSubscribers': 'غير مشترك',
    'subscriptions.pendingSubscribers': 'في الانتظار',
    'subscriptions.title': 'المشتركين',
    'subscriptions.searchPlaceholder': 'البحث في المشتركين...',
    'subscriptions.export': 'تصدير',
    'subscriptions.sendNewsletter': 'إرسال النشرة الإخبارية',
    'subscriptions.viewSubscriber': 'عرض المشترك',
    'subscriptions.deleteSubscriber': 'حذف المشترك',
    'subscriptions.deleteConfirmation': 'هل أنت متأكد من حذف {name}؟',
    'subscriptions.sendToAll': 'إرسال بريد إلكتروني للجميع',
    'subscriptions.sendToSubscriber': 'إرسال بريد إلكتروني للمشترك',
    'subscriptions.emailSubject': 'موضوع البريد الإلكتروني',
    'subscriptions.emailMessage': 'رسالة البريد الإلكتروني',
    'subscriptions.sendEmail': 'إرسال البريد الإلكتروني',
    
    // Blog
    'blog.totalPosts': 'إجمالي المقالات',
    'blog.publishedPosts': 'المقالات المنشورة',
    'blog.totalViews': 'إجمالي المشاهدات',
    'blog.totalComments': 'إجمالي التعليقات',
    'blog.export': 'تصدير',
    'blog.newPost': 'مقال جديد',
    'blog.filters.published': 'منشور',
    'blog.filters.draft': 'مسودة',
    'blog.filters.archived': 'مؤرشف',
    'blog.filters.allCategories': 'جميع الفئات',
    'blog.filters.company': 'الشركة',
    'blog.table.title': 'العنوان',
    'blog.table.featuredImage': 'الصورة المميزة',
    'blog.tags.label': 'العلامات',
    'blog.filters.allTags': 'جميع العلامات',
    'blog.filters.clearAll': 'مسح الكل',
    'blog.filters.active': 'المرشحات النشطة:',
    'blog.filters.category': 'الفئة:',
    'blog.filters.tag': 'العلامة:',
    'blog.filters.date': 'التاريخ:',
    'blog.filters.search': 'البحث:',
    'blog.table.author': 'المؤلف',
    'blog.table.category': 'الفئة',
    'blog.table.status': 'الحالة',
    'blog.table.views': 'المشاهدات',
    'blog.table.publishedAt': 'تاريخ النشر',
    'blog.table.actions': 'الإجراءات',
    'blog.viewPost': 'عرض مقال المدونة',
    'blog.deletePost': 'حذف مقال المدونة',
    'blog.deleteConfirmation': 'هل أنت متأكد من حذف "{title}"؟',
    'blog.deleteWarning': 'لا يمكن التراجع عن هذا الإجراء.',
    'blog.excerpt': 'الملخص',
    'blog.content': 'المحتوى',
    'blog.tags': 'العلامات',
    
    // PageViews
    'pageViews.totalViews': 'إجمالي المشاهدات',
    'pageViews.uniqueVisitors': 'الزوار الفريدون',
    'pageViews.avgSessionDuration': 'متوسط مدة الجلسة',
    'pageViews.bounceRate': 'معدل الارتداد',
    'pageViews.title': 'تحليلات مشاهدات الصفحات',
    'pageViews.export': 'تصدير',
    'pageViews.refresh': 'تحديث',
    'pageViews.searchPlaceholder': 'البحث في الصفحات...',
    'pageViews.last7Days': 'آخر 7 أيام',
    'pageViews.last30Days': 'آخر 30 يوم',
    'pageViews.last90Days': 'آخر 90 يوم',
    'pageViews.lastYear': 'السنة الماضية',
    'pageViews.table.page': 'الصفحة',
    'pageViews.table.views': 'المشاهدات',
    'pageViews.table.uniqueViews': 'المشاهدات الفريدة',
    'pageViews.table.avgTime': 'متوسط الوقت',
    'pageViews.table.bounceRate': 'معدل الارتداد',
    'pageViews.table.lastViewed': 'آخر مشاهدة',
    'pageViews.noResults': 'لم يتم العثور على مشاهدات الصفحات',
    'pageViews.noResultsMessage': 'حاول تعديل البحث أو النطاق الزمني',
    'admin.searchPages': 'البحث في الصفحات...',
    'admin.noResultsFound': 'لا توجد نتائج',

    // Dashboard specific translations
    'dashboard.totalProjects': 'إجمالي المشاريع',
    'dashboard.formSubmissions': 'طلبات النماذج',
    'dashboard.jobApplications': 'طلبات الوظائف',
    'dashboard.newsletterSubscribers': 'مشتركي النشرة الإخبارية',
    'dashboard.blogPosts': 'مقالات المدونة',
    'dashboard.pageViews': 'مشاهدات الصفحة',
    'dashboard.recentActivity': 'النشاط الأخير',
    'dashboard.recentActivities': 'الأنشطة الأخيرة',
    'dashboard.quickActions': 'الإجراءات السريعة',
    'dashboard.fromLastMonth': 'من الشهر الماضي',
    'dashboard.noRecentActivities': 'لا توجد أنشطة حديثة',
    'dashboard.timePeriods.day': 'آخر يوم',
    'dashboard.timePeriods.week': 'آخر أسبوع',
    'dashboard.timePeriods.month': 'آخر شهر',
    'dashboard.timePeriods.6months': 'آخر 6 أشهر',
    'dashboard.timePeriods.year': 'آخر سنة',
    'dashboard.selectTimePeriod': 'اختر الفترة الزمنية',
    'dashboard.newProject': 'مشروع جديد',
    'dashboard.createProject': 'إنشاء مشروع جديد',
    'dashboard.viewReports': 'عرض التقارير',
    'dashboard.analyticsReports': 'عرض التحليلات والتقارير',
    'dashboard.manageUsers': 'إدارة المستخدمين',
    'dashboard.userManagement': 'أدوات إدارة المستخدمين',
    'dashboard.systemSettings': 'إعدادات النظام',
    'dashboard.configureSystem': 'تكوين إعدادات النظام',

    // Recent Activity translations
    'activity.newProjectCreated': 'تم إنشاء مشروع جديد',
    'activity.formSubmitted': 'تم استلام طلب نموذج جديد',
    'activity.jobApplication': 'تم استلام طلب وظيفة جديد',
    'activity.newsletterSubscription': 'اشتراك جديد في النشرة الإخبارية',
    'activity.timeAgo': 'منذ',
    'activity.hoursAgo': 'ساعات',
    'activity.smartOfficeProject': 'تم إضافة مشروع "مجمع المكاتب الذكي" الجديد',
    'activity.contactFormSubmission': 'طلب نموذج اتصال من جون دو',
    'activity.civilEngineerApplication': 'طلب وظيفة لمهندس مدني',

    // Projects page translations
    'projects.title': 'إدارة المشاريع',
    'projects.subtitle': 'إنشاء وتحرير وإدارة مشاريع البناء الخاصة بك',
    'projects.newProject': 'مشروع جديد',
    'projects.searchPlaceholder': 'البحث في المشاريع...',
    'projects.filterAll': 'جميع المشاريع',
    'projects.filterActive': 'نشط',
    'projects.filterCompleted': 'مكتمل',
    'projects.filterPlanning': 'قيد التخطيط',
    'projects.sectorAll': 'جميع القطاعات',
    'projects.sectorCommercial': 'تجاري',
    'projects.sectorResidential': 'سكني',
    'projects.sectorInfrastructure': 'بنية تحتية',
    'projects.projectName': 'اسم المشروع',
    'projects.location': 'الموقع',
    'projects.status': 'الحالة',
    'projects.sector': 'القطاع',
    'projects.budget': 'الميزانية',
    'projects.startDate': 'تاريخ البداية',
    'projects.endDate': 'تاريخ الانتهاء',
    'projects.actions': 'الإجراءات',
    'projects.delete': 'حذف',
    'projects.customer': 'العميل',
    'projects.deleteProject': 'حذف المشروع',
    'projects.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{projectName}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'projects.noProjects': 'لم يتم العثور على مشاريع',
    'projects.loading': 'جاري تحميل المشاريع...',
    'projects.pagination.showing': 'عرض',
    'projects.pagination.of': 'من',
    'projects.pagination.projects': 'مشاريع',
    'projects.pagination.page': 'صفحة',

    // Submissions page translations
    'submissions.title': 'طلبات النماذج',
    'submissions.subtitle': 'إدارة ومراجعة جميع طلبات النماذج',
    'submissions.export': 'تصدير',
    'submissions.archiveAll': 'أرشفة الكل',
    'submissions.totalSubmissions': 'إجمالي الطلبات',
    'submissions.inReview': 'قيد المراجعة',
    'submissions.archived': 'مؤرشف',
    'submissions.pending': 'معلق',
    'submissions.new': 'جديد',
    'submissions.reviewed': 'تم المراجعة',
    'submissions.inProgress': 'قيد التنفيذ',
    'submissions.searchPlaceholder': 'البحث في الطلبات...',
    'submissions.allTypes': 'جميع الأنواع',
    'submissions.typeContact': 'اتصال',
    'submissions.typeQuote': 'طلب عرض سعر',
    'submissions.typeConsultation': 'استشارة',
    'submissions.typePartnership': 'شراكة',
    'submissions.allStatus': 'جميع الحالات',
    'submissions.statusNew': 'جديد',
    'submissions.statusReviewed': 'تم المراجعة',
    'submissions.statusInProgress': 'قيد التنفيذ',
    'submissions.statusCompleted': 'مكتمل',
    'submissions.statusArchived': 'مؤرشف',
    'submissions.clearFilters': 'مسح المرشحات',
    'submissions.submission': 'الطلب',
    'submissions.contactInfo': 'معلومات الاتصال',
    'submissions.type': 'النوع',
    'submissions.status': 'الحالة',
    'submissions.submitted': 'تم الإرسال',
    'submissions.actions': 'الإجراءات',
    'submissions.noResults': 'لم يتم العثور على طلبات',
    'submissions.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'submissions.submissionDetails': 'تفاصيل الطلب',
    'submissions.name': 'الاسم',
    'submissions.company': 'الشركة',
    'submissions.email': 'البريد الإلكتروني',
    'submissions.phone': 'الهاتف',

    // Job Applications page translations
    'jobApplications.title': 'طلبات الوظائف',
    'jobApplications.subtitle': 'إدارة ومراجعة طلبات الوظائف',
    'jobApplications.totalApplications': 'إجمالي الطلبات',
    'jobApplications.interview': 'مقابلة',
    'jobApplications.rejected': 'مرفوض',
    'jobApplications.pending': 'معلق',
    'jobApplications.export': 'تصدير',
    'jobApplications.new': 'جديد',
    'jobApplications.interviews': 'المقابلات',
    'jobApplications.reviewed': 'تم المراجعة',
    'jobApplications.searchPlaceholder': 'البحث في الطلبات...',
    'jobApplications.allPositions': 'جميع المناصب',
    'jobApplications.positionCivil': 'مهندس مدني',
    'jobApplications.positionMEP': 'مهندس ميكانيكي وكهربائي',
    'jobApplications.positionProject': 'مدير مشروع',
    'jobApplications.positionArchitect': 'مهندس معماري',
    'jobApplications.allStatus': 'جميع الحالات',
    'jobApplications.statusNew': 'جديد',
    'jobApplications.statusReviewed': 'تم المراجعة',
    'jobApplications.statusInterviewScheduled': 'مقابلة مجدولة',
    'jobApplications.statusInterviewed': 'تمت المقابلة',
    'jobApplications.statusAccepted': 'مقبول',
    'jobApplications.statusRejected': 'مرفوض',
    'jobApplications.clearFilters': 'مسح المرشحات',
    'jobApplications.candidate': 'المرشح',
    'jobApplications.position': 'المنصب',
    'jobApplications.experience': 'الخبرة',
    'jobApplications.location': 'الموقع',
    'jobApplications.status': 'الحالة',
    'jobApplications.applied': 'تم التقديم',
    'jobApplications.actions': 'الإجراءات',
    'jobApplications.expected': 'المتوقع',
    'jobApplications.noResults': 'لم يتم العثور على طلبات',
    'jobApplications.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'jobApplications.applicationDetails': 'تفاصيل الطلب',
    'jobApplications.fullName': 'الاسم الكامل',
    'jobApplications.positionApplied': 'المنصب المطلوب',
    'jobApplications.email': 'البريد الإلكتروني',
    'jobApplications.phone': 'الهاتف',
    'jobApplications.availability': 'التوفر',
    'jobApplications.education': 'التعليم',

    // Admin Blog page translations
    'adminBlog.title': 'إدارة مقالات المدونة',
    'adminBlog.subtitle': 'إنشاء وتحرير وإدارة محتوى المدونة',
    'adminBlog.export': 'تصدير',
    'adminBlog.newPost': 'مقال جديد',
    'adminBlog.totalPosts': 'إجمالي المقالات',
    'adminBlog.published': 'منشور',
    'adminBlog.drafts': 'مسودات',
    'adminBlog.totalViews': 'إجمالي المشاهدات',
    'adminBlog.searchPlaceholder': 'البحث في مقالات المدونة...',
    'adminBlog.allStatus': 'جميع الحالات',
    'adminBlog.statusPublished': 'منشور',
    'adminBlog.statusDraft': 'مسودة',
    'adminBlog.statusScheduled': 'مجدول',
    'adminBlog.statusArchived': 'مؤرشف',
    'adminBlog.allCategories': 'جميع الفئات',
    'adminBlog.categoryTechnology': 'التكنولوجيا',
    'adminBlog.categoryEngineering': 'الهندسة',
    'adminBlog.categorySustainability': 'الاستدامة',
    'adminBlog.categorySafety': 'السلامة',
    'adminBlog.clearFilters': 'مسح المرشحات',
    'adminBlog.post': 'المقال',
    'adminBlog.author': 'المؤلف',
    'adminBlog.category': 'الفئة',
    'adminBlog.status': 'الحالة',
    'adminBlog.engagement': 'التفاعل',
    'adminBlog.actions': 'الإجراءات',
    'adminBlog.more': 'المزيد',
    'adminBlog.notPublished': 'غير منشور',
    'adminBlog.draft': 'مسودة',
    'adminBlog.noResults': 'لم يتم العثور على مقالات',
    'adminBlog.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'adminBlog.createFirstPost': 'إنشاء أول مقال',
    'adminBlog.deletePost': 'حذف مقال المدونة',
    'adminBlog.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{title}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'adminBlog.delete': 'حذف',

    // Admin Documents page translations
    'adminDocuments.title': 'إدارة المستندات',
    'adminDocuments.subtitle': 'رفع وتنظيم وإدارة المستندات',
    'adminDocuments.exportList': 'تصدير القائمة',
    'adminDocuments.uploadDocument': 'رفع مستند',
    'adminDocuments.totalDocuments': 'إجمالي المستندات',
    'adminDocuments.pdfFiles': 'ملفات PDF',
    'adminDocuments.totalDownloads': 'إجمالي التحميلات',
    'adminDocuments.publicFiles': 'ملفات عامة',
    'adminDocuments.searchDocuments': 'البحث في المستندات...',
    'adminDocuments.allTypes': 'جميع الأنواع',
    'adminDocuments.typePdf': 'PDF',
    'adminDocuments.typeWord': 'Word',
    'adminDocuments.typeExcel': 'Excel',
    'adminDocuments.typeImage': 'صورة',
    'adminDocuments.typeArchive': 'أرشيف',
    'adminDocuments.allCategories': 'جميع الفئات',
    'adminDocuments.categoryCompany': 'مستندات الشركة',
    'adminDocuments.categoryProject': 'مستندات المشروع',
    'adminDocuments.categorySafety': 'مستندات السلامة',
    'adminDocuments.categoryTechnical': 'مستندات تقنية',
    'adminDocuments.categoryFinancial': 'مستندات مالية',
    'adminDocuments.table.name': 'الاسم',
    'adminDocuments.table.type': 'النوع',
    'adminDocuments.table.category': 'الفئة',
    'adminDocuments.table.size': 'الحجم',
    'adminDocuments.table.downloads': 'التحميلات',
    'adminDocuments.table.status': 'الحالة',
    'adminDocuments.table.actions': 'الإجراءات',
    'adminDocuments.statusPublic': 'عام',
    'adminDocuments.statusPrivate': 'خاص',
    
    // Vendors
    'vendors.title': 'إدارة الموردين',
    'vendors.subtitle': 'إدارة علاقات الموردين والشراكات',
    'vendors.totalVendors': 'إجمالي الموردين',
    'vendors.activeVendors': 'الموردين النشطين',
    'vendors.pendingVendors': 'الموردين المعلقين',
    'vendors.avgRating': 'متوسط التقييم',
    'vendors.export': 'تصدير',
    'vendors.addVendor': 'إضافة مورد',
    'vendors.searchPlaceholder': 'البحث في الموردين...',
    'vendors.filters.all': 'الكل',
    'vendors.filters.allCategories': 'جميع الفئات',
    'vendors.status.active': 'نشط',
    'vendors.status.pending': 'معلق',
    'vendors.status.inactive': 'غير نشط',
    'vendors.category.construction': 'البناء',
    'vendors.category.technology': 'التكنولوجيا',
    'vendors.category.sustainability': 'الاستدامة',
    'vendors.category.safety': 'السلامة',
    'vendors.category.office': 'المكتب',
    'vendors.table.name': 'الاسم',
    'vendors.table.category': 'الفئة',
    'vendors.table.contact': 'جهة الاتصال',
    'vendors.table.rating': 'التقييم',
    'vendors.table.projects': 'المشاريع',
    'vendors.table.status': 'الحالة',
    'vendors.table.actions': 'الإجراءات',
    
    // Clients
    'clients.title': 'إدارة العملاء',
    'clients.subtitle': 'إدارة علاقات العملاء ومحافظ المشاريع',
    'clients.totalClients': 'إجمالي العملاء',
    'clients.activeClients': 'العملاء النشطين',
    'clients.totalValue': 'القيمة الإجمالية',
    'clients.avgProjectValue': 'متوسط قيمة المشروع',
    'clients.export': 'تصدير',
    'clients.addClient': 'إضافة عميل',
    'clients.searchPlaceholder': 'البحث في العملاء...',
    'clients.filters.all': 'الكل',
    'clients.filters.allTypes': 'جميع الأنواع',
    'clients.status.active': 'نشط',
    'clients.status.pending': 'معلق',
    'clients.status.inactive': 'غير نشط',
    'clients.type.corporate': 'شركة',
    'clients.type.construction': 'البناء',
    'clients.type.energy': 'الطاقة',
    'clients.type.technology': 'التكنولوجيا',
    'clients.type.smallBusiness': 'شركة صغيرة',
    'clients.table.name': 'الاسم',
    'clients.table.type': 'النوع',
    'clients.table.contact': 'جهة الاتصال',
    'clients.table.projects': 'المشاريع',
    'clients.table.value': 'القيمة',
    'clients.table.status': 'الحالة',
    'clients.table.actions': 'الإجراءات',
    
    // Users
    'users.title': 'إدارة المستخدمين',
    'users.subtitle': 'إدارة حسابات المستخدمين والصلاحيات',
    'users.totalUsers': 'إجمالي المستخدمين',
    'users.activeUsers': 'المستخدمين النشطين',
    'users.adminUsers': 'مستخدمي الإدارة',
    'users.pendingUsers': 'المستخدمين المعلقين',
    'users.export': 'تصدير',
    'users.addUser': 'إضافة مستخدم',
    'users.searchPlaceholder': 'البحث في المستخدمين...',
    'users.filters.allRoles': 'جميع الأدوار',
    'users.filters.allStatuses': 'جميع الحالات',
    'users.status.active': 'نشط',
    'users.status.pending': 'معلق',
    'users.status.inactive': 'غير نشط',
    'users.role.admin': 'مدير',
    'users.role.manager': 'مدير قسم',
    'users.role.employee': 'موظف',
    'users.table.name': 'الاسم',
    'users.table.role': 'الدور',
    'users.table.department': 'القسم',
    'users.table.lastLogin': 'آخر تسجيل دخول',
    'users.table.status': 'الحالة',
    'users.table.actions': 'الإجراءات',
    'users.never': 'أبداً',
    
    // Settings
    'settings.title': 'إعدادات النظام',
    'settings.subtitle': 'تكوين تفضيلات وخيارات النظام',
    'settings.save': 'حفظ التغييرات',
    'settings.reset': 'إعادة تعيين للافتراضي',
    'settings.tabs.general': 'عام',
    'settings.tabs.notifications': 'الإشعارات',
    'settings.tabs.security': 'الأمان',
    'settings.tabs.system': 'النظام',
    'settings.general.title': 'الإعدادات العامة',
    'settings.general.siteName': 'اسم الموقع',
    'settings.general.siteDescription': 'وصف الموقع',
    'settings.general.siteUrl': 'رابط الموقع',
    'settings.general.adminEmail': 'بريد الإدارة',
    'settings.general.timezone': 'المنطقة الزمنية',
    'settings.notifications.title': 'إعدادات الإشعارات',
    'settings.notifications.emailNotifications': 'إشعارات البريد الإلكتروني',
    'settings.notifications.smsNotifications': 'إشعارات الرسائل النصية',
    'settings.notifications.pushNotifications': 'الإشعارات الفورية',
    'settings.notifications.newSubmissions': 'الطلبات الجديدة',
    'settings.notifications.newJobApplications': 'طلبات الوظائف الجديدة',
    'settings.notifications.newBlogComments': 'تعليقات المدونة الجديدة',
    'settings.notifications.systemAlerts': 'تنبيهات النظام',
    'settings.notifications.weeklyReports': 'التقارير الأسبوعية',
    'settings.security.title': 'إعدادات الأمان',
    'settings.security.twoFactorAuth': 'المصادقة الثنائية',
    'settings.security.sessionTimeout': 'انتهاء الجلسة (بالدقائق)',
    'settings.security.passwordExpiry': 'انتهاء كلمة المرور (بالأيام)',
    'settings.security.loginAttempts': 'أقصى محاولات تسجيل الدخول',
    'settings.security.ipWhitelist': 'قائمة IP المسموحة',
    'settings.security.sslEnabled': 'SSL مفعل',
    'settings.security.backupEnabled': 'النسخ الاحتياطي مفعل',
    'settings.security.backupFrequency': 'تكرار النسخ الاحتياطي',
    'settings.system.title': 'إعدادات النظام',
    'settings.system.maintenanceMode': 'وضع الصيانة',
    'settings.system.debugMode': 'وضع التصحيح',
    'settings.system.cacheEnabled': 'التخزين المؤقت مفعل',
    'settings.system.compressionEnabled': 'الضغط مفعل',
    'settings.system.maxUploadSize': 'أقصى حجم رفع (ميجابايت)',
    'settings.system.allowedFileTypes': 'أنواع الملفات المسموحة',
    'settings.system.apiRateLimit': 'حد معدل API',
    'settings.system.logRetention': 'احتفاظ السجلات (بالأيام)',
    'settings.successMessage': 'تم حفظ الإعدادات بنجاح!',
    'settings.confirmReset': 'تأكيد إعادة التعيين',
    'settings.resetConfirmMessage': 'هل أنت متأكد من أنك تريد إعادة تعيين جميع الإعدادات إلى قيمها الافتراضية؟ لا يمكن التراجع عن هذا الإجراء.',
    'settings.resetSettings': 'إعادة تعيين الإعدادات',
    'settings.cancel': 'إلغاء',
    'settings.siteInformation': 'معلومات الموقع',
    'settings.seoSettings': 'إعدادات SEO',
    'settings.metaKeywords': 'الكلمات المفتاحية',
    'settings.metaDescription': 'وصف الموقع',
    'settings.notificationChannels': 'قنوات الإشعارات',
    'settings.notificationTypes': 'أنواع الإشعارات',
    'settings.receiveNotificationsViaEmail': 'تلقي الإشعارات عبر البريد الإلكتروني',
    'settings.browserPushNotifications': 'إشعارات المتصفح الفورية',
    'settings.smsNotificationsPremium': 'إشعارات الرسائل النصية (مميز)',
    'settings.monthlyReports': 'التقارير الشهرية',
    'settings.maintenanceAlerts': 'تنبيهات الصيانة',
    'settings.securityAlerts': 'تنبيهات الأمان',
    'settings.authenticationAccess': 'المصادقة والوصول',
    'settings.extraSecurityLayer': 'طبقة أمان إضافية',
    'settings.autoLogoutAfterInactivity': 'تسجيل خروج تلقائي بعد عدم النشاط',
    'settings.maxFailedAttemptsBeforeLockout': 'أقصى محاولات فاشلة قبل القفل',
    'settings.passwordExpiresAfterDays': 'انتهاء كلمة المرور بعد أيام',
    'settings.systemSecurity': 'أمان النظام',
    'settings.passwordComplexity': 'تعقيد كلمة المرور',
    'settings.autoLogout': 'تسجيل خروج تلقائي',
    'settings.auditLogging': 'تسجيل التدقيق',
    'settings.systemStatus': 'حالة النظام',
    'settings.systemConfiguration': 'تكوين النظام',
    'settings.autoBackup': 'نسخ احتياطي تلقائي',
    'settings.performanceMonitoring': 'مراقبة الأداء',
    'settings.errorReporting': 'الإبلاغ عن الأخطاء',
    'adminDocuments.categoryMedia': 'ملفات الوسائط',
    'adminDocuments.clearFilters': 'مسح المرشحات',
    'adminDocuments.document': 'المستند',
    'adminDocuments.type': 'النوع',
    'adminDocuments.size': 'الحجم',
    'adminDocuments.category': 'الفئة',
    'adminDocuments.uploadedBy': 'رفع بواسطة',
    'adminDocuments.downloads': 'التحميلات',
    'adminDocuments.visibility': 'الرؤية',
    'adminDocuments.actions': 'الإجراءات',
    'adminDocuments.more': 'المزيد',
    'adminDocuments.public': 'عام',
    'adminDocuments.private': 'خاص',
    'adminDocuments.download': 'تحميل',
    'adminDocuments.share': 'مشاركة',
    'adminDocuments.edit': 'تعديل',
    'adminDocuments.delete': 'حذف',
    'adminDocuments.noResults': 'لم يتم العثور على مستندات',
    'adminDocuments.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'adminDocuments.uploadFirstDocument': 'رفع أول مستند',
    'adminDocuments.selectFile': 'اختيار ملف',
    'adminDocuments.dragAndDrop': 'اسحب وأفلت الملفات هنا، أو انقر للتصفح',
    'adminDocuments.chooseFiles': 'اختيار الملفات',
    'adminDocuments.selectCategory': 'اختيار الفئة',
    'adminDocuments.description': 'الوصف',
    'adminDocuments.descriptionPlaceholder': 'وصف مختصر للمستند',
    'adminDocuments.makePublic': 'جعل هذا المستند عاماً',
    'adminDocuments.upload': 'رفع',
    'adminDocuments.deleteDocument': 'حذف المستند',
    'adminDocuments.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',

    // Admin Vendors page translations
    'adminVendors.title': 'إدارة الموردين',
    'adminVendors.subtitle': 'إدارة شبكة الموردين وعلاقات الموردين',
    'adminVendors.export': 'تصدير',
    'adminVendors.addVendor': 'إضافة مورد',
    'adminVendors.totalVendors': 'إجمالي الموردين',
    'adminVendors.active': 'نشط',
    'adminVendors.pending': 'معلق',
    'adminVendors.avgRating': 'متوسط التقييم',
    'adminVendors.searchVendors': 'البحث في الموردين...',
    'adminVendors.allStatus': 'جميع الحالات',
    'adminVendors.statusActive': 'نشط',
    'adminVendors.statusPending': 'معلق',
    'adminVendors.statusInactive': 'غير نشط',
    'adminVendors.statusSuspended': 'معلق',
    'adminVendors.allCategories': 'جميع الفئات',
    'adminVendors.categoryConstruction': 'مواد البناء',
    'adminVendors.categoryEngineering': 'خدمات الهندسة',
    'adminVendors.categorySteel': 'أعمال الصلب والمعادن',
    'adminVendors.categoryGreen': 'التكنولوجيا الخضراء',
    'adminVendors.categoryLogistics': 'اللوجستيات والنقل',
    'adminVendors.clearFilters': 'مسح المرشحات',
    'adminVendors.vendor': 'المورد',
    'adminVendors.contact': 'جهة الاتصال',
    'adminVendors.category': 'الفئة',
    'adminVendors.status': 'الحالة',
    'adminVendors.rating': 'التقييم',
    'adminVendors.projects': 'المشاريع',
    'adminVendors.joined': 'انضم',
    'adminVendors.actions': 'الإجراءات',
    'adminVendors.noResults': 'لم يتم العثور على موردين',
    'adminVendors.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'adminVendors.addFirstVendor': 'إضافة أول مورد',
    'adminVendors.deleteVendor': 'حذف المورد',
    'adminVendors.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'adminVendors.delete': 'حذف',

    // Admin Clients page translations
    'adminClients.title': 'إدارة العملاء',
    'adminClients.subtitle': 'إدارة علاقات العملاء ومحفظة المشاريع',
    'adminClients.export': 'تصدير',
    'adminClients.addClient': 'إضافة عميل',
    'adminClients.totalClients': 'إجمالي العملاء',
    'adminClients.active': 'نشط',
    'adminClients.totalValue': 'إجمالي القيمة',
    'adminClients.totalProjects': 'إجمالي المشاريع',
    'adminClients.searchPlaceholder': 'البحث في العملاء...',
    'adminClients.allStatus': 'جميع الحالات',
    'adminClients.statusActive': 'نشط',
    'adminClients.statusPending': 'معلق',
    'adminClients.statusInactive': 'غير نشط',
    'adminClients.statusSuspended': 'معلق',
    'adminClients.allTypes': 'جميع الأنواع',
    'adminClients.typeGovernment': 'حكومي',
    'adminClients.typePrivate': 'خاص',
    'adminClients.clearFilters': 'مسح المرشحات',
    'adminClients.client': 'العميل',
    'adminClients.contact': 'جهة الاتصال',
    'adminClients.type': 'النوع',
    'adminClients.status': 'الحالة',
    'adminClients.projects': 'المشاريع',
    'adminClients.joined': 'انضم',
    'adminClients.actions': 'الإجراءات',
    'adminClients.last': 'آخر',
    'adminClients.noResults': 'لم يتم العثور على عملاء',
    'adminClients.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'adminClients.addFirstClient': 'إضافة أول عميل',
    'adminClients.deleteClient': 'حذف العميل',
    'adminClients.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'adminClients.delete': 'حذف',

    // Admin Users page translations
    'adminUsers.title': 'إدارة المستخدمين',
    'adminUsers.subtitle': 'إدارة مستخدمي الإدارة وأذوناتهم',
    'adminUsers.export': 'تصدير',
    'adminUsers.addUser': 'إضافة مستخدم',
    'adminUsers.totalUsers': 'إجمالي المستخدمين',
    'adminUsers.active': 'نشط',
    'adminUsers.admins': 'المديرون',
    'adminUsers.pending': 'معلق',
    'adminUsers.searchPlaceholder': 'البحث في المستخدمين...',
    'adminUsers.allRoles': 'جميع الأدوار',
    'adminUsers.roleSuperAdmin': 'مدير عام',
    'adminUsers.roleAdmin': 'مدير',
    'adminUsers.roleEditor': 'محرر',
    'adminUsers.roleViewer': 'مشاهد',
    'adminUsers.allStatus': 'جميع الحالات',
    'adminUsers.statusActive': 'نشط',
    'adminUsers.statusInactive': 'غير نشط',
    'adminUsers.statusPending': 'معلق',
    'adminUsers.statusSuspended': 'معلق',
    'adminUsers.clearFilters': 'مسح المرشحات',
    'adminUsers.user': 'المستخدم',
    'adminUsers.role': 'الدور',
    'adminUsers.status': 'الحالة',
    'adminUsers.department': 'القسم',
    'adminUsers.lastLogin': 'آخر تسجيل دخول',
    'adminUsers.created': 'تم الإنشاء',
    'adminUsers.actions': 'الإجراءات',
    'adminUsers.never': 'أبداً',
    'adminUsers.noResults': 'لم يتم العثور على مستخدمين',
    'adminUsers.noResultsMessage': 'حاول تعديل البحث أو المرشحات',
    'adminUsers.addFirstUser': 'إضافة أول مستخدم',
    'adminUsers.deleteUser': 'حذف المستخدم',
    'adminUsers.deleteConfirm': 'هل أنت متأكد من أنك تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'adminUsers.delete': 'حذف',
    'adminUsers.resetPassword': 'إعادة تعيين كلمة المرور',
    'adminUsers.newPassword': 'كلمة المرور الجديدة',
    'adminUsers.enterNewPassword': 'أدخل كلمة المرور الجديدة',
    'adminUsers.confirmPassword': 'تأكيد كلمة المرور',
    'adminUsers.confirmNewPassword': 'تأكيد كلمة المرور الجديدة',

    // Admin Settings page translations
    'adminSettings.title': 'إعدادات النظام',
    'adminSettings.subtitle': 'تكوين لوحة الإدارة وتفضيلات النظام',
    'adminSettings.resetToDefault': 'إعادة تعيين إلى الافتراضي',
    'adminSettings.saveChanges': 'حفظ التغييرات',
    'adminSettings.settings': 'الإعدادات',
    'adminSettings.tabGeneral': 'عام',
    'adminSettings.tabNotifications': 'الإشعارات',
    'adminSettings.tabSecurity': 'الأمان',
    'adminSettings.tabEmail': 'البريد الإلكتروني',
    'adminSettings.tabBackup': 'النسخ الاحتياطي',
    'adminSettings.generalSettings': 'الإعدادات العامة',
    'adminSettings.siteName': 'اسم الموقع',
    'adminSettings.siteUrl': 'رابط الموقع',
    'adminSettings.siteDescription': 'وصف الموقع',
    'adminSettings.adminEmail': 'بريد المدير الإلكتروني',
    'adminSettings.timezone': 'المنطقة الزمنية',
    'adminSettings.language': 'اللغة',
    'adminSettings.dateFormat': 'تنسيق التاريخ',
    'adminSettings.notificationSettings': 'إعدادات الإشعارات',
    'adminSettings.emailNotifications': 'إشعارات البريد الإلكتروني',
    'adminSettings.smsNotifications': 'إشعارات الرسائل النصية',
    'adminSettings.pushNotifications': 'الإشعارات الفورية',
    'adminSettings.newSubmissions': 'الطلبات الجديدة',
    'adminSettings.newJobApplications': 'طلبات العمل الجديدة',
    'adminSettings.weeklyReports': 'التقارير الأسبوعية',
    'adminSettings.securitySettings': 'إعدادات الأمان',
    'adminSettings.twoFactorAuth': 'المصادقة الثنائية',
    'adminSettings.sessionTimeout': 'انتهاء الجلسة (بالدقائق)',
    'adminSettings.passwordExpiry': 'انتهاء كلمة المرور (بالأيام)',
    'adminSettings.maxLoginAttempts': 'الحد الأقصى لمحاولات تسجيل الدخول',
    'adminSettings.backupFrequency': 'تكرار النسخ الاحتياطي',
    'adminSettings.ipWhitelist': 'قائمة IP المسموحة',
    'adminSettings.emailConfiguration': 'تكوين البريد الإلكتروني',
    'adminSettings.smtpHost': 'خادم SMTP',
    'adminSettings.smtpPort': 'منفذ SMTP',
    'adminSettings.smtpUsername': 'اسم مستخدم SMTP',
    'adminSettings.smtpPassword': 'كلمة مرور SMTP',
    'adminSettings.fromName': 'اسم المرسل',
    'adminSettings.fromEmail': 'بريد المرسل الإلكتروني',
    'adminSettings.backupSettings': 'إعدادات النسخ الاحتياطي',
    'adminSettings.automaticBackup': 'النسخ الاحتياطي التلقائي',
    'adminSettings.backupLocation': 'موقع النسخ الاحتياطي',
    'adminSettings.retentionDays': 'أيام الاحتفاظ',
    'adminSettings.includeMediaFiles': 'تضمين ملفات الوسائط',
    'adminSettings.includeDatabase': 'تضمين قاعدة البيانات',
    'adminSettings.lastBackup': 'آخر نسخ احتياطي',
    'adminSettings.placeholderSiteName': 'أدخل اسم الموقع',
    'adminSettings.placeholderSiteUrl': 'أدخل رابط الموقع',
    'adminSettings.placeholderSiteDescription': 'أدخل وصف الموقع',
    'adminSettings.placeholderAdminEmail': 'أدخل بريد المدير الإلكتروني',
    'adminSettings.placeholderSmtpHost': 'أدخل خادم SMTP',
    'adminSettings.placeholderSmtpPort': 'أدخل منفذ SMTP',
    'adminSettings.placeholderSmtpUsername': 'أدخل اسم مستخدم SMTP',
    'adminSettings.placeholderSmtpPassword': 'أدخل كلمة مرور SMTP',
    'adminSettings.placeholderFromName': 'أدخل اسم المرسل',
    'adminSettings.placeholderFromEmail': 'أدخل بريد المرسل الإلكتروني',
    'adminSettings.placeholderIpWhitelist': 'أدخل عناوين IP مفصولة بفواصل',
    'adminSettings.receiveNotificationsViaEmail': 'تلقي الإشعارات عبر البريد الإلكتروني',
    'adminSettings.receiveNotificationsViaSms': 'تلقي الإشعارات عبر الرسائل النصية',
    'adminSettings.receiveBrowserPushNotifications': 'تلقي الإشعارات الفورية للمتصفح',
    'adminSettings.notifyWhenNewFormSubmissions': 'الإشعار عند استلام طلبات جديدة',
    'adminSettings.notifyWhenNewJobApplications': 'الإشعار عند استلام طلبات عمل جديدة',
    'adminSettings.receiveWeeklySummaryReports': 'تلقي التقارير الأسبوعية الملخصة',
    'adminSettings.addExtraLayerOfSecurity': 'إضافة طبقة إضافية من الأمان لحسابك',
    'adminSettings.enableAutomaticSystemBackups': 'تفعيل النسخ الاحتياطي التلقائي للنظام',
    'adminSettings.includeUploadedImagesAndDocuments': 'تضمين الصور والوثائق المرفوعة في النسخ الاحتياطي',
    'adminSettings.includeDatabaseInBackup': 'تضمين قاعدة البيانات في النسخ الاحتياطي',


    // Subscribe section
    'subscribe.title': 'ابق على اطلاع',
    'subscribe.subtitle': 'اشترك في نشرتنا الإخبارية للحصول على أحدث المشاريع والرؤى وأخبار الشركة.',
    'subscribe.placeholder': 'أدخل عنوان بريدك الإلكتروني',
    'subscribe.button': 'اشتراك',
    'subscribe.success': 'شكراً لاشتراكك! يرجى التحقق من صندوق الوارد.',
    'subscribe.error': 'يرجى إدخال عنوان بريد إلكتروني صحيح.',
    
    // Navigation dropdown items
    'nav.aboutUs': 'من نحن',
    'nav.organizationChart': 'الهيكل التنظيمي',
    'nav.csr': 'المسؤولية الاجتماعية',
    'nav.codeOfEthics': 'مدونة الأخلاقيات',
    'nav.hse': 'الصحة والسلامة والبيئة',
    'nav.qualityManagement': 'إدارة الجودة',
    
    // CSR Page
    'csr.title': 'المسؤولية الاجتماعية للشركات',
    'csr.subtitle': 'بناء مستقبل أفضل من خلال البناء المسؤول والمشاركة المجتمعية',
    'csr.communityFirst': 'المجتمع أولاً',
    'csr.sustainableFuture': 'مستقبل مستدام',
    'csr.peopleCentered': 'مرتكز على الناس',
    'csr.mission': 'مهمتنا',
    'csr.missionText': 'إنشاء تأثير إيجابي دائم في المجتمعات التي نخدمها من خلال ممارسات البناء المسؤولة، والإشراف البيئي، والمشاركة الاجتماعية الهادفة التي تبني مستقبلاً مستداماً للجميع.',
    'csr.coreValues': 'القيم الأساسية',
    'csr.integrity': 'النزاهة في جميع عملياتنا',
    'csr.respect': 'الاحترام للمجتمعات والبيئة',
    'csr.innovation': 'الابتكار في الممارسات المستدامة',
    'csr.collaboration': 'التعاون مع أصحاب المصلحة',
    'csr.vision': 'رؤيتنا',
    'csr.visionText': 'أن نكون شركة البناء الرائدة التي تحدد معايير المسؤولية الاجتماعية للشركات، وخلق إرث من التغيير الإيجابي الذي يمتد إلى ما هو أبعد من مشاريع البناء لدينا.',
    'csr.impactGoals': 'أهداف التأثير',
    'csr.zeroHarm': 'صفر ضرر بيئي بحلول عام 2030',
    'csr.communityEngagement': '100% مشاركة مجتمعية في المشاريع',
    'csr.educationalSupport': 'دعم تعليمي لأكثر من 10,000 طالب',
    'csr.safetyStandards': 'معايير السلامة الرائدة في الصناعة',
    'csr.impactNumbers': 'تأثيرنا بالأرقام',
    'csr.impactSubtitle': 'قياس التزامنا بالمسؤولية الاجتماعية للشركات من خلال النتائج الملموسة',
    'csr.communityProjects': 'مشاريع مجتمعية',
    'csr.studentsSupported': 'طالب مدعوم',
    'csr.greenCertifications': 'شهادات خضراء',
    'csr.safetyRecord': 'سجل السلامة',
    'csr.initiatives': 'مبادرات المسؤولية الاجتماعية',
    'csr.initiativesSubtitle': 'أربعة ركائز لبرنامج المسؤولية الاجتماعية للشركات',
    'csr.communityDevelopment': 'التنمية المجتمعية',
    'csr.communityDescription': 'دعم المجتمعات المحلية من خلال تطوير البنية التحتية والبرامج الاجتماعية.',
    'csr.environmentalSustainability': 'الاستدامة البيئية',
    'csr.environmentalDescription': 'ملتزمون بممارسات البناء المستدامة وحماية البيئة.',
    'csr.educationTraining': 'التعليم والتدريب',
    'csr.educationDescription': 'الاستثمار في التعليم وتطوير المهارات للأجيال القادمة.',
    'csr.safetyHealth': 'السلامة والصحة',
    'csr.safetyDescription': 'ضمان أعلى معايير السلامة والصحة لجميع أصحاب المصلحة.',
    'csr.keyInitiatives': 'المبادرات الرئيسية:',
    'csr.educationalInfrastructure': 'دعم البنية التحتية التعليمية',
    'csr.healthcareFacility': 'تطوير المرافق الصحية',
    'csr.communityCenter': 'بناء المراكز المجتمعية',
    'csr.youthDevelopment': 'برامج تطوير الشباب',
    'csr.greenBuilding': 'شهادات المباني الخضراء',
    'csr.wasteReduction': 'برامج تقليل النفايات',
    'csr.renewableEnergy': 'دمج الطاقة المتجددة',
    'csr.carbonFootprint': 'تقليل البصمة الكربونية',
    'csr.scholarshipPrograms': 'برامج المنح الدراسية',
    'csr.technicalTraining': 'مراكز التدريب التقني',
    'csr.internshipOpportunities': 'فرص التدريب',
    'csr.educationalMaterial': 'تبرعات المواد التعليمية',
    'csr.workplaceSafety': 'برامج سلامة مكان العمل',
    'csr.healthAwareness': 'حملات التوعية الصحية',
    'csr.emergencyResponse': 'تدريب الاستجابة للطوارئ',
    'csr.safetyEquipment': 'توفير معدات السلامة',
    'csr.joinUs': 'انضم إلينا في إحداث فرق',
    'csr.joinUsText': 'معاً، يمكننا بناء مستقبل أفضل لمجتمعاتنا والبيئة. اتصل بنا لمعرفة المزيد عن برامج المسؤولية الاجتماعية وكيف يمكنك المشاركة.',
    'csr.learnMore': 'اعرف المزيد عنا',
    'csr.partnerWithUs': 'شراكة معنا',
    
    // Code of Ethics Page
    'ethics.title': 'مدونة الأخلاقيات',
    'ethics.subtitle': 'التزامنا بالنزاهة والشفافية والممارسات التجارية الأخلاقية',
    'ethics.introduction': 'مقدمة',
    'ethics.introductionText': 'تخدم مدونة الأخلاقيات الخاصة بنا كأساس لجميع أنشطتنا التجارية وعلاقاتنا. وهي تعكس التزامنا بإدارة الأعمال بأعلى معايير النزاهة والشفافية والاحترام لجميع أصحاب المصلحة.',
    'ethics.corePrinciples': 'المبادئ الأساسية',
    'ethics.integrity': 'النزاهة',
    'ethics.integrityText': 'نقوم بجميع الأنشطة التجارية بأمانة وعدالة وشفافية.',
    'ethics.respect': 'الاحترام',
    'ethics.respectText': 'نعامل جميع الأفراد بكرامة واحترام، ونقدر التنوع والشمول.',
    'ethics.accountability': 'المساءلة',
    'ethics.accountabilityText': 'نتحمل مسؤولية أفعالنا وقراراتنا، ونتأكد من الشفافية في جميع العمليات.',
    'ethics.excellence': 'التميز',
    'ethics.excellenceText': 'نسعى لتحقيق أعلى المعايير في كل ما نقوم به، ونحسن ممارساتنا باستمرار.',
    'ethics.businessConduct': 'السلوك التجاري',
    'ethics.businessConductText': 'إرشادات للممارسات التجارية الأخلاقية والسلوك المهني',
    'ethics.conflictsOfInterest': 'تضارب المصالح',
    'ethics.conflictsText': 'نتجنب المواقف التي تتعارض فيها المصالح الشخصية مع مصالح الشركة.',
    'ethics.fairCompetition': 'المنافسة العادلة',
    'ethics.fairCompetitionText': 'نتنافس بإنصاف وقانونية، ونحترم المنافسين ولوائح السوق.',
    'ethics.confidentiality': 'السرية',
    'ethics.confidentialityText': 'نحمي المعلومات السرية ونحترم حقوق الملكية الفكرية.',
    'ethics.giftsEntertainment': 'الهدايا والترفيه',
    'ethics.giftsText': 'نحافظ على معايير مناسبة للهدايا والترفيه في العلاقات التجارية.',
    'ethics.stakeholderRelations': 'علاقات أصحاب المصلحة',
    'ethics.stakeholderText': 'التزامنا بالعلاقات الأخلاقية مع جميع أصحاب المصلحة',
    'ethics.customers': 'العملاء',
    'ethics.customersText': 'نقدم خدمات عالية الجودة ونحافظ على التواصل الصادق مع عملائنا.',
    'ethics.employees': 'الموظفون',
    'ethics.employeesText': 'نخلق بيئة عمل آمنة وشاملة ومحترمة لجميع الموظفين.',
    'ethics.suppliers': 'الموردون',
    'ethics.suppliersText': 'نعمل مع موردين يشاركوننا معاييرنا وقيمنا الأخلاقية.',
    'ethics.community': 'المجتمع',
    'ethics.communityText': 'نساهم إيجابياً في المجتمعات التي نعمل فيها.',
    'ethics.compliance': 'الامتثال والإبلاغ',
    'ethics.complianceText': 'التزامنا بالامتثال القانوني والإبلاغ الأخلاقي',
    'ethics.legalCompliance': 'الامتثال القانوني',
    'ethics.legalText': 'نمتثل لجميع القوانين واللوائح المعمول بها في عملياتنا.',
    'ethics.reportingViolations': 'الإبلاغ عن الانتهاكات',
    'ethics.reportingText': 'نشجع الإبلاغ عن الانتهاكات الأخلاقية من خلال قنوات سرية.',
    'ethics.whistleblowerProtection': 'حماية المبلغين',
    'ethics.whistleblowerText': 'نحمي الأفراد الذين يبلغون عن الانتهاكات الأخلاقية من الانتقام.',
    'ethics.continuousImprovement': 'التحسين المستمر',
    'ethics.improvementText': 'نراجع ونحدث معاييرنا وممارساتنا الأخلاقية بانتظام.',
    
    // HSE Page
    'hse.title': 'الصحة والسلامة والبيئة',
    'hse.subtitle': 'حماية الناس والمجتمعات والبيئة من خلال إدارة شاملة للصحة والسلامة والبيئة',
    'hse.commitment': 'التزامنا بالصحة والسلامة والبيئة',
    'hse.commitmentText': 'نحن ملتزمون بالحفاظ على أعلى معايير الصحة والسلامة وحماية البيئة في جميع عملياتنا. تضمن سياسات الصحة والسلامة والبيئة رفاهية موظفينا والمجتمعات والبيئة.',
    'hse.zeroHarm': 'سياسة عدم الإضرار',
    'hse.zeroHarmText': 'هدفنا هو تحقيق صفر ضرر للناس والبيئة من خلال إدارة المخاطر الاستباقية والتحسين المستمر.',
    'hse.healthManagement': 'إدارة الصحة',
    'hse.healthText': 'برامج صحية شاملة والدعم الطبي لجميع الموظفين وأصحاب المصلحة.',
    'hse.safetyManagement': 'إدارة السلامة',
    'hse.safetyText': 'أنظمة وإجراءات سلامة قوية لمنع الحوادث والإصابات.',
    'hse.environmentalManagement': 'إدارة البيئة',
    'hse.environmentalText': 'ممارسات مستدامة وإجراءات حماية البيئة في جميع العمليات.',
    'hse.hsePrograms': 'برامج الصحة والسلامة والبيئة',
    'hse.programsText': 'برامج شاملة تغطي جميع جوانب الصحة والسلامة والبيئة',
    'hse.occupationalHealth': 'الصحة المهنية',
    'hse.occupationalText': 'فحوصات صحية منتظمة ودعم طبي وبرامج العافية.',
    'hse.emergencyResponse': 'الاستجابة للطوارئ',
    'hse.emergencyText': 'خطط استجابة شاملة للطوارئ وإجراءات إدارة الأزمات.',
    'hse.environmentalProtection': 'حماية البيئة',
    'hse.protectionText': 'إدارة النفايات والتحكم في التلوث والاستخدام المستدام للموارد.',
    'hse.trainingEducation': 'التدريب والتعليم',
    'hse.trainingText': 'برامج تدريب وتوعية مستمرة للصحة والسلامة والبيئة لجميع الموظفين.',
    'hse.performanceMetrics': 'مؤشرات الأداء',
    'hse.metricsText': 'مؤشرات الأداء الرئيسية لإدارة الصحة والسلامة والبيئة',
    'hse.lostTimeInjuries': 'إصابات وقت الضياع',
    'hse.environmentalIncidents': 'الحوادث البيئية',
    'hse.trainingHours': 'ساعات التدريب',
    'hse.certifications': 'الشهادات',
    'hse.certificationsText': 'شهادات الصحة والسلامة والبيئة واعتماداتنا',
    'hse.iso45001': 'ISO 45001 - الصحة والسلامة المهنية',
    'hse.iso14001': 'ISO 14001 - إدارة البيئة',
    'hse.ohsas18001': 'OHSAS 18001 - إدارة السلامة',
    'hse.continuousImprovement': 'التحسين المستمر',
    'hse.improvementText': 'عمليات تدقيق وتقييم وتحسين منتظمة لأداء الصحة والسلامة والبيئة.',
    
    // Quality Management Page
    'quality.title': 'إدارة الجودة',
    'quality.subtitle': 'تقديم التميز من خلال إدارة الجودة المنهجية والتحسين المستمر',
    'quality.commitment': 'التزامنا بالجودة',
    'quality.commitmentText': 'نحن ملتزمون بتقديم أعلى جودة في جميع مشاريعنا وخدماتنا. نظام إدارة الجودة الخاص بنا يضمن التميز المستمر ورضا العملاء.',
    'quality.qualityPolicy': 'سياسة الجودة',
    'quality.policyText': 'تؤكد سياسة الجودة الخاصة بنا على رضا العملاء والتحسين المستمر والالتزام بالمعايير الدولية.',
    'quality.qualityObjectives': 'أهداف الجودة',
    'quality.objectivesText': 'أهداف واضحة لأداء الجودة والتحسين المستمر',
    'quality.customerSatisfaction': 'رضا العملاء',
    'quality.satisfactionText': 'تحقيق 100% رضا العملاء من خلال التسليمات عالية الجودة.',
    'quality.defectReduction': 'تقليل العيوب',
    'quality.defectText': 'تقليل العيوب وإعادة العمل من خلال مراقبة الجودة المنهجية.',
    'quality.onTimeDelivery': 'التسليم في الوقت المحدد',
    'quality.deliveryText': 'إكمال جميع المشاريع في الجدول الزمني دون المساس بالجودة.',
    'quality.continuousImprovement': 'التحسين المستمر',
    'quality.improvementText': 'مراجعة وتحسين منتظم لعمليات وإجراءات الجودة.',
    'quality.qualitySystem': 'نظام إدارة الجودة',
    'quality.systemText': 'نظام شامل يغطي جميع جوانب إدارة الجودة',
    'quality.planning': 'تخطيط الجودة',
    'quality.planningText': 'خطط جودة مفصلة لكل مشروع وتسليم خدمة.',
    'quality.control': 'مراقبة الجودة',
    'quality.controlText': 'مراقبة ومراقبة منهجية للجودة طوال تنفيذ المشروع.',
    'quality.assurance': 'ضمان الجودة',
    'quality.assuranceText': 'إجراءات استباقية لضمان تلبية معايير الجودة.',
    'quality.improvement': 'تحسين الجودة',
    'quality.standards': 'معايير الجودة',
    'quality.standardsText': 'الالتزام بمعايير الجودة الدولية وأفضل الممارسات',
    'quality.iso9001': 'ISO 9001 - نظام إدارة الجودة',
    'quality.iso14001': 'ISO 14001 - إدارة البيئة',
    'quality.ohsas18001': 'OHSAS 18001 - الصحة والسلامة المهنية',
    'quality.processes': 'عمليات الجودة',
    'quality.processesText': 'عمليات منهجية لإدارة الجودة',
    'quality.designReview': 'مراجعة التصميم',
    'quality.designText': 'مراجعة شاملة للتصاميم قبل التنفيذ.',
    'quality.materialInspection': 'فحص المواد',
    'quality.materialText': 'فحص شامل لجميع المواد والمكونات.',
    'quality.testing': 'الاختبار والتحقق',
    'quality.testingText': 'اختبار وتحقق صارم لجميع التسليمات.',
    'quality.documentation': 'التوثيق',
    'quality.documentationText': 'توثيق شامل لجميع أنشطة الجودة.',
    'quality.certifications': 'شهادات الجودة',
    'quality.certificationsText': 'شهادات الجودة واعتماداتنا',
    'quality.audits': 'تدقيق الجودة',
    'quality.auditsText': 'عمليات تدقيق داخلية وخارجية منتظمة لضمان الامتثال.',
    'quality.training': 'تدريب الجودة',
    'quality.trainingText': 'برامج تدريب شاملة لإدارة الجودة.',
    
    'nav.ourClients': 'عملاؤنا',
    'nav.ourVendors': 'موردونا',
    'nav.ourServices': 'خدماتنا',
    'nav.ourProjects': 'مشاريعنا',
    'nav.ongoingProjects': 'المشاريع الجارية',
    'nav.completedProjects': 'المشاريع المكتملة',
    'nav.industriesSectors': 'الصناعات والقطاعات',
    'nav.news': 'الأخبار',
    'nav.whatWeDo': 'ما نفعله',
    'nav.sectorsIndustries': 'القطاعات والصناعات',
    
    // Services
    'services.buildingInfrastructure': 'البناء والبنية التحتية',
    'services.designEngineering': 'التصميم والهندسة',
    'services.architecturalFitout': 'التشطيب المعماري',
    'services.civilWorks': 'الأعمال المدنية',
    'services.mepWorks': 'أعمال الميكانيكا والكهرباء',
    'services.dataCenters': 'بناء مراكز البيانات',
    'services.pricingBidding': 'التسعير والمزايدة',
    'services.maintenanceWorks': 'أعمال الصيانة',
    
    // Maintenance Works Service
    'maintenanceWorks.hero.title': 'الصيانة',
    'maintenanceWorks.hero.highlight': 'والأعمال',
    'maintenanceWorks.hero.subtitle': 'خدمات شاملة للصيانة وإدارة المرافق لجميع أنواع المباني',
    'maintenanceWorks.overview.title': 'حافظ على مرافقك',
    'maintenanceWorks.overview.highlight': 'تعمل بخدمات الصيانة المتخصصة',
    'maintenanceWorks.overview.description1': 'يوفر قسم أعمال الصيانة لدينا خدمات شاملة لصيانة وإدارة المرافق لضمان الأداء الأمثل للمباني وطول عمرها. نقدم حلول الصيانة الوقائية والتصحيحية والطوارئ لجميع أنواع المرافق.',
    'maintenanceWorks.overview.description2': 'من الصيانة الروتينية إلى الإصلاحات الكبرى، نتعامل مع كل جانب من جوانب صيانة المرافق بما في ذلك أنظمة التدفئة والتهوية وتكييف الهواء، والأنظمة الكهربائية، والسباكة، وصيانة الهيكل، وأتمتة المباني. يضمن فنيونا ذوو الخبرة تشغيل جميع الأنظمة بكفاءة وأمان.',
    'maintenanceWorks.overview.description3': 'نعمل مع مديري العقارات وأصحاب المباني ومشغلي المرافق لتطوير برامج صيانة مخصصة تلبي الاحتياجات والميزانيات المحددة. تشمل خدماتنا الصيانة المجدولة، والاستجابة للطوارئ، وترقية الأنظمة، وتحسين الأداء.',
    'maintenanceWorks.overview.description4': 'تدمج حلول الصيانة لدينا التقنيات الحديثة، وتقنيات الصيانة التنبؤية، والممارسات الموفرة للطاقة لتقليل تكاليف التشغيل وإطالة عمر المعدات. نضمن الامتثال للوائح السلامة والمعايير البيئية مع الحفاظ على جودة الخدمة العالية.',
    'maintenanceWorks.overview.stats.projects': 'عقود الصيانة',
    'maintenanceWorks.overview.stats.experience': 'سنوات الخبرة',
    'maintenanceWorks.fallback.title': 'أعمال الصيانة',
    'maintenanceWorks.services.title': 'خدمات الصيانة لدينا',
    'maintenanceWorks.services.subtitle': 'حلول شاملة لصيانة وإدارة المرافق لجميع احتياجات المباني',
    'maintenanceWorks.services.preventive.title': 'الصيانة الوقائية',
    'maintenanceWorks.services.preventive.description': 'صيانة مجدولة لمنع أعطال المعدات',
    'maintenanceWorks.services.preventive.feature1': 'صيانة أنظمة التدفئة والتهوية',
    'maintenanceWorks.services.preventive.feature2': 'فحوصات كهربائية',
    'maintenanceWorks.services.preventive.feature3': 'فحوصات السباكة',
    'maintenanceWorks.services.preventive.feature4': 'اختبار الأنظمة',
    'maintenanceWorks.services.corrective.title': 'الصيانة التصحيحية',
    'maintenanceWorks.services.corrective.description': 'خدمات الإصلاح والاستعادة للمشاكل الموجودة',
    'maintenanceWorks.services.corrective.feature1': 'إصلاح المعدات',
    'maintenanceWorks.services.corrective.feature2': 'استعادة الأنظمة',
    'maintenanceWorks.services.corrective.feature3': 'استبدال المكونات',
    'maintenanceWorks.services.corrective.feature4': 'ضبط الأداء',
    'maintenanceWorks.services.emergency.title': 'الاستجابة للطوارئ',
    'maintenanceWorks.services.emergency.description': 'خدمات صيانة وإصلاح الطوارئ على مدار الساعة',
    'maintenanceWorks.services.emergency.feature1': 'إصلاحات الطوارئ',
    'maintenanceWorks.services.emergency.feature2': 'استعادة الأنظمة',
    'maintenanceWorks.services.emergency.feature3': 'الاستجابة للسلامة',
    'maintenanceWorks.services.emergency.feature4': 'النشر السريع',
    'maintenanceWorks.services.facility.title': 'إدارة المرافق',
    'maintenanceWorks.services.facility.description': 'إدارة وتشغيل شامل للمرافق',
    'maintenanceWorks.services.facility.feature1': 'تشغيل المباني',
    'maintenanceWorks.services.facility.feature2': 'إدارة الموردين',
    'maintenanceWorks.services.facility.feature3': 'إدارة أوامر العمل',
    'maintenanceWorks.services.facility.feature4': 'مراقبة الأداء',
    'maintenanceWorks.services.energy.title': 'إدارة الطاقة',
    'maintenanceWorks.services.energy.description': 'خدمات كفاءة الطاقة والتحسين',
    'maintenanceWorks.services.energy.feature1': 'تدقيق الطاقة',
    'maintenanceWorks.services.energy.feature2': 'تحسينات الكفاءة',
    'maintenanceWorks.services.energy.feature3': 'تحسين الأنظمة',
    'maintenanceWorks.services.energy.feature4': 'تقليل التكاليف',
    'maintenanceWorks.services.specialized.title': 'الخدمات المتخصصة',
    'maintenanceWorks.services.specialized.description': 'صيانة متخصصة للأنظمة والمعدات المحددة',
    'maintenanceWorks.services.specialized.feature1': 'صيانة المصاعد',
    'maintenanceWorks.services.specialized.feature2': 'أنظمة السلامة من الحرائق',
    'maintenanceWorks.services.specialized.feature3': 'أنظمة الأمان',
    'maintenanceWorks.services.specialized.feature4': 'أتمتة المباني',
    'maintenanceWorks.whyChoose.title': 'لماذا تختار FMC لأعمال الصيانة؟',
    'maintenanceWorks.whyChoose.subtitle': 'خبرتنا في صيانة وإدارة المرافق، مقترنة بالنهج الاستباقي وجودة الخدمة، تضمن الأداء الأمثل للمباني.',
    'maintenanceWorks.whyChoose.experts.title': 'فنيون خبراء',
    'maintenanceWorks.whyChoose.experts.description': 'محترفون مهرة مع خبرة واسعة في الصيانة',
    'maintenanceWorks.whyChoose.reliability.title': 'خدمة موثوقة',
    'maintenanceWorks.whyChoose.reliability.description': 'خدمات صيانة عالية الجودة ومتسقة يمكنك الاعتماد عليها',
    'maintenanceWorks.whyChoose.proactive.title': 'نهج استباقي',
    'maintenanceWorks.whyChoose.proactive.description': 'استراتيجيات الصيانة الوقائية التي تقلل من التوقف والتكاليف',
    'maintenanceWorks.whyChoose.response.title': 'استجابة سريعة',
    'maintenanceWorks.whyChoose.response.description': 'أوقات استجابة سريعة لاحتياجات الصيانة الطارئة والعاجلة',
    'maintenanceWorks.whyChoose.card.title': 'الحفاظ على التميز',
    'maintenanceWorks.whyChoose.card.subtitle': 'الحفاظ على تشغيل المرافق بأقصى أداء',
    'maintenanceWorks.cta.title': 'هل أنت مستعد لصيانة مرافقك؟',
    'maintenanceWorks.cta.subtitle': 'دعنا نناقش احتياجات الصيانة لديك ونطور خطة شاملة لإدارة المرافق',
    'maintenanceWorks.cta.consultation': 'احصل على استشارة الصيانة',
    'maintenanceWorks.cta.callNow': 'اتصل الآن',
    
    // MEP Works Service
    'mepWorks.hero.title': 'الميكانيك',
    'mepWorks.hero.highlight': 'والكهرباء والسباكة',
    'mepWorks.hero.subtitle': 'خدمات مهنية للميكانيك والكهرباء والسباكة لأنظمة المباني الكاملة',
    'mepWorks.overview.title': 'أنظمة المباني الكاملة',
    'mepWorks.overview.highlight': 'مع التميز في هندسة الميكانيك والكهرباء والسباكة',
    'mepWorks.overview.description1': 'يوفر قسم أعمال الميكانيك والكهرباء والسباكة لدينا خدمات شاملة للميكانيك والكهرباء والسباكة لجميع أنواع مشاريع البناء. نصمم ونركب ونحافظ على أنظمة المباني التي تضمن الراحة والأمان وكفاءة الطاقة.',
    'mepWorks.overview.description2': 'من التصميم الأولي إلى التشغيل النهائي، نتعامل مع كل جانب من جوانب أنظمة الميكانيك والكهرباء والسباكة بما في ذلك تصميم التدفئة والتهوية وتكييف الهواء، وتوزيع الكهرباء، وشبكات السباكة، وأنظمة الحماية من الحرائق. يضمن مهندسونا ذوو الخبرة أن جميع الأنظمة تلبي متطلبات الكود ومعايير الأداء.',
    'mepWorks.overview.description3': 'نعمل مع المهندسين المعماريين والمقاولين وأصحاب المباني لدمج أنظمة الميكانيك والكهرباء والسباكة بسلاسة في مشاريع البناء. تشمل خدماتنا نمذجة الطاقة، وتحسين الأنظمة، وحلول التصميم المستدامة التي تقلل تكاليف التشغيل والتأثير البيئي.',
    'mepWorks.overview.description4': 'تدمج حلول الميكانيك والكهرباء والسباكة لدينا أحدث التقنيات والمعدات الموفرة للطاقة وأنظمة المباني الذكية. نضمن التنسيق المناسب بين جميع أنظمة المباني والأداء الأمثل والموثوقية طويلة المدى مع الحفاظ على فعالية التكلفة والامتثال للوائح.',
    'mepWorks.overview.stats.projects': 'مشاريع الميكانيك والكهرباء والسباكة',
    'mepWorks.overview.stats.experience': 'سنوات الخبرة',
    'mepWorks.fallback.title': 'أعمال الميكانيك والكهرباء والسباكة',
    'mepWorks.services.title': 'خدمات الميكانيك والكهرباء والسباكة لدينا',
    'mepWorks.services.subtitle': 'حلول شاملة للميكانيك والكهرباء والسباكة لجميع احتياجات المباني',
    'mepWorks.services.mechanical.title': 'الأنظمة الميكانيكية',
    'mepWorks.services.mechanical.description': 'تصميم وتركيب أنظمة التدفئة والتهوية وتكييف الهواء والميكانيكية',
    'mepWorks.services.mechanical.feature1': 'تصميم التدفئة والتهوية وتكييف الهواء',
    'mepWorks.services.mechanical.feature2': 'أنظمة التهوية',
    'mepWorks.services.mechanical.feature3': 'أنظمة التدفئة',
    'mepWorks.services.mechanical.feature4': 'أنظمة التبريد',
    'mepWorks.services.electrical.title': 'الأنظمة الكهربائية',
    'mepWorks.services.electrical.description': 'خدمات تصميم وتركيب كهربائية كاملة',
    'mepWorks.services.electrical.feature1': 'توزيع الطاقة',
    'mepWorks.services.electrical.feature2': 'تصميم الإضاءة',
    'mepWorks.services.electrical.feature3': 'أنظمة الطوارئ',
    'mepWorks.services.electrical.feature4': 'التحكم الذكي',
    'mepWorks.services.plumbing.title': 'أنظمة السباكة',
    'mepWorks.services.plumbing.description': 'حلول أنظمة إمداد المياه والصرف الصحي',
    'mepWorks.services.plumbing.feature1': 'إمداد المياه',
    'mepWorks.services.plumbing.feature2': 'أنظمة الصرف الصحي',
    'mepWorks.services.plumbing.feature3': 'معالجة المياه',
    'mepWorks.services.plumbing.feature4': 'إدارة النفايات',
    'mepWorks.services.fire.title': 'الحماية من الحرائق',
    'mepWorks.services.fire.description': 'تركيب أنظمة السلامة والحماية من الحرائق',
    'mepWorks.services.fire.feature1': 'إطفاء الحرائق',
    'mepWorks.services.fire.feature2': 'أنظمة الكشف',
    'mepWorks.services.fire.feature3': 'إضاءة الطوارئ',
    'mepWorks.services.fire.feature4': 'أنظمة السلامة',
    'mepWorks.services.energy.title': 'إدارة الطاقة',
    'mepWorks.services.energy.description': 'حلول كفاءة الطاقة والمباني الذكية',
    'mepWorks.services.energy.feature1': 'نمذجة الطاقة',
    'mepWorks.services.energy.feature2': 'تحسين الكفاءة',
    'mepWorks.services.energy.feature3': 'التحكم الذكي',
    'mepWorks.services.energy.feature4': 'أنظمة المراقبة',
    'mepWorks.services.maintenance.title': 'خدمات الصيانة',
    'mepWorks.services.maintenance.description': 'صيانة مستمرة وتحسين الأنظمة',
    'mepWorks.services.maintenance.feature1': 'الصيانة الوقائية',
    'mepWorks.services.maintenance.feature2': 'إصلاح الأنظمة',
    'mepWorks.services.maintenance.feature3': 'ضبط الأداء',
    'mepWorks.services.maintenance.feature4': 'خدمة الطوارئ',
    
    // Data Centers Works (Arabic)
    'dataCenters.hero.title': 'تمكين البنية التحتية',
    'dataCenters.hero.highlight': 'الرقمية',
    'dataCenters.hero.subtitle': 'تمكين التحول الرقمي من خلال حلول بنية تحتية لمراكز البيانات موثوقة وقابلة للتوسع وجاهزة للمستقبل',
    'dataCenters.overview.title': 'بناء أسس رقمية',
    'dataCenters.overview.highlight': 'آمنة ومرنة',
    'dataCenters.overview.description1': 'نجمع بين الخبرة الهندسية القوية والتنفيذ العملي لبناء أسس رقمية آمنة ومرنة، داعمة لرؤية السعودية 2030.',
    'dataCenters.overview.description2': '',
    'dataCenters.overview.description3': '',
    'dataCenters.overview.description4': '',
    'dataCenters.whyChoose.title': 'لماذا تختار إف إم سي؟',
    'dataCenters.whyChoose.subtitle': 'المميزات الاستراتيجية',
    'dataCenters.whyChoose.scalable.title': 'قابل للتوسع وجاهز للمستقبل',
    'dataCenters.whyChoose.scalable.description': 'حلول مصممة لتنمو مع عملك، تتكيف بسلاسة مع التقنيات والأحمال المتطورة.',
    'dataCenters.whyChoose.sustainable.title': 'تصميم مستدام',
    'dataCenters.whyChoose.sustainable.description': 'دمج المعماريات الموفرة للطاقة والتقنيات الخضراء لتقليل البصمة الكربونية وتكاليف التشغيل.',
    'dataCenters.whyChoose.endToEnd.title': 'خدمة شاملة من البداية للنهاية',
    'dataCenters.whyChoose.endToEnd.description': 'خدمات دورة حياة كاملة من المفهوم والبناء إلى الاتصال والأمان والصيانة، مما يلغي الحاجة لعدة موردين.',
    'dataCenters.whyChoose.rapid.title': 'نشر سريع',
    'dataCenters.whyChoose.rapid.description': 'مدعوم بقدرات EPC (الهندسة والتوريد والبناء) الداخلية وشبكة توريد محلية لتسليم أسرع.',
    'dataCenters.whyChoose.reliability.title': 'الموثوقية',
    'dataCenters.whyChoose.reliability.description': 'مصممة لوقت تشغيل مستمر مع مراقبة استباقية لضمان الأداء غير المنقطع.',
    'dataCenters.overview.stats.projects': 'مشاريع مراكز البيانات',
    'dataCenters.overview.stats.experience': 'سنوات الخبرة',
    'dataCenters.services.title': 'حلولنا وعروضنا',
    'dataCenters.services.subtitle': 'حلول بنية تحتية شاملة لمراكز البيانات',
    'dataCenters.services.power.title': 'أنظمة الطاقة والنسخ الاحتياطي',
    'dataCenters.services.power.description': 'أنظمة توزيع الطاقة والنسخ الاحتياطي الموثوقة للعمليات المستمرة',
    'dataCenters.services.power.ups.title': 'أنظمة UPS',
    'dataCenters.services.power.ups.description': 'توفير طاقة نقية ومستمرة باستخدام طوبولوجيات Standby و Line Interactive و Online/Double Conversion. نقدم UPS معياري لتوسع عالي وتحمل للأعطال.',
    'dataCenters.services.power.generators.title': 'مولدات الديزل الاحتياطية',
    'dataCenters.services.power.generators.description': 'مولدات عالية الأداء مع محركات استجابة سريعة قادرة على قبول الحمولة الكاملة في غضون ثوانٍ. تشمل الميزات حاويات مخففة للصوت لتقليل الضوضاء وتخزين وقود مرن للاستقلالية الممتدة.',
    'dataCenters.services.power.distribution.title': 'توزيع الطاقة',
    'dataCenters.services.power.distribution.description': 'توزيع الطاقة المعياري و rack PDUs (Switched, Metered, Basic) لضمان وصول الطاقة لأحمال تكنولوجيا المعلومات بكفاءة.',
    'dataCenters.services.cooling.title': 'تقنيات التبريد',
    'dataCenters.services.cooling.description': 'حلول التبريد الدقيقة المصممة للحفاظ على 99.99% وقت تشغيل',
    'dataCenters.services.cooling.feature1': 'وحدات التحكم القريبة للمياه المبردة و DX',
    'dataCenters.services.cooling.feature2': 'أنظمة احتواء الممرات',
    'dataCenters.services.cooling.feature3': 'التبريد داخل الصف واستخراج الحرارة داخل الرف',
    'dataCenters.services.cooling.feature4': 'التبريد المباشر للسائل إلى الشريحة والغمر السائل',
    'dataCenters.services.infrastructure.title': 'الأعمال المدنية والميكانيكية والكهربائية والبنية التحتية',
    'dataCenters.services.infrastructure.description': 'إعداد موقع شامل جاهز للاستخدام والبنية التحتية',
    'dataCenters.services.infrastructure.civil.title': 'الأعمال المدنية والميكانيكية والكهربائية',
    'dataCenters.services.infrastructure.civil.description': 'إعداد موقع شامل جاهز للاستخدام بما في ذلك السلامة الإنشائية والعزل الحراري والتقسيم المقاوم للحريق.',
    'dataCenters.services.infrastructure.flooring.title': 'أرضيات الوصول المرتفعة',
    'dataCenters.services.infrastructure.flooring.description': 'ألواح ثقيلة (نوى إسمنتية أو كبريتات الكالسيوم) مع تشطيبات HPL مضادة للكهرباء الساكنة لدعم الأرفف الثقيلة وإدارة تدفق الهواء.',
    'dataCenters.services.infrastructure.racks.title': 'الأرفف والملحقات',
    'dataCenters.services.infrastructure.racks.description': 'خزائن وإدارة تدفق الهواء وأنظمة إدارة الكابلات ومفاتيح KVM.',
    'dataCenters.services.infrastructure.cabling.title': 'الكابلات',
    'dataCenters.services.infrastructure.cabling.description': 'تصميم ونشر أنظمة النحاس والألياف من درجة مركز البيانات.',
    'dataCenters.services.security.title': 'السلامة والأمان والإدارة',
    'dataCenters.services.security.description': 'حلول شاملة للسلامة والأمان والإدارة',
    'dataCenters.services.security.fire.title': 'إطفاء الحرائق',
    'dataCenters.services.security.fire.description': 'حماية متطورة تشمل VESDA (كشف الدخان الشفطي للتحذير المبكر جداً) وأنظمة العامل النظيف (Novec 1230 / FM-200).',
    'dataCenters.services.security.dcim.title': 'DCIM (إدارة بنية مركز البيانات التحتية)',
    'dataCenters.services.security.dcim.description': 'حل لوحة تحكم واحدة لمراقبة إدارة الأصول وتخطيط السعة واستهلاك الطاقة.',
    'dataCenters.services.security.ems.title': 'الأمان و EMS',
    'dataCenters.services.security.ems.description': 'الأمان المادي (CCTV، التحكم في الوصول) مجتمع مع أنظمة المراقبة البيئية (أجهزة استشعار درجة الحرارة والرطوبة وكشف التسرب).',
    'dataCenters.services.modular.title': 'مراكز البيانات المعيارية الجاهزة',
    'dataCenters.services.modular.description': 'وحدات مجمعة ومختبرة في المصنع يتم نقلها إلى الموقع للنشر السريع. قابلة للتوسع بدرجة عالية وفعالة من حيث التكلفة وقابلة للنقل ومثالية للتعافي من الكوارث أو المواقع النائية.',
    'dataCenters.fallback.title': 'بناء مراكز البيانات',
    'mepWorks.whyChoose.title': 'لماذا تختار إف إم سي لأعمال الميكانيك والكهرباء والسباكة؟',
    'mepWorks.whyChoose.subtitle': 'خبرتنا في أنظمة الميكانيك والكهرباء والسباكة، مجتمعة مع الابتكار التقني والتركيب عالي الجودة، توفر أنظمة مباني موثوقة وفعالة.',
    'mepWorks.whyChoose.experts.title': 'مهندسون خبراء',
    'mepWorks.whyChoose.experts.description': 'مهندسون مرخصون مع خبرة واسعة في أنظمة الميكانيك والكهرباء والسباكة',
    'mepWorks.whyChoose.quality.title': 'تركيب عالي الجودة',
    'mepWorks.whyChoose.quality.description': 'تركيب مهني يضمن الأداء الأمثل للأنظمة',
    'mepWorks.whyChoose.innovation.title': 'الابتكار التقني',
    'mepWorks.whyChoose.innovation.description': 'أحدث التقنيات والحلول الموفرة للطاقة',
    'mepWorks.whyChoose.support.title': 'الدعم المستمر',
    'mepWorks.whyChoose.support.description': 'خدمات صيانة ودعم شاملة',
    'mepWorks.whyChoose.card.title': 'تشغيل المباني',
    'mepWorks.whyChoose.card.subtitle': 'أنظمة موثوقة للبناء الحديث',
    'mepWorks.cta.title': 'هل أنت مستعد لتشغيل مبناك؟',
    'mepWorks.cta.subtitle': 'دعنا نناقش متطلبات الميكانيك والكهرباء والسباكة لديك وننشئ أنظمة مباني فعالة',
    'mepWorks.cta.consultation': 'احصل على استشارة الميكانيك والكهرباء والسباكة',
    'mepWorks.cta.callNow': 'اتصل الآن',
    
    // Pricing & Bidding Service
    'pricingBidding.hero.title': 'التسعير',
    'pricingBidding.hero.highlight': 'والمزايدة',
    'pricingBidding.hero.subtitle': 'خدمات تقدير التكلفة المهنية والمزايدة التنافسية لمشاريع البناء',
    'pricingBidding.overview.title': 'تقدير التكلفة الدقيق',
    'pricingBidding.overview.highlight': 'مع التميز في المزايدة التنافسية',
    'pricingBidding.overview.description1': 'يوفر قسم التسعير والمزايدة لدينا خدمات تقدير التكلفة المهنية والمزايدة التنافسية لمشاريع البناء من جميع الأحجام. نقدم تقديرات دقيقة وشفافة تساعد العملاء على اتخاذ قرارات مالية مدروسة.',
    'pricingBidding.overview.description2': 'من التقديرات الأولية إلى العطاءات التنافسية، نتعامل مع كل جانب من جوانب تسعير المشاريع بما في ذلك تحليل المواد، وتكاليف العمالة، والمعدات، والمرافق العامة، والربح، والهوامش. يضمن فريقنا ذو الخبرة تقديرات دقيقة ومتنافسة.',
    'pricingBidding.overview.description3': 'نعمل مع المطورين والمقاولين وأصحاب المشاريع لتطوير استراتيجيات تسعير فعالة تلبي الميزانيات والأهداف المحددة. تشمل خدماتنا تحليل القيمة، وهندسة التكلفة، وإدارة المخاطر، وتحسين التكلفة.',
    'pricingBidding.overview.description4': 'تدمج حلول التسعير لدينا أحدث برامج تقدير التكلفة، وقواعد البيانات السعرية، والممارسات الصناعية لضمان الدقة والتنافسية. نضمن الشفافية في التسعير، والامتثال للمعايير، والنتائج المالية المثلى مع الحفاظ على جودة المشروع.',
    'pricingBidding.overview.stats.projects': 'مشاريع التسعير',
    'pricingBidding.overview.stats.experience': 'سنوات الخبرة',
    'pricingBidding.fallback.title': 'التسعير والمزايدة',
    'pricingBidding.services.title': 'خدمات التسعير والمزايدة لدينا',
    'pricingBidding.services.subtitle': 'حلول شاملة لتقدير التكلفة والمزايدة التنافسية لجميع احتياجات المشاريع',
    'pricingBidding.services.estimation.title': 'تقدير التكلفة',
    'pricingBidding.services.estimation.description': 'تقدير دقيق ومفصل لتكاليف المشاريع',
    'pricingBidding.services.estimation.feature1': 'تحليل المواد',
    'pricingBidding.services.estimation.feature2': 'تقدير العمالة',
    'pricingBidding.services.estimation.feature3': 'تكاليف المعدات',
    'pricingBidding.services.estimation.feature4': 'المرافق العامة',
    'pricingBidding.services.bidding.title': 'المزايدة التنافسية',
    'pricingBidding.services.bidding.description': 'عطاءات تنافسية ومربحة للمشاريع',
    'pricingBidding.services.bidding.feature1': 'تحليل المنافسة',
    'pricingBidding.services.bidding.feature2': 'استراتيجيات التسعير',
    'pricingBidding.services.bidding.feature3': 'إدارة المخاطر',
    'pricingBidding.services.bidding.feature4': 'تحسين الربحية',
    'pricingBidding.services.analysis.title': 'تحليل التكلفة',
    'pricingBidding.services.analysis.description': 'تحليل مفصل لتكاليف المشاريع والقيمة',
    'pricingBidding.services.analysis.feature1': 'تحليل القيمة',
    'pricingBidding.services.analysis.feature2': 'هندسة التكلفة',
    'pricingBidding.services.analysis.feature3': 'تحليل الربحية',
    'pricingBidding.services.analysis.feature4': 'تحسين التكلفة',
    'pricingBidding.services.value.title': 'هندسة القيمة',
    'pricingBidding.services.value.description': 'تحسين القيمة والتكلفة للمشاريع',
    'pricingBidding.services.value.feature1': 'تحليل البدائل',
    'pricingBidding.services.value.feature2': 'تحسين التصميم',
    'pricingBidding.services.value.feature3': 'تقليل التكلفة',
    'pricingBidding.services.value.feature4': 'تحسين الأداء',
    'pricingBidding.services.support.title': 'الدعم والاستشارة',
    'pricingBidding.services.support.description': 'دعم مستمر واستشارة في التسعير',
    'pricingBidding.services.support.feature1': 'استشارة التسعير',
    'pricingBidding.services.support.feature2': 'مراجعة التقديرات',
    'pricingBidding.services.support.feature3': 'الدعم التقني',
    'pricingBidding.services.support.feature4': 'التدريب والتطوير',
    'pricingBidding.services.reporting.title': 'التقارير والتحليل',
    'pricingBidding.services.reporting.description': 'تقارير مفصلة وتحليل الأداء المالي',
    'pricingBidding.services.reporting.feature1': 'تقارير التكلفة',
    'pricingBidding.services.reporting.feature2': 'تحليل الربحية',
    'pricingBidding.services.reporting.feature3': 'تقارير الأداء',
    'pricingBidding.services.reporting.feature4': 'تحليل الاتجاهات',
    'pricingBidding.whyChoose.title': 'لماذا تختار إف إم سي للتسعير والمزايدة؟',
    'pricingBidding.whyChoose.subtitle': 'خبرتنا في تقدير التكلفة والمزايدة التنافسية، مجتمعة مع الدقة والشفافية، توفر نتائج مالية مثلى للمشاريع.',
    'pricingBidding.whyChoose.experts.title': 'خبراء التسعير',
    'pricingBidding.whyChoose.experts.description': 'محترفون ذوو خبرة واسعة في تقدير التكلفة والمزايدة',
    'pricingBidding.whyChoose.accuracy.title': 'دقة التقدير',
    'pricingBidding.whyChoose.accuracy.description': 'تقديرات دقيقة ومفصلة بناءً على أحدث البيانات',
    'pricingBidding.whyChoose.strategy.title': 'النهج الاستراتيجي',
    'pricingBidding.whyChoose.strategy.description': 'استراتيجيات مزايدة فعالة مصممة لكل مشروع وسوق',
    'pricingBidding.whyChoose.transparency.title': 'الشفافية',
    'pricingBidding.whyChoose.transparency.description': 'شفافية كاملة في التسعير والتقديرات',
    'pricingBidding.whyChoose.support.title': 'الدعم المستمر',
    'pricingBidding.whyChoose.support.description': 'دعم مستمر واستشارة طوال دورة المشروع',
    'pricingBidding.whyChoose.card.title': 'تسعير المشاريع',
    'pricingBidding.whyChoose.card.subtitle': 'حلول مالية ذكية للبناء الحديث',
    'pricingBidding.cta.title': 'هل أنت مستعد لتسعير مشروعك؟',
    'pricingBidding.cta.subtitle': 'دعنا نناقش متطلبات التسعير لديك ونطور استراتيجية مزايدة فعالة',
    'pricingBidding.cta.consultation': 'احصل على استشارة التسعير',
    'pricingBidding.cta.callNow': 'اتصل الآن',
    
    // Sectors
    'sectors.commercial': 'تجاري',
    'sectors.entertainment': 'ترفيهي',
    'sectors.hotel': 'فندقي',
    'sectors.industrial': 'صناعي',
    'sectors.residential': 'سكني',
    'sectors.school': 'التعليم',
    'sectors.utilities': 'مرافق عامة',
    'sectors.warehouse': 'مستودعات',
    'sectors.title': 'القطاعات',
    
    // Buttons and actions
    'contact.us': 'اتصل بنا',
    'follow.us': 'تابعنا',
    'site.map': 'خريطة الموقع',
    
    // LinkedIn banner
    'linkedin.banner': 'انضم إلى مجتمعنا المهني على لينكد إن للحصول على الرؤى والتحديثات!',
    
    // Subscribe modal translations
    'subscribe.modal.title': 'اشترك في نشرتنا الإخبارية',
    'subscribe.modal.success.title': 'تم الاشتراك بنجاح!',
    'subscribe.modal.success.message': 'شكراً لاشتراكك في نشرتنا الإخبارية. ستتلقى تحديثات حول أحدث مشاريعنا وأخبار الشركة.',
    'subscribe.modal.name.label': 'الاسم',
    'subscribe.modal.name.placeholder': 'أدخل اسمك',
    'subscribe.modal.email.label': 'البريد الإلكتروني *',
    'subscribe.modal.email.placeholder': 'أدخل عنوان بريدك الإلكتروني',
    'subscribe.modal.consent.text': 'لقد قرأت وأوافق على',
    'subscribe.modal.consent.terms': 'شروط الخدمة',
    'subscribe.modal.consent.and': 'و',
    'subscribe.modal.consent.privacy': 'سياسة الخصوصية.',
    'subscribe.modal.submit.subscribing': 'جاري الاشتراك...',
    'subscribe.modal.submit.text': 'اشتراك',
    'subscribe.modal.errors.emailRequired': 'البريد الإلكتروني مطلوب',
    'subscribe.modal.errors.consentRequired': 'يرجى الموافقة على الشروط وسياسة الخصوصية',
    'subscribe.modal.errors.invalidEmail': 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    
    // Button texts
    'buttons.downloadNow': 'حمل الآن',
    'buttons.viewDetails': 'عرض التفاصيل',
    'buttons.readMore': 'اقرأ المزيد',
    'buttons.getQuote': 'احصل على عرض سعر',
    'buttons.learnMore': 'اعرف المزيد',
    'buttons.viewAll': 'عرض الكل',
    'buttons.showMore': 'عرض المزيد',
    'buttons.showLess': 'عرض أقل',
    'buttons.explore': 'استكشف',
    'buttons.discover': 'اكتشف',
    'buttons.seeAll': 'عرض الكل',
    'buttons.viewAllNews': 'عرض جميع الأخبار',
    'buttons.seeAllVendors': 'عرض جميع الموردين',
    
    // Common actions
    'common.cancel': 'إلغاء',
    'common.delete': 'حذف',
    'common.loading': 'جاري التحميل...',
    
    // Chairman and leadership
    'leadership.chairman': 'الرئيس التنفيذي',
    'leadership.chairmanFMC': 'رئيس مجلس الإدارة، إف إم سي',
    'leadership.engrMohammadFarhat': 'محمد فرحات',
    'leadership.mohamedAbdulRahmanFarhat': 'محمد عبد الرحمن فرحات',
    'leadership.position.chairman': 'رئيس مجلس الإدارة',
    
    // Cities
    'cities.jeddah': 'جدة',
    'cities.riyadh': 'الرياض',
    'cities.dammam': 'الدمام',
    
    // Contact Widget
    'contact.widget.button': 'اتصل بنا',
    'contact.widget.support': 'دعم إف إم سي',
    'contact.widget.online': 'متصل',
    'contact.widget.message': 'مرحباً 👋 كيف يمكنني مساعدتك؟',
    'contact.widget.whatsapp': 'واتساب',
    'contact.widget.call': 'اتصال',
    'contact.widget.email': 'بريد إلكتروني',
    
    // Privacy Policy
    'privacy.title': 'سياسة الخصوصية',
    'privacy.subtitle': 'خصوصيتك مهمة بالنسبة لنا. تعلم كيف نجمع ونستخدم ونحمي معلوماتك.',
    'privacy.lastUpdated': 'آخر تحديث: 15 يناير 2024',
    'privacy.sections.introduction.title': 'مقدمة',
    'privacy.sections.introduction.content1': 'إف إم سي للإنشاءات ("نحن" أو "خاصتنا" أو "لنا") ملتزمة بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيف نجمع ونستخدم ونكشف ونحمي معلوماتك عند زيارة موقعنا الإلكتروني أو استخدام خدماتنا أو التفاعل معنا.',
    'privacy.sections.introduction.content2': 'باستخدام خدماتنا، فإنك توافق على جمع واستخدام المعلومات وفقاً لهذه السياسة.',
    'privacy.informationWeCollect.title': 'المعلومات التي نجمعها',
    'privacy.personalInformation.title': 'المعلومات الشخصية',
    'privacy.automaticallyCollected.title': 'المعلومات المجمعة تلقائياً',
    'privacy.howWeUse.title': 'كيف نستخدم معلوماتك',
    'privacy.informationSharing.title': 'مشاركة المعلومات والكشف عنها',
    'privacy.dataSecurity.title': 'أمان البيانات',
    'privacy.cookiesTracking.title': 'الكوكيز وتقنيات التتبع',
    'privacy.yourRights.title': 'حقوق الخصوصية الخاصة بك',
    'privacy.dataRetention.title': 'الاحتفاظ بالبيانات',
    'privacy.internationalTransfers.title': 'التحويلات الدولية للبيانات',
    'privacy.childrensPrivacy.title': 'خصوصية الأطفال',
    'privacy.changesPolicy.title': 'تغييرات سياسة الخصوصية هذه',
    'privacy.contact.title': 'اتصل بنا',
    'privacy.effective': 'هذه سياسة الخصوصية سارية المفعول اعتباراً من 15 يناير 2024، وستبقى سارية باستثناء أي تغييرات في أحكامها في المستقبل.',
    'privacy.personalInformation.desc': 'قد نجمع معلومات شخصية تقدمها لنا طوعياً، بما في ذلك:',
    'privacy.personalInformation.list1': 'الاسم ومعلومات الاتصال (البريد الإلكتروني، رقم الهاتف، العنوان)',
    'privacy.personalInformation.list2': 'اسم الشركة والمسمى الوظيفي',
    'privacy.personalInformation.list3': 'متطلبات ومواصفات المشروع',
    'privacy.personalInformation.list4': 'تفضيلات التواصل',
    'privacy.personalInformation.list5': 'السيرة الذاتية ومعلومات التوظيف (لطلبات الوظائف)',
    'privacy.automaticallyCollected.desc': 'عندما تزور موقعنا الإلكتروني، نجمع تلقائياً معلومات معينة:',
    'privacy.automaticallyCollected.list1': 'عنوان IP ومعلومات الجهاز',
    'privacy.automaticallyCollected.list2': 'نوع المتصفح والإصدار',
    'privacy.automaticallyCollected.list3': 'الصفحات المزارة والوقت المستغرق',
    'privacy.automaticallyCollected.list4': 'الموقع الإلكتروني المرجعي',
    'privacy.automaticallyCollected.list5': 'الكوكيز والتقنيات المماثلة',
    'privacy.howWeUse.desc': 'نستخدم المعلومات المجمعة لأغراض مختلفة:',
    'privacy.howWeUse.list1': 'تقديم وصيانة خدماتنا',
    'privacy.howWeUse.list2': 'معالجة والرد على استفساراتك',
    'privacy.howWeUse.list3': 'إرسال تحديثات المشاريع والنشرات الإخبارية',
    'privacy.howWeUse.list4': 'تحسين موقعنا الإلكتروني وخدماتنا',
    'privacy.howWeUse.list5': 'الامتثال للالتزامات القانونية',
    'privacy.howWeUse.list6': 'الحماية من التهديدات الأمنية والاحتيال',
    'privacy.howWeUse.list7': 'التوظيف وتقييم المرشحين للوظائف',
    'privacy.informationSharing.desc': 'نحن لا نبيع أو نتاجر أو نؤجر معلوماتك الشخصية لأطراف ثالثة. قد نشارك معلوماتك في الظروف التالية:',
    'privacy.informationSharing.list1': 'مقدمو الخدمات: مع مقدمي الخدمات من الأطراف الثالثة الموثوقين الذين يساعدوننا في تشغيل أعمالنا',
    'privacy.informationSharing.list2': 'المتطلبات القانونية: عند الحاجة بموجب القانون أو لحماية حقوقنا وسلامتنا',
    'privacy.informationSharing.list3': 'تحويلات الأعمال: فيما يتعلق بالاندماج أو الاستحواذ أو بيع الأصول',
    'privacy.informationSharing.list4': 'الموافقة: بموافقتك الصريحة',
    'privacy.dataSecurity.desc1': 'نطبق تدابير أمنية تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير.',
    'privacy.dataSecurity.desc2': 'ومع ذلك، لا توجد طريقة نقل عبر الإنترنت أو التخزين الإلكتروني آمنة بنسبة 100%، ولا يمكننا ضمان الأمان المطلق.',
    'privacy.cookiesTracking.desc1': 'نستخدم الكوكيز وتقنيات التتبع المماثلة لتحسين تجربة التصفح الخاصة بك وتحليل حركة المرور على الموقع.',
    'privacy.cookiesTracking.desc2': 'يمكنك التحكم في إعدادات الكوكيز من خلال تفضيلات متصفحك. ومع ذلك، قد يؤثر تعطيل الكوكيز على وظائف الموقع.',
    'privacy.yourRights.desc': 'اعتماداً على موقعك، قد تكون لديك الحقوق التالية فيما يتعلق بمعلوماتك الشخصية:',
    'privacy.yourRights.list1': 'الوصول: طلب نسخة من معلوماتك الشخصية',
    'privacy.yourRights.list2': 'التصحيح: طلب تصحيح المعلومات غير الدقيقة',
    'privacy.yourRights.list3': 'الحذف: طلب حذف معلوماتك الشخصية',
    'privacy.yourRights.list4': 'القابلية للنقل: طلب نقل بياناتك',
    'privacy.yourRights.list5': 'الاعتراض: الاعتراض على معالجة معلوماتك',
    'privacy.yourRights.list6': 'السحب: سحب الموافقة على معالجة البيانات',
    'privacy.dataRetention.desc': 'نحتفظ بمعلوماتك الشخصية فقط طالما كان ذلك ضرورياً لتحقيق الأغراض المحددة في سياسة الخصوصية هذه، ما لم تكن هناك حاجة لفترة احتفاظ أطول أو يسمح بها القانون.',
    'privacy.internationalTransfers.desc': 'قد يتم نقل معلوماتك ومعالجتها في بلدان أخرى غير بلدك. نضمن وجود ضمانات مناسبة لحماية معلوماتك وفقاً لسياسة الخصوصية هذه.',
    'privacy.childrensPrivacy.desc': 'خدماتنا غير مخصصة للأطفال دون سن 13 عاماً. نحن لا نجمع معلومات شخصية من الأطفال دون سن 13 عاماً.',
    'privacy.changesPolicy.desc': 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات من خلال نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث".',
    'privacy.contact.desc': 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارسات البيانات الخاصة بنا، يرجى الاتصال بنا:',
    'privacy.contact.email': 'البريد الإلكتروني:',
    'privacy.contact.phone': 'الهاتف:',
    'privacy.contact.address': 'العنوان:',
    
    // Terms of Service
    'terms.title': 'شروط الخدمة',
    'terms.subtitle': 'يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا.',
    'terms.lastUpdated': 'آخر تحديث: 15 يناير 2024',
    'terms.sections.introduction.title': 'مقدمة',
    'terms.sections.introduction.content1': 'تحكم شروط الخدمة هذه ("الشروط") استخدامك لموقعنا الإلكتروني والخدمات المقدمة من إف إم سي للإنشاءات ("الشركة" أو "نحن" أو "خاصتنا" أو "لنا").',
    'terms.sections.introduction.content2': 'بالوصول إلى خدماتنا أو استخدامها، فإنك توافق على الالتزام بهذه الشروط.',
    'terms.services.title': 'وصف الخدمات',
    'terms.userResponsibilities.title': 'مسؤوليات المستخدم',
    'terms.prohibited.title': 'الأنشطة المحظورة',
    'terms.intellectualProperty.title': 'حقوق الملكية الفكرية',
    'terms.privacy.title': 'الخصوصية وحماية البيانات',
    'terms.disclaimers.title': 'الإخلاءات والقيود',
    'terms.serviceAvailability.title': 'توفر الخدمة',
    'terms.informationAccuracy.title': 'دقة المعلومات',
    'terms.thirdPartyContent.title': 'محتوى الطرف الثالث',
    'terms.limitationLiability.title': 'تحديد المسؤولية',
    'terms.indemnification.title': 'التعويض',
    'terms.termination.title': 'الإنهاء',
    'terms.governingLaw.title': 'القانون الحاكم',
    'terms.changes.title': 'تغييرات الشروط',
    'terms.severability.title': 'القابلية للفصل',
    'terms.contact.title': 'معلومات الاتصال',
    'terms.effective': 'هذه شروط الخدمة سارية المفعول اعتباراً من 15 يناير 2024، وستبقى سارية حتى يتم تعديلها أو إنهاؤها.',
    'terms.services.desc': 'تقدم إف إم سي للإنشاءات خدمات البناء والهندسة وإدارة المشاريع بما في ذلك:',
    'terms.services.list1': 'البناء التجاري والسكني',
    'terms.services.list2': 'تطوير البنية التحتية',
    'terms.services.list3': 'إدارة المشاريع والاستشارات',
    'terms.services.list4': 'الخدمات الهندسية والمعمارية',
    'terms.services.list5': 'التجديد وإعادة التصميم',
    'terms.services.list6': 'وثائق البناء والتقارير',
    'terms.userResponsibilities.desc': 'عند استخدام خدماتنا، فإنك توافق على:',
    'terms.userResponsibilities.list1': 'تقديم معلومات دقيقة وكاملة',
    'terms.userResponsibilities.list2': 'استخدام خدماتنا للأغراض القانونية فقط',
    'terms.userResponsibilities.list3': 'احترام حقوق الملكية الفكرية',
    'terms.userResponsibilities.list4': 'الحفاظ على أمان حسابك',
    'terms.userResponsibilities.list5': 'عدم التدخل في الأداء السليم لخدماتنا',
    'terms.userResponsibilities.list6': 'الامتثال لجميع القوانين واللوائح المعمول بها',
    'terms.prohibited.desc': 'لا يجوز لك استخدام خدماتنا لـ:',
    'terms.prohibited.list1': 'انتهاك أي قوانين أو لوائح معمول بها',
    'terms.prohibited.list2': 'انتهاك حقوق الملكية الفكرية',
    'terms.prohibited.list3': 'نقل محتوى ضار أو مسيء أو غير مناسب',
    'terms.prohibited.list4': 'محاولة الحصول على وصول غير مصرح به لأنظمتنا',
    'terms.prohibited.list5': 'التدخل في وصول المستخدمين الآخرين لخدماتنا',
    'terms.prohibited.list6': 'استخدام خدماتنا لأغراض تجارية دون إذن',
    'terms.prohibited.list7': 'محاولة الهندسة العكسية أو تعديل خدماتنا',
    'terms.intellectualProperty.desc1': 'جميع المحتويات والميزات والوظائف الخاصة بخدماتنا مملوكة لشركة إف إم سي للإنشاءات ومحمية بموجب قوانين حقوق الطبع والنشر والعلامات التجارية والملكية الفكرية الدولية الأخرى.',
    'terms.intellectualProperty.desc2': 'لا يجوز لك إعادة إنتاج أو توزيع أو تعديل أو إنشاء أعمال مشتقة دون موافقتنا الكتابية الصريحة.',
    'terms.privacy.desc1': 'خصوصيتك مهمة بالنسبة لنا. جمعنا واستخدامنا للمعلومات الشخصية يحكمه سياسة الخصوصية الخاصة بنا، والتي يتم دمجها في هذه الشروط بالرجوع إليها.',
    'terms.privacy.desc2': 'باستخدام خدماتنا، فإنك توافق على جمع واستخدام المعلومات كما هو موضح في سياسة الخصوصية الخاصة بنا.',
    'terms.serviceAvailability.desc': 'نسعى لتقديم خدمات موثوقة وغير منقطعة، لكننا لا نضمن أن خدماتنا ستكون متاحة في جميع الأوقات أو خالية من الأخطاء.',
    'terms.informationAccuracy.desc': 'بينما نسعى لتقديم معلومات دقيقة ومحدثة، فإننا لا نقدم ضمانات حول دقة أو اكتمال أو موثوقية أي محتوى على خدماتنا.',
    'terms.thirdPartyContent.desc': 'قد تحتوي خدماتنا على روابط لمواقع إلكترونية أو محتوى من طرف ثالث. نحن لسنا مسؤولين عن محتوى أو ممارسات هذه المواقع من الطرف الثالث.',
    'terms.limitationLiability.desc': 'إلى أقصى حد يسمح به القانون، لن تكون شركة إف إم سي للإنشاءات مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، بما في ذلك على سبيل المثال لا الحصر:',
    'terms.limitationLiability.list1': 'فقدان الأرباح أو البيانات أو الاستخدام',
    'terms.limitationLiability.list2': 'انقطاع الأعمال',
    'terms.limitationLiability.list3': 'إصابة شخصية أو أضرار في الممتلكات',
    'terms.limitationLiability.list4': 'أي أضرار ناتجة عن استخدام خدماتنا',
    'terms.indemnification.desc': 'توافق على تعويض وحماية شركة إف إم سي للإنشاءات من أي مطالبات أو أضرار أو خسائر أو نفقات ناشئة عن استخدامك لخدماتنا أو انتهاك هذه الشروط.',
    'terms.termination.desc1': 'قد نقوم بإنهاء أو تعليق وصولك إلى خدماتنا فوراً، دون إشعار مسبق، لأي سبب، بما في ذلك انتهاك هذه الشروط.',
    'terms.termination.desc2': 'عند الإنهاء، سيتوقف حقك في استخدام خدماتنا فوراً.',
    'terms.governingLaw.desc': 'تحكم هذه الشروط وتفسر وفقاً لقوانين المملكة العربية السعودية. أي نزاعات تنشأ من هذه الشروط تخضع للاختصاص الحصري لمحاكم جدة، المملكة العربية السعودية.',
    'terms.changes.desc': 'نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سنخطر المستخدمين بأي تغييرات جوهرية من خلال نشر الشروط الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث".',
    'terms.severability.desc': 'إذا تم العثور على أي حكم من هذه الشروط غير قابل للتنفيذ أو غير صالح، فسيتم تقييد هذا الحكم أو إلغاؤه إلى الحد الأدنى اللازم بحيث تبقى هذه الشروط سارية المفعول بالكامل.',
    'terms.contact.desc': 'إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا:',
    'terms.contact.email': 'البريد الإلكتروني:',
    'terms.contact.phone': 'الهاتف:',
    'terms.contact.address': 'العنوان:',
    
    // Cookie Policy
    'cookie.title': 'سياسة الكوكيز',
    'cookie.subtitle': 'تعلم كيف نستخدم الكوكيز والتقنيات المماثلة لتحسين تجربة التصفح الخاصة بك.',
    'cookie.lastUpdated': 'آخر تحديث: 15 يناير 2024',
    'cookie.sections.introduction.title': 'مقدمة',
    'cookie.sections.introduction.content1': 'توضح سياسة الكوكيز هذه كيف تستخدم إف إم سي للإنشاءات ("نحن" أو "خاصتنا" أو "لنا") الكوكيز والتقنيات المماثلة عند زيارة موقعنا الإلكتروني.',
    'cookie.sections.introduction.content2': 'باستخدام موقعنا الإلكتروني، فإنك توافق على استخدام الكوكيز كما هو موضح في هذه السياسة.',
    'cookie.types.title': 'أنواع الكوكيز التي نستخدمها',
    'cookie.essential.title': 'الكوكيز الأساسية',
    'cookie.essential.desc': 'هذه الكوكيز ضرورية لعمل الموقع الإلكتروني بشكل صحيح. تمكن الوظائف الأساسية مثل التنقل بين الصفحات والوصول إلى المناطق الآمنة وإرسال النماذج.',
    'cookie.functional.title': 'الكوكيز الوظيفية',
    'cookie.functional.desc': 'تعزز هذه الكوكيز وظائف وتخصيص موقعنا الإلكتروني من خلال تذكر تفضيلاتك وخياراتك.',
    'cookie.analytics.title': 'كوكيز التحليلات',
    'cookie.analytics.desc': 'تساعدنا هذه الكوكيز على فهم كيفية تفاعل الزوار مع موقعنا الإلكتروني من خلال جمع المعلومات والإبلاغ عنها بشكل مجهول.',
    'cookie.marketing.title': 'كوكيز التسويق',
    'cookie.marketing.desc': 'تستخدم هذه الكوكيز لتتبع الزوار عبر المواقع الإلكترونية لعرض الإعلانات ذات الصلة والجذابة.',
    'cookie.specific.title': 'الكوكيز المحددة التي نستخدمها',
    'cookie.thirdParty.title': 'كوكيز الطرف الثالث',
    'cookie.management.title': 'إدارة تفضيلات الكوكيز الخاصة بك',
    'cookie.browserSettings.title': 'إعدادات المتصفح',
    'cookie.consent.title': 'موافقة الكوكيز',
    'cookie.impact.title': 'تأثير تعطيل الكوكيز',
    'cookie.updates.title': 'تحديثات سياسة الكوكيز هذه',
    'cookie.contact.title': 'اتصل بنا',
    'cookie.effective': 'هذه سياسة الكوكيز سارية المفعول اعتباراً من 15 يناير 2024، وستبقى سارية حتى يتم تعديلها أو تحديثها.',
    'cookie.essential.list1': 'كوكيز المصادقة والأمان',
    'cookie.essential.list2': 'كوكيز إدارة الجلسة',
    'cookie.essential.list3': 'كوكيز موازنة التحميل',
    'cookie.essential.list4': 'كوكيز تخصيص واجهة المستخدم',
    'cookie.functional.list1': 'كوكيز تفضيل اللغة',
    'cookie.functional.list2': 'كوكيز المظهر وتفضيلات العرض',
    'cookie.functional.list3': 'كوكيز الاحتفاظ ببيانات النماذج',
    'cookie.functional.list4': 'كوكيز تحسين تجربة المستخدم',
    'cookie.analytics.list1': 'كوكيز Google Analytics',
    'cookie.analytics.list2': 'تتبع مشاهدات الصفحات ومدة الجلسة',
    'cookie.analytics.list3': 'تحليل مصادر الزيارات',
    'cookie.analytics.list4': 'رؤى سلوك المستخدم',
    'cookie.marketing.list1': 'كوكيز تكامل وسائل التواصل الاجتماعي',
    'cookie.marketing.list2': 'كوكيز منصات الإعلان',
    'cookie.marketing.list3': 'كوكيز إعادة الاستهداف',
    'cookie.marketing.list4': 'تتبع فعالية الحملات',
    'cookie.googleAnalytics.title': 'Google Analytics',
    'cookie.googleAnalytics.purpose': 'الغرض:',
    'cookie.googleAnalytics.duration': 'المدة:',
    'cookie.googleAnalytics.provider': 'المزود:',
    'cookie.session.title': 'كوكيز الجلسة',
    'cookie.language.title': 'تفضيل اللغة',
    'cookie.thirdParty.desc': 'بعض الكوكيز على موقعنا الإلكتروني يتم تعيينها من قبل خدمات الطرف الثالث التي نستخدمها لتحسين تجربتك:',
    'cookie.thirdParty.list1': 'Google Analytics: لتحليلات الموقع ومراقبة الأداء',
    'cookie.thirdParty.list2': 'منصات وسائل التواصل الاجتماعي: لميزات المشاركة والتكامل الاجتماعي',
    'cookie.thirdParty.list3': 'معالجات الدفع: لمعالجة الدفع الآمن (إن أمكن)',
    'cookie.thirdParty.list4': 'شبكات توصيل المحتوى: لتحميل المحتوى بشكل أسرع',
    'cookie.thirdParty.note': 'هذه الأطراف الثالثة لديها سياسات خصوصية وممارسات كوكيز خاصة بها. نوصي بمراجعة سياساتها لمزيد من المعلومات.',
    'cookie.browserSettings.desc': 'يمكنك التحكم في الكوكيز وإدارتها من خلال إعدادات متصفحك:',
    'cookie.browserSettings.chrome': 'Chrome: الإعدادات → الخصوصية والأمان → الكوكيز وبيانات المواقع الأخرى',
    'cookie.browserSettings.firefox': 'Firefox: الخيارات → الخصوصية والأمان → الكوكيز وبيانات الموقع',
    'cookie.browserSettings.safari': 'Safari: التفضيلات → الخصوصية → إدارة بيانات الموقع',
    'cookie.browserSettings.edge': 'Edge: الإعدادات → أذونات الكوكيز والموقع → الكوكيز وبيانات الموقع',
    'cookie.consent.desc': 'عندما تزور موقعنا الإلكتروني لأول مرة، ستظهر لك لافتة موافقة الكوكيز التي تسمح لك بـ:',
    'cookie.consent.list1': 'قبول جميع الكوكيز',
    'cookie.consent.list2': 'رفض الكوكيز غير الأساسية',
    'cookie.consent.list3': 'تخصيص تفضيلات الكوكيز الخاصة بك',
    'cookie.consent.list4': 'معرفة المزيد حول استخدامنا للكوكيز',
    'cookie.impact.desc': 'بينما يمكنك تعطيل الكوكيز، يرجى ملاحظة أن القيام بذلك قد يؤثر على تجربتك على موقعنا الإلكتروني:',
    'cookie.impact.list1': 'قد لا تعمل بعض ميزات الموقع بشكل صحيح',
    'cookie.impact.list2': 'قد لا يتم حفظ تفضيلاتك وإعداداتك',
    'cookie.impact.list3': 'قد تحتاج إلى إعادة إدخال المعلومات في كل زيارة',
    'cookie.impact.list4': 'قد لا يكون المحتوى المخصص متاحاً',
    'cookie.impact.list5': 'قد يتأثر أداء الموقع',
    'cookie.updates.desc': 'قد نقوم بتحديث سياسة الكوكيز هذه من وقت لآخر لتعكس التغييرات في ممارساتنا أو لأسباب تشغيلية أو قانونية أو تنظيمية أخرى. سنخطرك بأي تغييرات جوهرية من خلال نشر السياسة المحدثة على موقعنا الإلكتروني.',
    'cookie.contact.desc': 'إذا كان لديك أي أسئلة حول استخدامنا للكوكيز أو سياسة الكوكيز هذه، يرجى الاتصال بنا:',
    'cookie.contact.email': 'البريد الإلكتروني:',
    'cookie.contact.phone': 'الهاتف:',
    'cookie.contact.address': 'العنوان:',
    
    // Site Map
    'sitemap.title': 'خريطة الموقع',
    'sitemap.subtitle': 'تصفح موقعنا الإلكتروني بسهولة مع خريطة الموقع الشاملة هذه.',
    'sitemap.description': 'اعثر على ما تبحث عنه بسرعة وكفاءة',
    'sitemap.quickAccess': 'الوصول السريع',
    'sitemap.quickAccessDesc': 'الصفحات والإجراءات الأكثر شيوعاً',
    'sitemap.completeStructure': 'هيكل الموقع الإلكتروني الكامل',
    'sitemap.completeStructureDesc': 'استكشف جميع أقسام وصفحات موقعنا الإلكتروني منظمة حسب الفئة',
    'sitemap.mainPages': 'الصفحات الرئيسية',
    'sitemap.about': 'من نحن',
    'sitemap.whatWeDo': 'ما نفعله',
    'sitemap.ourServices': 'خدماتنا',
    'sitemap.sectorsIndustries': 'القطاعات والصناعات',
    'sitemap.resourcesNews': 'الموارد والأخبار',
    'sitemap.legalPrivacy': 'القانونية والخصوصية',
    'sitemap.cantFind': 'لا تجد ما تبحث عنه؟',
    'sitemap.cantFindDesc': 'استخدم وظيفة البحث الخاصة بنا أو اتصل بنا مباشرة للحصول على المساعدة',
    'sitemap.learnMore': 'اعرف المزيد عنا',
    'sitemap.lastUpdated': 'يتم تحديث خريطة الموقع هذه بانتظام لتعكس هيكل موقعنا الإلكتروني الحالي. آخر تحديث: يناير 2025',
    'sitemap.sections.mainPages': 'الصفحات الرئيسية',
    'sitemap.sections.about': 'من نحن',
    'sitemap.sections.whatWeDo': 'ما نفعله',
    'sitemap.sections.ourServices': 'خدماتنا',
    'sitemap.sections.sectorsIndustries': 'القطاعات والصناعات',
    'sitemap.sections.resourcesNews': 'الموارد والأخبار',
    'sitemap.sections.legalPrivacy': 'القانونية والخصوصية',
    'sitemap.links.home': 'الرئيسية',
    'sitemap.links.homeDesc': 'مرحباً بكم في إف إم سي للإنشاءات',
    'sitemap.links.contact': 'اتصل بنا',
    'sitemap.links.contactDesc': 'تواصل مع فريقنا',
    'sitemap.links.aboutUs': 'من نحن',
    'sitemap.links.aboutUsDesc': 'تعرف على شركتنا ومهمتنا',
    'sitemap.links.organizationChart': 'الهيكل التنظيمي',
    'sitemap.links.organizationChartDesc': 'هيكل شركتنا والقيادة',
    'sitemap.links.csr': 'المسؤولية الاجتماعية للشركات',
    'sitemap.links.csrDesc': 'التزامنا بالاستدامة والمجتمع',
    'sitemap.links.codeOfEthics': 'مدونة الأخلاقيات',
    'sitemap.links.codeOfEthicsDesc': 'معاييرنا الأخلاقية ومبادئ العمل',
    'sitemap.links.hse': 'الصحة والسلامة والبيئة',
    'sitemap.links.hseDesc': 'التزامنا بالسلامة وحماية البيئة',
    'sitemap.links.qualityManagement': 'إدارة الجودة',
    'sitemap.links.qualityManagementDesc': 'ضمان الجودة وأنظمة الإدارة',
    'sitemap.links.ourClients': 'عملاؤنا',
    'sitemap.links.ourClientsDesc': 'الشركاء الموثوقون ومحفظة العملاء',
    'sitemap.links.ourVendors': 'موردونا',
    'sitemap.links.ourVendorsDesc': 'الشراكات الاستراتيجية مع الموردين',
    'sitemap.links.careers': 'الوظائف',
    'sitemap.links.careersDesc': 'فرص العمل ومعلومات المسار المهني',
    'sitemap.links.documents': 'الوثائق',
    'sitemap.links.documentsDesc': 'وثائق الشركة والموارد',
    'sitemap.links.ourServices': 'خدماتنا',
    'sitemap.links.ourServicesDesc': 'نظرة شاملة على خدماتنا',
    'sitemap.links.projects': 'المشاريع',
    'sitemap.links.projectsDesc': 'تصفح محفظة مشاريعنا الكاملة',
    'sitemap.links.servicesOverview': 'نظرة عامة على الخدمات',
    'sitemap.links.servicesOverviewDesc': 'خدمات البناء الشاملة',
    'sitemap.links.buildingInfrastructure': 'البناء والبنية التحتية',
    'sitemap.links.buildingInfrastructureDesc': 'خدمات البناء والبنية التحتية الأساسية',
    'sitemap.links.designEngineering': 'التصميم والهندسة',
    'sitemap.links.designEngineeringDesc': 'حلول التصميم والهندسة المهنية',
    'sitemap.links.architecturalFitout': 'التشطيب المعماري',
    'sitemap.links.architecturalFitoutDesc': 'خدمات التشطيب الداخلي والمعماري',
    'sitemap.links.civilWorks': 'الأعمال المدنية',
    'sitemap.links.civilWorksDesc': 'الهندسة المدنية والبناء',
    'sitemap.links.mepWorks': 'أعمال الميكانيكية والكهربائية والسباكة',
    'sitemap.links.mepWorksDesc': 'خدمات الميكانيكية والكهربائية والسباكة',
    'sitemap.links.dataCenters': 'بناء مراكز البيانات',
    'sitemap.links.dataCentersDesc': 'خدمات بناء مراكز البيانات والبنية التحتية الاحترافية',
    'sitemap.links.pricing': 'التسعير',
    'sitemap.links.pricingDesc': 'التسعير الشفاف وتقدير التكلفة',
    'sitemap.links.maintenance': 'الصيانة',
    'sitemap.links.maintenanceDesc': 'خدمات الصيانة والدعم المستمرة',
    'sitemap.links.sectorsOverview': 'نظرة عامة على القطاعات',
    'sitemap.links.sectorsOverviewDesc': 'استكشف جميع قطاعات البناء لدينا',
    'sitemap.links.industriesSectors': 'الصناعات والقطاعات',
    'sitemap.links.industriesSectorsDesc': 'التغطية الشاملة للصناعة',
    'sitemap.links.commercial': 'التجاري',
    'sitemap.links.commercialDesc': 'خبرة البناء التجاري',
    'sitemap.links.entertainment': 'الترفيه',
    'sitemap.links.entertainmentDesc': 'مرافق الترفيه والترويح',
    'sitemap.links.hotel': 'الفندق',
    'sitemap.links.hotelDesc': 'خدمات البناء الفندقي',
    'sitemap.links.industrial': 'الصناعي',
    'sitemap.links.industrialDesc': 'حلول البناء الصناعي',
    'sitemap.links.residential': 'السكني',
    'sitemap.links.residentialDesc': 'مشاريع البناء السكني',
    'sitemap.links.school': 'التعليم',
    'sitemap.links.schoolDesc': 'بناء المرافق التعليمية',
    'sitemap.links.utilities': 'المرافق',
    'sitemap.links.utilitiesDesc': 'البنية التحتية والمرافق',
    'sitemap.links.warehouse': 'المستودع',
    'sitemap.links.warehouseDesc': 'بناء مرافق التخزين',
    'sitemap.links.blogNews': 'المدونة والأخبار',
    'sitemap.links.blogNewsDesc': 'رؤى الصناعة وأخبار الشركة',
    'sitemap.links.ourSuccessPartners': 'شركاء نجاحنا',
    'sitemap.links.ourSuccessPartnersDesc': 'الشراكات والتعاون الاستراتيجي',
    'sitemap.links.privacyPolicy': 'سياسة الخصوصية',
    'sitemap.links.privacyPolicyDesc': 'كيف نحمي معلوماتك',
    'sitemap.links.termsOfService': 'شروط الخدمة',
    'sitemap.links.termsOfServiceDesc': 'شروط وأحكام الاستخدام',
    'sitemap.links.cookiePolicy': 'سياسة الكوكيز',
    'sitemap.links.cookiePolicyDesc': 'استخدامنا للكوكيز وإدارتها',
    'sitemap.links.siteMap': 'خريطة الموقع',
    'sitemap.links.siteMapDesc': 'دليل التنقل الكامل للموقع',
    'sitemap.quickLinks.getQuote': 'احصل على عرض سعر',
    'sitemap.quickLinks.getQuoteDesc': 'اطلب عرض سعر للمشروع',
    'sitemap.quickLinks.viewProjects': 'عرض المشاريع',
    'sitemap.quickLinks.viewProjectsDesc': 'استكشف أعمالنا',
    'sitemap.quickLinks.ourServices': 'خدماتنا',
    'sitemap.quickLinks.ourServicesDesc': 'نظرة شاملة على الخدمات',
    'sitemap.quickLinks.joinOurTeam': 'انضم إلى فريقنا',
    'sitemap.quickLinks.joinOurTeamDesc': 'فرص العمل',
    'sitemap.quickLinks.ourClients': 'عملاؤنا',
    'sitemap.quickLinks.ourClientsDesc': 'شاهد محفظة عملائنا',
    'sitemap.quickLinks.companyDocuments': 'وثائق الشركة',
    'sitemap.quickLinks.companyDocumentsDesc': 'تحميل موارد الشركة',
    'sitemap.contactUs': 'اتصل بنا',
    'cookie.sessionCookies.title': 'كوكيز الجلسة',
    'cookie.sessionCookies.purpose': 'الغرض:',
    'cookie.sessionCookies.purposeDesc': 'الحفاظ على جلسة المستخدم والتفضيلات',
    'cookie.sessionCookies.duration': 'المدة:',
    'cookie.sessionCookies.durationDesc': 'مدة الجلسة',
    'cookie.sessionCookies.provider': 'المزود:',
    'cookie.sessionCookies.providerDesc': 'إف إم سي للإنشاءات',
    'cookie.languageCookies.title': 'كوكيز تفضيل اللغة',
    'cookie.languageCookies.purpose': 'الغرض:',
    'cookie.languageCookies.purposeDesc': 'تذكر اختيار لغة المستخدم',
    'cookie.languageCookies.duration': 'المدة:',
    'cookie.languageCookies.durationDesc': 'سنة واحدة',
    'cookie.languageCookies.provider': 'المزود:',
    'cookie.languageCookies.providerDesc': 'إف إم سي للإنشاءات',
    'contact.companyAddress': 'إف إم سي للإنشاءات، جدة، المملكة العربية السعودية',
    'cookie.googleAnalytics.purposeDesc': 'تحليلات الموقع ومراقبة الأداء',
    'cookie.googleAnalytics.durationDesc': 'حتى سنتين',
    'cookie.googleAnalytics.providerDesc': 'جوجل المحدودة',
    'contact.phone': '+966 12 345 6789',
    'contact.email': 'info@fmcksa.com',
    'contact.email.privacy': 'info@fmcksa.com',
    
    // About Page Translations
    'about.hero.title': 'من',
    'about.hero.subtitle': 'نبني المستقبل من خلال الابتكار والتميز والالتزام الثابت بحلول البناء عالية الجودة.',
    'about.story.introduction': 'مقدمة',
    'about.story.title': 'قصة',
    'about.story.highlight': 'تأسست شركة أف أم سي برؤية من أجل تحويل صناعة البناء من خلال الابتكار والجودة والالتزام الثابت بالتميز.',
    'about.story.desc1': 'بدأت الشركة كشركة عائلية صغيرة ونمت لتصبح أحد أكثر شركات البناء الموثوقة في المنطقة، التي عرفت بتقديم مشاريع تجاوزت جميع التوقعات وتقف كشهادات على حرفيتنا.',
    'about.story.desc2': 'اليوم، تواصل إف إم سي دفع الحدود، مع تبني التقنيات الجديدة والممارسات المستدامة مع الحفاظ على اللمسة الشخصية التي ميزتنا لأكثر من عقدين.',
    'about.story.yearsExcellence': 'سنوات من التميز',
    'about.story.projectsCompleted': 'مشاريع مكتملة',
    'about.story.buildingExcellence': 'بناء التميز',
    'about.story.craftingTomorrow': 'صياغة البنية التحتية للمستقبل',
    'about.story.visionReality': 'من الرؤية إلى الواقع، نحول مشاريع البناء إلى معالم للتميز والابتكار.',
    'about.missionVision.title': 'مهمتنا ورؤيتنا',
    'about.missionVision.subtitle': 'قيادة مستقبل البناء من خلال الابتكار والتميز والتنمية المستدامة',
    'about.mission.title': 'مهمتنا',
    'about.mission.desc': 'تقديم حلول بناء استثنائية تتجاوز توقعات العملاء مع الحفاظ على أعلى معايير الجودة والأمان والاستدامة.',
    'about.mission.point1': 'التحول من خلال التكنولوجيا المبتكرة',
    'about.mission.point2': 'بناء علاقات عملاء دائمة',
    'about.mission.point3': 'إنشاء بنية تحتية مستدامة',
    'about.vision.title': 'رؤيتنا',
    'about.vision.desc': 'أن نكون شركة البناء الرائدة في المملكة العربية السعودية وما بعدها، معترف بها للابتكار والتميز والالتزام ببناء مستقبل مستدام.',
    'about.vision.point1': 'ريادة التقنيات من الجيل القادم',
    'about.vision.point2': 'التوسع عبر المنطقة',
    'about.vision.point3': 'إلهام المهنيين المستقبليين',
    'about.values.title': 'قيمنا',
    'about.values.desc': 'المبادئ الأساسية التي توجه كل قرار نتخذه وكل مشروع نقوم به مع التزام ثابت.',
    'about.values.integrity': 'النزاهة - الصدق والشفافية',
    'about.values.excellence': 'التميز - جودة لا هوادة فيها',
    'about.values.collaboration': 'التعاون - العمل الجماعي الموحد',
    'about.values.passion': 'الشغف - الحماس المتفاني',
    'about.history.title': 'تاريخ الشركة',
    'about.leadership.title': 'القادة والاداريين',
    'about.stats.industriesServed': 'قطاعات مخدومة',
    'about.stats.completedProjects': 'مشاريع مكتملة',
    'about.stats.yearsExperience': 'سنوات الخبرة',
    'about.stats.clientSatisfaction': 'رضا العملاء',
    'about.cta.title': 'مستعدون للبناء معاً؟',
    'about.cta.subtitle': 'دعنا نناقش مشروع البناء القادم الخاص بك ونستكشف كيف يمكن لإف إم سي أن تحقق رؤيتك.',
    'about.cta.button1': 'ابدأ الآن',
    'about.cta.button2': 'شاهد أعمالنا',
    'about.modal.title': 'ملف عضو الفريق',
    'about.modal.biography': 'السيرة الذاتية',
    'about.modal.expertise': 'مجالات الخبرة',
    'about.modal.experience': 'من الخبرة',
    'about.modal.close': 'إغلاق',
    'about.timeline.categories.foundation': 'التأسيس',
    'about.timeline.categories.milestone': 'معلم',
    'about.timeline.categories.certification': 'شهادة',
    'about.timeline.categories.growth': 'النمو',
    'about.timeline.categories.innovation': 'الابتكار',
    'about.timeline.categories.sustainability': 'الاستدامة',
    'about.timeline.categories.achievement': 'الإنجاز',
    'about.timeline.categories.strategy': 'الاستراتيجية',
    'about.timeline.categories.partnership': 'الشراكة',
    'about.timeline.categories.transformation': 'التحول',
    'about.timeline.categories.future': 'المستقبل',
    'about.timeline.milestone': 'معلم',
    'about.timeline.progress': 'من',
    'about.timeline.2006.title': 'تأسيس إف إم سي للإنشاءات',
    'about.timeline.2006.desc': 'تأسست إف إم سي للإنشاءات في المملكة العربية السعودية برؤية لتحويل صناعة البناء من خلال الابتكار والجودة والالتزام الثابت بالتميز.',
    'about.timeline.2008.title': 'أول مشروع تجاري كبير',
    'about.timeline.2008.desc': 'أكملنا بنجاح أول مشروع بناء تجاري واسع النطاق، مما أسس إف إم سي كشريك موثوق في قطاع البناء.',
    'about.timeline.2010.title': 'تحقيق شهادة الأيزو',
    'about.timeline.2010.desc': 'حصلنا على شهادة إدارة الجودة ISO 9001، مما يوضح التزامنا بالمعايير الدولية وتميز الجودة.',
    'about.timeline.2012.title': 'توسيع القوى العاملة',
    'about.timeline.2012.desc': 'وسعنا فريقنا إلى أكثر من 200 محترف ماهر، بما في ذلك المهندسين ومديري المشاريع وعمال البناء المتخصصين.',
    'about.timeline.2014.title': 'مبادرة تكامل التكنولوجيا',
    'about.timeline.2014.desc': 'نفذنا برامج إدارة المشاريع المتقدمة وتكنولوجيا BIM لتعزيز كفاءة المشروع والتواصل مع العملاء.',
    'about.timeline.2016.title': 'التركيز على البناء المستدام',
    'about.timeline.2016.desc': 'أطلقنا مبادرة الاستدامة، مع دمج ممارسات البناء الأخضر والمواد الصديقة للبيئة في جميع المشاريع الجديدة.',
    'about.timeline.2018.title': 'الريادة في السوق الإقليمي',
    'about.timeline.2018.desc': 'حققنا الاعتراف كواحدة من أفضل شركات البناء في المنطقة الغربية من المملكة العربية السعودية مع أكثر من 100 مشروع مكتمل.',
    'about.timeline.2019.title': 'محاذاة رؤية 2030',
    'about.timeline.2019.desc': 'وضعنا استراتيجية الشركة مع رؤية السعودية 2030، مع التركيز على المشاريع الضخمة ومبادرات التنمية الوطنية.',
    'about.timeline.2020.title': 'التحول الرقمي',
    'about.timeline.2020.desc': 'تنقلنا بنجاح خلال الوباء العالمي من خلال تنفيذ إدارة المشاريع الرقمية الشاملة وأدوات التعاون عن بُعد.',
    'about.timeline.2021.title': 'تطوير الشراكات الاستراتيجية',
    'about.timeline.2021.desc': 'أقمنا شراكات رئيسية مع شركات البناء الدولية ومقدمي التكنولوجيا لتعزيز قدرات الخدمة.',
    'about.timeline.2022.title': 'إعادة تسمية وتحديث الشركة',
    'about.timeline.2022.desc': 'أكملنا مبادرة إعادة التسمية الشاملة التي تعكس تطورنا إلى قائد بناء حديث مدفوع بالتكنولوجيا.',
    'about.timeline.2023.title': 'إطلاق حلول المباني الذكية',
    'about.timeline.2023.desc': 'قدمنا تقنيات المباني الذكية وخدمات تكامل إنترنت الأشياء، مما يضع إف إم سي في طليعة البناء الذكي.',
    'about.timeline.2024.title': 'توسيع محفظة المشاريع الضخمة',
    'about.timeline.2024.desc': 'حصلنا بنجاح وبدأنا مشاريع ضخمة متعددة بقيمة تزيد عن مليار ريال سعودي، مما يمثل أكبر محفظة مشاريع لدينا حتى الآن.',
    'about.timeline.2025.title': 'مركز البناء من الجيل القادم',
    'about.timeline.2025.desc': 'إنشاء مقرنا الجديد ومركز التدريب، مع تقنيات البناء المتطورة وقدرات الصناعة 4.0.',
    'about.timeline.pause': 'إيقاف التشغيل التلقائي',
    'about.timeline.start': 'بدء التشغيل التلقائي',
    
    // Team Members Translations
    'about.team.ahmed.name': 'المهندس محمد فرحات',
    'about.team.ahmed.position': 'المدير العام',
    'about.team.ahmed.expertise1': 'القيادة الاستراتيجية',
    'about.team.ahmed.expertise2': 'تطوير الأعمال',
    'about.team.ahmed.expertise3': 'محاذاة رؤية 2030',
    'about.team.ahmed.expertise4': 'ابتكار الصناعة',
    'about.team.ahmed.experience': '20+ سنة',
    'about.team.abdulrahman.name': 'عبدالرحمن فرحات',
    'about.team.abdulrahman.position': 'مدير القسم المدني',
    'about.team.abdulrahman.expertise1': 'الهندسة المدنية',
    'about.team.abdulrahman.expertise2': 'إدارة المشاريع',
    'about.team.abdulrahman.expertise3': 'تطوير البنية التحتية',
    'about.team.abdulrahman.expertise4': 'مراقبة الجودة',
    'about.team.abdulrahman.experience': '15+ سنة',
    'about.team.kasem.name': 'قاسم فرحات',
    'about.team.kasem.position': 'مدير قسم الميكانيكية والكهربائية',
    'about.team.kasem.expertise1': 'أنظمة الميكانيكية والكهربائية',
    'about.team.kasem.expertise2': 'كفاءة الطاقة',
    'about.team.kasem.expertise3': 'تقنية المباني الذكية',
    'about.team.kasem.expertise4': 'الهندسة المستدامة',
    'about.team.kasem.experience': '12+ سنة',
    'about.team.abdulrahman2.name': 'عبدالرحمن سلام',
    'about.team.abdulrahman2.position': 'المدير التنفيذي',
    'about.team.abdulrahman2.expertise1': 'القيادة التنفيذية',
    'about.team.abdulrahman2.expertise2': 'إدارة العمليات',
    'about.team.abdulrahman2.expertise3': 'التنفيذ الاستراتيجي',
    'about.team.abdulrahman2.expertise4': 'تطوير المشاريع',
    'about.team.abdulrahman2.experience': '18+ سنة',
    'about.story.story': 'الشركة',
    'about.team.ahmed.bio': 'محمد فرحات هو الرئيس التنفيذي الرؤيوي لشركة إف إم سي للإنشاءات. مع أكثر من 40 عاماً من الخبرة في صناعة البناء، قاد تحول إف إم سي من شركة عائلية صغيرة إلى واحدة من أكثر شركات البناء الموثوقة في المملكة العربية السعودية. كانت قيادته حاسمة في محاذاة إف إم سي مع رؤية السعودية 2030 وتأسيس الشركة كرائد في تكنولوجيا البناء المبتكرة.',
    'about.team.abdulrahman.bio': 'عبدالرحمن فرحات يعمل كمدير القسم المدني، ويجلب خبرة في الهندسة المدنية وإدارة البناء إلى شركة إف إم سي للإنشاءات. يشرف على مشاريع البنية التحتية المدنية الكبرى ويضمن أعلى معايير التميز الهندسي في جميع أنشطة البناء المدني.',
    'about.team.kasem.bio': 'قاسم فرحات يعمل كمدير قسم الميكانيكية والكهربائية، متخصص في أنظمة الميكانيكية والكهربائية والسباكة. يقود قسم الميكانيكية والكهربائية في إف إم سي بخبرة في أنظمة المباني الحديثة وكفاءة الطاقة وتقنيات المباني الذكية التي تتماشى مع أهداف الاستدامة في المملكة العربية السعودية.',
    'about.team.abdulrahman2.bio': 'عبدالرحمن سلام يعمل كمدير تنفيذي، يقود العمليات اليومية والتنفيذ الاستراتيجي في إف إم سي. مع خبرة واسعة في إدارة المشاريع وتطوير الأعمال، يضمن التميز التشغيلي ويدفع نمو الشركة في محاذاة مع أهداف رؤية السعودية 2030.',
    
    // Organization Chart Translations
    'org.hero.title': 'الهيكل',
    'org.hero.subtitle': 'هيكلنا التنظيمي يعكس التزامنا بالتميز والكفاءة والخبرة المهنية عبر جميع الأقسام',
    'org.generalManager': 'المدير العام',
    'org.deputyGeneralManager': 'نائب المدير العام',
    'org.electricalMechanical': '(الكهربائية والميكانيكية)',
    'org.executiveManager': 'المدير التنفيذي',
    'org.estimationDepartment': 'قسم التقدير',
    'org.estimatorManager': 'مدير التقدير',
    'org.electricalEngineers': 'المهندسين الكهربائيين',
    'org.mechanicalEngineers': 'المهندسين الميكانيكيين',
    'org.projectManager': 'مدير المشروع',
    'org.projectSecretary': 'سكرتير المشروع',
    'org.qaQcEngineers': 'مهندسي ضمان الجودة',
    'org.technicalDepartment': 'القسم التقني',
    'org.seniorMechanicalEngineers': 'المهندسين الميكانيكيين الكبار',
    'org.mechanicalDraftsman': 'رسام الميكانيكية',
    'org.mechanicalForeman': 'مشرف الميكانيكية',
    'org.mechanicalTechnicians': 'فنيي الميكانيكية',
    'org.seniorElectricalEngineers': 'المهندسين الكهربائيين الكبار',
    'org.electricalDraftsman': 'رسام الكهربائية',
    'org.electricalForeman': 'مشرف الكهربائية',
    'org.electricalTechnicians': 'فنيي الكهربائية',
    'org.procurementDepartment': 'قسم المشتريات',
    'org.procurementOfficers': 'موظفو المشتريات',
    'org.purchaseAdministrator': 'مدير المشتريات',
    'org.materialCoordinator': 'منسق المواد',
    'org.financeDepartment': 'القسم المالي',
    'org.financeManager': 'مدير المالية',
    'org.chiefAccountant': 'المحاسب الرئيسي',
    'org.accountants': 'المحاسبين',
    'org.adminGeneralServices': 'الإدارة والخدمات العامة',
    'org.hrManager': 'مدير الموارد البشرية',
    'org.hrOfficeAdmin': 'إدارة الموارد البشرية والمكتب',
    'org.itDepartment': 'قسم تقنية المعلومات',
    'org.transportLegalDepartment': 'قسم النقل / القانوني',
    'org.contractingCivil': '(المقاولات والمدنية)',
    'org.contractDepartment': 'قسم العقود',
    'org.contractManager': 'مدير العقود',
    'org.contractEngineers': 'مهندسي العقود',
    'org.contractAdministrators': 'مديري العقود',
    'org.civilDepartment': 'القسم المدني',
    'org.civilEngineers': 'المهندسين المدنيين',
    'org.civilDraftsman': 'رسام المدنية',
    'org.civilForeman': 'مشرف المدنية',
    'org.civilTechnicians': 'فنيي المدنية',
    'org.srQuantitySurveyor': 'مساح كميات كبير',
    'org.documentsSection': 'قسم الوثائق',
    'org.seniorCivilEngineers': 'المهندسين المدنيين الكبار',
    'org.structuralDraftsman': 'رسام الإنشاءات',
    'org.structuralForeman': 'مشرف الإنشاءات',
    'org.structuralTechnicians': 'فنيي الإنشاءات',
    'org.seniorArchitectEngineers': 'المهندسين المعماريين الكبار',
    'org.architectEngineers': 'المهندسين المعماريين',
    'org.architecturalDraftsman': 'رسام العمارة',
    'org.architecturalForeman': 'مشرف العمارة',
    'org.architecturalTechnicians': 'فنيي العمارة',
    'org.hero.chart': 'التنظيمي',
    'org.backToAbout': 'العودة إلى من نحن',
    'org.cta.title': 'انضم إلى فريقنا المهني',
    'org.cta.description': 'كن جزءاً من هيكلنا التنظيمي المهني وساهم في مشاريع البناء والبنية التحتية الاستثنائية',
    'org.cta.viewCareers': 'عرض الوظائف',
    'org.cta.contactUs': 'اتصل بنا',
    
    
    
    // Services Page Arabic Translations
    'services.title': 'خدماتنا',
    'services.hero.subtitle': 'حلول بناء وهندسية شاملة مصممة لتلبية متطلبات مشروعك',
    'services.building.title': 'البناء والبنية التحتية',
    'services.industrial.title': 'البناء الصناعي',
    'services.building.description': 'خدمات بناء شاملة للمباني التجارية والسكنية والصناعية مع تطوير البنية التحتية الحديثة.',
    'services.industrial.description': 'مرافق صناعية ثقيلة ومصانع تصنيع وهياكل صناعية متخصصة',
    'services.commercial.description': 'مباني مكتبية حديثة ومساحات تجارية ومرافق تجارية مبنية بأحدث التقنيات والممارسات المستدامة',
    'services.residential.description': 'منازل مخصصة وتطويرات سكنية تجمع بين الفخامة والراحة والتصميم المبتكر',
    'services.building.feature1': 'البناء التجاري والسكني',
    'services.building.feature2': 'المرافق الصناعية والمستودعات',
    'services.building.feature3': 'تطوير البنية التحتية',
    'services.building.feature4': 'أعمال الأساس والهيكل',
    'services.building.feature5': 'ضمان الجودة والاختبار',
    'services.building.feature6': 'إدارة المشاريع والتنسيق',
    'services.building.benefit1': 'تسليم المشروع من البداية للنهاية',
    'services.building.benefit2': 'تقنيات بناء متقدمة',
    'services.building.benefit3': 'ضمان الإنجاز في الوقت المحدد',
    'services.building.benefit4': 'حلول فعالة من حيث التكلفة',
    'services.building.benefit5': 'ممارسات بناء مستدامة',
    'services.design.title': 'التصميم والهندسة',
    'services.design.description': 'خدمات التصميم المعماري والهندسي المهنية مع حلول مبتكرة وخبرة تقنية.',
    'services.design.feature1': 'التصميم المعماري والتخطيط',
    'services.design.feature2': 'الهندسة الإنشائية',
    'services.design.feature3': 'تصميم الهندسة الميكانيكية والكهربائية',
    'services.design.feature4': 'النمذجة ثلاثية الأبعاد والتصور',
    'services.design.feature5': 'الوثائق التقنية',
    'services.design.feature6': 'تحسين التصميم',
    'services.design.benefit1': 'حلول تصميم مبتكرة',
    'services.design.benefit2': 'التميز التقني',
    'services.design.benefit3': 'تحسين التكلفة',
    'services.design.benefit4': 'مبادئ التصميم المستدام',
    'services.design.benefit5': 'وثائق شاملة',
    'services.cta.title': 'مستعد لبدء مشروعك؟',
    'services.cta.subtitle': 'تواصل مع خبرائنا لمناقشة احتياجاتك الإنشائية والحصول على حل مخصص.',
    'services.cta.button': 'ابدأ الآن',
    'services.cta.contact': 'اتصل بنا',
    'services.whatWeOffer': 'ما نقدمه',
    'services.keyBenefits': 'الفوائد الرئيسية',
    'services.getQuoteFor': 'احصل على عرض سعر لـ',
    'services.fallback.imageText': 'صورة الخدمة',
    'services.process.title': 'عملية العمل',
    'services.process.subtitle': 'كيف نقدم حلول بناء وهندسية استثنائية',
    'services.process.step1.title': 'الاستشارة',
    'services.process.step1.description': 'نناقش متطلباتك ونقدم المشورة الخبيرة',
    'services.process.step2.title': 'التصميم والتخطيط',
    'services.process.step2.description': 'إنشاء خطط وتصاميم مفصلة لمشروعك',
    'services.process.step3.title': 'التنفيذ',
    'services.process.step3.description': 'تنفيذ المشروع بدقة وجودة',
    'services.process.step4.title': 'التسليم',
    'services.process.step4.description': 'تسليم المشروع مع الدعم المستمر',
    'services.why.title': 'لماذا تختار FMC',
    'services.why.subtitle1': 'نجمع بين عقود من الخبرة والتكنولوجيا المتطورة',
    'services.why.subtitle2': 'لتقديم حلول بناء تتجاوز التوقعات',
    'services.why.feature1.title': 'فريق خبير',
    'services.why.feature1.description': 'محترفون ذوو خبرة مع سجل حافل بالإنجازات',
    'services.why.feature2.title': 'ضمان الجودة',
    'services.why.feature2.description': 'مراقبة جودة صارمة في كل مرحلة',
    'services.why.feature3.title': 'الابتكار',
    'services.why.feature3.description': 'أحدث التقنيات وطرق البناء',
    'services.excellence.title': 'التميز في كل مشروع',
    'services.excellence.subtitle': 'تقديم نتائج متميزة منذ 2006',
    'services.cta.button1': 'ابدأ الآن',
    'services.cta.button2': 'اتصل بنا',
    'services.fitout.title': 'التشطيب المعماري',
    'services.fitout.description': 'خدمات التصميم الداخلي والتشطيب الكاملة للمساحات التجارية والسكنية مع الجماليات الحديثة.',
    'services.fitout.feature1': 'التصميم الداخلي والتخطيط',
    'services.fitout.feature2': 'الأثاث والتجهيزات المخصصة',
    'services.fitout.feature3': 'اختيار المواد المتميزة',
    'services.fitout.feature4': 'تحسين المساحة',
    'services.fitout.feature5': 'تحسين الجماليات',
    'services.fitout.feature6': 'تنسيق المشروع',
    'services.fitout.benefit1': 'حلول مخصصة',
    'services.fitout.benefit2': 'تشطيبات متميزة',
    'services.fitout.benefit3': 'كفاءة المساحة',
    'services.fitout.benefit4': 'جماليات حديثة',
    'services.fitout.benefit5': 'حرفية عالية الجودة',
    'services.civil.title': 'الأعمال المدنية',
    'services.civil.description': 'خدمات الهندسة المدنية الشاملة بما في ذلك الطرق والجسور وتطوير البنية التحتية.',
    'services.civil.feature1': 'بناء الطرق والطرق السريعة',
    'services.civil.feature2': 'هندسة الجسور والأنفاق',
    'services.civil.feature3': 'البنية التحتية للمرافق',
    'services.civil.feature4': 'أنظمة الصرف',
    'services.civil.feature5': 'إعداد الموقع',
    'services.civil.feature6': 'مراقبة الجودة',
    'services.civil.benefit1': 'بنية تحتية متينة',
    'services.civil.benefit2': 'الامتثال للسلامة',
    'services.civil.benefit3': 'كفاءة التكلفة',
    'services.civil.benefit4': 'التسليم في الوقت المحدد',
    'services.civil.benefit5': 'موثوقية طويلة المدى',
    'services.mep.title': 'أعمال الميكانيكية والكهربائية',
    'services.mep.description': 'خدمات الميكانيكية والكهربائية والسباكة مع حلول موفرة للطاقة وتكامل المباني الذكية.',
    'services.pricing.title': 'التسعير',
    'services.pricing.description': 'تسعير شفاف ومتنافس مع تفصيل تكاليف مفصل وحلول هندسة القيمة.',
    'services.pricing.feature1': 'تحليل التكلفة والتقدير',
    'services.pricing.feature2': 'هندسة القيمة',
    'services.pricing.feature3': 'تخطيط الميزانية',
    'services.pricing.feature4': 'وثائق المناقصة',
    'services.pricing.feature5': 'تحسين الأسعار',
    'services.pricing.feature6': 'التخطيط المالي',
    'services.pricing.benefit1': 'تسعير شفاف',
    'services.pricing.benefit2': 'تحسين التكلفة',
    'services.pricing.benefit3': 'قيمة مقابل المال',
    'services.pricing.benefit4': 'التحكم في الميزانية',
    'services.pricing.benefit5': 'التخطيط المالي',
    'services.maintenance.title': 'الصيانة',
    'services.maintenance.description': 'خدمات الصيانة وإدارة المرافق الشاملة لضمان الأداء طويل المدى للمباني.',
    'services.maintenance.feature1': 'الصيانة الوقائية',
    'services.maintenance.feature2': 'الإصلاحات التصحيحية',
    'services.maintenance.feature3': 'إدارة المرافق',
    'services.maintenance.feature4': 'صيانة المعدات',
    'services.maintenance.feature5': 'الخدمات الطارئة',
    'services.maintenance.feature6': 'مراقبة الأداء',
    'services.maintenance.benefit1': 'عمر أطول',
    'services.maintenance.benefit2': 'كفاءة التكلفة',
    'services.maintenance.benefit3': 'الامتثال للسلامة',
    'services.maintenance.benefit4': 'تحسين الصيانة',
    'services.maintenance.benefit5': 'توفير التكلفة',
    
    // Sectors Page Arabic Translations
    'sectors.hero.title': 'قطاعاتنا',
    'sectors.hero.subtitle': 'استكشف محفظتنا المتنوعة عبر قطاعات البناء والهندسة المتعددة',
    'sectors.hero.description1': 'من المباني التجارية والمجمعات السكنية إلى المرافق الصناعية ومشاريع البنية التحتية، نقدم حلولاً متخصصة مصممة لتلبية المتطلبات والمعايير الفريدة لكل قطاع.',
    'sectors.hero.description2': 'خبرتنا الواسعة تمتد عبر ثمانية قطاعات رئيسية، مما يمكننا من تقديم خدمات بناء شاملة تلبي الاحتياجات المحددة للصناعات وأنواع المشاريع المتنوعة.',
    'sectors.hero.description3': 'مع أكثر من 25 عاماً من الخبرة ومئات المشاريع المكتملة، أثبتنا أنفسنا كشريك موثوق قادر على التعامل مع تحديات البناء المعقدة عبر جميع القطاعات.',
    'sectors.commercial.name': 'تجاري',
    'sectors.commercial.description': 'مباني المكاتب ومراكز البيع بالتجزئة والمولات والمجمعات التجارية',
    'sectors.entertainment.name': 'ترفيهي',
    'sectors.entertainment.description': 'أماكن الترفيه ودور السينما والحدائق الترفيهية والمرافق الترفيهية',
    'sectors.hotel.name': 'فندقي',
    'sectors.hotel.description': 'الفنادق الفاخرة والمنتجعات والمرافق السياحية ومجمعات الإقامة',
    'sectors.education.name': 'تعليمي',
    'sectors.education.description': 'المدارس والجامعات ومراكز التدريب والمؤسسات التعليمية',
    'sectors.residential.name': 'سكني',
    'sectors.residential.description': 'المجمعات السكنية والشقق والفلل والمشاريع السكنية',
    'sectors.industrial.name': 'صناعي',
    'sectors.industrial.description': 'المرافق الصناعية والمستودعات والمصانع ومراكز الإنتاج',
    'sectors.energy.name': 'طاقة',
    'sectors.energy.description': 'محطات الطاقة ومرافق الطاقة المتجددة ومشاريع البنية التحتية للطاقة',
    'sectors.healthcare.name': 'صحي',
    'sectors.healthcare.description': 'المستشفيات والمراكز الطبية والعيادات والمرافق الصحية',
    'sectors.warehouse.name': 'مستودعات',
    'sectors.warehouse.description': 'مرافق التخزين ومراكز اللوجستيات ومراكز التوزيع',
    'sectors.cta.title': 'مستعد لبناء رؤيتك؟',
    'sectors.cta.subtitle': 'دعنا نساعدك في إحياء مشروعك بخبرتنا المتخصصة في القطاعات وسجلنا الحافل بالإنجازات.',
    'sectors.cta.button': 'ابدأ مشروعك',
    'sectors.cta.contact': 'اتصل بنا',
    
    // Projects Page Arabic Translations
    'projects.hero.title': 'تعرف على',
    'projects.hero.projects': 'مشاريعنا',
    'projects.hero.subtitle': 'اكتشف محفظتنا من مشاريع البناء والهندسة الناجحة عبر مختلف القطاعات',
    'projects.categories.all': 'جميع القطاعات',
    'projects.categories.commercial': 'تجاري',
    'projects.categories.residential': 'سكني',
    'projects.categories.infrastructure': 'بنية تحتية',
    'projects.categories.industrial': 'صناعي',
    'projects.categories.maintenance': 'صيانة',
    'projects.locations.all': 'جميع المواقع',
    'projects.locations.jeddah': 'جدة',
    'projects.locations.riyadh': 'الرياض',
    'projects.locations.al-dammam': 'الدمام',
    'projects.locations.al-ula': 'العلا',
    'projects.status.all': 'جميع الحالات',
    'projects.status.ongoing': 'قيد التنفيذ',
    'projects.search.label': 'البحث',
    'projects.search.placeholder': 'البحث في المشاريع...',
    'projects.view.photo': 'عرض الصور',
    'projects.view.grid': 'عرض الشبكة',
    'projects.view.list': 'عرض القائمة',
    'projects.view.map': 'عرض الخريطة',
    'projects.map.title': 'خريطة مواقع المشاريع',
    'projects.map.subtitle': 'استكشف مشاريعنا في مواقع مختلفة',
    'projects.map.widgetTitle': 'مواقع مشاريع FMC',
    'projects.results.found': 'تم العثور على',
    'projects.results.count': 'مشروع',
    'projects.filter.categories': 'الفئات',
    'projects.filter.locations': 'المواقع',
    'projects.filter.status': 'الحالة',
    'projects.filters.active': 'المرشحات النشطة:',
    'projects.filters.sector': 'القطاع:',
    'projects.filters.location': 'الموقع:',
    'projects.filters.status': 'الحالة:',
    'projects.filters.search': 'البحث:',
    'projects.filters.clearAll': 'مسح الكل',
    'projects.cta.title': 'مستعد لبدء مشروعك؟',
    'projects.cta.subtitle': 'دعنا نساعدك في إحياء رؤيتك بخبرتنا المثبتة وسجلنا الحافل بالإنجازات.',
    'projects.cta.contact': 'اتصل بنا',
    'projects.sector.commercial': 'تجاري',
    'projects.sector.residential': 'سكني',
    'projects.sector.infrastructure': 'بنية تحتية',
    'projects.sector.maintenance': 'صيانة',
    'projects.sector.industrial': 'صناعي',
    'projects.share': 'مشاركة المشروع',
    'projects.labels.location': 'الموقع',
    'projects.labels.size': 'المساحة',
    'projects.labels.value': 'القيمة',
    'projects.labels.keyFeatures': 'المميزات الرئيسية',
    'projects.labels.year': 'السنة',
    'projects.labels.builtUpArea': 'المساحة المبنية',
    'projects.views': 'مشاهدات',
    'projects.viewDetails': 'عرض التفاصيل',
    'projects.noResults.title': 'لم يتم العثور على مشاريع',
    'projects.noResults.message': 'حاول تعديل معايير البحث أو المرشحات للعثور على ما تبحث عنه.',
    'projects.noResults.clearFilters': 'مسح جميع المرشحات',
    'projects.stats.title': 'إحصائيات المشاريع',
    'projects.stats.subtitle': 'سجلنا الحافل يتحدث عن نفسه بأرقام مذهلة عبر جميع القطاعات',
    'projects.stats.completed': 'مشاريع مكتملة',
    'projects.stats.value': 'إجمالي القيمة',
    'projects.stats.satisfaction': 'رضا العملاء',
    'projects.stats.experience': 'سنوات الخبرة',
    'projects.cta.button1': 'ابدأ مشروعك',
    'projects.cta.button2': 'شاهد خدماتنا',
    'projects.locations.title': 'مواقع مشاريعنا',
    'projects.locations.subtitle': 'استكشف مشاريعنا عبر مواقع مختلفة وشاهد أين نصنع الفرق',
    
    // Vendors Page Arabic Translations
    'vendors.hero.title': 'موردونا الموثوقون',
    'vendors.hero.subtitle': 'نعمل مع الشركات الرائدة في التصنيع والموردين عبر المنطقة لتقديم جودة وموثوقية استثنائية',
    'vendors.hero.description': 'كن شريكاً معنا',
    'vendors.categories.all': 'جميع الفئات',
    'vendors.categories.materials': 'المواد',
    'vendors.categories.equipment': 'المعدات',
    'vendors.categories.services': 'الخدمات',
    'vendors.categories.technology': 'التكنولوجيا',
    'vendors.search.placeholder': 'البحث في الموردين...',
    'vendors.cta.title': 'كن شريكنا',
    'vendors.cta.subtitle': 'انضم إلى شبكة موردينا ومزودينا الموثوقين لمساعدتنا في تقديم حلول بناء استثنائية.',
    'vendors.cta.button': 'قدم الآن',
    'vendors.cta.contact': 'اتصل بنا',
    'vendors.hero.partners': 'الشركاء',
    'vendors.verified': 'شريك موثوق',
    'vendors.specialties': 'التخصصات:',
    'vendors.partnership': 'الشراكة:',
    'vendors.noResults': 'لم يتم العثور على موردين',
    'vendors.noResultsDesc': 'حاول تعديل معايير البحث أو فلتر الفئة.',
    'vendors.contact': 'اتصل بالمورد',
    
    // Clients Page Translations
    'clients.hero.title': 'عملاؤنا',
    'clients.hero.subtitle': 'موثوق من قبل المنظمات الرائدة عبر مختلف الصناعات',
    'clients.hero.description': 'نفتخر بالعمل مع بعض من أكثر الشركات والمنظمات المرموقة في المملكة العربية السعودية والمنطقة. محفظة عملائنا المتنوعة تعكس التزامنا بالتميز وقدرتنا على تقديم نتائج استثنائية عبر قطاعات متعددة.',
    'clients.categories.all': 'جميع الفئات',
    'clients.categories.entertainment': 'الترفيه والإعلام',
    'clients.categories.healthcare': 'الرعاية الصحية',
    'clients.categories.education': 'التعليم',
    'clients.categories.government': 'الحكومة',
    'clients.categories.retail': 'التجزئة والتجارة',
    'clients.categories.hospitality': 'فندقي',
    'clients.categories.technology': 'التكنولوجيا',
    'clients.categories.finance': 'المالية',
    'clients.categories.manufacturing': 'التصنيع',
    'clients.categories.infrastructure': 'البنية التحتية',
    'clients.projects': 'المشاريع',
    'clients.since': 'منذ',
    'clients.contact.title': 'كن عميلاً لنا',
    'clients.contact.subtitle': 'مستعد لبدء مشروعك القادم معنا؟',
    'clients.contact.description': 'املأ النموذج أدناه وسيتواصل معك فريقنا خلال 24 ساعة.',
    'clients.form.firstName': 'الاسم الأول',
    'clients.form.lastName': 'اسم العائلة',
    'clients.form.email': 'عنوان البريد الإلكتروني',
    'clients.form.phone': 'رقم الهاتف',
    'clients.form.mobile': 'رقم الجوال',
    'clients.form.company': 'اسم الشركة',
    'clients.form.position': 'المنصب',
    'clients.form.projectType': 'نوع المشروع',
    'clients.form.projectDetails': 'تفاصيل المشروع',
    'clients.form.message': 'الرسالة',
    'clients.form.consent': 'أوافق على الشروط والأحكام',
    'clients.form.submit': 'إرسال الرسالة',
    'clients.form.submitting': 'جاري الإرسال...',
    'clients.form.success': 'شكراً لك! تم إرسال رسالتك بنجاح.',
    'clients.form.close': 'إغلاق',
    'clients.projectTypes.residential': 'البناء السكني',
    'clients.projectTypes.commercial': 'البناء التجاري',
    'clients.projectTypes.industrial': 'البناء الصناعي',
    'clients.projectTypes.infrastructure': 'تطوير البنية التحتية',
    'clients.projectTypes.renovation': 'التجديد والتطوير',
    'clients.projectTypes.designBuild': 'التصميم والبناء',
    'clients.projectTypes.projectManagement': 'إدارة المشاريع',
    'clients.projectTypes.consulting': 'خدمات الاستشارة',
    'clients.projectTypes.other': 'أخرى',
    
    // Careers Page Translations
    'careers.hero.title': 'انضم إلى فريقنا',
    'careers.hero.subtitle': 'ابني مسيرتك المهنية مع إف إم سي للإنشاءات',
    'careers.hero.description': 'اكتشف فرص عمل مثيرة في البناء والهندسة وإدارة المشاريع. انضم إلى فريق يقدر الابتكار والنمو والتميز.',
    'careers.search.placeholder': 'البحث عن وظائف...',
    'careers.filters.department': 'القسم',
    'careers.filters.location': 'الموقع',
    'careers.filters.type': 'نوع الوظيفة',
    'careers.filters.all': 'الكل',
    'careers.view.grid': 'عرض الشبكة',
    'careers.view.list': 'عرض القائمة',
    'careers.job.apply': 'تقدم الآن',
    'careers.job.view': 'عرض التفاصيل',
    'careers.job.share': 'مشاركة',
    'careers.job.posted': 'تاريخ النشر',
    'careers.job.experience': 'الخبرة',
    'careers.job.salary': 'الراتب',
    'careers.job.location': 'الموقع',
    'careers.job.type': 'النوع',
    'careers.job.remote': 'عن بُعد',
    'careers.job.urgent': 'عاجل',
    'careers.job.fullTime': 'دوام كامل',
    'careers.job.partTime': 'دوام جزئي',
    'careers.job.contract': 'عقد',
    'careers.job.internship': 'تدريب',
    'careers.modal.title': 'التقدم للوظيفة',
    'careers.modal.subtitle': 'قدم طلبك',
    'careers.form.name': 'الاسم الكامل',
    'careers.form.email': 'عنوان البريد الإلكتروني',
    'careers.form.mobile': 'رقم الجوال',
    'careers.form.currentSalary': 'الراتب الحالي',
    'careers.form.expectedSalary': 'الراتب المتوقع',
    'careers.form.currentLocation': 'الموقع الحالي',
    'careers.form.experience': 'سنوات الخبرة',
    'careers.form.position': 'المنصب المتقدم له',
    'careers.form.cv': 'رفع السيرة الذاتية',
    'careers.form.consent': 'أوافق على الشروط والأحكام',
    'careers.form.submit': 'تقديم الطلب',
    'careers.form.submitting': 'جاري التقديم...',
    'careers.form.success': 'تم تقديم الطلب بنجاح!',
    'careers.form.close': 'إغلاق',
    'careers.departments.engineering': 'الهندسة',
    'careers.departments.projectManagement': 'إدارة المشاريع',
    'careers.departments.construction': 'البناء',
    'careers.departments.hr': 'الموارد البشرية',
    'careers.departments.finance': 'المالية',
    'careers.departments.it': 'تقنية المعلومات',
    'careers.departments.operations': 'العمليات',
    'careers.locations.jeddah': 'جدة',
    'careers.locations.riyadh': 'الرياض',
    'careers.locations.dammam': 'الدمام',
    'careers.locations.remote': 'عن بُعد',
    
    // Contact Information
    'contact.companyName': 'شركة إف إم سي',
    'contact.address.poBox': 'صندوق بريد 6599، جدة',
    'contact.address.postalCode': '21452',
    'contact.address.country': 'المملكة العربية السعودية',
    
    // Contact Page Translations - Arabic
    'contact.title': 'اتصل بنا',
    'contact.hero.subtitle': 'تواصل مع فريقنا لاستفسارات المشاريع أو الشراكات أو الفرص الوظيفية. نحن هنا لمساعدتك في تحقيق رؤيتك.',
    'contact.form.title': 'نموذج الاتصال',
    'contact.form.subtitle': 'املأ النموذج أدناه وسيتواصل معك فريقنا في أقرب وقت ممكن لمناقشة استفسارك، سواء كان لطلب عروض أسعار للمشاريع أو الشراكات أو الفرص الوظيفية.',
    'contact.form.success.title': 'تم إرسال الرسالة بنجاح!',
    'contact.form.success.message': 'شكراً لك على استفسارك. سنتواصل معك خلال 24 ساعة.',
    'contact.form.type.label': 'ماذا تبحث عنه؟',
    'contact.form.type.quote': 'طلب عرض سعر لمشروع جديد',
    'contact.form.type.vendor': 'طلب شراكة كمورد',
    'contact.form.type.subcontractor': 'طلب شراكة كمقاول من الباطن',
    'contact.form.type.job': 'البحث عن فرصة وظيفية',
    'contact.form.company.label': 'اسم الشركة',
    'contact.form.company.placeholder': 'أدخل اسم شركتك',
    'contact.form.name.label': 'الاسم الكامل للتواصل',
    'contact.form.name.placeholder': 'أدخل اسمك الكامل',
    'contact.form.position.label': 'المنصب',
    'contact.form.position.placeholder': 'أدخل منصبك',
    'contact.form.phone.label': 'رقم الهاتف',
    'contact.form.phone.placeholder': 'أدخل رقم هاتفك',
    'contact.form.mobile.label': 'رقم الجوال',
    'contact.form.mobile.placeholder': 'أدخل رقم جوالك',
    'contact.form.email.label': 'البريد الإلكتروني',
    'contact.form.email.placeholder': 'أدخل عنوان بريدك الإلكتروني',
    'contact.form.projectType.label': 'نوع المشروع',
    'contact.form.projectType.placeholder': 'اختر نوع المشروع',
    'contact.form.projectDetails.label': 'تفاصيل المشروع',
    'contact.form.projectDetails.placeholder': 'أخبرنا عن متطلبات مشروعك والجدول الزمني وأي احتياجات محددة...',
    'contact.form.vendorName.label': 'اسم المورد',
    'contact.form.vendorName.placeholder': 'أدخل اسم المورد',
    'contact.form.subcontractorName.label': 'اسم المقاول من الباطن',
    'contact.form.subcontractorName.placeholder': 'أدخل اسم المقاول من الباطن',
    'contact.form.services.label': 'الخدمات المقدمة',
    'contact.form.services.placeholder': 'اوصف الخدمات التي تقدمها شركتك',
    'contact.form.vat.label': 'رقم ضريبة القيمة المضافة',
    'contact.form.vat.placeholder': 'أدخل رقم ضريبة القيمة المضافة',
    'contact.form.profile.label': 'رفع ملف تعريف الشركة',
    'contact.form.profile.placeholder': 'انقر لرفع ملف تعريف الشركة',
    'contact.form.certificate.label': 'رفع شهادة تسجيل الشركة',
    'contact.form.certificate.placeholder': 'انقر لرفع شهادة تسجيل الشركة',
    'contact.form.message.label': 'الرسالة',
    'contact.form.message.placeholder': 'أخبرنا المزيد عن شركتك واهتمامك بالشراكة...',
    'contact.form.location.label': 'الموقع الحالي',
    'contact.form.location.placeholder': 'أدخل موقعك الحالي',
    'contact.form.experience.label': 'سنوات الخبرة',
    'contact.form.experience.placeholder': 'اختر مستوى الخبرة',
    'contact.form.experience.0-1': '0-1 سنوات',
    'contact.form.experience.2-3': '2-3 سنوات',
    'contact.form.experience.4-5': '4-5 سنوات',
    'contact.form.experience.6-10': '6-10 سنوات',
    'contact.form.experience.10+': '10+ سنوات',
    'contact.form.jobPosition.label': 'المنصب المتقدم له',
    'contact.form.jobPosition.placeholder': 'أدخل المنصب الذي تتقدم له',
    'contact.form.cv.label': 'رفع السيرة الذاتية',
    'contact.form.cv.placeholder': 'انقر لرفع سيرتك الذاتية',
    'contact.form.consent.label': 'أوافق على معالجة بياناتي الشخصية لأغراض التوظيف',
    'contact.form.submit.sending': 'جاري الإرسال...',
    'contact.form.submit.send': 'إرسال الرسالة',
    'contact.form.fileTypes': 'PDF، DOC، DOCX (حد أقصى 5 ميجابايت)',
    'contact.info.title': 'معلومات الاتصال',
    'contact.info.subtitle': 'تواصل معنا من خلال أي من القنوات التالية. نحن دائماً مستعدون لمساعدتك في احتياجاتك الإنشائية والهندسية.',
    'contact.info.office.title': 'عنوان المكتب',
    'contact.info.phone.title': 'أرقام الهاتف',
    'contact.info.email.title': 'عنوان البريد الإلكتروني',
    'contact.info.hours.title': 'ساعات العمل',
    'contact.info.hours.weekdays': 'السبت - الأربعاء: ٨:٠٠ ص - ٥:٠٠ م',
    'contact.info.hours.thursday': 'الخميس: ٨:٠٠ ص - ٢:٣٠ م',
    'contact.info.hours.weekend': 'الجمعة: مغلق',
    
    // Home Page Blog Section Translations - Arabic
    'home.blog.title': 'أحدث من مدونتنا',
    'home.blog.subtitle': 'ابق على اطلاع برؤى البناء والاتجاهات الصناعية وتحديثات المشاريع',
    'home.blog.views': 'مشاهدات',
    'home.blog.readTime': 'دقائق للقراءة',
    'home.blog.viewArticle': 'عرض المقال',
    'home.blog.articles.1.title': 'المدن الذكية: مستقبل البنية التحتية الحضرية',
    'home.blog.articles.1.description': 'اكتشف كيف تقوم تقنيات المدن الذكية بثورة في التخطيط الحضري والبناء، من أجهزة الاستشعار الذكية إلى أنظمة إدارة المرور الذكية.',
    'home.blog.articles.1.category': 'التكنولوجيا',
    'home.blog.articles.2.title': 'البناء المستدام: بناء من أجل الغد',
    'home.blog.articles.2.description': 'استكشف ممارسات البناء المستدام المبتكرة التي تقلل من التأثير البيئي مع الحفاظ على الفعالية من حيث التكلفة والجودة.',
    'home.blog.articles.2.category': 'الاستدامة',
    'home.blog.articles.3.title': 'هندسة الجسور الحديثة: من المفهوم إلى الإنجاز',
    'home.blog.articles.3.description': 'نظرة متعمقة على أحدث تقنيات بناء الجسور والمواد ومبادئ التصميم التي تشكل مستقبل البنية التحتية.',
    'home.blog.articles.3.category': 'البناء',
    'home.blog.articles.4.title': 'صعود البناء المعياري',
    'home.blog.articles.4.description': 'كيف تقوم التصنيع المسبق بتحويل صناعة البناء، وتقليل التكاليف وتحسين الجودة وتسريع الجداول الزمنية للمشاريع.',
    'home.blog.articles.4.category': 'الصناعة',
    'home.blog.articles.5.title': 'السلامة أولاً: بروتوكولات السلامة المتقدمة في البناء',
    'home.blog.articles.5.description': 'تدابير السلامة والبروتوكولات الأساسية التي يجب أن يعرفها كل محترف في البناء لضمان سلامة مكان العمل والامتثال.',
    'home.blog.articles.5.category': 'السلامة',
    'home.blog.articles.6.title': 'مواد البناء الخضراء: البدائل الصديقة للبيئة',
    'home.blog.articles.6.description': 'استكشف مواد البناء المستدامة التي تقوم بثورة في البناء مع تقليل التأثير البيئي والبصمة الكربونية.',
    'home.blog.articles.6.category': 'الاستدامة',
    
    // Home Page Vendors Section Translations - Arabic
    'home.vendors.title': 'تعرف على',
    'home.vendors.highlight': 'موردينا',
    'home.vendors.subtitle': 'حلول بناء شاملة مصممة لتلبية احتياجاتك ورؤيتك المحددة',
    'home.vendors.viewAll': 'عرض جميع الموردين',
    
    // Home Page Success Partners Section Translations - Arabic
    'home.partners.title': 'شركاء',
    'home.partners.highlight': 'نجاحنا',
    
    
    // Blog posts
    'blog.posts.smartCities.title': 'المدن الذكية: مستقبل البنية التحتية الحضرية',
    'blog.posts.smartCities.excerpt': 'استكشاف كيف تقوم تقنيات المدن الذكية بثورة في التطوير الحضري وإدارة البنية التحتية.',
    'blog.posts.smartCities.category': 'المدن الذكية',
    
    'blog.posts.sustainableConstruction.title': 'البناء المستدام: البناء من أجل الغد',
    'blog.posts.sustainableConstruction.excerpt': 'اكتشف الأساليب المبتكرة للبناء الصديق للبيئة وممارسات البناء الأخضر.',
    'blog.posts.sustainableConstruction.category': 'الاستدامة',
    
    'blog.posts.bridgeEngineering.title': 'هندسة الجسور الحديثة: من المفهوم إلى الإنجاز',
    'blog.posts.bridgeEngineering.excerpt': 'نظرة متعمقة على تقنيات تصميم وبناء الجسور المعاصرة.',
    'blog.posts.bridgeEngineering.category': 'الهندسة',
    
    'blog.posts.prefabricatedConstruction.title': 'صعود البناء الجاهز',
    'blog.posts.prefabricatedConstruction.excerpt': 'كيف يغير البناء الجاهز صناعة البناء بأساليب بناء أسرع وأكثر كفاءة.',
    'blog.posts.prefabricatedConstruction.category': 'الابتكار',
    
    'blog.posts.constructionSafety.title': 'الأمان أولاً: بروتوكولات الأمان المتقدمة في البناء',
    'blog.posts.constructionSafety.excerpt': 'إجراءات الأمان الأساسية والبروتوكولات التي يجب على كل مشروع بناء تنفيذها.',
    'blog.posts.constructionSafety.category': 'الأمان',
    
    'blog.posts.greenMaterials.title': 'مواد البناء الخضراء: البدائل الصديقة للبيئة',
    'blog.posts.greenMaterials.excerpt': 'استكشاف المواد المستدامة التي تقوم بثورة في صناعة البناء.',
    'blog.posts.greenMaterials.category': 'المواد',
    
    'blog.posts.digitalTwins.title': 'التوائم الرقمية في البناء: الواقع الافتراضي يلتقي بالواقع',
    'blog.posts.digitalTwins.excerpt': 'كيف تقوم تقنية التوأم الرقمي بتحويل إدارة المشاريع وعمليات البناء.',
    'blog.posts.digitalTwins.category': 'التكنولوجيا',
    
    'blog.posts.costManagement.title': 'إدارة التكلفة الفعالة في مشاريع البناء',
    'blog.posts.costManagement.excerpt': 'استراتيجيات للحفاظ على السيطرة على الميزانية وتعظيم القيمة في مشاريع البناء.',
    'blog.posts.costManagement.category': 'إدارة المشاريع',
    
    'blog.posts.innovativeMaterials.title': 'المواد المبتكرة التي تشكل مستقبل البناء',
    'blog.posts.innovativeMaterials.excerpt': 'المواد المتطورة التي تدفع حدود ما هو ممكن في البناء.',
    'blog.posts.innovativeMaterials.category': 'الابتكار',
    
    'blog.posts.aiAutomation.title': 'الذكاء الاصطناعي والأتمتة في البناء: الثورة القادمة',
    'blog.posts.aiAutomation.excerpt': 'كيف يقوم الذكاء الاصطناعي والأتمتة بتحويل سير عمل البناء والكفاءة.',
    'blog.posts.aiAutomation.category': 'التكنولوجيا',
    
    'blog.posts.sustainableUrban.title': 'التطوير الحضري المستدام: دراسات الحالة وأفضل الممارسات',
    'blog.posts.sustainableUrban.excerpt': 'أمثلة من العالم الحقيقي لمشاريع التطوير الحضري المستدام وتأثيرها.',
    'blog.posts.sustainableUrban.category': 'التخطيط الحضري',
    
    'blog.posts.projectManagement.title': 'تقنيات إدارة المشاريع المتقدمة في البناء',
    'blog.posts.projectManagement.excerpt': 'منهجيات إدارة المشاريع الحديثة التي تضمن تسليم مشاريع البناء بنجاح.',
    'blog.posts.projectManagement.category': 'إدارة المشاريع',
    
    'blog.posts.bridgeDesign.title': 'تصميم الجسور المبتكر: عجائب الهندسة في العصر الحديث',
    'blog.posts.bridgeDesign.excerpt': 'استكشاف تصاميم الجسور الرائدة التي تجمع بين الجماليات والتميز الهندسي.',
    'blog.posts.bridgeDesign.category': 'الهندسة',
    
    'blog.posts.greenCertification.title': 'شهادة البناء الأخضر: LEED وما بعدها',
    'blog.posts.greenCertification.excerpt': 'فهم شهادات البناء الأخضر وأهميتها في البناء المستدام.',
    'blog.posts.greenCertification.category': 'الشهادة',
    
    // Our Services Page
    'ourServices.title': 'تعرف على خدماتنا',
    'ourServices.highlight': 'الخدمات',
    'ourServices.subtitle': 'حلول شاملة في البناء والهندسة مصممة لتحويل رؤيتك إلى واقع بالتميز والابتكار.',
    'ourServices.cta.title': 'مستعد لبدء مشروعك القادم؟',
    'ourServices.cta.subtitle': 'تواصل معنا اليوم لمناقشة احتياجاتك في البناء والهندسة. فريقنا الخبير جاهز لتحويل رؤيتك إلى واقع.',
    'ourServices.cta.button': 'ابدأ اليوم',
    'ourServices.learnMore': 'اعرف المزيد',
    
    // Service Types
    'ourServices.buildingInfrastructure.title': 'البناء والبنية التحتية',
    'ourServices.buildingInfrastructure.description': 'خدمات بناء شاملة للمباني التجارية والسكنية والصناعية مع تطوير البنية التحتية الحديثة.',
    'ourServices.designEngineering.title': 'التصميم والهندسة',
    'ourServices.designEngineering.description': 'خدمات التصميم المعماري والهندسي المهنية مع الحلول المبتكرة والخبرة التقنية.',
    'ourServices.architecturalFitout.title': 'التشطيب المعماري',
    'ourServices.architecturalFitout.description': 'خدمات التشطيب الداخلي المتخصصة للمساحات التجارية والسكنية مع التشطيبات المتميزة والحلول المخصصة.',
    'ourServices.civilWorks.title': 'الأعمال المدنية',
    'ourServices.civilWorks.description': 'خدمات الهندسة المدنية الشاملة تشمل الطرق والجسور والمرافق وتطوير البنية التحتية.',
    'ourServices.mepWorks.title': 'أعمال الميكانيك والكهرباء والسباكة',
    'ourServices.mepWorks.description': 'تركيب وصيانة أنظمة الميكانيك والكهرباء والسباكة مع تكامل التكنولوجيا الحديثة.',
    'ourServices.dataCenters.title': 'بناء مراكز البيانات',
    'ourServices.dataCenters.description': 'خدمات بناء مراكز البيانات والبنية التحتية الاحترافية مع أنظمة طاقة وتبريد وأمان متقدمة.',
    'ourServices.pricing.title': 'التسعير',
    'ourServices.pricing.description': 'خدمات تسعير شفافة ومتنافسة مع تحليل مفصل للتكاليف والهندسة القيمية.',
    'ourServices.maintenance.title': 'الصيانة',
    'ourServices.maintenance.description': 'خدمات صيانة شاملة للمباني والبنية التحتية مع الحلول الوقائية والتصحيحية.',
    
    // Documents Page
    'documents.hero.title': 'وثائق الشركة',
    'documents.hero.highlight': '',
    'documents.subtitle': 'الوصول إلى مجموعتنا الشاملة من وثائق الشركة والتقارير والموارد.',
    'documents.search.label': 'البحث',
    'documents.search.placeholder': 'البحث في الوثائق بالعنوان أو التاريخ أو المجلد أو العدد...',
    'documents.filter.category': 'الفئة',
    'documents.filter.year': 'السنة',
    'documents.categories.all': 'جميع الفئات',
    'documents.categories.business': 'أعمال',
    'documents.categories.technology': 'تقنية',
    'documents.categories.innovation': 'ابتكار',
    'documents.categories.architecture': 'عمارة',
    'documents.categories.industrial': 'صناعي',
    'documents.categories.construction': 'بناء',
    'documents.categories.design': 'تصميم',
    'documents.years.all': 'جميع السنوات',
    'documents.results.found': 'وثيقة موجودة',
    'documents.view.grid': 'عرض الشبكة',
    'documents.view.list': 'عرض القائمة',
    'documents.magazine': 'مجلة',
    'documents.download': 'تحميل',
    'documents.view': 'عرض',
    'documents.views': 'مشاهدة',
    'documents.share': 'مشاركة الوثيقة',
    'documents.volume': 'المجلد',
    'documents.issue': 'العدد',
    'documents.filters.active': 'المرشحات النشطة:',
    'documents.filters.category': 'الفئة:',
    'documents.filters.year': 'السنة:',
    'documents.filters.search': 'البحث:',
    'documents.filters.clearAll': 'مسح جميع المرشحات',
    'documents.noDocuments.title': 'لا توجد وثائق متاحة',
    'documents.noDocuments.message': 'نقوم حاليًا بتحديث مجموعة الوثائق الخاصة بنا. يرجى العودة قريبًا للحصول على أحدث الموارد.',
    'documents.cta.title': 'تحتاج إلى وثائق محددة؟',
    'documents.cta.subtitle': 'لا تجد ما تبحث عنه؟ اتصل بنا وسنساعدك في العثور على الوثائق المناسبة.',
    'documents.cta.button': 'اتصل بنا',
    
    // Document Items
    'documents.april2019.title': 'إرشادات سلامة البناء',
    'documents.april2019.date': 'أبريل 2019',
    'documents.april2019.volume': 'المجلد 12',
    'documents.april2019.issue': 'العدد 4',
    'documents.march2019.title': 'معايير إدارة المشاريع',
    'documents.march2019.date': 'مارس 2019',
    'documents.march2019.volume': 'المجلد 12',
    'documents.march2019.issue': 'العدد 3',
    'documents.february2019.title': 'إجراءات مراقبة الجودة',
    'documents.february2019.date': 'فبراير 2019',
    'documents.february2019.volume': 'المجلد 12',
    'documents.february2019.issue': 'العدد 2',
    'documents.january2019.title': 'امتثال رمز البناء',
    'documents.january2019.date': 'يناير 2019',
    'documents.january2019.volume': 'المجلد 12',
    'documents.january2019.issue': 'العدد 1',
    'documents.december2018.title': 'البناء الصناعي',
    'documents.december2018.date': 'ديسمبر 2018',
    'documents.december2018.volume': 'المجلد 11',
    'documents.december2018.issue': 'العدد 12',
    'documents.november2018.title': 'إدارة البناء',
    'documents.november2018.date': 'نوفمبر 2018',
    'documents.november2018.volume': 'المجلد 11',
    'documents.november2018.issue': 'العدد 11',
    'documents.october2018.title': 'تطوير البنية التحتية',
    'documents.october2018.date': 'أكتوبر 2018',
    'documents.october2018.volume': 'المجلد 11',
    'documents.october2018.issue': 'العدد 10',
    'documents.september2018.title': 'سلامة البناء',
    'documents.september2018.date': 'سبتمبر 2018',
    'documents.september2018.volume': 'المجلد 11',
    'documents.september2018.issue': 'العدد 9',
    'documents.august2018.title': 'التميز في التصميم',
    'documents.august2018.date': 'أغسطس 2018',
    'documents.august2018.volume': 'المجلد 11',
    'documents.august2018.issue': 'العدد 8',
    
    // Industries & Sectors Page
    'industriesSectors.title': 'الصناعات والقطاعات',
    'industriesSectors.highlight': 'والقطاعات',
    'industriesSectors.subtitle': 'نخدم صناعات متنوعة بحلول بناء متخصصة مصممة لتلبية متطلبات ومعايير القطاع الفريدة.',
    'industriesSectors.cta.title': 'تبحث عن حلول مخصصة للصناعة؟',
    'industriesSectors.cta.subtitle': 'فرقنا المتخصصة تفهم المتطلبات الفريدة لكل صناعة. دعنا نساعدك في بناء شيء استثنائي.',
    'industriesSectors.cta.startProject': 'ابدأ مشروعك',
    'industriesSectors.cta.viewWork': 'شاهد أعمالنا',
    'industriesSectors.projects': 'مشاريع',
    
    // Sector Types
    'industriesSectors.commercial.title': 'تجاري',
    'industriesSectors.commercial.description': 'مباني المكاتب ومراكز البيع بالتجزئة والمولات التجارية والمجمعات التجارية المصممة لاحتياجات الأعمال الحديثة. نتخصص في إنشاء مساحات عمل ديناميكية تعزز الإنتاجية والتعاون. مشاريعنا التجارية تتميز بتكامل التكنولوجيا المتطورة ومبادئ التصميم المستدام.',
    'industriesSectors.entertainment.title': 'ترفيهي',
    'industriesSectors.entertainment.description': 'أماكن الترفيه ودور السينما وحدائق الألعاب والمرافق الترفيهية التي تخلق تجارب لا تُنسى. نصمم مساحات غامرة تسحر الجماهير وتخلق ذكريات دائمة. مشاريعنا الترفيهية تجمع بين التكنولوجيا المتطورة والتصميم المبتكر لتقديم تجارب زوار استثنائية.',
    'industriesSectors.hotel.title': 'فندقي',
    'industriesSectors.hotel.description': 'الفنادق الفاخرة والمنتجعات والفنادق البوتيكية ومشاريع فندقية مع وسائل الراحة عالمية المستوى. نخلق تجارب ضيوف استثنائية من خلال التصميم المبتكر واللمسات النهائية المتميزة. مشاريعنا الفندقية تجمع بين الراحة والوظائف والجاذبية الجمالية لتتجاوز توقعات الضيوف.',
    'industriesSectors.industrial.title': 'صناعي',
    'industriesSectors.industrial.description': 'مرافق التصنيع ومصانع المعالجة والمجمعات الصناعية المبنية للكفاءة المثلى. نتخصص في إنشاء بيئات إنتاج متطورة تعظم الأداء التشغيلي. مشاريعنا الصناعية تدمج أنظمة الأتمتة المتقدمة وممارسات التصنيع المستدام.',
    'industriesSectors.residential.title': 'سكني',
    'industriesSectors.residential.description': 'مجمعات الإسكان والشقق والفلل والمشاريع السكنية التي تشعرك بالمنزل. نخلق مساحات معيشة مريحة تجمع بين المرافق الحديثة والقيم التقليدية. مشاريعنا السكنية تركز على التكامل المجتمعي والعيش المستدام وجودة الحياة الاستثنائية.',
    'industriesSectors.school.title': 'التعليم',
    'industriesSectors.school.description': 'المؤسسات التعليمية والجامعات والمدارس ومراكز التعلم التي تلهم المعرفة. نصمم بيئات تعليمية مبتكرة تعزز الإبداع والتميز الأكاديمي. مشاريعنا التعليمية تدمج التكنولوجيا الحديثة والمساحات المرنة والتصميم المستدام لدعم الأجيال القادمة.',
    'industriesSectors.utilities.title': 'مرافق عامة',
    'industriesSectors.utilities.description': 'محطات الطاقة ومرافق معالجة المياه ومشاريع البنية التحتية للخدمات الأساسية. نبني البنية التحتية الحيوية التي تدعم المجتمعات وتدفع النمو الاقتصادي. مشاريعنا للمرافق العامة تركز على الموثوقية والكفاءة والاستدامة البيئية للنجاح على المدى الطويل.',
    'industriesSectors.warehouse.title': 'مستودعات',
    'industriesSectors.warehouse.description': 'مرافق التخزين ومراكز اللوجستيات ومراكز التوزيع لعمليات سلسلة التوريد الفعالة. نصمم حلول مستودعات ذكية تحسن إدارة المخزون وكفاءة التوزيع. مشاريعنا للمستودعات تدمج الأتمتة المتقدمة والتحكم في المناخ وأنظمة الأمان لأقصى فعالية تشغيلية.',
    
    // Commercial Sector Projects - Arabic
    'commercial.projects.project1.title': 'مجمع مكاتب حديث',
    'commercial.projects.project1.description': 'مبنى مكاتب متطور يتميز بمساحات عمل مرنة وتكامل تكنولوجي متقدم وعناصر تصميم مستدامة.',
    'commercial.projects.project1.location': 'الرياض',
    'commercial.projects.project1.status': 'مكتمل',
    'commercial.projects.project1.completion': '2023',
    'commercial.projects.project1.size': '450,000 قدم مربع',
    'commercial.projects.project1.value': '120 مليون دولار',
    'commercial.projects.project1.features.smart': 'أنظمة المباني الذكية',
    'commercial.projects.project1.features.flexible': 'مساحات عمل مرنة',
    'commercial.projects.project1.features.green': 'سقف أخضر',
    'commercial.projects.project1.features.security': 'أمان متقدم',
    
    'commercial.projects.project2.title': 'تطوير مول تجاري',
    'commercial.projects.project2.description': 'وجهة تجزئة شاملة مع متاجر رئيسية متعددة ومرافق ترفيهية وخيارات طعام متميزة.',
    'commercial.projects.project2.location': 'جدة',
    'commercial.projects.project2.status': 'قيد التنفيذ',
    'commercial.projects.project2.completion': '2024',
    'commercial.projects.project2.size': '800,000 قدم مربع',
    'commercial.projects.project2.value': '180 مليون دولار',
    'commercial.projects.project2.features.retail': 'تجارة متعددة المستويات',
    'commercial.projects.project2.features.entertainment': 'منطقة ترفيهية',
    'commercial.projects.project2.features.food': 'ساحة طعام',
    'commercial.projects.project2.features.parking': 'مرآب سيارات',
    
    'commercial.projects.project3.title': 'المقر الرئيسي للشركة',
    'commercial.projects.project3.description': 'مبنى شركة رئيسي مصمم ليعكس الهوية التجارية مع توفير مرافق متطورة لعمليات الأعمال.',
    'commercial.projects.project3.location': 'الدمام',
    'commercial.projects.project3.status': 'مكتمل',
    'commercial.projects.project3.completion': '2022',
    'commercial.projects.project3.size': '300,000 قدم مربع',
    'commercial.projects.project3.value': '85 مليون دولار',
    'commercial.projects.project3.features.suites': 'جناح تنفيذي',
    'commercial.projects.project3.features.conference': 'مراكز مؤتمرات',
    'commercial.projects.project3.features.amenities': 'مرافق الموظفين',
    'commercial.projects.project3.features.brand': 'تكامل العلامة التجارية',
    
    // Commercial Sector Page Content - Arabic
    'commercial.hero.title': 'القطاع',
    'commercial.hero.highlight': 'التجاري',
    'commercial.hero.subtitle': 'بناء المساحات التجارية الحديثة ومباني المكاتب ومراكز البيع بالتجزئة والمجمعات التجارية التي تدفع النمو الاقتصادي',
    'commercial.overview.title': 'التميز في البناء التجاري',
    'commercial.overview.subtitle': 'بناء مستقبل الأعمال',
    'commercial.overview.description': 'قسم البناء التجاري لدينا متخصص في إنشاء بيئات أعمال مبتكرة تعزز الإنتاجية والتعاون والنمو. من المجمعات المكتبية الشاهقة إلى مراكز البيع بالتجزئة النابضة بالحياة، نقدم مشاريع تتجاوز التوقعات وتقف كمعالم للتميز المعماري.',
    'commercial.overview.stats.projects': 'مشاريع تجارية',
    'commercial.overview.stats.experience': 'سنوات خبرة',
    'commercial.overview.description1': 'خبرتنا في القطاع التجاري تشمل بناء مباني المكاتب المتطورة ومراكز البيع بالتجزئة والمولات التجارية والتطويرات متعددة الاستخدامات. نفهم المتطلبات الفريدة للمساحات التجارية التي تحتاج إلى أن تكون وظيفية وفعالة وملهمة.',
    'commercial.overview.description2': 'من المقرات الرئيسية للشركات إلى الوجهات التجارية، نقدم مشاريع تجارية تعزز عمليات الأعمال مع إنشاء بيئات تجذب العملاء والموظفين على حد سواء.',
    
    // Commercial Services Section - Arabic
    'commercial.services.title': 'خدمات البناء التجاري لدينا',
    'commercial.services.subtitle': 'حلول بناء تجارية شاملة لاحتياجات الأعمال الحديثة',
    'commercial.services.office.title': 'مباني المكاتب',
    'commercial.services.office.description': 'مجمعات مكاتب حديثة مع مساحات مرنة وتكنولوجيا متقدمة',
    'commercial.services.office.feature1': 'خطط أرضية مفتوحة',
    'commercial.services.office.feature2': 'مرافق الاجتماعات',
    'commercial.services.office.feature3': 'تكامل التكنولوجيا',
    'commercial.services.office.feature4': 'حلول مواقف السيارات',
    'commercial.services.retail.title': 'مراكز البيع بالتجزئة',
    'commercial.services.retail.description': 'المولات التجارية ومساحات البيع بالتجزئة المصممة لتجربة العملاء',
    'commercial.services.retail.feature1': 'تصميم واجهات المحلات',
    'commercial.services.retail.feature2': 'تحسين تدفق العملاء',
    'commercial.services.retail.feature3': 'مرافق التحميل',
    'commercial.services.retail.feature4': 'أنظمة الأمان',
    'commercial.services.corporate.title': 'المقرات الرئيسية للشركات',
    'commercial.services.corporate.description': 'مباني شركات رئيسية تعكس الهوية التجارية',
    'commercial.services.corporate.feature1': 'مرافق تنفيذية',
    'commercial.services.corporate.feature2': 'مراكز المؤتمرات',
    'commercial.services.corporate.feature3': 'مناطق الاستقبال',
    'commercial.services.corporate.feature4': 'تكامل العلامة التجارية',
    'commercial.services.mixed.title': 'تطويرات متعددة الاستخدامات',
    'commercial.services.mixed.description': 'مشاريع تطوير تجارية وسكنية متكاملة',
    'commercial.services.mixed.feature1': 'تصميم متعدد الأغراض',
    'commercial.services.mixed.feature2': 'مرافق مشتركة',
    'commercial.services.mixed.feature3': 'استخدام فعال للأرض',
    'commercial.services.mixed.feature4': 'التكامل المجتمعي',
    'commercial.services.parks.title': 'المجمعات التجارية',
    'commercial.services.parks.description': 'تطوير وبناء مجمعات تجارية شاملة',
    'commercial.services.parks.feature1': 'تخطيط الحرم',
    'commercial.services.parks.feature2': 'المناظر الطبيعية',
    'commercial.services.parks.feature3': 'البنية التحتية',
    'commercial.services.parks.feature4': 'قدرة التوسع',
    'commercial.services.smart.title': 'المباني الذكية',
    'commercial.services.smart.description': 'مباني متكاملة مع التكنولوجيا وأنظمة الأتمتة',
    'commercial.services.smart.feature1': 'أتمتة المباني',
    'commercial.services.smart.feature2': 'إدارة الطاقة',
    'commercial.services.smart.feature3': 'الأمان الذكي',
    'commercial.services.smart.feature4': 'تكامل إنترنت الأشياء',
    'commercial.projects.title': 'مشاريعنا التجارية',
    'commercial.projects.subtitle': 'اكتشف محفظتنا من التطويرات التجارية المبتكرة التي تشكل مستقبل الأعمال',
    'commercial.fallback.title': 'البناء التجاري',
    'commercial.project.category': 'تجاري',
    'commercial.project.status.completed': 'مكتمل',
    'commercial.project.status.ongoing': 'قيد التنفيذ',
    'commercial.project.location': 'الموقع:',
    'commercial.project.size': 'المساحة:',
    'commercial.project.value': 'القيمة:',
    'commercial.project.status': 'الحالة:',
    'commercial.project.features': 'الميزات الرئيسية:',
    
    // Commercial Why Choose Section - Arabic
    'commercial.whyChoose.title': 'لماذا تختار FMC للبناء التجاري؟',
    'commercial.whyChoose.subtitle': 'خبرتنا في البناء التجاري، مقترنة بالتكنولوجيا المبتكرة وإدارة المشاريع الفعالة، تقدم بيئات أعمال استثنائية.',
    'commercial.whyChoose.trackRecord.title': 'سجل حافل مثبت',
    'commercial.whyChoose.trackRecord.description': 'عقود من الخبرة في تقديم مشاريع تجارية ناجحة عبر مختلف الصناعات',
    'commercial.whyChoose.expertTeams.title': 'فرق خبراء',
    'commercial.whyChoose.expertTeams.description': 'فرق متخصصة تفهم متطلبات وأنظمة البناء التجاري',
    'commercial.whyChoose.quality.title': 'معايير الجودة',
    'commercial.whyChoose.quality.description': 'التزام بأعلى معايير الجودة وممارسات البناء المستدامة',
    'commercial.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'commercial.whyChoose.delivery.description': 'إدارة مشاريع فعالة تضمن الإنجاز في الوقت المحدد ضمن الميزانية',
    'commercial.whyChoose.card.title': 'بناء نجاح الأعمال',
    'commercial.whyChoose.card.subtitle': 'حيث تلتقي التجارة بتميز البناء',
    
    // Commercial CTA Section - Arabic
    'commercial.cta.title': 'مستعد لبناء رؤيتك التجارية؟',
    'commercial.cta.subtitle': 'دعنا نتعاون لإنشاء مساحات تجارية مبتكرة تدفع عملك إلى الأمام',
    'commercial.cta.startProject': 'ابدأ مشروعك',
    'commercial.cta.callNow': 'اتصل الآن',
    
    // Entertainment Sector Projects - Arabic
    'entertainment.projects.project1.title': 'مجمع سينما',
    'entertainment.projects.project1.description': 'مجمع سينما متطور يتميز بشاشات متعددة ومقاعد متميزة وتكنولوجيا صوتية ومرئية متقدمة.',
    'entertainment.projects.project1.location': 'الرياض',
    'entertainment.projects.project1.status': 'مكتمل',
    'entertainment.projects.project1.completion': '2023',
    'entertainment.projects.project1.size': '150,000 قدم مربع',
    'entertainment.projects.project1.value': '45 مليون دولار',
    'entertainment.projects.project1.features.imax': 'مسرح IMAX',
    'entertainment.projects.project1.features.seating': 'مقاعد متميزة',
    'entertainment.projects.project1.features.audio': 'Dolby Atmos',
    'entertainment.projects.project1.features.concession': 'مناطق المأكولات',
    
    'entertainment.projects.project2.title': 'تطوير حديقة ألعاب',
    'entertainment.projects.project2.description': 'حديقة ألعاب شاملة مع جاذبيات متعددة ومناطق موضوعية ومرافق ترفيهية لجميع الأعمار.',
    'entertainment.projects.project2.location': 'جدة',
    'entertainment.projects.project2.status': 'قيد التنفيذ',
    'entertainment.projects.project2.completion': '2025',
    'entertainment.projects.project2.size': '2,000,000 قدم مربع',
    'entertainment.projects.project2.value': '350 مليون دولار',
    'entertainment.projects.project2.features.coasters': 'قطارات الأفعوانية',
    'entertainment.projects.project2.features.water': 'ألعاب مائية',
    'entertainment.projects.project2.features.themed': 'مناطق موضوعية',
    'entertainment.projects.project2.features.shows': 'عروض ترفيهية',
    
    'entertainment.projects.project3.title': 'مكان حفلات موسيقية',
    'entertainment.projects.project3.description': 'مكان موسيقي احترافي مصمم للعروض الحية مع صوتيات عالمية المستوى ومرافق حديثة.',
    'entertainment.projects.project3.location': 'الدمام',
    'entertainment.projects.project3.status': 'مكتمل',
    'entertainment.projects.project3.completion': '2022',
    'entertainment.projects.project3.size': '200,000 قدم مربع',
    'entertainment.projects.project3.value': '75 مليون دولار',
    'entertainment.projects.project3.features.acoustic': 'هندسة صوتية',
    'entertainment.projects.project3.features.vip': 'مناطق VIP',
    'entertainment.projects.project3.features.sound': 'أنظمة صوتية',
    'entertainment.projects.project3.features.backstage': 'مرافق خلف المسرح',
    
    // Entertainment Sector Page Content - Arabic
    'entertainment.hero.title': 'القطاع',
    'entertainment.hero.highlight': 'الترفيهي',
    'entertainment.hero.subtitle': 'خلق تجارب ترفيهية استثنائية من خلال البناء المبتكر للمسارح ودور السينما والمرافق الترفيهية',
    'entertainment.overview.title': 'بناء الوجهات الترفيهية',
    'entertainment.overview.description1': 'خبرتنا في القطاع الترفيهي تشمل بناء مسارح ترفيهية عالمية المستوى، من دور السينما المتطورة وحدائق الألعاب إلى المرافق الترفيهية والمراكز الثقافية. نفهم المتطلبات الفريدة للمساحات الترفيهية.',
    'entertainment.overview.description2': 'من الهندسة الصوتية إلى أنظمة الإضاءة المتخصصة، نقدم مسارح ترفيهية توفر تجارب لا تُنسى مع الالتزام بأعلى معايير السلامة والوظائف.',
    'entertainment.overview.stats.projects': 'مشاريع ترفيهية',
    'entertainment.overview.stats.experience': 'سنوات خبرة',
    'entertainment.fallback.title': 'البناء الترفيهي',
    
    // Entertainment Services Section - Arabic
    'entertainment.services.title': 'خدمات البناء الترفيهي لدينا',
    'entertainment.services.subtitle': 'حلول بناء متخصصة للمرافق الترفيهية والترفيهية',
    'entertainment.services.cinema.title': 'مجمعات السينما',
    'entertainment.services.cinema.description': 'دور سينما متطورة مع أنظمة صوتية ومرئية متقدمة',
    'entertainment.services.cinema.feature1': 'أنظمة الإسقاط الرقمي',
    'entertainment.services.cinema.feature2': 'هندسة الصوت المحيطي',
    'entertainment.services.cinema.feature3': 'مقاعد مريحة',
    'entertainment.services.cinema.feature4': 'مرافق المأكولات',
    'entertainment.services.theme.title': 'حدائق الألعاب',
    'entertainment.services.theme.description': 'بناء حدائق ألعاب كاملة من المفهوم إلى الإنجاز',
    'entertainment.services.theme.feature1': 'بنية تحتية للألعاب',
    'entertainment.services.theme.feature2': 'أنظمة الأمان',
    'entertainment.services.theme.feature3': 'بيئات موضوعية',
    'entertainment.services.theme.feature4': 'مرافق الزوار',
    'entertainment.services.concert.title': 'أماكن الحفلات الموسيقية',
    'entertainment.services.concert.description': 'مسارح موسيقية احترافية وقاعات عروض',
    'entertainment.services.concert.feature1': 'هندسة صوتية',
    'entertainment.services.concert.feature2': 'بناء المسرح',
    'entertainment.services.concert.feature3': 'أنظمة صوتية',
    'entertainment.services.concert.feature4': 'مرافق الجمهور',
    'entertainment.services.recreation.title': 'مراكز الترفيه',
    'entertainment.services.recreation.description': 'بناء مرافق المجتمع والترفيه',
    'entertainment.services.recreation.feature1': 'مرافق رياضية',
    'entertainment.services.recreation.feature2': 'مسابح',
    'entertainment.services.recreation.feature3': 'مناطق لياقة بدنية',
    'entertainment.services.recreation.feature4': 'قاعات متعددة الأغراض',
    'entertainment.services.cultural.title': 'المراكز الثقافية',
    'entertainment.services.cultural.description': 'بناء المتاحف والمعارض والمرافق الثقافية',
    'entertainment.services.cultural.feature1': 'مساحات عرض',
    'entertainment.services.cultural.feature2': 'تحكم في المناخ',
    'entertainment.services.cultural.feature3': 'أنظمة الأمان',
    'entertainment.services.cultural.feature4': 'ميزات إمكانية الوصول',
    'entertainment.services.complex.title': 'المجمعات الترفيهية',
    'entertainment.services.complex.description': 'مجمعات ترفيهية وطعام متعددة الاستخدامات',
    'entertainment.services.complex.feature1': 'تصميم متعدد المسارح',
    'entertainment.services.complex.feature2': 'أنظمة متكاملة',
    'entertainment.services.complex.feature3': 'مرافق مواقف السيارات',
    'entertainment.services.complex.feature4': 'امتثال الأمان',
    'entertainment.projects.title': 'مشاريعنا الترفيهية',
    'entertainment.projects.subtitle': 'اكتشف محفظتنا من المسارح الترفيهية المبتكرة التي تخلق تجارب لا تُنسى',
    'entertainment.project.category': 'ترفيهي',
    'entertainment.project.status.completed': 'مكتمل',
    'entertainment.project.status.ongoing': 'قيد التنفيذ',
    'entertainment.project.location': 'الموقع:',
    'entertainment.project.size': 'المساحة:',
    'entertainment.project.value': 'القيمة:',
    'entertainment.project.status': 'الحالة:',
    'entertainment.project.features': 'الميزات الرئيسية:',
    
    // Entertainment Why Choose Section - Arabic
    'entertainment.whyChoose.title': 'لماذا تختار FMC للبناء الترفيهي؟',
    'entertainment.whyChoose.subtitle': 'خبرتنا في البناء الترفيهي، مقترنة بالتكنولوجيا المبتكرة والحلول الإبداعية، تقدم مسارح ترفيهية استثنائية.',
    'entertainment.whyChoose.specialized.title': 'خبرة متخصصة',
    'entertainment.whyChoose.specialized.description': 'فهم عميق لمتطلبات وأنظمة المسارح الترفيهية',
    'entertainment.whyChoose.technical.title': 'التميز التقني',
    'entertainment.whyChoose.technical.description': 'تكامل أنظمة صوتية ومرئية وإضاءة وأمان متقدمة',
    'entertainment.whyChoose.creative.title': 'حلول إبداعية',
    'entertainment.whyChoose.creative.description': 'مناهج تصميم مبتكرة لتجارب ترفيهية فريدة',
    'entertainment.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'entertainment.whyChoose.delivery.description': 'إدارة مشاريع فعالة تلبي متطلبات تاريخ الافتتاح',
    'entertainment.whyChoose.card.title': 'خلق التجارب الترفيهية',
    'entertainment.whyChoose.card.subtitle': 'حيث تلتقي الخيال بتميز البناء',
    
    // Entertainment CTA Section - Arabic
    'entertainment.cta.title': 'مستعد لبناء رؤيتك الترفيهية؟',
    'entertainment.cta.subtitle': 'دعنا نتعاون لإنشاء مسارح ترفيهية استثنائية تسحر و تلهم',
    'entertainment.cta.startProject': 'ابدأ مشروعك',
    'entertainment.cta.callNow': 'اتصل الآن',
    
    // Hotel Sector Projects - Arabic
    'hotel.projects.project1.title': 'مجمع منتجع فاخر',
    'hotel.projects.project1.description': 'منتجع خمس نجوم يتميز بإقامات فاخرة ومرافق عالمية المستوى وإطلالات خلابة على الساحل.',
    'hotel.projects.project1.location': 'جدة',
    'hotel.projects.project1.status': 'مكتمل',
    'hotel.projects.project1.completion': '2023',
    'hotel.projects.project1.size': '500,000 قدم مربع',
    'hotel.projects.project1.value': '200 مليون دولار',
    'hotel.projects.project1.features.beachfront': 'إمكانية الوصول للشاطئ',
    'hotel.projects.project1.features.spa': 'مرافق سبا',
    'hotel.projects.project1.features.dining': 'مطاعم راقية',
    'hotel.projects.project1.features.conference': 'مراكز المؤتمرات',
    
    'hotel.projects.project2.title': 'فندق بوتيك',
    'hotel.projects.project2.description': 'فندق بوتيك حميم يتميز بشخصية فريدة وخدمة مخصصة وعناصر تصميم متطورة.',
    'hotel.projects.project2.location': 'الرياض',
    'hotel.projects.project2.status': 'قيد التنفيذ',
    'hotel.projects.project2.completion': '2024',
    'hotel.projects.project2.size': '100,000 قدم مربع',
    'hotel.projects.project2.value': '65 مليون دولار',
    'hotel.projects.project2.features.design': 'تصميم مخصص',
    'hotel.projects.project2.features.service': 'خدمة مخصصة',
    'hotel.projects.project2.features.character': 'شخصية محلية',
    'hotel.projects.project2.features.amenities': 'مرافق فريدة',
    
    'hotel.projects.project3.title': 'فندق أعمال',
    'hotel.projects.project3.description': 'فندق أعمال حديث مصمم للمسافرين من رجال الأعمال مع مرافق اجتماعات شاملة ومرافق أعمال.',
    'hotel.projects.project3.location': 'الدمام',
    'hotel.projects.project3.status': 'مكتمل',
    'hotel.projects.project3.completion': '2022',
    'hotel.projects.project3.size': '300,000 قدم مربع',
    'hotel.projects.project3.value': '120 مليون دولار',
    'hotel.projects.project3.features.business': 'مركز أعمال',
    'hotel.projects.project3.features.meeting': 'قاعات اجتماعات',
    'hotel.projects.project3.features.lounge': 'صالة تنفيذية',
    'hotel.projects.project3.features.internet': 'إنترنت عالي السرعة',
    
    // Hotel Sector Page Content - Arabic
    'hotel.hero.title': 'القطاع',
    'hotel.hero.highlight': 'الفندقي',
    'hotel.hero.subtitle': 'بناء الفنادق الفاخرة والمنتجعات ومرافق فندقية التي تقدم تجارب ضيوف استثنائية وذكريات دائمة',
    'hotel.overview.title': 'صنع التميز الفندقي',
    'hotel.overview.description1': 'خبرتنا في القطاع الفندقي تشمل بناء مرافق فندقية عالمية المستوى، من الفنادق الفاخرة خمس نجوم وخصائص البوتيك إلى مجمعات المنتجعات ومراكز المؤتمرات. نفهم المتطلبات المعقدة للبناء الفندقي.',
    'hotel.overview.description2': 'من راحة غرف الضيوف إلى الكفاءة التشغيلية، نقدم مشاريع فندقية تعزز تجربة الضيوف مع تعظيم الأداء التشغيلي والربحية للملاك.',
    'hotel.overview.stats.projects': 'مشاريع فندقية',
    'hotel.overview.stats.experience': 'سنوات خبرة',
    'hotel.fallback.title': 'البناء الفندقي',
    
    // Hotel Services Section - Arabic
    'hotel.services.title': 'خدمات البناء الفندقي لدينا',
    'hotel.services.subtitle': 'حلول بناء فندقي شاملة لتجارب ضيوف استثنائية',
    'hotel.services.luxury.title': 'فنادق فاخرة',
    'hotel.services.luxury.description': 'فنادق خمس نجوم مع مرافق متميزة وتصميم متطور',
    'hotel.services.luxury.feature1': 'جناح رئاسي',
    'hotel.services.luxury.feature2': 'خدمات الكونسيرج',
    'hotel.services.luxury.feature3': 'مرافق سبا',
    'hotel.services.luxury.feature4': 'مطاعم راقية',
    'hotel.services.boutique.title': 'فنادق بوتيك',
    'hotel.services.boutique.description': 'فنادق حميمة وأنيقة مع شخصية فريدة وخدمة مخصصة',
    'hotel.services.boutique.feature1': 'تصميم مخصص',
    'hotel.services.boutique.feature2': 'شخصية محلية',
    'hotel.services.boutique.feature3': 'خدمة مخصصة',
    'hotel.services.boutique.feature4': 'مرافق فريدة',
    'hotel.services.resort.title': 'مجمعات المنتجعات',
    'hotel.services.resort.description': 'وجهات منتجعات كاملة مع مرافق ترفيهية شاملة',
    'hotel.services.resort.feature1': 'مسابح متعددة',
    'hotel.services.resort.feature2': 'مراكز ترفيهية',
    'hotel.services.resort.feature3': 'إمكانية الوصول للشاطئ',
    'hotel.services.resort.feature4': 'مسارح ترفيهية',
    'hotel.services.conference.title': 'فنادق المؤتمرات',
    'hotel.services.conference.description': 'فنادق أعمال مع مرافق اجتماعات ومؤتمرات واسعة',
    'hotel.services.conference.feature1': 'قاعات اجتماعات',
    'hotel.services.conference.feature2': 'مراكز المؤتمرات',
    'hotel.services.conference.feature3': 'مراكز أعمال',
    'hotel.services.conference.feature4': 'مرافق تقديم الطعام',
    'hotel.services.smart.title': 'فنادق ذكية',
    'hotel.services.smart.description': 'فنادق متكاملة التكنولوجيا مع أنظمة أتمتة حديثة',
    'hotel.services.smart.feature1': 'أتمتة الغرف',
    'hotel.services.smart.feature2': 'تسجيل رقمي',
    'hotel.services.smart.feature3': 'تحكم ذكي',
    'hotel.services.smart.feature4': 'اتصال عالي السرعة',
    'hotel.services.extended.title': 'فنادق الإقامة الممتدة',
    'hotel.services.extended.description': 'إقامة طويلة الأمد مع مرافق على طراز الشقق',
    'hotel.services.extended.feature1': 'مطابخ صغيرة',
    'hotel.services.extended.feature2': 'مساحة ممتدة',
    'hotel.services.extended.feature3': 'مرافق غسيل',
    'hotel.services.extended.feature4': 'حلول التخزين',
    'hotel.projects.title': 'مشاريعنا الفندقية',
    'hotel.projects.subtitle': 'اكتشف محفظتنا من المرافق الفندقية المبتكرة التي تقدم تجارب ضيوف استثنائية',
    'hotel.project.category': 'فندقي',
    'hotel.project.status.completed': 'مكتمل',
    'hotel.project.status.ongoing': 'قيد التنفيذ',
    'hotel.project.location': 'الموقع:',
    'hotel.project.size': 'المساحة:',
    'hotel.project.value': 'القيمة:',
    'hotel.project.status': 'الحالة:',
    'hotel.project.features': 'الميزات الرئيسية:',
    
    // Hotel Why Choose Section - Arabic
    'hotel.whyChoose.title': 'لماذا تختار FMC للبناء الفندقي؟',
    'hotel.whyChoose.subtitle': 'خبرتنا في البناء الفندقي، مقترنة بفهم توقعات الضيوف والمتطلبات التشغيلية، تقدم خصائص فندقية استثنائية.',
    'hotel.whyChoose.expertise.title': 'خبرة فندقية',
    'hotel.whyChoose.expertise.description': 'معرفة متخصصة بعمليات الفنادق وتوقعات الضيوف والمعايير الصناعية',
    'hotel.whyChoose.guest.title': 'تركيز تجربة الضيوف',
    'hotel.whyChoose.guest.description': 'تصميم وبناء يضع الأولوية للراحة والراحة والتجارب الم memorable',
    'hotel.whyChoose.luxury.title': 'معايير الفخامة',
    'hotel.whyChoose.luxury.description': 'التزام بأعلى جودة التشطيبات ومعايير البناء المتميزة',
    'hotel.whyChoose.schedule.title': 'جدول الافتتاح',
    'hotel.whyChoose.schedule.description': 'تسليم مشروع فعال لتلبية تواريخ الافتتاح الحرجة وأهداف الإيرادات',
    'hotel.whyChoose.card.title': 'خلق التميز الفندقي',
    'hotel.whyChoose.card.subtitle': 'حيث تلتقي الفخامة بحرفية البناء',
    
    // Hotel CTA Section - Arabic
    'hotel.cta.title': 'مستعد لبناء رؤيتك الفندقية؟',
    'hotel.cta.subtitle': 'دعنا نتعاون لإنشاء مرافق فندقية استثنائية توفر تجارب ضيوف لا تُنسى',
    'hotel.cta.startProject': 'ابدأ مشروعك',
    'hotel.cta.callNow': 'اتصل الآن',
    
    // Industrial Sector Projects - Arabic
    'industrial.projects.project1.title': 'مصنع تصنيع متقدم',
    'industrial.projects.project1.description': 'منشأة تصنيع متطورة مصممة للإنتاج عالي التقنية مع أنظمة آلية ومراقبة الجودة.',
    'industrial.projects.project1.location': 'جدة',
    'industrial.projects.project1.status': 'مكتمل',
    'industrial.projects.project1.completion': '2023',
    'industrial.projects.project1.size': '600,000 قدم مربع',
    'industrial.projects.project1.value': '95 مليون دولار',
    'industrial.projects.project1.features.automation': 'خطوط إنتاج آلية',
    'industrial.projects.project1.features.quality': 'مختبرات مراقبة الجودة',
    'industrial.projects.project1.features.robotics': 'روبوتات متقدمة',
    'industrial.projects.project1.features.energy': 'أنظمة طاقة مستدامة',
    
    'industrial.projects.project2.title': 'منشأة معالجة كيميائية',
    'industrial.projects.project2.description': 'مصنع معالجة كيميائية حديث مع أنظمة أمان متقدمة وتكنولوجيا الامتثال البيئي.',
    'industrial.projects.project2.location': 'ينبع',
    'industrial.projects.project2.status': 'قيد التنفيذ',
    'industrial.projects.project2.completion': '2024',
    'industrial.projects.project2.size': '450,000 قدم مربع',
    'industrial.projects.project2.value': '110 مليون دولار',
    'industrial.projects.project2.features.safety': 'أنظمة أمان متقدمة',
    'industrial.projects.project2.features.environmental': 'ضوابط بيئية',
    'industrial.projects.project2.features.automation': 'أتمتة العمليات',
    'industrial.projects.project2.features.waste': 'معالجة النفايات',
    
    // Industrial Sector Page Content - Arabic
    'industrial.hero.title': 'القطاع',
    'industrial.hero.highlight': 'الصناعي',
    'industrial.hero.subtitle': 'بناء أساس التقدم الصناعي مع مرافق التصنيع والمعالجة المتطورة',
    'industrial.overview.title': 'التميز والابتكار الصناعي',
    'industrial.overview.description': 'خبرتنا في القطاع الصناعي تغطي مرافق التصنيع ومصانع المعالجة والمجمعات الصناعية. نركز على الكفاءة والأمان والاستدامة لإنشاء مرافق تدفع النمو الصناعي.',
    'industrial.overview.feature1': 'أنظمة أتمتة متقدمة',
    'industrial.overview.feature2': 'معايير الأمان والامتثال',
    'industrial.overview.feature3': 'الاستدامة البيئية',
    'industrial.overview.feature4': 'تكامل مراقبة الجودة',
    'industrial.overview.stats.projects': 'مشاريع صناعية',
    'industrial.overview.stats.experience': 'سنوات خبرة',
    'industrial.overview.card.title': 'المشاريع الصناعية',
    'industrial.overview.card.description': 'لقد نجحنا في تسليم مشاريع صناعية، مما أدى إلى إنشاء مرافق تدفع التميز في التصنيع والنمو الاقتصادي.',
    'industrial.projects.title': 'مشاريعنا الصناعية',
    'industrial.projects.subtitle': 'اكتشف محفظتنا من المرافق الصناعية المبتكرة التي تدفع مستقبل التصنيع',
    'industrial.project.category': 'صناعي',
    'industrial.project.status.completed': 'مكتمل',
    'industrial.project.status.ongoing': 'قيد التنفيذ',
    'industrial.project.location': 'الموقع:',
    'industrial.project.size': 'المساحة:',
    'industrial.project.value': 'القيمة:',
    'industrial.project.features': 'الميزات الرئيسية',
    'industrial.cta.title': 'مستعد لبناء منشأتك الصناعية؟',
    'industrial.cta.subtitle': 'دعنا نناقش كيف يمكننا إحياء رؤيتك الصناعية بخبرتنا في البناء والتطوير الصناعي.',
    'industrial.cta.startProject': 'ابدأ مشروعك',
    'industrial.cta.exploreSectors': 'استكشف القطاعات الأخرى',
    
    // Industrial Services - Arabic
    'industrial.services.title': 'خدمات البناء الصناعي لدينا',
    'industrial.services.subtitle': 'حلول بناء صناعي شاملة للتميز في التصنيع والكفاءة التشغيلية',
    'industrial.services.manufacturing.title': 'مصانع التصنيع',
    'industrial.services.manufacturing.description': 'مرافق تصنيع متطورة مع أنظمة أتمتة متقدمة ومراقبة الجودة',
    'industrial.services.manufacturing.feature1': 'خطوط إنتاج مؤتمتة',
    'industrial.services.manufacturing.feature2': 'أنظمة مراقبة الجودة',
    'industrial.services.manufacturing.feature3': 'تكامل الروبوتات',
    'industrial.services.manufacturing.feature4': 'كفاءة الطاقة',
    'industrial.services.warehouse.title': 'مستودعات صناعية',
    'industrial.services.warehouse.description': 'مرافق تخزين وتوزيع واسعة النطاق مع بنية تحتية لوجستية حديثة',
    'industrial.services.warehouse.feature1': 'أنظمة تخزين مؤتمتة',
    'industrial.services.warehouse.feature2': 'أرصفة التحميل',
    'industrial.services.warehouse.feature3': 'التحكم في المناخ',
    'industrial.services.warehouse.feature4': 'أنظمة الأمان',
    'industrial.services.processing.title': 'مرافق المعالجة',
    'industrial.services.processing.description': 'مصانع معالجة متخصصة لصناعات الغذاء والكيماويات ومعالجة المواد',
    'industrial.services.processing.feature1': 'تصميم صحي',
    'industrial.services.processing.feature2': 'إدارة النفايات',
    'industrial.services.processing.feature3': 'بروتوكولات السلامة',
    'industrial.services.processing.feature4': 'الامتثال للوائح',
    'industrial.services.energy.title': 'بنية الطاقة التحتية',
    'industrial.services.energy.description': 'أنظمة توليد وتوزيع الطاقة للعمليات الصناعية',
    'industrial.services.energy.feature1': 'محطات الطاقة',
    'industrial.services.energy.feature2': 'شبكات التوزيع',
    'industrial.services.energy.feature3': 'أنظمة النسخ الاحتياطي',
    'industrial.services.energy.feature4': 'تكامل الطاقة المتجددة',
    'industrial.services.research.title': 'مرافق البحث',
    'industrial.services.research.description': 'مراكز البحث والتطوير المتقدمة مع التكنولوجيا المتطورة',
    'industrial.services.research.feature1': 'مساحات المختبرات',
    'industrial.services.research.feature2': 'معدات الاختبار',
    'industrial.services.research.feature3': 'مراكز البيانات',
    'industrial.services.research.feature4': 'مناطق التعاون',
    'industrial.services.maintenance.title': 'مراكز الصيانة',
    'industrial.services.maintenance.description': 'مرافق صيانة وإصلاح متخصصة للمعدات الصناعية',
    'industrial.services.maintenance.feature1': 'أحواض المعدات',
    'industrial.services.maintenance.feature2': 'تخزين الأدوات',
    'industrial.services.maintenance.feature3': 'معدات السلامة',
    'industrial.services.maintenance.feature4': 'مناطق التدريب',
    
    // Residential Sector Projects - Arabic
    'residential.projects.project1.title': 'مجمع فيلات فاخرة',
    'residential.projects.project1.description': 'تطوير سكني متميز يتميز بفيلات فاخرة مع مرافق حديثة وتنسيق حدائق جميل.',
    'residential.projects.project1.location': 'جدة',
    'residential.projects.project1.status': 'مكتمل',
    'residential.projects.project1.completion': '2023',
    'residential.projects.project1.size': '250,000 قدم مربع',
    'residential.projects.project1.value': '65 مليون دولار',
    'residential.projects.project1.features.villas': 'فيلات فاخرة',
    'residential.projects.project1.features.amenities': 'مرافق حديثة',
    'residential.projects.project1.features.landscaping': 'تنسيق حدائق جميل',
    'residential.projects.project1.features.security': 'أنظمة أمان',
    
    'residential.projects.project2.title': 'برج شقق حديث',
    'residential.projects.project2.description': 'برج سكني معاصر يتميز بميزات المنزل الذكي ومرافق المجتمع.',
    'residential.projects.project2.location': 'الرياض',
    'residential.projects.project2.status': 'قيد التنفيذ',
    'residential.projects.project2.completion': '2024',
    'residential.projects.project2.size': '400,000 قدم مربع',
    'residential.projects.project2.value': '80 مليون دولار',
    'residential.projects.project2.features.smart': 'ميزات المنزل الذكي',
    'residential.projects.project2.features.community': 'مرافق المجتمع',
    'residential.projects.project2.features.design': 'تصميم حديث',
    'residential.projects.project2.features.finishes': 'تشطيبات متميزة',
    
    // Residential Sector Page Content - Arabic
    'residential.hero.title': 'القطاع',
    'residential.hero.highlight': 'السكني',
    'residential.hero.subtitle': 'خلق المنازل الحلمية والمجتمعات التي توفر الراحة والفخامة والعيش الحديث',
    'residential.overview.title': 'التميز والابتكار السكني',
    'residential.overview.description': 'خبرتنا في القطاع السكني تغطي المجمعات السكنية والشقق والفيلات والتطويرات السكنية. نركز على إنشاء مساحات معيشة مريحة ومستدامة وحديثة.',
    'residential.overview.feature1': 'مساحات معيشة مريحة',
    'residential.overview.feature2': 'مرافق حديثة',
    'residential.overview.feature3': 'تصميم مستدام',
    'residential.overview.feature4': 'مرافق المجتمع',
    'residential.overview.stats.projects': 'مشاريع سكنية',
    'residential.overview.stats.experience': 'سنوات خبرة',
    'residential.overview.card.title': 'المشاريع السكنية',
    'residential.overview.card.description': 'لقد نجحنا في تسليم مشاريع سكنية، مما أدى إلى إنشاء منازل ومجتمعات تحبها العائلات للعيش فيها.',
    'residential.projects.title': 'مشاريعنا السكنية',
    'residential.projects.subtitle': 'اكتشف محفظتنا من التطويرات السكنية المبتكرة التي تعيد تعريف العيش الحديث',
    'residential.project.category': 'سكني',
    'residential.project.status.completed': 'مكتمل',
    'residential.project.status.ongoing': 'قيد التنفيذ',
    'residential.project.location': 'الموقع:',
    'residential.project.size': 'المساحة:',
    'residential.project.value': 'القيمة:',
    'residential.project.features': 'الميزات الرئيسية',
    'residential.cta.title': 'مستعد لبناء منزل أحلامك؟',
    'residential.cta.subtitle': 'دعنا نناقش كيف يمكننا إحياء رؤيتك السكنية بخبرتنا في بناء وتطوير المنازل.',
    'residential.cta.startProject': 'ابدأ مشروعك',
    'residential.cta.exploreSectors': 'استكشف القطاعات الأخرى',
    
    // Residential Services - Arabic
    'residential.services.title': 'خدمات البناء السكني لدينا',
    'residential.services.subtitle': 'حلول بناء سكني شاملة لمساحات معيشة مريحة وحديثة',
    'residential.services.villas.title': 'فيلات فاخرة',
    'residential.services.villas.description': 'بناء فيلات متميزة بتصاميم مخصصة وتشطيبات عالية الجودة',
    'residential.services.villas.feature1': 'عمارة مخصصة',
    'residential.services.villas.feature2': 'مواد متميزة',
    'residential.services.villas.feature3': 'أنظمة منزل ذكي',
    'residential.services.villas.feature4': 'تصميم المناظر الطبيعية',
    'residential.services.apartments.title': 'مجمعات شقق',
    'residential.services.apartments.description': 'مباني شقق حديثة مع مرافق معاصرة وتخطيطات فعالة',
    'residential.services.apartments.feature1': 'تخطيطات حديثة',
    'residential.services.apartments.feature2': 'مرافق مجتمعية',
    'residential.services.apartments.feature3': 'مرافق وقوف السيارات',
    'residential.services.apartments.feature4': 'أنظمة الأمان',
    'residential.services.townhouses.title': 'بيوت متلاصقة',
    'residential.services.townhouses.description': 'وحدات سكنية متصلة مع مداخل فردية ومرافق مشتركة',
    'residential.services.townhouses.feature1': 'مداخل فردية',
    'residential.services.townhouses.feature2': 'مرافق مشتركة',
    'residential.services.townhouses.feature3': 'حدائق خاصة',
    'residential.services.townhouses.feature4': 'مساحات مجتمعية',
    'residential.services.compounds.title': 'مجمعات سكنية',
    'residential.services.compounds.description': 'مجتمعات مسيجة مع مرافق شاملة ومناطق ترفيهية',
    'residential.services.compounds.feature1': 'أمان مسيج',
    'residential.services.compounds.feature2': 'مرافق ترفيهية',
    'residential.services.compounds.feature3': 'خدمات صيانة',
    'residential.services.compounds.feature4': 'مراكز مجتمعية',
    'residential.services.renovation.title': 'تجديد المنازل',
    'residential.services.renovation.description': 'خدمات تجديد وإعادة تشكيل المنازل الكاملة للممتلكات الموجودة',
    'residential.services.renovation.feature1': 'تصميم داخلي',
    'residential.services.renovation.feature2': 'تحديثات هيكلية',
    'residential.services.renovation.feature3': 'تركيبات حديثة',
    'residential.services.renovation.feature4': 'كفاءة الطاقة',
    'residential.services.custom.title': 'منازل مخصصة',
    'residential.services.custom.description': 'بناء منازل مصممة خصيصاً وفقاً للتفضيلات والمتطلبات الفردية',
    'residential.services.custom.feature1': 'تصميم شخصي',
    'residential.services.custom.feature2': 'تخطيطات مرنة',
    'residential.services.custom.feature3': 'حرفية عالية الجودة',
    'residential.services.custom.feature4': 'إدارة الجدول الزمني',
    
    // School Sector Projects - Arabic
    'school.projects.project1.title': 'حرم المدرسة الدولية',
    'school.projects.project1.description': 'مجمع تعليمي حديث يتميز بفصول دراسية متطورة ومختبرات علوم ومرافق رياضية.',
    'school.projects.project1.location': 'جدة',
    'school.projects.project1.status': 'مكتمل',
    'school.projects.project1.completion': '2023',
    'school.projects.project1.size': '450,000 قدم مربع',
    'school.projects.project1.value': '75 مليون دولار',
    'school.projects.project1.features.classrooms': 'فصول دراسية حديثة',
    'school.projects.project1.features.labs': 'مختبرات علوم',
    'school.projects.project1.features.sports': 'مرافق رياضية',
    'school.projects.project1.features.technology': 'تكامل التكنولوجيا',
    
    'school.projects.project2.title': 'مركز البحوث الجامعية',
    'school.projects.project2.description': 'منشأة بحثية متطورة مصممة للدراسات المتقدمة والابتكار في مختلف المجالات.',
    'school.projects.project2.location': 'الرياض',
    'school.projects.project2.status': 'قيد التنفيذ',
    'school.projects.project2.completion': '2024',
    'school.projects.project2.size': '380,000 قدم مربع',
    'school.projects.project2.value': '90 مليون دولار',
    'school.projects.project2.features.research': 'مختبرات البحوث',
    'school.projects.project2.features.conference': 'مراكز المؤتمرات',
    'school.projects.project2.features.innovation': 'مراكز الابتكار',
    'school.projects.project2.features.collaborative': 'مساحات تعاونية',
    
    // School Sector Page Content - Arabic
    'school.hero.title': 'قطاع',
    'school.hero.highlight': 'التعليم',
    'school.hero.subtitle': 'بناء المستقبل من خلال المرافق التعليمية المبتكرة التي تلهم التعلم والنمو',
    'school.overview.title': 'التميز والابتكار التعليمي',
    'school.overview.description': 'خبرتنا في قطاع المدارس تغطي المؤسسات التعليمية والجامعات ومراكز التعلم. نركز على إنشاء بيئات تعزز التميز الأكاديمي والتطوير الشخصي.',
    'school.overview.feature1': 'بيئات تعلم حديثة',
    'school.overview.feature2': 'تكامل التكنولوجيا',
    'school.overview.feature3': 'مساحات تعاونية',
    'school.overview.feature4': 'تصميم مستدام',
    'school.overview.stats.projects': 'مشاريع تعليمية',
    'school.overview.stats.experience': 'سنوات خبرة',
    'school.overview.card.title': 'المشاريع التعليمية',
    'school.overview.card.description': 'لقد نجحنا في تسليم مشاريع تعليمية، مما أدى إلى إنشاء بيئات تعلم تلهم الطلاب والمعلمين على حد سواء.',
    'school.projects.title': 'مشاريعنا التعليمية',
    'school.projects.subtitle': 'اكتشف محفظتنا من المرافق التعليمية المبتكرة التي تشكل مستقبل التعلم',
    'school.project.category': 'تعليمي',
    'school.project.status.completed': 'مكتمل',
    'school.project.status.ongoing': 'قيد التنفيذ',
    'school.project.location': 'الموقع:',
    'school.project.size': 'المساحة:',
    'school.project.value': 'القيمة:',
    'school.project.features': 'الميزات الرئيسية',
    'school.cta.title': 'مستعد لبناء منشأتك التعليمية؟',
    'school.cta.subtitle': 'دعنا نناقش كيف يمكننا إحياء رؤيتك التعليمية بخبرتنا في بناء وتطوير المدارس.',
    'school.cta.startProject': 'ابدأ مشروعك',
    'school.cta.exploreSectors': 'استكشف القطاعات الأخرى',
    
    // School Services - Arabic
    'school.services.title': 'خدمات البناء التعليمي لدينا',
    'school.services.subtitle': 'حلول بناء تعليمي شاملة لبيئات تعلم ملهمة',
    'school.services.universities.title': 'الجامعات',
    'school.services.universities.description': 'مؤسسات التعليم العالي مع مرافق بحث متقدمة وبنية تحتية حديثة',
    'school.services.universities.feature1': 'مختبرات البحث',
    'school.services.universities.feature2': 'قاعات المحاضرات',
    'school.services.universities.feature3': 'سكن الطلاب',
    'school.services.universities.feature4': 'مرافق المكتبة',
    'school.services.schools.title': 'المدارس',
    'school.services.schools.description': 'مرافق التعليم الابتدائي والثانوي مع فصول دراسية حديثة ومرافق',
    'school.services.schools.feature1': 'فصول دراسية حديثة',
    'school.services.schools.feature2': 'مختبرات العلوم',
    'school.services.schools.feature3': 'مرافق رياضية',
    'school.services.schools.feature4': 'مساحات الكافتيريا',
    'school.services.kindergartens.title': 'رياض الأطفال',
    'school.services.kindergartens.description': 'مراكز تعليم الطفولة المبكرة مع بيئات آمنة ومحفزة',
    'school.services.kindergartens.feature1': 'مناطق اللعب',
    'school.services.kindergartens.feature2': 'ميزات السلامة',
    'school.services.kindergartens.feature3': 'زوايا التعلم',
    'school.services.kindergartens.feature4': 'مساحات خارجية',
    'school.services.training.title': 'مراكز التدريب',
    'school.services.training.description': 'مرافق التطوير المهني والتدريب المهني',
    'school.services.training.feature1': 'مساحات الورش',
    'school.services.training.feature2': 'غرف المعدات',
    'school.services.training.feature3': 'قاعات المؤتمرات',
    'school.services.training.feature4': 'مختبرات عملية',
    'school.services.libraries.title': 'المكتبات',
    'school.services.libraries.description': 'مرافق مكتبة حديثة مع موارد رقمية ومساحات دراسة',
    'school.services.libraries.feature1': 'موارد رقمية',
    'school.services.libraries.feature2': 'مناطق الدراسة',
    'school.services.libraries.feature3': 'مساحات جماعية',
    'school.services.libraries.feature4': 'الوصول للتكنولوجيا',
    'school.services.sports.title': 'المرافق الرياضية',
    'school.services.sports.description': 'مرافق رياضية وترفيهية شاملة للمؤسسات التعليمية',
    'school.services.sports.feature1': 'صالات الألعاب الرياضية',
    'school.services.sports.feature2': 'ملاعب اللعب',
    'school.services.sports.feature3': 'مسابح',
    'school.services.sports.feature4': 'تخزين المعدات',
    
    // Utilities Sector Projects - Arabic
    'utilities.projects.project1.title': 'محطة طاقة شمسية',
    'utilities.projects.project1.description': 'منشأة طاقة شمسية واسعة النطاق مصممة لتوفير طاقة نظيفة ومتجددة للمنطقة.',
    'utilities.projects.project1.location': 'جدة',
    'utilities.projects.project1.status': 'مكتمل',
    'utilities.projects.project1.completion': '2023',
    'utilities.projects.project1.size': '800,000 قدم مربع',
    'utilities.projects.project1.value': '150 مليون دولار',
    'utilities.projects.project1.features.solar': 'ألواح شمسية',
    'utilities.projects.project1.features.storage': 'تخزين الطاقة',
    'utilities.projects.project1.features.grid': 'تكامل الشبكة',
    'utilities.projects.project1.features.monitoring': 'أنظمة المراقبة',
    
    'utilities.projects.project2.title': 'منشأة معالجة المياه',
    'utilities.projects.project2.description': 'محطة تنقية مياه حديثة مع تقنيات ترشيح ومعالجة متقدمة.',
    'utilities.projects.project2.location': 'الرياض',
    'utilities.projects.project2.status': 'قيد التنفيذ',
    'utilities.projects.project2.completion': '2024',
    'utilities.projects.project2.size': '350,000 قدم مربع',
    'utilities.projects.project2.value': '95 مليون دولار',
    'utilities.projects.project2.features.filtration': 'ترشيح متقدم',
    'utilities.projects.project2.features.purification': 'تنقية المياه',
    'utilities.projects.project2.features.quality': 'مراقبة الجودة',
    'utilities.projects.project2.features.distribution': 'أنظمة التوزيع',
    
    // Utilities Sector Page Content - Arabic
    'utilities.hero.title': 'قطاع',
    'utilities.hero.highlight': 'المرافق',
    'utilities.hero.subtitle': 'دفع التقدم بالطاقة المستدامة وحلول البنية التحتية الأساسية',
    'utilities.overview.title': 'التميز والابتكار في البنية التحتية',
    'utilities.overview.description': 'خبرتنا في قطاع المرافق تغطي محطات الطاقة ومنشآت معالجة المياه ومشاريع البنية التحتية. نركز على الاستدامة والكفاءة والموثوقية لإنشاء خدمات أساسية للمجتمعات.',
    'utilities.overview.feature1': 'حلول الطاقة المستدامة',
    'utilities.overview.feature2': 'بنية تحتية متقدمة',
    'utilities.overview.feature3': 'الامتثال البيئي',
    'utilities.overview.feature4': 'عمليات موثوقة',
    'utilities.overview.stats.projects': 'مشاريع مرافق',
    'utilities.overview.stats.experience': 'سنوات خبرة',
    'utilities.overview.card.title': 'مشاريع المرافق',
    'utilities.overview.card.description': 'لقد نجحنا في تسليم مشاريع مرافق، مما أدى إلى إنشاء بنية تحتية أساسية تدفع المجتمعات والتقدم.',
    'utilities.projects.title': 'مشاريعنا في المرافق',
    'utilities.projects.subtitle': 'اكتشف محفظتنا من مشاريع البنية التحتية المبتكرة التي تدفع المستقبل',
    'utilities.project.category': 'مرافق',
    'utilities.project.status.completed': 'مكتمل',
    'utilities.project.status.ongoing': 'قيد التنفيذ',
    'utilities.project.location': 'الموقع:',
    'utilities.project.size': 'المساحة:',
    'utilities.project.value': 'القيمة:',
    'utilities.project.features': 'الميزات الرئيسية',
    'utilities.cta.title': 'مستعد لبناء مشروع البنية التحتية الخاص بك؟',
    'utilities.cta.subtitle': 'دعنا نناقش كيف يمكننا إحياء رؤيتك في المرافق بخبرتنا في بناء وتطوير البنية التحتية.',
    'utilities.cta.startProject': 'ابدأ مشروعك',
    'utilities.cta.exploreSectors': 'استكشف القطاعات الأخرى',
    
    // Utilities Services - Arabic
    'utilities.services.title': 'خدمات البناء للمرافق لدينا',
    'utilities.services.subtitle': 'حلول بناء المرافق الشاملة للبنية التحتية والخدمات الأساسية',
    'utilities.services.power.title': 'محطات الطاقة',
    'utilities.services.power.description': 'مرافق توليد الكهرباء بما في ذلك مصادر الطاقة التقليدية والمتجددة',
    'utilities.services.power.feature1': 'توليد الطاقة',
    'utilities.services.power.feature2': 'اتصال الشبكة',
    'utilities.services.power.feature3': 'أنظمة النسخ الاحتياطي',
    'utilities.services.power.feature4': 'مرافق الصيانة',
    'utilities.services.water.title': 'معالجة المياه',
    'utilities.services.water.description': 'أنظمة معالجة وتوزيع المياه لإمداد المياه النظيفة',
    'utilities.services.water.feature1': 'محطات المعالجة',
    'utilities.services.water.feature2': 'شبكات التوزيع',
    'utilities.services.water.feature3': 'خزانات التخزين',
    'utilities.services.water.feature4': 'مراقبة الجودة',
    'utilities.services.sewage.title': 'أنظمة الصرف الصحي',
    'utilities.services.sewage.description': 'بنية تحتية لجمع ومعالجة مياه الصرف الصحي',
    'utilities.services.sewage.feature1': 'أنظمة الجمع',
    'utilities.services.sewage.feature2': 'محطات المعالجة',
    'utilities.services.sewage.feature3': 'محطات الضخ',
    'utilities.services.sewage.feature4': 'الامتثال البيئي',
    'utilities.services.gas.title': 'بنية الغاز التحتية',
    'utilities.services.gas.description': 'مرافق توزيع وتخزين الغاز الطبيعي',
    'utilities.services.gas.feature1': 'شبكات التوزيع',
    'utilities.services.gas.feature2': 'مرافق التخزين',
    'utilities.services.gas.feature3': 'محطات الضغط',
    'utilities.services.gas.feature4': 'أنظمة السلامة',
    'utilities.services.telecom.title': 'الاتصالات',
    'utilities.services.telecom.description': 'بنية تحتية للاتصالات بما في ذلك الأبراج والشبكات الليفية',
    'utilities.services.telecom.feature1': 'أبراج الاتصالات',
    'utilities.services.telecom.feature2': 'الشبكات الليفية',
    'utilities.services.telecom.feature3': 'مراكز البيانات',
    'utilities.services.telecom.feature4': 'غرف المعدات',
    'utilities.services.renewable.title': 'الطاقة المتجددة',
    'utilities.services.renewable.description': 'بنية تحتية للطاقة الشمسية والرياح ومصادر الطاقة المتجددة الأخرى',
    'utilities.services.renewable.feature1': 'مزارع الطاقة الشمسية',
    'utilities.services.renewable.feature2': 'مزارع الرياح',
    'utilities.services.renewable.feature3': 'تخزين الطاقة',
    'utilities.services.renewable.feature4': 'تكامل الشبكة',
    
    // Warehouse Sector Projects - Arabic
    'warehouse.projects.project1.title': 'مركز التوزيع الحديث',
    'warehouse.projects.project1.description': 'منشأة لوجستية متطورة مصممة لعمليات التخزين والتوزيع الفعالة.',
    'warehouse.projects.project1.location': 'جدة',
    'warehouse.projects.project1.status': 'مكتمل',
    'warehouse.projects.project1.completion': '2023',
    'warehouse.projects.project1.size': '500,000 قدم مربع',
    'warehouse.projects.project1.value': '75 مليون دولار',
    'warehouse.projects.project1.features.storage': 'تخزين آلي',
    'warehouse.projects.project1.features.docks': 'أرصفة التحميل',
    'warehouse.projects.project1.features.security': 'أنظمة الأمان',
    'warehouse.projects.project1.features.climate': 'التحكم في المناخ',
    
    'warehouse.projects.project2.title': 'منشأة التخزين المبرد',
    'warehouse.projects.project2.description': 'مستودع متخصص مع بيئات محكومة بدرجة الحرارة للبضائع القابلة للتلف.',
    'warehouse.projects.project2.location': 'الرياض',
    'warehouse.projects.project2.status': 'قيد التنفيذ',
    'warehouse.projects.project2.completion': '2024',
    'warehouse.projects.project2.size': '300,000 قدم مربع',
    'warehouse.projects.project2.value': '60 مليون دولار',
    'warehouse.projects.project2.features.temperature': 'التحكم في درجة الحرارة',
    'warehouse.projects.project2.features.refrigeration': 'أنظمة التبريد',
    'warehouse.projects.project2.features.quality': 'مراقبة الجودة',
    'warehouse.projects.project2.features.layout': 'تخطيط فعال',
    
    // Warehouse Sector Page Content - Arabic
    'warehouse.hero.title': 'قطاع',
    'warehouse.hero.highlight': 'المستودعات',
    'warehouse.hero.subtitle': 'بناء حلول التخزين واللوجستيات الفعالة التي تدفع التميز في سلسلة التوريد',
    'warehouse.overview.title': 'التميز والابتكار في اللوجستيات',
    'warehouse.overview.description': 'خبرتنا في قطاع المستودعات تغطي مرافق التخزين ومراكز اللوجستيات ومحاور التوزيع. نركز على الكفاءة والأتمتة والتحسين لإنشاء مساحات تعظم الأداء التشغيلي.',
    'warehouse.overview.feature1': 'حلول التخزين الفعالة',
    'warehouse.overview.feature2': 'أنظمة آلية',
    'warehouse.overview.feature3': 'الأمان والحماية',
    'warehouse.overview.feature4': 'سير العمل المحسن',
    'warehouse.overview.stats.projects': 'مشاريع مستودعات',
    'warehouse.overview.stats.experience': 'سنوات خبرة',
    'warehouse.overview.card.title': 'مشاريع المستودعات',
    'warehouse.overview.card.description': 'لقد نجحنا في تسليم مشاريع مستودعات، مما أدى إلى إنشاء حلول تخزين ولوجستيات فعالة تحسن عمليات سلسلة التوريد.',
    'warehouse.projects.title': 'مشاريعنا في المستودعات',
    'warehouse.projects.subtitle': 'اكتشف محفظتنا من مرافق التخزين واللوجستيات المبتكرة التي تحسن سلاسل التوريد',
    'warehouse.project.category': 'مستودع',
    'warehouse.project.status.completed': 'مكتمل',
    'warehouse.project.status.ongoing': 'قيد التنفيذ',
    'warehouse.project.location': 'الموقع:',
    'warehouse.project.size': 'المساحة:',
    'warehouse.project.value': 'القيمة:',
    'warehouse.project.features': 'الميزات الرئيسية',
    'warehouse.cta.title': 'مستعد لبناء مشروع المستودع الخاص بك؟',
    'warehouse.cta.subtitle': 'دعنا نناقش كيف يمكننا إحياء رؤيتك اللوجستية بخبرتنا في بناء وتطوير المستودعات.',
    'warehouse.cta.startProject': 'ابدأ مشروعك',
    'warehouse.cta.exploreSectors': 'استكشف القطاعات الأخرى',
    
    // Warehouse Services - Arabic
    'warehouse.services.title': 'خدمات البناء للمستودعات لدينا',
    'warehouse.services.subtitle': 'حلول بناء المستودعات الشاملة لعمليات التخزين واللوجستيات الفعالة',
    'warehouse.services.distribution.title': 'مراكز التوزيع',
    'warehouse.services.distribution.description': 'مرافق توزيع واسعة النطاق مع أنظمة لوجستية وأتمتة متقدمة',
    'warehouse.services.distribution.feature1': 'أنظمة مؤتمتة',
    'warehouse.services.distribution.feature2': 'أرصفة التحميل',
    'warehouse.services.distribution.feature3': 'أنظمة الفرز',
    'warehouse.services.distribution.feature4': 'إدارة الأسطول',
    'warehouse.services.cold.title': 'التخزين البارد',
    'warehouse.services.cold.description': 'مرافق تخزين مكيفة للبضائع القابلة للتلف والأدوية',
    'warehouse.services.cold.feature1': 'التحكم في المناخ',
    'warehouse.services.cold.feature2': 'مراقبة درجة الحرارة',
    'warehouse.services.cold.feature3': 'كفاءة الطاقة',
    'warehouse.services.cold.feature4': 'أنظمة السلامة',
    'warehouse.services.retail.title': 'مستودعات التجزئة',
    'warehouse.services.retail.description': 'مراكز توزيع تجزئة حديثة مع إدارة مخزون فعالة',
    'warehouse.services.retail.feature1': 'أنظمة المخزون',
    'warehouse.services.retail.feature2': 'معالجة الطلبات',
    'warehouse.services.retail.feature3': 'مراقبة الجودة',
    'warehouse.services.retail.feature4': 'معالجة المرتجعات',
    'warehouse.services.industrial.title': 'التخزين الصناعي',
    'warehouse.services.industrial.description': 'مرافق تخزين ثقيلة للمواد والمعدات الصناعية',
    'warehouse.services.industrial.feature1': 'أرضيات ثقيلة',
    'warehouse.services.industrial.feature2': 'أنظمة الرافعات',
    'warehouse.services.industrial.feature3': 'معالجة المواد',
    'warehouse.services.industrial.feature4': 'بروتوكولات السلامة',
    'warehouse.services.ecommerce.title': 'تنفيذ التجارة الإلكترونية',
    'warehouse.services.ecommerce.description': 'مراكز تنفيذ متخصصة لعمليات البيع بالتجزئة والتجارة الإلكترونية عبر الإنترنت',
    'warehouse.services.ecommerce.feature1': 'تنفيذ الطلبات',
    'warehouse.services.ecommerce.feature2': 'محطات التعبئة',
    'warehouse.services.ecommerce.feature3': 'مناطق الشحن',
    'warehouse.services.ecommerce.feature4': 'تكامل التكنولوجيا',
    'warehouse.services.custom.title': 'مستودعات مخصصة',
    'warehouse.services.custom.description': 'حلول مستودعات مصممة خصيصاً لمتطلبات الصناعة المحددة',
    'warehouse.services.custom.feature1': 'تصميم مخصص',
    'warehouse.services.custom.feature2': 'تخطيطات مرنة',
    'warehouse.services.custom.feature3': 'معدات متخصصة',
    'warehouse.services.custom.feature4': 'حلول قابلة للتوسع',
    
    // Building & Infrastructure Service - Arabic
    'buildingInfrastructure.hero.title': 'البناء و',
    'buildingInfrastructure.hero.highlight': 'البنية التحتية',
    'buildingInfrastructure.hero.subtitle': 'خدمات بناء شاملة للمباني التجارية والسكنية والصناعية مع تطوير البنية التحتية الحديثة',
    'buildingInfrastructure.overview.title': 'التميز في البناء',
    'buildingInfrastructure.overview.highlight': 'من الأساس إلى التشطيب',
    'buildingInfrastructure.overview.description1': 'قسم البناء والبنية التحتية لدينا يقدم حلول بناء شاملة، من التخطيط الأولي إلى التسليم النهائي. نتخصص في إنشاء هياكل مستدامة ومبتكرة وعالية الجودة تتحمل اختبار الزمن.',
    'buildingInfrastructure.overview.description2': 'مع أكثر من عقدين من الخبرة، نجحنا في إكمال مئات المشاريع عبر مختلف القطاعات، مما جعلنا شريكاً موثوقاً لجميع احتياجاتك الإنشائية. نهجنا الشامل يشمل كل شيء من إعداد الموقع وأعمال الأساس إلى الهندسة الإنشائية واللمسات الأخيرة.',
    'buildingInfrastructure.overview.description3': 'نستخدم أحدث تقنيات البناء والممارسات الإنشائية المستدامة وإجراءات مراقبة الجودة الصارمة لضمان أن كل مشروع يلبي أعلى المعايير. فريقنا من المهندسين المعتمدين والمهندسين المعماريين والمهنيين الإنشائيين يعملون بشكل تعاوني لتسليم المشاريع في الوقت المحدد، ضمن الميزانية، وتجاوز التوقعات.',
    'buildingInfrastructure.overview.description4': 'من المجمعات السكنية والمباني التجارية إلى المرافق الصناعية ومشاريع البنية التحتية، لدينا الخبرة والموارد للتعامل مع مشاريع أي حجم وتعقيد. التزامنا بالسلامة والمسؤولية البيئية ورضا العملاء يدفع كل جانب من جوانب عملية البناء لدينا.',
    'buildingInfrastructure.overview.stats.projects': 'مشروع مكتمل',
    'buildingInfrastructure.overview.stats.experience': 'سنوات خبرة',
    'buildingInfrastructure.fallback.title': 'البناء والبنية التحتية',
    'buildingInfrastructure.services.title': 'خدمات البناء لدينا',
    'buildingInfrastructure.services.subtitle': 'حلول بناء شاملة مصممة لتلبية متطلباتك المحددة',
    'buildingInfrastructure.services.commercial.title': 'البناء التجاري',
    'buildingInfrastructure.services.commercial.description': 'مباني المكاتب ومساحات البيع بالتجزئة ومراكز التسوق والمجمعات التجارية',
    'buildingInfrastructure.services.commercial.feature1': 'مساحات مكاتب حديثة',
    'buildingInfrastructure.services.commercial.feature2': 'بيئات البيع بالتجزئة',
    'buildingInfrastructure.services.commercial.feature3': 'مراكز التسوق',
    'buildingInfrastructure.services.commercial.feature4': 'المجمعات التجارية',
    'buildingInfrastructure.services.residential.title': 'البناء السكني',
    'buildingInfrastructure.services.residential.description': 'المنازل الفاخرة ومباني الشقق والمجتمعات السكنية',
    'buildingInfrastructure.services.residential.feature1': 'المنازل الفاخرة',
    'buildingInfrastructure.services.residential.feature2': 'مباني الشقق',
    'buildingInfrastructure.services.residential.feature3': 'المجتمعات السكنية',
    'buildingInfrastructure.services.residential.feature4': 'التصاميم المخصصة',
    'buildingInfrastructure.services.industrial.title': 'المرافق الصناعية',
    'buildingInfrastructure.services.industrial.description': 'مصانع التصنيع والمستودعات والمجمعات الصناعية',
    'buildingInfrastructure.services.industrial.feature1': 'مصانع التصنيع',
    'buildingInfrastructure.services.industrial.feature2': 'المستودعات',
    'buildingInfrastructure.services.industrial.feature3': 'المجمعات الصناعية',
    'buildingInfrastructure.services.industrial.feature4': 'المرافق المتخصصة',
    'buildingInfrastructure.services.infrastructure.title': 'تطوير البنية التحتية',
    'buildingInfrastructure.services.infrastructure.description': 'الطرق والجسور والمرافق ومشاريع البنية التحتية العامة',
    'buildingInfrastructure.services.infrastructure.feature1': 'بناء الطرق',
    'buildingInfrastructure.services.infrastructure.feature2': 'هندسة الجسور',
    'buildingInfrastructure.services.infrastructure.feature3': 'أنظمة المرافق',
    'buildingInfrastructure.services.infrastructure.feature4': 'البنية التحتية العامة',
    'buildingInfrastructure.services.foundation.title': 'أعمال الأساس والهيكل',
    'buildingInfrastructure.services.foundation.description': 'أنظمة أساس قوية وحلول الهندسة الإنشائية',
    'buildingInfrastructure.services.foundation.feature1': 'أنظمة الأساس',
    'buildingInfrastructure.services.foundation.feature2': 'الهندسة الإنشائية',
    'buildingInfrastructure.services.foundation.feature3': 'الهياكل الحاملة',
    'buildingInfrastructure.services.foundation.feature4': 'التصميم الزلزالي',
    'buildingInfrastructure.services.management.title': 'إدارة المشاريع',
    'buildingInfrastructure.services.management.description': 'تنسيق المشاريع الشامل وضمان الجودة',
    'buildingInfrastructure.services.management.feature1': 'تنسيق المشاريع',
    'buildingInfrastructure.services.management.feature2': 'ضمان الجودة',
    'buildingInfrastructure.services.management.feature3': 'إدارة الجدول الزمني',
    'buildingInfrastructure.services.management.feature4': 'التحكم في التكلفة',
    'buildingInfrastructure.whyChoose.title': 'لماذا تختار FMC للبناء والبنية التحتية؟',
    'buildingInfrastructure.whyChoose.subtitle': 'التزامنا بالتميز والابتكار ورضا العملاء يميزنا في صناعة البناء.',
    'buildingInfrastructure.whyChoose.trackRecord.title': 'سجل حافل مثبت',
    'buildingInfrastructure.whyChoose.trackRecord.description': 'أكثر من 500 مشروع ناجح مكتمل بجودة استثنائية وتسليم في الوقت المحدد',
    'buildingInfrastructure.whyChoose.expertTeam.title': 'فريق خبير',
    'buildingInfrastructure.whyChoose.expertTeam.description': 'محترفون ذوو مهارات عالية مع عقود من الخبرة المجتمعة في البناء',
    'buildingInfrastructure.whyChoose.quality.title': 'ضمان الجودة',
    'buildingInfrastructure.whyChoose.quality.description': 'عمليات مراقبة جودة صارمة تضمن أعلى المعايير في كل مشروع',
    'buildingInfrastructure.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'buildingInfrastructure.whyChoose.delivery.description': 'إدارة مشاريع فعالة تضمن الإكمال في الوقت المحدد ضمن الميزانية',
    'buildingInfrastructure.whyChoose.card.title': 'التميز في كل مشروع',
    'buildingInfrastructure.whyChoose.card.subtitle': 'بناء المستقبل، مشروع واحد في كل مرة',
    'buildingInfrastructure.cta.title': 'مستعد لبدء مشروع البناء الخاص بك؟',
    'buildingInfrastructure.cta.subtitle': 'دعنا نناقش احتياجاتك الإنشائية ونخلق شيئاً استثنائياً معاً',
    'buildingInfrastructure.cta.consultation': 'احصل على استشارة مجانية',
    'buildingInfrastructure.cta.callNow': 'اتصل الآن',
    
    // Design & Engineering Service - Arabic
    'designEngineering.hero.title': 'التصميم و',
    'designEngineering.hero.highlight': 'الهندسة',
    'designEngineering.hero.subtitle': 'خدمات التصميم المعماري والهندسي المهنية مع الحلول المبتكرة والخبرة التقنية',
    'designEngineering.overview.title': 'التصميم المبتكر',
    'designEngineering.overview.highlight': 'يلتقي بالتميز الهندسي',
    'designEngineering.overview.description1': 'فريق التصميم والهندسة لدينا يجمع بين الرؤية الإبداعية والدقة التقنية لتقديم حلول معمارية وهندسية استثنائية. نحول المفاهيم إلى واقع من خلال نهج التصميم المبتكرة والممارسات الهندسية المتطورة.',
    'designEngineering.overview.description2': 'من تطوير المفهوم الأولي إلى الوثائق التقنية التفصيلية، نضمن أن كل مشروع يلبي أعلى معايير التميز في التصميم والنزاهة الهندسية. فريقنا متعدد التخصصات يشمل مهندسين معماريين مرخصين ومهندسين إنشائيين ومهندسي MEP ومتخصصي التصميم الذين يتعاونون بسلاسة لإنشاء حلول متكاملة.',
    'designEngineering.overview.description3': 'نستفيد من برامج التصميم المتقدمة ونمذجة معلومات البناء (BIM) ومبادئ التصميم المستدام لتحسين أداء المباني وكفاءة الطاقة وراحة المستخدمين. حلولنا الهندسية تدمج أحدث التقنيات مع الحفاظ على الفعالية من حيث التكلفة والقابلية للبناء.',
    'designEngineering.overview.description4': 'عملية التصميم لدينا تؤكد على التعاون مع العملاء والامتثال للوائح وحل المشاكل المبتكرة. نقدم خدمات تصميم شاملة تشمل التصميم المعماري والهندسة الإنشائية وتصميم MEP والتصميم الداخلي ووثائق المشروع لضمان تسليم المشروع بسلاسة من المفهوم إلى الإكمال.',
    'designEngineering.overview.stats.designs': 'تصميم تم إنشاؤه',
    'designEngineering.overview.stats.experience': 'سنوات خبرة',
    'designEngineering.fallback.title': 'التصميم والهندسة',
    'designEngineering.services.title': 'خدمات التصميم والهندسة لدينا',
    'designEngineering.services.subtitle': 'حلول تصميم وهندسة شاملة لجميع احتياجات مشروعك',
    'designEngineering.services.architectural.title': 'التصميم المعماري',
    'designEngineering.services.architectural.description': 'حلول معمارية إبداعية ووظيفية لجميع أنواع المشاريع',
    'designEngineering.services.architectural.feature1': 'تطوير المفهوم',
    'designEngineering.services.architectural.feature2': 'تخطيط المساحات',
    'designEngineering.services.architectural.feature3': 'التصميم الجمالي',
    'designEngineering.services.architectural.feature4': 'الامتثال لقوانين البناء',
    'designEngineering.services.structural.title': 'الهندسة الإنشائية',
    'designEngineering.services.structural.description': 'تحليل وتصميم إنشائي قوي للأمان والمتانة',
    'designEngineering.services.structural.feature1': 'التحليل الإنشائي',
    'designEngineering.services.structural.feature2': 'حسابات الأحمال',
    'designEngineering.services.structural.feature3': 'تصميم الأساس',
    'designEngineering.services.structural.feature4': 'الهندسة الزلزالية',
    'designEngineering.services.mep.title': 'تصميم هندسة MEP',
    'designEngineering.services.mep.description': 'تصميم وتحسين أنظمة الميكانيكا والكهرباء والسباكة',
    'designEngineering.services.mep.feature1': 'تصميم HVAC',
    'designEngineering.services.mep.feature2': 'الأنظمة الكهربائية',
    'designEngineering.services.mep.feature3': 'تصميم السباكة',
    'designEngineering.services.mep.feature4': 'كفاءة الطاقة',
    'designEngineering.services.modeling.title': 'النمذجة ثلاثية الأبعاد والتصور',
    'designEngineering.services.modeling.description': 'النمذجة ثلاثية الأبعاد المتقدمة وتصور المشروع الواقعي',
    'designEngineering.services.modeling.feature1': 'النمذجة ثلاثية الأبعاد',
    'designEngineering.services.modeling.feature2': 'الرسم',
    'designEngineering.services.modeling.feature3': 'الجولات الافتراضية',
    'designEngineering.services.modeling.feature4': 'الرسوم المتحركة',
    'designEngineering.services.documentation.title': 'الوثائق التقنية',
    'designEngineering.services.documentation.description': 'الرسومات التقنية الشاملة ووثائق المشروع',
    'designEngineering.services.documentation.feature1': 'رسومات البناء',
    'designEngineering.services.documentation.feature2': 'المواصفات',
    'designEngineering.services.documentation.feature3': 'التقارير التقنية',
    'designEngineering.services.documentation.feature4': 'الوثائق كما تم البناء',
    'designEngineering.services.optimization.title': 'تحسين التصميم',
    'designEngineering.services.optimization.description': 'حلول تحسين الأداء والهندسة القيمة',
    'designEngineering.services.optimization.feature1': 'تحسين التكلفة',
    'designEngineering.services.optimization.feature2': 'تحليل الأداء',
    'designEngineering.services.optimization.feature3': 'الاستدامة',
    'designEngineering.services.optimization.feature4': 'الهندسة القيمة',
    'designEngineering.whyChoose.title': 'لماذا تختار FMC للتصميم والهندسة؟',
    'designEngineering.whyChoose.subtitle': 'خبرتنا في التصميم والهندسة، مقترنة بالتقنيات المبتكرة والحلول الإبداعية، تقدم نتائج استثنائية.',
    'designEngineering.whyChoose.experts.title': 'مصممون خبراء',
    'designEngineering.whyChoose.experts.description': 'مهندسون معماريون ومصممون مؤهلون تأهيلاً عالياً مع خبرة واسعة في الصناعة',
    'designEngineering.whyChoose.engineering.title': 'التميز الهندسي',
    'designEngineering.whyChoose.engineering.description': 'مهندسون محترفون يضمنون النزاهة الإنشائية والدقة التقنية',
    'designEngineering.whyChoose.innovation.title': 'حلول مبتكرة',
    'designEngineering.whyChoose.innovation.description': 'نهج تصميم متطورة ومنهجيات هندسية حديثة',
    'designEngineering.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'designEngineering.whyChoose.delivery.description': 'إدارة مشاريع فعالة تضمن إكمال التصميم في الوقت المحدد',
    'designEngineering.whyChoose.card.title': 'تصميم مساحات الغد',
    'designEngineering.whyChoose.card.subtitle': 'حيث تلتقي الإبداعية بالتميز الهندسي',
    'designEngineering.cta.title': 'مستعد لتصميم رؤيتك؟',
    'designEngineering.cta.subtitle': 'دعنا نتعاون لإنشاء حلول تصميم وهندسة مبتكرة لمشروعك',
    'designEngineering.cta.consultation': 'ابدأ استشارة التصميم',
    'designEngineering.cta.callNow': 'اتصل الآن',
    
    // Architectural Fitout Service - Arabic
    'architecturalFitout.hero.title': 'التشطيب',
    'architecturalFitout.hero.highlight': 'المعماري',
    'architecturalFitout.hero.subtitle': 'خدمات التصميم الداخلي والتشطيب المعماري المهنية لإنشاء مساحات وظيفية وجمالية',
    'architecturalFitout.overview.title': 'حول مساحتك',
    'architecturalFitout.overview.highlight': 'بحلول التشطيب الخبيرة',
    'architecturalFitout.overview.description1': 'فريق التشطيب المعماري لدينا متخصص في تحويل المساحات الداخلية إلى بيئات وظيفية وجميلة وفعالة. نجمع بين التصميم الإبداعي والحلول العملية لإنشاء مساحات تعزز الإنتاجية والرفاهية.',
    'architecturalFitout.overview.description2': 'من المفهوم إلى الإكمال، نتعامل مع كل جانب من جوانب التشطيب الداخلي بما في ذلك تخطيط المساحات واختيار المواد وتصميم الأثاث المخصص والتركيب. فريقنا ذو الخبرة يضمن أن كل مشروع يلبي أعلى معايير الجودة والحرفية.',
    'architecturalFitout.overview.description3': 'نعمل بشكل وثيق مع العملاء لفهم رؤيتهم ومتطلباتهم، ونقدم حلولاً مخصصة تعكس هويتهم التجارية واحتياجاتهم التشغيلية. خدمات التشطيب لدينا تغطي المكاتب ومساحات البيع بالتجزئة والأماكن الفندقية والممتلكات السكنية.',
    'architecturalFitout.overview.description4': 'نهجنا الشامل يشمل التخطيط التفصيلي للمشروع والتصور ثلاثي الأبعاد وتوريد المواد والتركيب المهني. نضمن التسليم في الوقت المحدد والجودة الاستثنائية مع الحفاظ على الفعالية من حيث التكلفة والاستدامة.',
    'architecturalFitout.overview.stats.projects': 'مشاريع التشطيب',
    'architecturalFitout.overview.stats.experience': 'سنوات خبرة',
    'architecturalFitout.fallback.title': 'التشطيب المعماري',
    'architecturalFitout.services.title': 'خدمات التشطيب لدينا',
    'architecturalFitout.services.subtitle': 'حلول التصميم الداخلي والتشطيب الكاملة لجميع متطلبات مساحتك',
    'architecturalFitout.services.office.title': 'تشطيب المكاتب',
    'architecturalFitout.services.office.description': 'مساحات مكتبية حديثة مصممة للإنتاجية والتعاون',
    'architecturalFitout.services.office.feature1': 'تصميم محطات العمل',
    'architecturalFitout.services.office.feature2': 'غرف الاجتماعات',
    'architecturalFitout.services.office.feature3': 'مناطق الاستقبال',
    'architecturalFitout.services.office.feature4': 'مساحات الاستراحة',
    'architecturalFitout.services.retail.title': 'تشطيب البيع بالتجزئة',
    'architecturalFitout.services.retail.description': 'مساحات بيع جذابة تعزز تجربة العملاء',
    'architecturalFitout.services.retail.feature1': 'تصميم تخطيط المتجر',
    'architecturalFitout.services.retail.feature2': 'أنظمة العرض',
    'architecturalFitout.services.retail.feature3': 'تصميم الإضاءة',
    'architecturalFitout.services.retail.feature4': 'تكامل العلامة التجارية',
    'architecturalFitout.services.hospitality.title': 'تشطيب فندقي',
    'architecturalFitout.services.hospitality.description': 'مساحات ترحيبية للفنادق والمطاعم والمقاهي',
    'architecturalFitout.services.hospitality.feature1': 'تصميم غرف الضيوف',
    'architecturalFitout.services.hospitality.feature2': 'مناطق الطعام',
    'architecturalFitout.services.hospitality.feature3': 'مساحات الاستقبال',
    'architecturalFitout.services.hospitality.feature4': 'مناطق المرافق',
    'architecturalFitout.services.residential.title': 'التشطيب السكني',
    'architecturalFitout.services.residential.description': 'ديكورات منزلية شخصية تعكس أسلوبك',
    'architecturalFitout.services.residential.feature1': 'مساحات المعيشة',
    'architecturalFitout.services.residential.feature2': 'تصميم المطبخ',
    'architecturalFitout.services.residential.feature3': 'تصميم غرف النوم',
    'architecturalFitout.services.residential.feature4': 'حلول التخزين',
    'architecturalFitout.services.custom.title': 'الأثاث المخصص',
    'architecturalFitout.services.custom.description': 'أثاث وتركيبات مخصصة مصممة حسب احتياجاتك',
    'architecturalFitout.services.custom.feature1': 'التصميم المخصص',
    'architecturalFitout.services.custom.feature2': 'اختيار المواد',
    'architecturalFitout.services.custom.feature3': 'التصنيع',
    'architecturalFitout.services.custom.feature4': 'التركيب',
    'architecturalFitout.services.project.title': 'إدارة المشاريع',
    'architecturalFitout.services.project.description': 'تنسيق المشاريع الشامل وضمان الجودة',
    'architecturalFitout.services.project.feature1': 'إدارة الجدول الزمني',
    'architecturalFitout.services.project.feature2': 'مراقبة الجودة',
    'architecturalFitout.services.project.feature3': 'تنسيق الموردين',
    'architecturalFitout.services.project.feature4': 'التفتيش النهائي',
    'architecturalFitout.whyChoose.title': 'لماذا تختار FMC للتشطيب المعماري؟',
    'architecturalFitout.whyChoose.subtitle': 'خبرتنا في التصميم الداخلي والتشطيب، مقترنة بالاهتمام بالتفاصيل والحرفية عالية الجودة، تقدم نتائج استثنائية.',
    'architecturalFitout.whyChoose.design.title': 'التصميم الإبداعي',
    'architecturalFitout.whyChoose.design.description': 'حلول التصميم الداخلي المبتكرة التي تعظم إمكانات المساحة',
    'architecturalFitout.whyChoose.quality.title': 'الحرفية عالية الجودة',
    'architecturalFitout.whyChoose.quality.description': 'حرفيون مهرة يضمنون جودة فائقة واهتمام بالتفاصيل',
    'architecturalFitout.whyChoose.custom.title': 'الحلول المخصصة',
    'architecturalFitout.whyChoose.custom.description': 'حلول تشطيب مخصصة تلبي متطلباتك المحددة',
    'architecturalFitout.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'architecturalFitout.whyChoose.delivery.description': 'إدارة مشاريع فعالة تضمن الإكمال في الوقت المحدد',
    'architecturalFitout.whyChoose.card.title': 'إنشاء مساحات جميلة',
    'architecturalFitout.whyChoose.card.subtitle': 'حيث يلتقي التصميم بالوظائف',
    'architecturalFitout.cta.title': 'مستعد لتحويل مساحتك؟',
    'architecturalFitout.cta.subtitle': 'دعنا ننشئ ديكوراً داخلياً جميلاً ووظيفياً يعكس رؤيتك',
    'architecturalFitout.cta.consultation': 'ابدأ استشارة التصميم',
    'architecturalFitout.cta.callNow': 'اتصل الآن',
    
    // Civil Works Service - Arabic
    'civilWorks.hero.title': 'الأعمال',
    'civilWorks.hero.highlight': 'المدنية',
    'civilWorks.hero.subtitle': 'خدمات الهندسة المدنية وتطوير البنية التحتية الشاملة لجميع احتياجات البناء',
    'civilWorks.overview.title': 'بناء الأسس القوية',
    'civilWorks.overview.highlight': 'بتميز الهندسة المدنية',
    'civilWorks.overview.description1': 'قسم الأعمال المدنية لدينا متخصص في تطوير البنية التحتية، ويقدم حلول هندسة مدنية شاملة للطرق والجسور والمرافق والمنشآت العامة. نجمع بين الخبرة التقنية والنهج المبتكرة لتقديم مشاريع تعزز المجتمعات وتدعم النمو الاقتصادي.',
    'civilWorks.overview.description2': 'من التقييم الأولي للموقع إلى الإكمال النهائي، نتعامل مع كل جانب من جوانب البناء المدني بما في ذلك أعمال الحفر والأعمال الخرسانية وأنظمة الصرف وتركيب المرافق. فريقنا ذو الخبرة يضمن أن جميع المشاريع تلبي المتطلبات التنظيمية وتتجاوز معايير الجودة.',
    'civilWorks.overview.description3': 'نعمل مع الوكالات الحكومية والمطورين الخاصين والبلديات لتقديم مشاريع البنية التحتية التي تحسن الاتصال والأمان وجودة الحياة. خدماتنا تشمل بناء الطرق وهندسة الجسور ومرافق معالجة المياه وتطوير المساحات العامة.',
    'civilWorks.overview.description4': 'حلول الهندسة المدنية لدينا تدمج الممارسات المستدامة والمواد المتقدمة وتقنيات البناء الحديثة. نضمن الامتثال البيئي المناسب وبروتوكولات الأمان والمتانة طويلة المدى مع الحفاظ على الفعالية من حيث التكلفة والتسليم في الوقت المحدد.',
    'civilWorks.overview.stats.projects': 'مشاريع مدنية',
    'civilWorks.overview.stats.experience': 'سنوات خبرة',
    'civilWorks.fallback.title': 'الأعمال المدنية',
    'civilWorks.services.title': 'خدمات الأعمال المدنية لدينا',
    'civilWorks.services.subtitle': 'حلول الهندسة المدنية الكاملة لتطوير البنية التحتية والبناء',
    'civilWorks.services.roads.title': 'بناء الطرق',
    'civilWorks.services.roads.description': 'خدمات بناء الطرق عالية الجودة والصيانة',
    'civilWorks.services.roads.feature1': 'بناء الطرق السريعة',
    'civilWorks.services.roads.feature2': 'الطرق الحضرية',
    'civilWorks.services.roads.feature3': 'طرق الوصول الريفية',
    'civilWorks.services.roads.feature4': 'صيانة الطرق',
    'civilWorks.services.bridges.title': 'هندسة الجسور',
    'civilWorks.services.bridges.description': 'خدمات تصميم وبناء الجسور الإنشائية',
    'civilWorks.services.bridges.feature1': 'تصميم الجسور',
    'civilWorks.services.bridges.feature2': 'التحليل الإنشائي',
    'civilWorks.services.bridges.feature3': 'إشراف البناء',
    'civilWorks.services.bridges.feature4': 'برامج الصيانة',
    'civilWorks.services.utilities.title': 'بنية تحتية للمرافق',
    'civilWorks.services.utilities.description': 'تطوير أنظمة المياه والصرف والمرافق',
    'civilWorks.services.utilities.feature1': 'أنظمة المياه',
    'civilWorks.services.utilities.feature2': 'شبكات الصرف',
    'civilWorks.services.utilities.feature3': 'صرف العواصف',
    'civilWorks.services.utilities.feature4': 'تنسيق المرافق',
    'civilWorks.services.earthworks.title': 'أعمال الحفر والحفر',
    'civilWorks.services.earthworks.description': 'خدمات إعداد الموقع وأعمال الحفر',
    'civilWorks.services.earthworks.feature1': 'إزالة الموقع',
    'civilWorks.services.earthworks.feature2': 'الحفر',
    'civilWorks.services.earthworks.feature3': 'التسوية',
    'civilWorks.services.earthworks.feature4': 'الضغط',
    'civilWorks.services.concrete.title': 'البناء الخرساني',
    'civilWorks.services.concrete.description': 'الهياكل الخرسانية المسلحة والأساسات',
    'civilWorks.services.concrete.feature1': 'أعمال الأساس',
    'civilWorks.services.concrete.feature2': 'الخرسانة الإنشائية',
    'civilWorks.services.concrete.feature3': 'العناصر مسبقة الصنع',
    'civilWorks.services.concrete.feature4': 'مراقبة الجودة',
    'civilWorks.services.project.title': 'إدارة المشاريع',
    'civilWorks.services.project.description': 'تنسيق المشاريع الشامل والإشراف',
    'civilWorks.services.project.feature1': 'التخطيط والجدولة',
    'civilWorks.services.project.feature2': 'ضمان الجودة',
    'civilWorks.services.project.feature3': 'إدارة السلامة',
    'civilWorks.services.project.feature4': 'مراقبة التقدم',
    'civilWorks.whyChoose.title': 'لماذا تختار FMC للأعمال المدنية؟',
    'civilWorks.whyChoose.subtitle': 'خبرتنا في الهندسة المدنية وتطوير البنية التحتية، مقترنة بالحرفية عالية الجودة والتميز التقني، تقدم نتائج استثنائية.',
    'civilWorks.whyChoose.experience.title': 'خبرة مثبتة',
    'civilWorks.whyChoose.experience.description': 'سجل حافل في مشاريع البنية التحتية المدنية',
    'civilWorks.whyChoose.quality.title': 'ضمان الجودة',
    'civilWorks.whyChoose.quality.description': 'مراقبة جودة صارمة تضمن معايير بناء فائقة',
    'civilWorks.whyChoose.innovation.title': 'الابتكار التقني',
    'civilWorks.whyChoose.innovation.description': 'حلول هندسية متقدمة وتقنيات بناء حديثة',
    'civilWorks.whyChoose.delivery.title': 'التسليم في الوقت المحدد',
    'civilWorks.whyChoose.delivery.description': 'إدارة مشاريع فعالة تضمن الإكمال في الوقت المحدد',
    'civilWorks.whyChoose.card.title': 'بناء البنية التحتية',
    'civilWorks.whyChoose.card.subtitle': 'ربط المجتمعات من خلال البناء عالي الجودة',
    'civilWorks.cta.title': 'مستعد لبدء مشروعك المدني؟',
    'civilWorks.cta.subtitle': 'دعنا نناقش احتياجات البنية التحتية الخاصة بك وننشئ حلولاً تفيد مجتمعك',
    'civilWorks.cta.consultation': 'احصل على استشارة المشروع',
    'civilWorks.cta.callNow': 'اتصل الآن',
    
    // OurVendors form translations
    'ourVendors.form.vendorName.placeholder': 'أدخل اسم المورد',
    'ourVendors.form.contactFullName': 'الاسم الكامل للجهة الاتصال *',
    'ourVendors.form.contactFullName.placeholder': 'أدخل اسمك الكامل',
    'ourVendors.form.position.placeholder': 'أدخل منصبك',
    'ourVendors.form.phone.placeholder': 'أدخل رقم هاتفك',
    'ourVendors.form.mobile.placeholder': 'أدخل رقم جوالك',
    'ourVendors.form.email.placeholder': 'أدخل عنوان بريدك الإلكتروني',
    'ourVendors.form.services.placeholder': 'اوصف خدماتك أو منتجاتك',
    'ourVendors.form.vat.placeholder': 'أدخل رقم ضريبة القيمة المضافة',
    'ourVendors.form.subcontractorName.placeholder': 'أدخل اسم المقاول من الباطن',
    'ourVendors.form.subcontractingServices.placeholder': 'اوصف خدمات المقاولة من الباطن',
    'ourVendors.form.additionalInfo.placeholder': 'أي معلومات إضافية أو أسئلة...',
  }
};
